(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(18);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _uprrAngularAnalytics = __webpack_require__(302);
	
	var _uprrAngularAnalytics2 = _interopRequireDefault(_uprrAngularAnalytics);
	
	var _usage = __webpack_require__(278);
	
	var _usage2 = __webpack_require__(279);
	
	var _usage3 = _interopRequireDefault(_usage2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.usage', [_utils2.default.name, _uprrAngularAnalytics2.default.name]).constant('RC_USAGE_URL', _usage.RC_USAGE_URL).constant('RC_USAGE_DP_URL', _usage.RC_USAGE_DP_URL).provider('Usage', _usage3.default);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(14);
	
	var _common2 = _interopRequireDefault(_common);
	
	__webpack_require__(281);
	
	__webpack_require__(282);
	
	var _utilsService = __webpack_require__(283);
	
	var _utilsService2 = _interopRequireDefault(_utilsService);
	
	var _utilsService3 = __webpack_require__(285);
	
	var _utilsService4 = _interopRequireDefault(_utilsService3);
	
	var _utils = __webpack_require__(284);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.utils', [_common2.default.name]).service('rcFeatureTests', _utilsService2.default).service('rcUserId', _utilsService4.default).service('rcUtils', _utils2.default);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyboardNavigation = __webpack_require__(184);
	
	exports.default = angular.module('rc.keyboardNavigation', []).constant('KEYS', _keyboardNavigation.KEYS);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _position = __webpack_require__(214);
	
	var _position2 = _interopRequireDefault(_position);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.position', []).service('$position', _position2.default);

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mediaQuery = __webpack_require__(190);
	
	var _mediaQuery2 = __webpack_require__(191);
	
	var _mediaQuery3 = _interopRequireDefault(_mediaQuery2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.mediaQuery', []).constant('BREAKPOINTS', _mediaQuery.BREAKPOINTS).service('rcMediaQuery', _mediaQuery3.default);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bindHtml = __webpack_require__(131);
	
	var _bindHtml2 = _interopRequireDefault(_bindHtml);
	
	var _bindHtmlDirective = __webpack_require__(130);
	
	var _bindHtmlDirective2 = _interopRequireDefault(_bindHtmlDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.bindHtml', []).directive('rcBindHtmlUnsafe', _bindHtml2.default).directive('rcBindHtmlUnsafeCompile', _bindHtmlDirective2.default);

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contentReplace = __webpack_require__(171);
	
	var _contentReplace2 = _interopRequireDefault(_contentReplace);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.contentReplace', []).directive('rcContentReplace', _contentReplace2.default);

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _overlay = __webpack_require__(10);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _modal = __webpack_require__(193);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(194);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _modalService = __webpack_require__(195);
	
	var _modalService2 = _interopRequireDefault(_modalService);
	
	var _modalService3 = __webpack_require__(196);
	
	var _modalService4 = _interopRequireDefault(_modalService3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.modal', [_usage2.default.name, _overlay2.default.name]).directive('rcModalWindow', _modal2.default).provider('$rcModal', _modal4.default).service('$rcModalStack', _modalService2.default).service('$$rcStackedMap', _modalService4.default);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _navSlideMenuTransformer = __webpack_require__(202);
	
	var _navSlideMenuTransformer2 = _interopRequireDefault(_navSlideMenuTransformer);
	
	var _navDesktopTransformer = __webpack_require__(198);
	
	var _navDesktopTransformer2 = _interopRequireDefault(_navDesktopTransformer);
	
	var _navRegisterWithApptemplate = __webpack_require__(201);
	
	var _navRegisterWithApptemplate2 = _interopRequireDefault(_navRegisterWithApptemplate);
	
	var _navLink = __webpack_require__(199);
	
	var _navLink2 = _interopRequireDefault(_navLink);
	
	var _nestedNav = __webpack_require__(203);
	
	var _nestedNav2 = _interopRequireDefault(_nestedNav);
	
	var _appTemplateDesktopNavigation = __webpack_require__(197);
	
	var _appTemplateDesktopNavigation2 = _interopRequireDefault(_appTemplateDesktopNavigation);
	
	var _slideMenuNavigation = __webpack_require__(205);
	
	var _slideMenuNavigation2 = _interopRequireDefault(_slideMenuNavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.navigation', [])
	// Public API
	.directive('rcNav', _navRegisterWithApptemplate2.default).directive('rcNav', _navSlideMenuTransformer2.default).component('rcNav', _navDesktopTransformer2.default).component('rcNavLink', _navLink2.default).component('rcNestedNav', _nestedNav2.default)
	
	// Internal components
	.component('rcAppTemplateNav', _appTemplateDesktopNavigation2.default).component('rcSlideMenuNav', _slideMenuNavigation2.default); // A common navigation module, used by both app template and slide menu.

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _overlay = __webpack_require__(210);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.overlay', []).directive('rcOverlay', _overlay2.default);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _seamlessUi = __webpack_require__(230);
	
	var _seamlessUi2 = _interopRequireDefault(_seamlessUi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.seamlessUi', []).service('rcSeamlessUi', _seamlessUi2.default);

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _target = __webpack_require__(270);
	
	var _target2 = _interopRequireDefault(_target);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.target', []).directive('rcTarget', _target2.default);

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var RC_APP_TEMPLATE_FOOTER_CONTENT = exports.RC_APP_TEMPLATE_FOOTER_CONTENT = [{
	    label: 'Home',
	    url: '/emp'
	}, {
	    label: 'Search',
	    url: '/emp/search'
	}, {
	    label: 'New Stuff',
	    url: '/emp/newstuff'
	}, {
	    label: 'Phonebook',
	    url: '/emp/hr/phonebook'
	}, {
	    label: 'UP Online',
	    url: '/emp/news/uponline'
	}, {
	    label: 'Help',
	    url: '/helpinfo.shtml'
	}, {
	    label: 'Feedback',
	    url: '/feedback.shtml'
	}];
	var RC_APP_TEMPLATE_LOGOUT_LINK = exports.RC_APP_TEMPLATE_LOGOUT_LINK = '/admin/logout.cfm';
	var RC_APP_TEMPLATE_HEADER_LOGO_LINK = exports.RC_APP_TEMPLATE_HEADER_LOGO_LINK = '/';

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(167);
	
	exports.default = angular.module('rc.common', []).constant('USER_ID_SERVICE_URL', _common.USER_ID_SERVICE_URL);

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _focus = __webpack_require__(172);
	
	var _focus2 = _interopRequireDefault(_focus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.focus', []).directive('rcFocus', _focus2.default);

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _contentReplace = __webpack_require__(7);
	
	var _contentReplace2 = _interopRequireDefault(_contentReplace);
	
	var _groupbox = __webpack_require__(173);
	
	var _groupbox2 = _interopRequireDefault(_groupbox);
	
	var _groupboxDirective = __webpack_require__(175);
	
	var _groupboxDirective2 = _interopRequireDefault(_groupboxDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.groupbox', [_usage2.default.name, _contentReplace2.default.name]).component('rcGroupbox', _groupbox2.default).directive('rcGroupboxHeading', _groupboxDirective2.default);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _hoverIntent = __webpack_require__(176);
	
	var HOVER_INTENT_MODULE = angular.module('rc.hoverIntent', []);
	
	angular.forEach(_hoverIntent.HOVER_TRIGGERS, function (e) {
	    /* Manual dependency injection because ngmin/ngannotate doesn't pick this up */
	    HOVER_INTENT_MODULE.directive(e.name, ["$timeout", function ($timeout) {
	        'ngInject';
	
	        return {
	            restrict: 'A',
	            link: function link(scope, element, attributes) {
	                var hoverPromise;
	                function cancelDelayedEvent() {
	                    $timeout.cancel(hoverPromise);
	                }
	
	                element.bind(e.trigger, function (event) {
	                    cancelDelayedEvent();
	                    var delay = scope.$eval(attributes.rcHoverintentDelay);
	                    if (!delay) {
	                        delay = 150;
	                    }
	
	                    hoverPromise = $timeout(function () {
	                        scope.$eval(attributes[e.name], { $event: event });
	                    }, delay);
	                });
	
	                element.bind(e.cancel, cancelDelayedEvent);
	            }
	        };
	    }]);
	});
	
	exports.default = HOVER_INTENT_MODULE;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _components = __webpack_require__(170);
	
	Object.keys(_components).forEach(function (key) {
	    if (key === "default") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _components[key];
	        }
	    });
	});
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc', Object.keys(_components2.default).map(function (component) {
	    var name = component.substr(0, 1).toLowerCase() + component.substr(1);
	    return 'rc.' + name;
	})).name;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _infiniteScroll = __webpack_require__(181);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.infiniteScroll', []).directive('rcInfiniteScroll', _infiniteScroll2.default);

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputFieldWrapper = __webpack_require__(183);
	
	var _inputFieldWrapper2 = _interopRequireDefault(_inputFieldWrapper);
	
	var _inputFieldWrapper3 = __webpack_require__(182);
	
	var _inputFieldWrapper4 = _interopRequireDefault(_inputFieldWrapper3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.inputFieldWrapper', []).service('$rcInputFieldWrapper', _inputFieldWrapper2.default).directive('select', _inputFieldWrapper4.default).directive('textarea', _inputFieldWrapper4.default).directive('input', _inputFieldWrapper4.default);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _listview = __webpack_require__(186);
	
	var _listview2 = _interopRequireDefault(_listview);
	
	var _listviewDirective = __webpack_require__(185);
	
	var _listviewDirective2 = _interopRequireDefault(_listviewDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.listview', [_usage2.default.name]).directive('rcListview', _listview2.default).directive('inputGroup', _listviewDirective2.default);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _loadingDirective = __webpack_require__(187);
	
	var _loadingDirective2 = _interopRequireDefault(_loadingDirective);
	
	var _loadingDirective3 = __webpack_require__(188);
	
	var _loadingDirective4 = _interopRequireDefault(_loadingDirective3);
	
	var _loading = __webpack_require__(189);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.loading', [_usage2.default.name]).directive('rcLoadingBackdrop', _loadingDirective2.default).directive('rcLoadingContent', _loadingDirective4.default).directive('rcLoading', _loading2.default);

/***/ },
/* 23 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var parentOfType = function parentOfType(element, nodeType) {
	    if (!element) {
	        return null;
	    }
	    if (element.nodeName === nodeType) {
	        return element;
	    }
	    return parentOfType(element.parentNode, nodeType);
	};
	
	var parentAppTemplateNode = function parentAppTemplateNode(element, $log) {
	    var appTemplate = parentOfType(element, 'RC-APP-TEMPLATE');
	    if (!appTemplate) {
	        $log.warn('<rc-nav> component must be used in the context of an <rc-app-template>');
	    }
	    return appTemplate;
	};
	
	exports.parentAppTemplateNode = parentAppTemplateNode;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _overlay = __webpack_require__(10);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _navigation = __webpack_require__(9);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _slideMenu = __webpack_require__(236);
	
	var _slideMenu2 = _interopRequireDefault(_slideMenu);
	
	var _slideMenuNavJs = __webpack_require__(233);
	
	var _slideMenuNavJs2 = _interopRequireDefault(_slideMenuNavJs);
	
	var _slideMenuNestedNav = __webpack_require__(234);
	
	var _slideMenuNestedNav2 = _interopRequireDefault(_slideMenuNestedNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.slideMenu', [_overlay2.default.name, _usage2.default.name, _navigation2.default.name])
	// Public component
	.component('rcSlideMenu', _slideMenu2.default)
	
	// Internal components
	.component('rcSlideMenuNestedNav', _slideMenuNestedNav2.default).component('rcSlideMenuNavJs', _slideMenuNavJs2.default);

/***/ },
/* 25 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var regexTest = function regexTest(regex) {
	    return function (input) {
	        return regex.test(input);
	    };
	};
	
	// To pass this validator, value must:
	// 1. Be an integer
	// 2. Be greater than zero
	// 3. Have fewer than (or equal to) digits than the "length" param
	var simpleLengthTest = function simpleLengthTest(length) {
	    return function (input) {
	        var asInteger = parseFloat(input, 10);
	        if (asInteger % 1 === 0 && asInteger > 0) {
	            return input.length <= length;
	        }
	        return false;
	    };
	};
	
	function prependZeros(val, length) {
	    var spaceleft = length - val.length;
	    if (spaceleft > 0) {
	        val = new Array(spaceleft + 1).join('0') + val;
	    }
	    return val;
	}
	
	function numberGreaterThanAndLength(min, length) {
	    return function (val) {
	        val = prependZeros(val, length);
	        return val > min && val.length === length;
	    };
	}
	
	var ztsTest = function ztsTest(input) {
	    var numberGreaterThan0Length2 = numberGreaterThanAndLength(0, 2),
	        numberGreaterThan0Length3 = numberGreaterThanAndLength(0, 3),
	        numberGreaterThanMinus1Length2 = numberGreaterThanAndLength(-1, 2),
	        pieces = input.split(' ');
	    // [0] length 2, > 0 | [1] length 3, > 0 | [2] length 2, >= 0
	    return numberGreaterThan0Length2(pieces[0]) && numberGreaterThan0Length3(pieces[1]) && numberGreaterThanMinus1Length2(pieces[2]);
	};
	
	var validators = [
	//Regular Expression validators
	{ name: 'circ7', test: regexTest(/^[a-z]+\s?[0-9]{3}[a-z]?$/i) }, { name: 'alpha', test: regexTest(/^[A-Z ]+$/i) }, { name: 'carrier', test: regexTest(/^[a-z0-9]{2,4}$/i) }, { name: 'circ7List', test: regexTest(/^(\w{2,3}\d{3}[,;]{1}\s?)*\w{2,3}\d{3}$/i) }, { name: 'currency', test: regexTest(/^-?\$?(?:0|[1-9]\d{0,2}(?:,?\d{3})*)(?:\.\d+)?$/) }, { name: 'date', test: regexTest(/^(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])$/) }, { name: 'dateTime', test: regexTest(/^((?:0[1-9]|1[012])\/?(?:0[1-9]|[12][0-9]|3[01]))[ ]?((?:[0-1][0-9]|2[0-3]):?[0-5][0-9])$/) }, { name: 'dateWithYear', test: regexTest(/^(0[1-9]|1[012])\/?(0[1-9]|[12][0-9]|3[01])\/?([0-9]{4})$/) }, { name: 'email', test: regexTest(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i) }, { name: 'employeeId', test: regexTest(/^\d{7}$/) }, { name: 'equipmentId', test: regexTest(/^[a-z]{1,4}[\s]?\d{1,6}$/i) }, { name: 'equipmentIdList', test: regexTest(/^([a-z]{1,4}[\s]?\d{1,6}[,;\n]{1}\s?)*[a-z]{1,4}[\s]?\d{1,6}$/i) }, { name: 'integer', test: regexTest(/^(0*\d+|-?[1-9]+\d*)$/) }, { name: 'lata', test: regexTest(/^[a-z]{1,2}\d{5,6}$/i) }, { name: 'numeric', test: regexTest(/(^0$)|(^-?[1-9]\d*(\.\d+)?$)/) }, { name: 'phone', test: regexTest(/^(\(?[0-9]{1,3}\)?)?[- ]?([0-9]{3})?[- ]?([0-9]{3})[- ]?([0-9]{4})(?:[ ]?x([0-9]*))?$/i) }, { name: 'time', test: regexTest(/^([01][0-9]|2[0-3]):[0-5][0-9]$/) }, { name: 'timeWithSeconds', test: regexTest(/^\d{2}:\d{2}:\d{2}$/) }, { name: 'trainId', test: regexTest(/^\d?[a-z]{1}\w{1,6} \d{2}$/i) }, { name: 'trainIdList', test: regexTest(/^(\d?[a-z]{1}\w{1,6} \d{2}[,;]{1}\s?)*\d?[a-z]{1}\w{1,6} \d{2}$/i) }, { name: 'trainSymbol', test: regexTest(/^\d?\w{2,7}$/i) }, { name: 'userId', test: regexTest(/^\w{4}\d{3}$/i) }, { name: 'zipcode', test: regexTest(/^\d{5}(-\d{4})?$/) }, { name: 'yardTrack', test: regexTest(/^\d{1,2}[. \/]\d{1,3}$/) },
	
	//Simple Length validators
	{ name: 'yard', test: simpleLengthTest(2) }, { name: 'track', test: simpleLengthTest(3) }, { name: 'seq', test: simpleLengthTest(4) },
	
	//Special validators
	{ name: 'zts', test: ztsTest }];
	
	exports.default = validators;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.7
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* jshint ignore:start */
	// this code is in the core, but not in angular-messages.js
	var isArray = angular.isArray;
	var forEach = angular.forEach;
	var isString = angular.isString;
	var jqLite = angular.element;
	/* jshint ignore:end */
	
	/**
	 * @ngdoc module
	 * @name ngMessages
	 * @description
	 *
	 * The `ngMessages` module provides enhanced support for displaying messages within templates
	 * (typically within forms or when rendering message objects that return key/value data).
	 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
	 * show and hide error messages specific to the state of an input field, the `ngMessages` and
	 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
	 * sequencing based on the order of how the messages are defined in the template.
	 *
	 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
	 * `ngMessage` and `ngMessageExp` directives.
	 *
	 * # Usage
	 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
	 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
	 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
	 * {@link ngModel ngModel} directive.
	 *
	 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
	 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
	 * the `ngMessages` directive.
	 *
	 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
	 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
	 * directive.
	 *
	 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Enter text:
	 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
	 *   </label>
	 *   <div ng-messages="myForm.myField.$error" role="alert">
	 *     <div ng-message="required">Please enter a value for this field.</div>
	 *     <div ng-message="email">This field must be a valid email address.</div>
	 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
	 * set to the `$error` object owned by the `myField` input in our `myForm` form.
	 *
	 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
	 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
	 * setting `ng-message="required"` specifies that this particular element should be displayed when there
	 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
	 * `myForm.myField.$error`).
	 *
	 * ### Message order
	 *
	 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
	 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
	 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
	 * to prioritise messages using custom JavaScript code.
	 *
	 * Given the following error object for our example (which informs us that the field `myField` currently has both the
	 * `required` and `email` errors):
	 *
	 * ```javascript
	 * <!-- keep in mind that ngModel automatically sets these error flags -->
	 * myField.$error = { required : true, email: true, maxlength: false };
	 * ```
	 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
	 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
	 * but the `email` message will be visible because it is still applicable.
	 *
	 * ### Displaying multiple messages at the same time
	 *
	 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
	 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
	 *
	 * ```html
	 * <!-- attribute-style usage -->
	 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
	 *
	 * <!-- element-style usage -->
	 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
	 * ```
	 *
	 * ## Reusing and Overriding Messages
	 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
	 * template. This allows for generic collection of messages to be reused across multiple parts of an
	 * application.
	 *
	 * ```html
	 * <script type="text/ng-template" id="error-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <div ng-messages="myForm.myField.$error" role="alert">
	 *   <div ng-messages-include="error-messages"></div>
	 * </div>
	 * ```
	 *
	 * However, including generic messages may not be useful enough to match all input fields, therefore,
	 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
	 * them within the directive container.
	 *
	 * ```html
	 * <!-- a generic template of error messages known as "my-custom-messages" -->
	 * <script type="text/ng-template" id="my-custom-messages">
	 *   <div ng-message="required">This field is required</div>
	 *   <div ng-message="minlength">This field is too short</div>
	 * </script>
	 *
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            id="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
	 *        override the messages present in the ng-messages-include template -->
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <!-- this required message has overridden the template message -->
	 *     <div ng-message="required">You did not enter your email address</div>
	 *
	 *     <!-- this is a brand new message and will appear last in the prioritization -->
	 *     <div ng-message="email">Your email address is invalid</div>
	 *
	 *     <!-- and here are the generic error messages -->
	 *     <div ng-messages-include="my-custom-messages"></div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * In the example HTML code above the message that is set on required will override the corresponding
	 * required message defined within the remote template. Therefore, with particular input fields (such
	 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
	 * while more generic messages can be used to handle other, more general input errors.
	 *
	 * ## Dynamic Messaging
	 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
	 * repeaters to list messages is also supported. This means that the code below will be able to
	 * fully adapt itself and display the appropriate message when any of the expression data changes:
	 *
	 * ```html
	 * <form name="myForm">
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            name="myEmail"
	 *            ng-model="email"
	 *            minlength="5"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message="required">You did not enter your email address</div>
	 *     <div ng-repeat="errorMessage in errorMessages">
	 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
	 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
	 *     </div>
	 *   </div>
	 * </form>
	 * ```
	 *
	 * The `errorMessage.type` expression can be a string value or it can be an array so
	 * that multiple errors can be associated with a single error message:
	 *
	 * ```html
	 *   <label>
	 *     Email address
	 *     <input type="email"
	 *            ng-model="data.email"
	 *            name="myEmail"
	 *            ng-minlength="5"
	 *            ng-maxlength="100"
	 *            required />
	 *   </label>
	 *   <div ng-messages="myForm.myEmail.$error" role="alert">
	 *     <div ng-message-exp="'required'">You did not enter your email address</div>
	 *     <div ng-message-exp="['minlength', 'maxlength']">
	 *       Your email must be between 5 and 100 characters long
	 *     </div>
	 *   </div>
	 * ```
	 *
	 * Feel free to use other structural directives such as ng-if and ng-switch to further control
	 * what messages are active and when. Be careful, if you place ng-message on the same element
	 * as these structural directives, Angular may not be able to determine if a message is active
	 * or not. Therefore it is best to place the ng-message on a child element of the structural
	 * directive.
	 *
	 * ```html
	 * <div ng-messages="myForm.myEmail.$error" role="alert">
	 *   <div ng-if="showRequiredError">
	 *     <div ng-message="required">Please enter something</div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * ## Animations
	 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
	 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
	 * the DOM by the `ngMessages` directive.
	 *
	 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
	 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
	 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
	 * hook into the animations whenever these classes are added/removed.
	 *
	 * Let's say that our HTML code for our messages container looks like so:
	 *
	 * ```html
	 * <div ng-messages="myMessages" class="my-messages" role="alert">
	 *   <div ng-message="alert" class="some-message">...</div>
	 *   <div ng-message="fail" class="some-message">...</div>
	 * </div>
	 * ```
	 *
	 * Then the CSS animation code for the message container looks like so:
	 *
	 * ```css
	 * .my-messages {
	 *   transition:1s linear all;
	 * }
	 * .my-messages.ng-active {
	 *   // messages are visible
	 * }
	 * .my-messages.ng-inactive {
	 *   // messages are hidden
	 * }
	 * ```
	 *
	 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
	 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
	 *
	 * Therefore, the CSS code for the inner messages looks like so:
	 *
	 * ```css
	 * .some-message {
	 *   transition:1s linear all;
	 * }
	 *
	 * .some-message.ng-enter {}
	 * .some-message.ng-enter.ng-enter-active {}
	 *
	 * .some-message.ng-leave {}
	 * .some-message.ng-leave.ng-leave-active {}
	 * ```
	 *
	 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
	 */
	angular.module('ngMessages', [])
	
	  /**
	   * @ngdoc directive
	   * @module ngMessages
	   * @name ngMessages
	   * @restrict AE
	   *
	   * @description
	   * `ngMessages` is a directive that is designed to show and hide messages based on the state
	   * of a key/value object that it listens on. The directive itself complements error message
	   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
	   *
	   * `ngMessages` manages the state of internal messages within its container element. The internal
	   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
	   * on if they're present within the key/value object. By default, only one message will be displayed
	   * at a time and this depends on the prioritization of the messages within the template. (This can
	   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
	   *
	   * A remote template can also be used to promote message reusability and messages can also be
	   * overridden.
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {string} ngMessages an angular expression evaluating to a key/value object
	   *                 (this is typically the $error object on an ngModel instance).
	   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
	   *
	   * @example
	   * <example name="ngMessages-directive" module="ngMessagesExample"
	   *          deps="angular-messages.js"
	   *          animations="true" fixBase="true">
	   *   <file name="index.html">
	   *     <form name="myForm">
	   *       <label>
	   *         Enter your name:
	   *         <input type="text"
	   *                name="myName"
	   *                ng-model="name"
	   *                ng-minlength="5"
	   *                ng-maxlength="20"
	   *                required />
	   *       </label>
	   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
	   *
	   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
	   *         <div ng-message="required">You did not enter a field</div>
	   *         <div ng-message="minlength">Your field is too short</div>
	   *         <div ng-message="maxlength">Your field is too long</div>
	   *       </div>
	   *     </form>
	   *   </file>
	   *   <file name="script.js">
	   *     angular.module('ngMessagesExample', ['ngMessages']);
	   *   </file>
	   * </example>
	   */
	  .directive('ngMessages', ['$animate', function($animate) {
	    var ACTIVE_CLASS = 'ng-active';
	    var INACTIVE_CLASS = 'ng-inactive';
	
	    return {
	      require: 'ngMessages',
	      restrict: 'AE',
	      controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
	        var ctrl = this;
	        var latestKey = 0;
	        var nextAttachId = 0;
	
	        this.getAttachId = function getAttachId() { return nextAttachId++; };
	
	        var messages = this.messages = {};
	        var renderLater, cachedCollection;
	
	        this.render = function(collection) {
	          collection = collection || {};
	
	          renderLater = false;
	          cachedCollection = collection;
	
	          // this is true if the attribute is empty or if the attribute value is truthy
	          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
	                         isAttrTruthy($scope, $attrs.multiple);
	
	          var unmatchedMessages = [];
	          var matchedKeys = {};
	          var messageItem = ctrl.head;
	          var messageFound = false;
	          var totalMessages = 0;
	
	          // we use != instead of !== to allow for both undefined and null values
	          while (messageItem != null) {
	            totalMessages++;
	            var messageCtrl = messageItem.message;
	
	            var messageUsed = false;
	            if (!messageFound) {
	              forEach(collection, function(value, key) {
	                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
	                  // this is to prevent the same error name from showing up twice
	                  if (matchedKeys[key]) return;
	                  matchedKeys[key] = true;
	
	                  messageUsed = true;
	                  messageCtrl.attach();
	                }
	              });
	            }
	
	            if (messageUsed) {
	              // unless we want to display multiple messages then we should
	              // set a flag here to avoid displaying the next message in the list
	              messageFound = !multiple;
	            } else {
	              unmatchedMessages.push(messageCtrl);
	            }
	
	            messageItem = messageItem.next;
	          }
	
	          forEach(unmatchedMessages, function(messageCtrl) {
	            messageCtrl.detach();
	          });
	
	          unmatchedMessages.length !== totalMessages
	              ? $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS)
	              : $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
	        };
	
	        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);
	
	        // If the element is destroyed, proactively destroy all the currently visible messages
	        $element.on('$destroy', function() {
	          forEach(messages, function(item) {
	            item.message.detach();
	          });
	        });
	
	        this.reRender = function() {
	          if (!renderLater) {
	            renderLater = true;
	            $scope.$evalAsync(function() {
	              if (renderLater) {
	                cachedCollection && ctrl.render(cachedCollection);
	              }
	            });
	          }
	        };
	
	        this.register = function(comment, messageCtrl) {
	          var nextKey = latestKey.toString();
	          messages[nextKey] = {
	            message: messageCtrl
	          };
	          insertMessageNode($element[0], comment, nextKey);
	          comment.$$ngMessageNode = nextKey;
	          latestKey++;
	
	          ctrl.reRender();
	        };
	
	        this.deregister = function(comment) {
	          var key = comment.$$ngMessageNode;
	          delete comment.$$ngMessageNode;
	          removeMessageNode($element[0], comment, key);
	          delete messages[key];
	          ctrl.reRender();
	        };
	
	        function findPreviousMessage(parent, comment) {
	          var prevNode = comment;
	          var parentLookup = [];
	
	          while (prevNode && prevNode !== parent) {
	            var prevKey = prevNode.$$ngMessageNode;
	            if (prevKey && prevKey.length) {
	              return messages[prevKey];
	            }
	
	            // dive deeper into the DOM and examine its children for any ngMessage
	            // comments that may be in an element that appears deeper in the list
	            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
	              parentLookup.push(prevNode);
	              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
	            } else if (prevNode.previousSibling) {
	              prevNode = prevNode.previousSibling;
	            } else {
	              prevNode = prevNode.parentNode;
	              parentLookup.push(prevNode);
	            }
	          }
	        }
	
	        function insertMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	          if (!ctrl.head) {
	            ctrl.head = messageNode;
	          } else {
	            var match = findPreviousMessage(parent, comment);
	            if (match) {
	              messageNode.next = match.next;
	              match.next = messageNode;
	            } else {
	              messageNode.next = ctrl.head;
	              ctrl.head = messageNode;
	            }
	          }
	        }
	
	        function removeMessageNode(parent, comment, key) {
	          var messageNode = messages[key];
	
	          var match = findPreviousMessage(parent, comment);
	          if (match) {
	            match.next = messageNode.next;
	          } else {
	            ctrl.head = messageNode.next;
	          }
	        }
	      }]
	    };
	
	    function isAttrTruthy(scope, attr) {
	     return (isString(attr) && attr.length === 0) || //empty attribute
	            truthy(scope.$eval(attr));
	    }
	
	    function truthy(val) {
	      return isString(val) ? val.length : !!val;
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessagesInclude
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
	   * code from a remote template and place the downloaded template code into the exact spot
	   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
	   * for a series of pre-defined messages to be reused and also allows for the developer to
	   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-messages-include="remoteTplString">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
	   */
	  .directive('ngMessagesInclude',
	    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {
	
	    return {
	      restrict: 'AE',
	      require: '^^ngMessages', // we only require this for validation sake
	      link: function($scope, element, attrs) {
	        var src = attrs.ngMessagesInclude || attrs.src;
	        $templateRequest(src).then(function(html) {
	          if ($scope.$$destroyed) return;
	
	          if (isString(html) && !html.trim()) {
	            // Empty template - nothing to compile
	            replaceElementWithMarker(element, src);
	          } else {
	            // Non-empty template - compile and link
	            $compile(html)($scope, function(contents) {
	              element.after(contents);
	              replaceElementWithMarker(element, src);
	            });
	          }
	        });
	      }
	    };
	
	    // Helpers
	    function replaceElementWithMarker(element, src) {
	      // A comment marker is placed for debugging purposes
	      var comment = $compile.$$createComment ?
	          $compile.$$createComment('ngMessagesInclude', src) :
	          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
	      var marker = jqLite(comment);
	      element.after(marker);
	
	      // Don't pollute the DOM anymore by keeping an empty directive element
	      element.remove();
	    }
	  }])
	
	  /**
	   * @ngdoc directive
	   * @name ngMessage
	   * @restrict AE
	   * @scope
	   *
	   * @description
	   * `ngMessage` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * More information about using `ngMessage` can be found in the
	   * {@link module:ngMessages `ngMessages` module documentation}.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression" role="alert">
	   *   <ANY ng-message="stringValue">...</ANY>
	   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression" role="alert">
	   *   <ng-message when="stringValue">...</ng-message>
	   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * @param {expression} ngMessage|when a string value corresponding to the message key.
	   */
	  .directive('ngMessage', ngMessageDirectiveFactory())
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMessageExp
	   * @restrict AE
	   * @priority 1
	   * @scope
	   *
	   * @description
	   * `ngMessageExp` is a directive with the purpose to show and hide a particular message.
	   * For `ngMessageExp` to operate, a parent `ngMessages` directive on a parent DOM element
	   * must be situated since it determines which messages are visible based on the state
	   * of the provided key/value map that `ngMessages` listens on.
	   *
	   * @usage
	   * ```html
	   * <!-- using attribute directives -->
	   * <ANY ng-messages="expression">
	   *   <ANY ng-message-exp="expressionValue">...</ANY>
	   * </ANY>
	   *
	   * <!-- or by using element directives -->
	   * <ng-messages for="expression">
	   *   <ng-message when-exp="expressionValue">...</ng-message>
	   * </ng-messages>
	   * ```
	   *
	   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
	   *
	   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
	   */
	  .directive('ngMessageExp', ngMessageDirectiveFactory());
	
	function ngMessageDirectiveFactory() {
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AE',
	      transclude: 'element',
	      priority: 1, // must run before ngBind, otherwise the text is set on the comment
	      terminal: true,
	      require: '^^ngMessages',
	      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
	        var commentNode = element[0];
	
	        var records;
	        var staticExp = attrs.ngMessage || attrs.when;
	        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
	        var assignRecords = function(items) {
	          records = items
	              ? (isArray(items)
	                  ? items
	                  : items.split(/[\s,]+/))
	              : null;
	          ngMessagesCtrl.reRender();
	        };
	
	        if (dynamicExp) {
	          assignRecords(scope.$eval(dynamicExp));
	          scope.$watchCollection(dynamicExp, assignRecords);
	        } else {
	          assignRecords(staticExp);
	        }
	
	        var currentElement, messageCtrl;
	        ngMessagesCtrl.register(commentNode, messageCtrl = {
	          test: function(name) {
	            return contains(records, name);
	          },
	          attach: function() {
	            if (!currentElement) {
	              $transclude(function(elm, newScope) {
	                $animate.enter(elm, null, element);
	                currentElement = elm;
	
	                // Each time we attach this node to a message we get a new id that we can match
	                // when we are destroying the node later.
	                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();
	
	                // in the event that the element or a parent element is destroyed
	                // by another structural directive then it's time
	                // to deregister the message from the controller
	                currentElement.on('$destroy', function() {
	                  if (currentElement && currentElement.$$attachId === $$attachId) {
	                    ngMessagesCtrl.deregister(commentNode);
	                    messageCtrl.detach();
	                  }
	                  newScope.$destroy();
	                });
	              });
	            }
	          },
	          detach: function() {
	            if (currentElement) {
	              var elm = currentElement;
	              currentElement = null;
	              $animate.leave(elm);
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  function contains(collection, key) {
	    if (collection) {
	      return isArray(collection)
	          ? collection.indexOf(key) >= 0
	          : collection.hasOwnProperty(key);
	    }
	  }
	}
	
	
	})(window, window.angular);


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(26);
	module.exports = 'ngMessages';


/***/ },
/* 28 */
/***/ function(module, exports) {

	/*!
	 * The MIT License
	 *
	 * Copyright (c) 2012 James Allardice
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to
	 * deal in the Software without restriction, including without limitation the
	 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	 * sell copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
	 * IN THE SOFTWARE.
	 */
	
	( function ( global ) {
	
	  'use strict';
	
	  //
	  // Test for support. We do this as early as possible to optimise for browsers
	  // that have native support for the attribute.
	  //
	
	  var test = document.createElement('input');
	  var nativeSupport = test.placeholder !== void 0;
	
	  global.Placeholders = {
	    nativeSupport: nativeSupport,
	    disable: nativeSupport ? noop : disablePlaceholders,
	    enable: nativeSupport ? noop : enablePlaceholders
	  };
	
	  if ( nativeSupport ) {
	    return;
	  }
	
	  //
	  // If we reach this point then the browser does not have native support for
	  // the attribute.
	  //
	
	  // The list of input element types that support the placeholder attribute.
	  var validTypes = [
	    'text',
	    'search',
	    'url',
	    'tel',
	    'email',
	    'password',
	    'number',
	    'textarea'
	  ];
	
	  // The list of keycodes that are not allowed when the polyfill is configured
	  // to hide-on-input.
	  var badKeys = [
	
	    // The following keys all cause the caret to jump to the end of the input
	    // value.
	
	    27, // Escape
	    33, // Page up
	    34, // Page down
	    35, // End
	    36, // Home
	
	    // Arrow keys allow you to move the caret manually, which should be
	    // prevented when the placeholder is visible.
	
	    37, // Left
	    38, // Up
	    39, // Right
	    40, // Down
	
	    // The following keys allow you to modify the placeholder text by removing
	    // characters, which should be prevented when the placeholder is visible.
	
	    8, // Backspace
	    46 // Delete
	  ];
	
	  // Styling variables.
	  var placeholderStyleColor = '#ccc';
	  var placeholderClassName = 'placeholdersjs';
	  var classNameRegExp = new RegExp('(?:^|\\s)' + placeholderClassName + '(?!\\S)');
	
	  // The various data-* attributes used by the polyfill.
	  var ATTR_CURRENT_VAL = 'data-placeholder-value';
	  var ATTR_ACTIVE = 'data-placeholder-active';
	  var ATTR_INPUT_TYPE = 'data-placeholder-type';
	  var ATTR_FORM_HANDLED = 'data-placeholder-submit';
	  var ATTR_EVENTS_BOUND = 'data-placeholder-bound';
	  var ATTR_OPTION_FOCUS = 'data-placeholder-focus';
	  var ATTR_OPTION_LIVE = 'data-placeholder-live';
	  var ATTR_MAXLENGTH = 'data-placeholder-maxlength';
	
	  // Various other variables used throughout the rest of the script.
	  var UPDATE_INTERVAL = 100;
	  var head = document.getElementsByTagName('head')[ 0 ];
	  var root = document.documentElement;
	  var Placeholders = global.Placeholders;
	  var keydownVal;
	
	  // Get references to all the input and textarea elements currently in the DOM
	  // (live NodeList objects to we only need to do this once).
	  var inputs = document.getElementsByTagName('input');
	  var textareas = document.getElementsByTagName('textarea');
	
	  // Get any settings declared as data-* attributes on the root element.
	  // Currently the only options are whether to hide the placeholder on focus
	  // or input and whether to auto-update.
	  var hideOnInput = root.getAttribute(ATTR_OPTION_FOCUS) === 'false';
	  var liveUpdates = root.getAttribute(ATTR_OPTION_LIVE) !== 'false';
	
	  // Create style element for placeholder styles (instead of directly setting
	  // style properties on elements - allows for better flexibility alongside
	  // user-defined styles).
	  var styleElem = document.createElement('style');
	  styleElem.type = 'text/css';
	
	  // Create style rules as text node.
	  var styleRules = document.createTextNode(
	    '.' + placeholderClassName + ' {' +
	      'color:' + placeholderStyleColor + ';' +
	    '}'
	  );
	
	  // Append style rules to newly created stylesheet.
	  if ( styleElem.styleSheet ) {
	    styleElem.styleSheet.cssText = styleRules.nodeValue;
	  } else {
	    styleElem.appendChild(styleRules);
	  }
	
	  // Prepend new style element to the head (before any existing stylesheets,
	  // so user-defined rules take precedence).
	  head.insertBefore(styleElem, head.firstChild);
	
	  // Set up the placeholders.
	  var placeholder;
	  var elem;
	
	  for ( var i = 0, len = inputs.length + textareas.length; i < len; i++ ) {
	
	    // Find the next element. If we've already done all the inputs we move on
	    // to the textareas.
	    elem = i < inputs.length ? inputs[ i ] : textareas[ i - inputs.length ];
	
	    // Get the value of the placeholder attribute, if any. IE10 emulating IE7
	    // fails with getAttribute, hence the use of the attributes node.
	    placeholder = elem.attributes.placeholder;
	
	    // If the element has a placeholder attribute we need to modify it.
	    if ( placeholder ) {
	
	      // IE returns an empty object instead of undefined if the attribute is
	      // not present.
	      placeholder = placeholder.nodeValue;
	
	      // Only apply the polyfill if this element is of a type that supports
	      // placeholders and has a placeholder attribute with a non-empty value.
	      if ( placeholder && inArray(validTypes, elem.type) ) {
	        newElement(elem);
	      }
	    }
	  }
	
	  // If enabled, the polyfill will repeatedly check for changed/added elements
	  // and apply to those as well.
	  var timer = setInterval(function () {
	    for ( var i = 0, len = inputs.length + textareas.length; i < len; i++ ) {
	      elem = i < inputs.length ? inputs[ i ] : textareas[ i - inputs.length ];
	
	      // Only apply the polyfill if this element is of a type that supports
	      // placeholders, and has a placeholder attribute with a non-empty value.
	      placeholder = elem.attributes.placeholder;
	
	      if ( placeholder ) {
	
	        placeholder = placeholder.nodeValue;
	
	        if ( placeholder && inArray(validTypes, elem.type) ) {
	
	          // If the element hasn't had event handlers bound to it then add
	          // them.
	          if ( !elem.getAttribute(ATTR_EVENTS_BOUND) ) {
	            newElement(elem);
	          }
	
	          // If the placeholder value has changed or not been initialised yet
	          // we need to update the display.
	          if (
	            placeholder !== elem.getAttribute(ATTR_CURRENT_VAL) ||
	            ( elem.type === 'password' && !elem.getAttribute(ATTR_INPUT_TYPE) )
	          ) {
	
	            // Attempt to change the type of password inputs (fails in IE < 9).
	            if (
	              elem.type === 'password' &&
	              !elem.getAttribute(ATTR_INPUT_TYPE) &&
	              changeType(elem, 'text')
	            ) {
	              elem.setAttribute(ATTR_INPUT_TYPE, 'password');
	            }
	
	            // If the placeholder value has changed and the placeholder is
	            // currently on display we need to change it.
	            if ( elem.value === elem.getAttribute(ATTR_CURRENT_VAL) ) {
	              elem.value = placeholder;
	            }
	
	            // Keep a reference to the current placeholder value in case it
	            // changes via another script.
	            elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
	          }
	        }
	      } else if ( elem.getAttribute(ATTR_ACTIVE) ) {
	        hidePlaceholder(elem);
	        elem.removeAttribute(ATTR_CURRENT_VAL);
	      }
	    }
	
	    // If live updates are not enabled cancel the timer.
	    if ( !liveUpdates ) {
	      clearInterval(timer);
	    }
	  }, UPDATE_INTERVAL);
	
	  // Disabling placeholders before unloading the page prevents flash of
	  // unstyled placeholders on load if the page was refreshed.
	  addEventListener(global, 'beforeunload', function () {
	    Placeholders.disable();
	  });
	
	  //
	  // Utility functions
	  //
	
	  // No-op (used in place of public methods when native support is detected).
	  function noop() {}
	
	  // Avoid IE9 activeElement of death when an iframe is used.
	  //
	  // More info:
	  //  - http://bugs.jquery.com/ticket/13393
	  //  - https://github.com/jquery/jquery/commit/85fc5878b3c6af73f42d61eedf73013e7faae408
	  function safeActiveElement() {
	    try {
	      return document.activeElement;
	    } catch ( err ) {}
	  }
	
	  // Check whether an item is in an array. We don't use Array.prototype.indexOf
	  // so we don't clobber any existing polyfills. This is a really simple
	  // alternative.
	  function inArray( arr, item ) {
	    for ( var i = 0, len = arr.length; i < len; i++ ) {
	      if ( arr[ i ] === item ) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // Cross-browser DOM event binding
	  function addEventListener( elem, event, fn ) {
	    if ( elem.addEventListener ) {
	      return elem.addEventListener(event, fn, false);
	    }
	    if ( elem.attachEvent ) {
	      return elem.attachEvent('on' + event, fn);
	    }
	  }
	
	  // Move the caret to the index position specified. Assumes that the element
	  // has focus.
	  function moveCaret( elem, index ) {
	    var range;
	    if ( elem.createTextRange ) {
	      range = elem.createTextRange();
	      range.move('character', index);
	      range.select();
	    } else if ( elem.selectionStart ) {
	      elem.focus();
	      elem.setSelectionRange(index, index);
	    }
	  }
	
	  // Attempt to change the type property of an input element.
	  function changeType( elem, type ) {
	    try {
	      elem.type = type;
	      return true;
	    } catch ( e ) {
	      // You can't change input type in IE8 and below.
	      return false;
	    }
	  }
	
	  function handleElem( node, callback ) {
	
	    // Check if the passed in node is an input/textarea (in which case it can't
	    // have any affected descendants).
	    if ( node && node.getAttribute(ATTR_CURRENT_VAL) ) {
	      callback(node);
	    } else {
	
	      // If an element was passed in, get all affected descendants. Otherwise,
	      // get all affected elements in document.
	      var handleInputs = node ? node.getElementsByTagName('input') : inputs;
	      var handleTextareas = node ? node.getElementsByTagName('textarea') : textareas;
	
	      var handleInputsLength = handleInputs ? handleInputs.length : 0;
	      var handleTextareasLength = handleTextareas ? handleTextareas.length : 0;
	
	      // Run the callback for each element.
	      var len = handleInputsLength + handleTextareasLength;
	      var elem;
	      for ( var i = 0; i < len; i++ ) {
	
	        elem = i < handleInputsLength ?
	          handleInputs[ i ] :
	          handleTextareas[ i - handleInputsLength ];
	
	        callback(elem);
	      }
	    }
	  }
	
	  // Return all affected elements to their normal state (remove placeholder
	  // value if present).
	  function disablePlaceholders( node ) {
	    handleElem(node, hidePlaceholder);
	  }
	
	  // Show the placeholder value on all appropriate elements.
	  function enablePlaceholders( node ) {
	    handleElem(node, showPlaceholder);
	  }
	
	  // Hide the placeholder value on a single element. Returns true if the
	  // placeholder was hidden and false if it was not (because it wasn't visible
	  // in the first place).
	  function hidePlaceholder( elem, keydownValue ) {
	
	    var valueChanged = !!keydownValue && elem.value !== keydownValue;
	    var isPlaceholderValue = elem.value === elem.getAttribute(ATTR_CURRENT_VAL);
	
	    if (
	      ( valueChanged || isPlaceholderValue ) &&
	      elem.getAttribute(ATTR_ACTIVE) === 'true'
	    ) {
	
	      elem.removeAttribute(ATTR_ACTIVE);
	      elem.value = elem.value.replace(elem.getAttribute(ATTR_CURRENT_VAL), '');
	      elem.className = elem.className.replace(classNameRegExp, '');
	
	      // Restore the maxlength value. Old FF returns -1 if attribute not set.
	      // See GH-56.
	      var maxLength = elem.getAttribute(ATTR_MAXLENGTH);
	      if ( parseInt(maxLength, 10) >= 0 ) {
	        elem.setAttribute('maxLength', maxLength);
	        elem.removeAttribute(ATTR_MAXLENGTH);
	      }
	
	      // If the polyfill has changed the type of the element we need to change
	      // it back.
	      var type = elem.getAttribute(ATTR_INPUT_TYPE);
	      if ( type ) {
	        elem.type = type;
	      }
	
	      return true;
	    }
	
	    return false;
	  }
	
	  // Show the placeholder value on a single element. Returns true if the
	  // placeholder was shown and false if it was not (because it was already
	  // visible).
	  function showPlaceholder( elem ) {
	
	    var val = elem.getAttribute(ATTR_CURRENT_VAL);
	
	    if ( elem.value === '' && val ) {
	
	      elem.setAttribute(ATTR_ACTIVE, 'true');
	      elem.value = val;
	      elem.className += ' ' + placeholderClassName;
	
	      // Store and remove the maxlength value.
	      var maxLength = elem.getAttribute(ATTR_MAXLENGTH);
	      if ( !maxLength ) {
	        elem.setAttribute(ATTR_MAXLENGTH, elem.maxLength);
	        elem.removeAttribute('maxLength');
	      }
	
	      // If the type of element needs to change, change it (e.g. password
	      // inputs).
	      var type = elem.getAttribute(ATTR_INPUT_TYPE);
	      if ( type ) {
	        elem.type = 'text';
	      } else if ( elem.type === 'password' && changeType(elem, 'text') ) {
	        elem.setAttribute(ATTR_INPUT_TYPE, 'password');
	      }
	
	      return true;
	    }
	
	    return false;
	  }
	
	  // Returns a function that is used as a focus event handler.
	  function makeFocusHandler( elem ) {
	    return function () {
	
	      // Only hide the placeholder value if the (default) hide-on-focus
	      // behaviour is enabled.
	      if (
	        hideOnInput &&
	        elem.value === elem.getAttribute(ATTR_CURRENT_VAL) &&
	        elem.getAttribute(ATTR_ACTIVE) === 'true'
	      ) {
	
	        // Move the caret to the start of the input (this mimics the behaviour
	        // of all browsers that do not hide the placeholder on focus).
	        moveCaret(elem, 0);
	      } else {
	
	        // Remove the placeholder.
	        hidePlaceholder(elem);
	      }
	    };
	  }
	
	  // Returns a function that is used as a blur event handler.
	  function makeBlurHandler( elem ) {
	    return function () {
	      showPlaceholder(elem);
	    };
	  }
	
	  // Returns a function that is used as a submit event handler on form elements
	  // that have children affected by this polyfill.
	  function makeSubmitHandler( form ) {
	    return function () {
	
	        // Turn off placeholders on all appropriate descendant elements.
	        disablePlaceholders(form);
	    };
	  }
	
	  // Functions that are used as a event handlers when the hide-on-input
	  // behaviour has been activated - very basic implementation of the 'input'
	  // event.
	  function makeKeydownHandler( elem ) {
	    return function ( e ) {
	      keydownVal = elem.value;
	
	      // Prevent the use of the arrow keys (try to keep the cursor before the
	      // placeholder).
	      if (
	        elem.getAttribute(ATTR_ACTIVE) === 'true' &&
	        keydownVal === elem.getAttribute(ATTR_CURRENT_VAL) &&
	        inArray(badKeys, e.keyCode)
	      ) {
	        if ( e.preventDefault ) {
	            e.preventDefault();
	        }
	        return false;
	      }
	    };
	  }
	
	  function makeKeyupHandler(elem) {
	    return function () {
	      hidePlaceholder(elem, keydownVal);
	
	      // If the element is now empty we need to show the placeholder
	      if ( elem.value === '' ) {
	        elem.blur();
	        moveCaret(elem, 0);
	      }
	    };
	  }
	
	  function makeClickHandler(elem) {
	    return function () {
	      if (
	        elem === safeActiveElement() &&
	        elem.value === elem.getAttribute(ATTR_CURRENT_VAL) &&
	        elem.getAttribute(ATTR_ACTIVE) === 'true'
	      ) {
	        moveCaret(elem, 0);
	      }
	    };
	  }
	
	  // Bind event handlers to an element that we need to affect with the
	  // polyfill.
	  function newElement( elem ) {
	
	    // If the element is part of a form, make sure the placeholder string is
	    // not submitted as a value.
	    var form = elem.form;
	    if ( form && typeof form === 'string' ) {
	
	      // Get the real form.
	      form = document.getElementById(form);
	
	      // Set a flag on the form so we know it's been handled (forms can contain
	      // multiple inputs).
	      if ( !form.getAttribute(ATTR_FORM_HANDLED) ) {
	        addEventListener(form, 'submit', makeSubmitHandler(form));
	        form.setAttribute(ATTR_FORM_HANDLED, 'true');
	      }
	    }
	
	    // Bind event handlers to the element so we can hide/show the placeholder
	    // as appropriate.
	    addEventListener(elem, 'focus', makeFocusHandler(elem));
	    addEventListener(elem, 'blur', makeBlurHandler(elem));
	
	    // If the placeholder should hide on input rather than on focus we need
	    // additional event handlers
	    if (hideOnInput) {
	      addEventListener(elem, 'keydown', makeKeydownHandler(elem));
	      addEventListener(elem, 'keyup', makeKeyupHandler(elem));
	      addEventListener(elem, 'click', makeClickHandler(elem));
	    }
	
	    // Remember that we've bound event handlers to this element.
	    elem.setAttribute(ATTR_EVENTS_BOUND, 'true');
	    elem.setAttribute(ATTR_CURRENT_VAL, placeholder);
	
	    // If the element doesn't have a value and is not focussed, set it to the
	    // placeholder string.
	    if ( hideOnInput || elem !== safeActiveElement() ) {
	      showPlaceholder(elem);
	    }
	  }
	
	}(this) );


/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = "<span class=\"rc-accordion-heading noselect\"\n    tabindex=\"0\"\n    ng-keyup=\"rcAccPnlCtrl.toggleHeading($event)\"\n    ng-click=\"rcAccPnlCtrl.toggleHeading($event)\"\n    rc-content-replace=\"rcAccPnlCtrl.heading\"></span>\n<div class=\"rc-accordion-content\" ng-transclude></div>\n\n";

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-accordion rc-container\" ng-transclude></div>\n";

/***/ },
/* 31 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"medium-5 columns\">\n        <rc-groupbox>\n            <rc-groupbox-heading>\n                <span>Available</span>\n                <span class=\"badge\" ng-bind=\"addRemove.available.length\"></span>\n            </rc-groupbox-heading>\n            <select class=\"available\"\n                ng-model=\"addRemove.addRem\"\n                ng-options=\"(item[addRemove.displayProperty] || item) for item in addRemove.available | orderBy:'toString()'\"\n                multiple=\"multiple\"\n                size=\"7\">\n            </select>\n        </rc-groupbox>\n    </div>\n    <div class=\"actions medium-2 columns\">\n        <button type=\"button\"\n            class=\"make-selected\"\n            ng-click=\"addRemove.makeAllSelected()\">&#8594;</button>\n        <button type=\"button\"\n            class=\"make-available\"\n            ng-click=\"addRemove.makeAllAvailable()\">&#8592;</button>\n        <button type=\"button\" ng-click=\"addRemove.addAll()\">&#8649;</button>\n        <button type=\"button\" ng-click=\"addRemove.removeAll()\">&#8647;</button>\n    </div>\n    <div class=\"medium-5 columns\">\n        <rc-groupbox>\n            <rc-groupbox-heading>\n                <span>Selected</span>\n                <span class=\"badge\" ng-bind=\"addRemove.selected.length\"></span>\n            </rc-groupbox-heading>\n            <select class=\"selected\"\n                ng-model=\"addRemove.addSel\"\n                ng-options=\"(item[addRemove.displayProperty] || item) for item in addRemove.selected | orderBy:'toString()'\"\n                multiple=\"multiple\"\n                size=\"7\">\n            </select>\n        </rc-groupbox>\n    </div>\n</div>\n";

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"columns\">\n        <rc-accordion class=\"available\">\n            <rc-accordion-panel is-open=\"!!addRemove.available.length\">\n                <rc-accordion-heading>\n                    Available <span class=\"badge\" ng-bind=\"addRemove.available.length\"></span>\n                </rc-accordion-heading>\n                <ul rc-listview inset=\"false\" ng-show=\"addRemove.available && addRemove.available.length\">\n                    <li class=\"item\" ng-repeat=\"item in addRemove.available | orderBy:'toString()'\">\n                        <a ng-click=\"addRemove.makeSelected(item)\" ng-bind=\"(item[addRemove.property] || item)\"></a>\n                    </li>\n                </ul>\n                <button class=\"add-all\" ng-click=\"addRemove.addAll()\" ng-show=\"addRemove.available.length\">Add All</button>\n            </rc-accordion-panel>\n        </rc-accordion>\n    </div>\n    <div class=\"columns\">\n        <rc-accordion class=\"selected\">\n            <rc-accordion-panel is-open=\"!!addRemove.selected.length\">\n                <rc-accordion-heading>\n                    Selected <span class=\"badge\" ng-bind=\"addRemove.selected.length\"></span>\n                </rc-accordion-heading>\n                <ul rc-listview inset=\"false\" ng-show=\"addRemove.selected.length\">\n                    <li class=\"item\" ng-repeat=\"item in addRemove.selected | orderBy:'toString()'\">\n                        <a ng-click=\"addRemove.makeAvailable(item)\" ng-bind=\"(item[addRemove.property] || item)\"></a>\n                    </li>\n                </ul>\n                <button class=\"remove-all\" ng-click=\"addRemove.removeAll()\" ng-show=\"addRemove.selected.length\">Remove All</button>\n            </rc-accordion-panel>\n        </rc-accordion>\n    </div>\n</div>\n";

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = "<div class=\"small show-for-small-only\" rc-add-remove-small ></div>\n<div class=\"large show-for-medium-up\" rc-add-remove-large ></div>\n";

/***/ },
/* 34 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-alert\" ng-class=\"rcAlertCtrl.getAlertClasses()\">\n    <a href class=\"close-button\" ng-click=\"rcAlertCtrl.close()\" ng-if=\"rcAlertCtrl.isClosable()\">&times;</a>\n    <div class=\"details\" ng-transclude></div>\n    <rc-alert-oss tla=\"rcAlertCtrl.ossInfo()\"></rc-alert-oss>\n    <div class=\"icon\">\n        <span ng-class=\"rcAlertCtrl.getTypeClass()\"></span>\n    </div>\n</div>\n";

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = "<div class=\"oss-info\" ng-if=\"rcAlertOssCtrl.display()\">\n    Contact OSS at 1 (800) 621-8953 or (402) 544-5555 Option 1,1\n    <span ng-if=\"rcAlertOssCtrl.isTla()\"> and reference {{ rcAlertOssCtrl.tla() }}.</span>\n</div>\n";

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = "<div class=\"wrapper\" ng-class=\"rcAlertsCtrl.getAlertsClasses()\">\n    <rc-alert\n        ng-repeat=\"alert in rcAlertsCtrl.alerts\"\n        type=\"{{ ::alert.type }}\"\n        close-button=\"::alert.closeButton\"\n        timeout=\"{{ alert.timeout }}\"\n        oss-info=\"::alert.tla\"\n        show-icon=\"::alert.icon\"\n        on-close=\"alert.onClose($index)\"\n        focus=\"alert.focus\">\n        <p>\n            <strong ng-if=\"alert.title\" ng-bind=\"::alert.title\"></strong>\n            <span compile=\"true\" rc-bind-html-unsafe=\"::alert.message\"></span>\n        </p>\n    </rc-alert>\n</div>\n";

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = "<footer class=\"rc-app-template-footer\" ng-if=\"$ctrl.showFooter && $ctrl.footerContent\">\n    <div>\n        <section>\n            <ul>\n                <li ng-repeat=\"link in $ctrl.footerContent\" ng-switch=\"link.filter && link.filter.length > 0\">\n                    <a ng-href=\"{{ link.url }}\" ng-bind=\"link.label\" rc-target=\"link.target\"></a>\n                </li>\n            </ul>\n        </section>\n    </div>\n</footer>\n";

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = "<rc-app-template-nav>\n    <span class=\"list-repeat\" ng-repeat=\"content in $ctrl.navContent\">\n        <rc-nested-nav label=\"{{content.label}}\" ng-if=\"$ctrl.isSubnav(content)\">\n            <span class=\"list-repeat\" ng-repeat=\"subContent in content.sub\">\n                <rc-nested-nav label=\"{{subContent.label}}\" ng-if=\"$ctrl.isSubnav(subContent)\">\n                    <span class=\"list-repeat\" ng-repeat=\"nestedSubContent in subContent.sub\">\n                        <rc-nav-link\n                            url=\"{{nestedSubContent.url}}\"\n                            target=\"{{nestedSubContent.target}}\"\n                            label=\"{{nestedSubContent.label}}\"></rc-nav-link>\n                    </span>\n                </rc-nested-nav>\n                <rc-nav-link ng-if=\"!$ctrl.isSubnav(subContent)\"\n                    url=\"{{subContent.url}}\"\n                    target=\"{{subContent.target}}\"\n                    label=\"{{subContent.label}}\"></rc-nav-link>\n            </span>\n        </rc-nested-nav>\n        <rc-nav-link ng-if=\"!$ctrl.isSubnav(content)\"\n            url=\"{{content.url}}\"\n            target=\"{{content.target}}\"\n            label=\"{{content.label}}\"></rc-nav-link>\n\n    </span>\n</rc-app-template-nav>\n";

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = "<header class=\"rc-app-template-header icon-app-header\" ng-class=\"{ 'noNav': !$ctrl.showNavBar }\">\n    <div class=\"rc-app-template-header-outer-wrapper\">\n        <div class=\"rc-app-template-header-wrapper\">\n            <a class=\"rc-app-template-logo-link\" ng-href=\"{{::$ctrl.logoLinkUrl}}\" ng-if=\"$ctrl.enableLogoLink\">\n                <div class=\"rc-app-template-logo-link-target\">\n                </div>\n            </a>\n            <div class=\"rc-app-template-titles\">\n                <h1 class=\"rc-app-template-application\" ng-bind=\"$ctrl.appTitle\"></h1>\n                <span ng-bind=\"$ctrl.pageTitle\"></span>\n            </div>\n            <div class=\"user-id\" ng-if=\"$ctrl.showUserId && $ctrl.userObj.userId\">\n                <span ng-bind=\"::$ctrl.userObj.userId\"></span>\n            </div>\n\n            <!-- Placeholder elements for rc-nav to insert itself -->\n            <div class=\"rc-app-template-navigation-container\">\n            </div>\n            <div class=\"rc-app-template-slide-menu-container\">\n            </div>\n\n            <!-- Elements instantiated if nav-content is used -->\n            <div ng-if=\"$ctrl.useDeclarativeNavigation()\">\n                <rc-app-template-nav-js nav-content=\"$ctrl.navContent\"></rc-app-template-nav-js>\n                <rc-slide-menu-nav-js nav-content=\"$ctrl.navContent\" user-obj=\"$ctrl.userObj\"></rc-app-template-nav-js>\n            </div>\n\n        </div>\n    </div>\n</header>\n<main class=\"rc-app-template-body row\">\n    <div class=\"column\">\n        <div ng-transclude></div>\n    </div>\n</main>\n<rc-app-template-footer footer-content=\"$ctrl.footerContent\" show-footer=\"$ctrl.showFooter\"></rc-app-template-footer>\n";

/***/ },
/* 40 */
/***/ function(module, exports) {

	module.exports = "<a class=\"circ7\">\n    <div class=\"row\">\n        <div class=\"small-3 columns circ7-code\" rc-bind-html-unsafe=\"match.model.circ7 | highlight:query:false: ' '\"></div>\n        <div class=\"small-6 columns\" rc-bind-html-unsafe=\"match.model.city | highlight:query\"></div>\n        <div class=\"small-2 columns\" rc-bind-html-unsafe=\"match.model.stateAbbreviation | highlight:query\"></div>\n    </div>\n</a>\n";

/***/ },
/* 41 */
/***/ function(module, exports) {

	module.exports = "<a class=\"cityState\">\n    <div class=\"row\">\n        <div class=\"small-9 columns\">\n            <span rc-bind-html-unsafe=\"match.model.name | highlight:query:false: ' '\"></span>,\n        </div>\n        <div class=\"small-3 columns\">\n            <span rc-bind-html-unsafe=\"match.model.state.abbreviation | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ },
/* 42 */
/***/ function(module, exports) {

	module.exports = "<a class=\"customer\">\n    <div class=\"row\">\n        <div class=\"small-10 columns\">\n            <span rc-bind-html-unsafe=\"match.model.fullName | highlight:query:false:' '\"></span>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"small-8 columns\">\n            <span rc-bind-html-unsafe=\"match.model.city | highlight:query\"></span>,\n        </div>\n        <div class=\"small-2 offset-2 columns\">\n            <span rc-bind-html-unsafe=\"match.model.state | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = "<ul\n    class=\"f-dropdown rc-autocomplete-dropdown\"\n    rc-scroller\n    ng-style=\"{ display: rcAcDropCtrl.showMatches() && 'block' || 'none', top: rcAcDropCtrl.position.top+'px', left: rcAcDropCtrl.position.left+'px' }\"\n>\n    <li\n        ng-repeat=\"match in rcAcDropCtrl.matches\"\n        ng-class=\"{active: rcAcDropCtrl.isActive($index)}\"\n        ng-mouseenter=\"rcAcDropCtrl.selectActive($index)\"\n        ng-mousedown=\"rcAcDropCtrl.selectMatch($index)\"\n        rc-scroll-if=\"rcAcDropCtrl.isActive($index)\"\n    >\n        <rc-autocomplete-match index=\"$index\" match=\"match\" query=\"rcAcDropCtrl.query\" template-url=\"templateUrl\"></rc-autocomplete-match>\n    </li>\n</ul>\n";

/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = "<a tabindex=\"-1\" rc-bind-html-unsafe=\"match.label | highlight:query\"></a>\n";

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-autocomplete-multiple\" ng-show=\"rcAcMultiCtrl.items.length > 0\">\n    <div class=\"rc-autocomplete-multiple-item\" ng-repeat=\"item in rcAcMultiCtrl.items\" tabindex=\"0\" ng-keydown=\"rcAcMultiCtrl.keyPressed($event, $index)\">\n        <div class=\"rc-autocomplete-multiple-remove\" ng-click=\"rcAcMultiCtrl.removeItem($index)\" >\n            <span class=\"icon close inverted\" ></span>\n        </div>\n        <div class=\"rc-autocomplete-multiple-item-label\" >{{ rcAcMultiCtrl.formatForDisplay(item) }}</div>\n    </div>\n</div>\n\n";

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = "<a class=\"person\">\n    <div class=\"row\">\n        <div class=\"small-6 columns\"><div rc-bind-html-unsafe=\"match.model.fullName | highlight:query:false:' '\"></div></div>\n        <div class=\"small-3 columns\"><span rc-bind-html-unsafe=\"match.model.employeeId | highlight:query\"></span></div>\n        <div class=\"small-3 columns\"><span rc-bind-html-unsafe=\"match.model.userId | highlight:query\"></span></div>\n    </div>\n</a>\n";

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = "<a class=\"splc\">\n    <div class=\"row\">\n        <div class=\"small-9 columns\">\n            <span rc-bind-html-unsafe=\"match.model.name | highlight:query:false: ' '\"></span>,\n        </div>\n        <div class=\"small-3 columns\">\n            <span rc-bind-html-unsafe=\"match.model.state.abbreviation | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports = "<a class=\"stcc\">\n    <div class=\"row\">\n        <div class=\"small-3 columns\">\n            <div rc-bind-html-unsafe=\"match.model.stcc | highlight:query:false: ' '\"></div>\n        </div>\n        <div class=\"small-9 columns\">\n            <span rc-bind-html-unsafe=\"match.model.description | capitalize | highlight:query\"></span>\n        </div>\n    </div>\n</a>\n";

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = "<rc-autocomplete-multiple ng-if=\"rcAcCtrl.multiple\"></rc-autocomplete-multiple>\n";

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-calendar-date-number\" ng-bind=\"::rcCalDayCtrl.number()\"></div>\n<div class=\"rc-calendar-indicator\"></div>\n";

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-calendar-month-heading\" ng-bind=\"::rcCalMCtrl.heading\"></div>\n<rc-calendar-week-headers></rc-calendar-week-headers>\n<rc-calendar-week ng-repeat=\"week in ::rcCalMCtrl.weeks track by $index\" item=\"week\"></rc-calendar-week>";

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = "<rc-calendar-popup\n    class=\"noselect\"\n    custom-holidays=\"rcCalCtrl.appHolidays()\"\n    disabled-dates=\"rcCalCtrl.disabledDates\"\n    focused-date=\"rcCalCtrl.focusedDate\"\n    is-range=\"rcCalCtrl.pickRange\"\n    minimum-date=\"rcCalCtrl.minDate()\"\n    maximum-date=\"rcCalCtrl.maxDate()\"\n    ok-button=\"rcCalCtrl.okButton\"\n    on-complete=\"rcCalCtrl.onSelectionComplete($selected)\"\n    selected-date=\"rcCalCtrl.getInputModel()\"\n    today-button=\"rcCalCtrl.todayButton\"\n    up-holidays=\"rcCalCtrl.holidays()\"\n></rc-calendar-popup>\n\n\n";

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-calendar-control\" ng-transclude=\"controls\" >\n    <a class=\"rc-calendar-today-button button\"\n        ng-if=\"::rcCalPopCtrl.todayButton()\"\n        ng-click=\"rcCalPopCtrl.focusToday()\"\n        href>Today</a>\n    <a class=\"rc-calendar-ok-button button\"\n        ng-if=\"rcCalPopCtrl.showOkButton()\"\n        ng-click=\"rcCalPopCtrl.complete()\"\n        href>OK</a>\n    <a class=\"rc-calendar-close button icon close\"\n        ng-click=\"rcCalPopCtrl.cancel()\"\n        href\n    ></a>\n</div>\n<div class=\"rc-calendar-content\" ng-transclude=\"content\" >\n    <rc-calendar-scroll-content></rc-calendar-scroll-content>\n</div>\n";

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-calendar-scroll-y\" rc-isolate-scroll=\"rcCalScrlCtrl.onBoundary($boundary, $event)\">\n    <div class=\"rc-calendar-scroll-month\" ng-repeat=\"month in rcCalScrlCtrl.months\">\n        <rc-calendar-month item=\"month\">\n    </div> \n</div>\n";

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-calendar-week-heading\"\n    ng-repeat=\"day in ::rcCalWHCtrl.days\">{{::day | firstLetter}}</div>";

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = "<rc-calendar-day \n    ng-repeat=\"day in ::rcCalWeekCtrl.week track by $index\" \n    item=\"day\"></rc-calendar-day>\n";

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports = "<div class=\"button-addon\">\n    <span class=\"buttonfix\"><button\n        type=\"button\"\n        class=\"icon calendar\"\n        ng-click=\"rcCalCtrl.togglePopup()\"\n        ng-keydown=\"rcCalCtrl.buttonKeydown($event)\"\n        rc-focus=\"rcCalCtrl.focusCalendarButton\"\n    ></button></span>\n</div>\n\n";

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-box\"></div>\n<div class=\"rc-mark\"></div>\n<label ng-transclude></label>\n";

/***/ },
/* 59 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-groupbox-heading\" rc-content-replace=\"rcGBCtrl.heading\"></div>\n<div class=\"rc-groupbox-content rc-container\" ng-transclude></div>\n";

/***/ },
/* 60 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-loading-backdrop\" ></div>\n";

/***/ },
/* 61 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-loading-content\">\n    <div class=\"rc-loading-animation\"></div>\n    <div class=\"rc-loading-title\" ng-switch=\"inline\">\n        <span ng-if=\"condition\" ng-switch-when=\"true\" rc-tooltip=\"{{message}}\">Loading</span>\n        <span ng-switch-default>Loading</span>\n    </div>\n    <div class=\"rc-loading-message\">{{message}}</div>\n</div>";

/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-modal {{windowClass}}\" >\n    <div class=\"rc-modal-title\" ng-show=\"title.length > 0\">{{title}}</div>\n    <div class=\"rc-modal-content-wrap\" ng-style=\"{ 'max-height': maxHeight, 'max-width': maxWidth }\">\n        <div class=\"rc-modal-content\" ng-transclude></div>\n    </div>\n    <div class=\"rc-modal-cancel\" ng-show=\"includeCancel\" ng-click=\"cancelModal()\">\n        <a href class=\"icon close inverted\"></a>\n    </div>\n</div>\n\n";

/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = "<rc-app-template-nav logout=\"{{$ctrl.logout}}\">\n    <ng-transclude></ng-transclude>\n</rc-app-template-nav>\n";

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = "<nav ng-class=\"[direction || 'right']\" class=\"rc-app-template-navigation-mobile\">\n    <a class=\"rc-slidemenu-button\" ng-click=\"slideMenu.toggleStates()\" ng-class=\"{ 'selected': open }\"></a>\n    <div class=\"rc-slidemenu-content\" ng-class=\"{ 'open': slideMenu.open, 'closed': !slideMenu.open }\">\n        <div ng-transclude=\"header\" class=\"rc-slidemenu-transclude\"></div> <!-- top of transcluded content -->\n\n        <div ng-click=\"slideMenu.closeMenu($event)\">\n            <ul rc-listview inset=\"false\" class=\"noselect\">\n                <div ng-transclude=\"nav\"></div>\n                <rc-nav-link ng-if=\"!!slideMenu.rcAppTemplate.logoutLink\">\n                    <a class=\"logout-link\" ng-href=\"{{::slideMenu.rcAppTemplate.logoutLink}}\">Logout</a>\n                </rc-nav-link>\n            </ul>\n        </div>\n    </div>\n    <rc-overlay opacity=\"0.25\" class=\"rc-slidemenu-overlay\" ng-click=\"slideMenu.closeMenu($event)\" ng-if=\"slideMenu.open\"></rc-overlay>\n</nav>\n";

/***/ },
/* 65 */
/***/ function(module, exports) {

	module.exports = "<a class=\"close-button icon close\" ng-click=\"close();\"></a>\n<p class=\"text\">No Internet connection detected. The application will automatically try to reconnect when it detects an Internet connection.</p>\n";

/***/ },
/* 66 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-overlay\" ng-style=\"{ 'background-color': 'rgba(0, 0, 0, {{ opacity || 0.0}})', 'z-index': z || auto }\"></div>\n";

/***/ },
/* 67 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-reauthenticate\">\n    <iframe src=\"/secure/\" rc-reauthenticate-iframe-onload=\"verifyLocationHref(locationHref)\"></iframe>\n</div>\n";

/***/ },
/* 68 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"medium-8 large-6 medium-centered column\">\n    <rc-groupbox heading=\"This page has moved\">\n      <p>You've reached a page that has been deprecated. You will be forwarded to <a ng-href=\"{{ ::redirector.redirectTo }}\" ng-bind=\"::redirector.redirectTo\"></a> in <span ng-bind=\"::redirector.timeout | msToS:true\"></span>.</p>\n      <div ng-transclude></div>\n      <!-- <div class=\"row\">\n        <div class=\"medium-10 large-6 medium-centered column\">\n          <button class=\"expand\" ng-click=\"redirector.cancelTimeout()\">Cancel Redirect</button>\n        </div>\n      </div> -->\n    </rc-groupbox>\n  </div>\n</div>\n";

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = "<rc-slide-menu-nav>\n    <slide-menu-nav>\n        <div ng-repeat=\"content in $ctrl.navContent\">\n            <rc-slide-menu-nested-nav ng-if=\"$ctrl.isSubnav(content)\" label=\"{{::content.label}}\">\n                <div ng-repeat=\"subContent in content.sub\">\n                    <rc-slide-menu-nested-nav ng-if=\"$ctrl.isSubnav(subContent)\"\n                        label=\"{{::subContent.label}}\">\n                        <rc-nav-link ng-repeat=\"nestedSubContent in subContent.sub\"\n                            url=\"{{::nestedSubContent.url}}\" label=\"{{::nestedSubContent.label}}\"></rc-nav-link>\n                    </rc-slide-menu-nested-nav>\n                    <rc-nav-link ng-if=\"!$ctrl.isSubnav(subContent)\"\n                        url=\"{{::subContent.url}}\" label=\"{{::subContent.label}}\"></rc-nav-link>\n                </div>\n            </rc-slide-menu-nested-nav>\n            <rc-nav-link ng-if=\"!$ctrl.isSubnav(content)\"\n                url=\"{{::content.url}}\" label=\"{{::content.label}}\"></rc-nav-link>\n        </div>\n    <slide-menu-nav>\n</rc-slide-menu-nav>\n";

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = "<li>\n    <span ng-click=\"nestedNav.toggleVisibility()\"\n        ng-bind=\"nestedNav.label\"></span>\n    <div ng-class=\"{open: nestedNav.isActive()}\" class=\"subcontent-wrapper\">\n        <span ng-click=\"nestedNav.toggleVisibility()\"\n            class=\"open\" ng-bind=\"nestedNav.label\"></span>\n            <ul>\n                <ng-transclude></ng-transclude>\n            </ul>\n    </div>\n</li>\n";

/***/ },
/* 71 */
/***/ function(module, exports) {

	module.exports = "<rc-slide-menu-nav>\n    <ng-transclude></ng-transclude>\n</rc-slide-menu-nav>\n";

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = "<span class=\"rc-smart-menu\"\n    tabindex=\"0\"\n    ng-class=\"{ 'current': rcSMCtrl.isOpen }\"\n    ng-click=\"rcSMCtrl.toggleSmartMenu($event)\"\n    ng-keyup=\"rcSMCtrl.toggleSmartMenu($event)\">\n    <span class=\"rc-smart-menu-label\"><span ng-transclude></span></span>\n</span>\n";

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = "<section class=\"additional-content\" ng-show=\"rcSMCtrl.hasSummaryContent()\">\n    <table>\n        <tbody>\n            <tr ng-repeat=\"data in rcSMCtrl.summaryContent\" ng-show=\"data.value\">\n                <td class=\"key\">{{ ::data.label }}</td>\n                <td class=\"value\">{{ ::data.value }}</td>\n            </tr>\n        </tbody>\n    </table>\n</section>\n<ul class=\"rc-smart-menu-items\" ng-class=\"{ 'rounded': !rcSMCtrl.summaryContent.length }\">\n    <li ng-repeat=\"item in rcSMCtrl.menuItems\"\n        ng-class=\"{ 'error': item.error, 'default': rcSMCtrl.additionalItems.length && $index > rcSMCtrl.additionalItems.length-1 }\"\n        ng-switch=\"item.url && item.url.length > 0\">\n        <a\n            ng-switch-when=\"true\"\n            ng-click=\"rcSMCtrl.publishClick($event, item)\"\n            ng-href=\"{{ ::item.url }}\"\n            rc-target=\"::item.target || '_blank'\"\n        >{{ ::item.label }}</a>\n        <span\n            ng-switch-default\n            ng-click=\"rcSMCtrl.handleCallback($event, item)\"\n            ng-keyup=\"rcSMCtrl.handleCallback($event, item)\"\n            tabindex=\"0\"\n        >{{ ::item.label }}</span>\n    </li>\n</ul>\n";

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = "<tr>\n    <th ng-repeat=\"column in $columns\"\n        ng-class=\"{\n                    'sortable': parse(column.sortable),\n                    'sort-asc': params.sorting()[parse(column.sortable)] === 'asc',\n                    'sort-desc': params.sorting()[parse(column.sortable)] === 'desc'\n                  }\"\n        ng-click=\"sortBy(column, $event)\"\n        ng-keyup=\"sortBy(column, $event)\"\n        tabindex=\"{{column.tabindex}}\"\n        ng-show=\"column.show(this)\"\n        ng-init=\"template = column.headerTemplateURL(this)\"\n        class=\"header {{column.class}} {{column.sortIndex(this)}}\"\n    >\n        <div ng-if=\"!template\" ng-show=\"!template\" ng-bind=\"parse(column.title)\"></div>\n        <div ng-if=\"template\" ng-show=\"template\">\n            <div ng-include=\"template\"></div>\n        </div>\n    </th>\n</tr>\n<tr ng-if=\"showFilter\" class=\"rc-table-filters\">\n    <th ng-repeat=\"column in $columns\" ng-show=\"column.show(this)\" class=\"filter\" ng-class=\"{\n                'rc-toggle-cell-hidden': !rcToggled[$index].on && rcToggled[$index].forced,\n                'rc-toggle-cell-visible': rcToggled[$index].on && rcToggled[$index].forced,\n            }\">\n        <div ng-repeat=\"(name, filter) in column.filter\">\n            <div ng-if=\"column.filterTemplateURL\" ng-show=\"column.filterTemplateURL\">\n                <div ng-include=\"column.filterTemplateURL\"></div>\n            </div>\n            <div ng-if=\"!column.filterTemplateURL\" ng-show=\"!column.filterTemplateURL\">\n                <!--div ng-include=\"'src/table/templates/table-' + filter + '.html'\"></div-->\n                <div table-text-filter ></div>\n            </div>\n        </div>\n    </th>\n</tr>\n";

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = "<input type=\"text\" name=\"{{column.filterName}}\" ng-model=\"params.filter()[name]\" ng-if=\"filter == 'text'\" class=\"input-filter form-control\" />\n";

/***/ },
/* 76 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-table-container\">\n    <div class=\"rc-table-controls row\" ng-hide=\"hideControls\">\n        <div class=\"small-6 column\">\n            <button ng-show=\"params.isGroupedBy()\"\n                ng-click=\"params.toggleGroups()\"\n                class=\"rc-expand-all\"\n                ng-bind=\"getExpandAllText(params)\">\n            </button>\n        </div>\n        <div toggle-dropdown class=\"rc-toggle-dropdown-container small-6 column\" ng-if=\"showToggleDropdown\">\n            <button class='rc-column-toggle-btn radius round flat'><i class='rc-dropdown'></i>Display</button>\n            <div class='joyride-tip-guide fade in rc-column-list'>\n                <span class=\"joyride-nub top\"></span>\n                <div class='joyride-content-wrapper'>\n                    <ul>\n                        <li class=\"rc-table-clickable-dropdown-item\" ng-repeat=\"column in $columns\" ng-click='rcToggleColumn($index, !rcToggled[$index].on)' ng-hide='rcToggled[$index].on === \"persist\"'>\n                            <rc-checkbox>\n                            <input type=\"checkbox\" rc-toggle-priority='{{column.rcTogglePriority}}' ng-model=\"rcToggled[$index].on\" id=\"rc-toggle-dropdown-{{$index}}\">\n                            </rc-checkbox>\n                            <span class=\"rc-table-column-toggle-label\" ng-bind=\"column.title()\"></span>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"rc-table-parent\">\n    </div>\n</div>\n\n";

/***/ },
/* 77 */
/***/ function(module, exports) {

	module.exports = "<ng-transclude class=\"rc-tab-content\" ng-class=\"{ 'active': rcTabCtrl.active }\"></ng-transclude>\n";

/***/ },
/* 78 */
/***/ function(module, exports) {

	module.exports = "<a href class=\"rc-tabset-scroll-left noselect\"></a>\n<div class=\"rc-tab-heading\"\n    ng-repeat=\"tab in rcTsHdrCtrl.tabs()\"\n    ng-class=\"{ 'active': tab.active, 'disabled': tab.disabled }\">\n    <a href ng-click=\"rcTsHdrCtrl.select(tab)\" rc-content-replace=\"tab.heading\"></a>\n</div>\n<a href class=\"rc-tabset-scroll-right noselect\"></a>\n";

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = "<rc-tabset-header class=\"noselect\" tabs=\"rcTabsetCtrl.tabs\"></rc-tabset-header>\n<ng-transclude class=\"rc-tabset-content rc-container\"></ng-transclude>\n";

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = "<span class=\"tooltip tip-{{placement}}\"\n  ng-class=\"{ in: isOpen(), fade: animation() }\">\n  <span rc-bind-html-unsafe=\"content\"></span>\n  <span class=\"nub\"></span>\n</span>\n";

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports = "<span class=\"tooltip tip-{{::placement}}\"\n  ng-class=\"{ in: isOpen(), fade: animation() }\">\n  <span ng-bind=\"content\"></span>\n  <span class=\"nub\"></span>\n</span>\n";

/***/ },
/* 82 */
/***/ function(module, exports) {

	module.exports = "<rc-alert class=\"rc-form-errors\" type=\"error\" close-button=\"false\" ng-show=\"showErrors\">\n    <h2 class=\"rc-form-errors-header\">Correct the following:</h2>\n    <div ng-repeat=\"error in errors\">\n        <rc-input-field-errors\n            ng-model-controller=\"error.modelController\"\n            focus-on-click=\"error.element\"\n            field-label=\"{{::error.fieldLabel}}\" />\n    </div>\n</rc-alert>\n";

/***/ },
/* 83 */
/***/ function(module, exports) {

	module.exports = "<ul class=\"rc-input-field-errors-list\"\n    ng-class=\"{ 'rc-input-field-errors-clickable': clickable }\"\n    ng-messages=\"ngModelController.$error\"\n    ng-show=\"ngModelController.showError\"\n    ng-click=\"focus()\">\n\n    <div ng-repeat=\"error in ::errorMessages\" class=\"rc-error-message-{{::error.label}}\">\n        <div ng-message-exp=\"error.label\" class=\"rc-error-message\">\n            <li><span rc-bind-html-unsafe=\"::error.message\"></li>\n        </div>\n    </div>\n</ul>\n";

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = "<div class=\"rc-wizard-steps\">\n    <a class=\"header button fit-text\"\n        ng-repeat=\"step in rcWzCtrl.enabledSteps\"\n        ng-click=\"rcWzCtrl.setActive($index);\"\n        ng-class=\"{ 'active': $index === rcWzCtrl.currentStep,\n            'not-completed': $index > rcWzCtrl.currentStep,\n            'completed': $index < rcWzCtrl.currentStep,\n            'is-disabled': !rcWzCtrl.validUpTo($index) }\">\n            <span class=\"stepNumber\" ng-bind=\"($index+1)\"></span> <span ng-bind=\"step.heading\"></span>\n    </a>\n</div>\n<div class=\"rc-wizard-step-content rc-container\">\n    <div ng-transclude></div>\n</div>\n<div class=\"rc-wizard-buttons\" rc-wizard-prev-next></div>\n";

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row prev-next\">\n    <div class=\"small-4 medium-3 columns\">\n        <button type=\"button\" ng-click=\"rcWzCtrl.previousStep();\" ng-if=\"rcWzCtrl.currentStep > 0\">Back</button>\n        <span ng-if=\"rcWzCtrl.currentStep === 0\">&nbsp;</span>\n    </div>\n    <div class=\"small-4 medium-6 columns indicators\">\n        <span ng-repeat=\"step in rcWzCtrl.enabledSteps\" class=\"indicator\" ng-class=\"{ 'active': step.isActive() }\"></span>\n    </div>\n    <div class=\"text-right small-4 medium-3 columns\" ng-switch=\"rcWzCtrl.enabledSteps[rcWzCtrl.enabledSteps.length - 1].isActive()\">\n        <button ng-switch-when=\"true\" class=\"primary\" ng-click=\"rcWzCtrl.finish();\">Submit</button>\n        <button ng-switch-default type=\"button\" class=\"primary\" ng-click=\"rcWzCtrl.nextStep();\">Next</button>\n    </div>\n</div>\n\n";

/***/ },
/* 86 */
/***/ function(module, exports) {

	module.exports = "<section class=\"rc-wizard-step\" ng-class=\"{ 'active': isActive() }\" ng-transclude></section>\n";

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _accordion = __webpack_require__(89);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _accordion3 = __webpack_require__(30);
	
	var _accordion4 = _interopRequireDefault(_accordion3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        closeOthers: '&'
	    },
	    controller: _accordion2.default,
	    controllerAs: 'rcAccCtrl',
	    transclude: true,
	    template: _accordion4.default
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _accordionController = __webpack_require__(90);
	
	var _accordionController2 = _interopRequireDefault(_accordionController);
	
	var _accordionPanel = __webpack_require__(29);
	
	var _accordionPanel2 = _interopRequireDefault(_accordionPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        heading: '@?',
	        isOpen: '=?'
	    },
	    require: {
	        accordionCtrl: '^rcAccordion'
	    },
	    controller: _accordionController2.default,
	    controllerAs: 'rcAccPnlCtrl',
	    template: _accordionPanel2.default,
	    transclude: true
	};

/***/ },
/* 89 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DEFAULT_CLOSE_OTHERS = true;
	
	var RcAccordionController = function () {
	    RcAccordionController.$inject = ["Usage"];
	    function RcAccordionController(Usage) {
	        'ngInject';
	
	        _classCallCheck(this, RcAccordionController);
	
	        Usage.register('accordion');
	
	        this.panels = [];
	    }
	
	    _createClass(RcAccordionController, [{
	        key: 'addPanel',
	        value: function addPanel(panel) {
	            this.panels.push(panel);
	        }
	    }, {
	        key: 'closeOtherPanels',
	        value: function closeOtherPanels(openPanel) {
	            if (this.shouldCloseOthers()) {
	                angular.forEach(this.panels, function (panel) {
	                    if (panel !== openPanel) {
	                        panel.isOpen = false;
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'removePanel',
	        value: function removePanel(panel) {
	            var index = this.panels.indexOf(panel);
	            if (index !== -1) {
	                this.panels.splice(index, 1);
	            }
	        }
	    }, {
	        key: 'shouldCloseOthers',
	        value: function shouldCloseOthers() {
	            var configuredClose = this.closeOthers();
	            return angular.isDefined(configuredClose) ? configuredClose : DEFAULT_CLOSE_OTHERS;
	        }
	    }]);
	
	    return RcAccordionController;
	}();
	
	exports.default = RcAccordionController;

/***/ },
/* 90 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ACTIVE_PANEL_CLASS = 'active';
	
	var RcAccordionPanelController = function () {
	    RcAccordionPanelController.$inject = ["$scope", "KEYS", "$element"];
	    function RcAccordionPanelController($scope, KEYS, $element) {
	        'ngInject';
	
	        _classCallCheck(this, RcAccordionPanelController);
	
	        this.KEYS = KEYS;
	        this.$scope = $scope;
	        this.$element = $element;
	    }
	
	    _createClass(RcAccordionPanelController, [{
	        key: 'isNonEnterKeyup',
	        value: function isNonEnterKeyup(event) {
	            // TODO: extract to KEYS Util
	            return event.type === 'keyup' && event.which !== this.KEYS.ENTER;
	        }
	    }, {
	        key: 'setHeading',
	        value: function setHeading(heading) {
	            this.heading = heading;
	        }
	    }, {
	        key: 'toggleHeading',
	        value: function toggleHeading(event) {
	            if (this.isNonEnterKeyup(event)) {
	                return;
	            }
	
	            this.isOpen = !this.isOpen;
	
	            if (angular.isFunction(this.headerClick)) {
	                this.headerClick();
	            }
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.accordionCtrl.addPanel(this);
	
	            var removeIsOpenWatch = this.$scope.$watch('rcAccPnlCtrl.isOpen', function (value) {
	                if (value) {
	                    _this.accordionCtrl.closeOtherPanels(_this);
	                    _this.$element.addClass(ACTIVE_PANEL_CLASS);
	                } else {
	                    _this.$element.removeClass(ACTIVE_PANEL_CLASS);
	                }
	            });
	
	            this.$scope.$on('$destroy', function () {
	                _this.accordionCtrl.removePanel(_this);
	                removeIsOpenWatch();
	            });
	        }
	    }]);
	
	    return RcAccordionPanelController;
	}();
	
	exports.default = RcAccordionPanelController;

/***/ },
/* 91 */
/***/ function(module, exports) {

	'use strict';
	
	RcAccordionHeadingDirective.$inject = ["$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcAccordionHeadingDirective;
	function RcAccordionHeadingDirective($parse) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        require: '^rcAccordionPanel',
	        transclude: true,
	        link: RcAccordionHeadingLink
	    };
	
	    function RcAccordionHeadingLink(scope, element, attrs, panelCtrl, transclude) {
	        panelCtrl.setHeading(transclude(scope, angular.noop));
	        panelCtrl.headerClick = function () {
	            return $parse(attrs.ngClick)(scope);
	        };
	    }
	}

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _contentReplace = __webpack_require__(7);
	
	var _contentReplace2 = _interopRequireDefault(_contentReplace);
	
	var _accordion = __webpack_require__(87);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _accordionComponent = __webpack_require__(88);
	
	var _accordionComponent2 = _interopRequireDefault(_accordionComponent);
	
	var _accordionDirective = __webpack_require__(91);
	
	var _accordionDirective2 = _interopRequireDefault(_accordionDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.accordion', [_usage2.default.name, _keyboardNavigation2.default.name, _contentReplace2.default.name]).component('rcAccordion', _accordion2.default).component('rcAccordionPanel', _accordionComponent2.default).directive('rcAccordionHeading', _accordionDirective2.default);

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _addRemove = __webpack_require__(94);
	
	var _addRemove2 = _interopRequireDefault(_addRemove);
	
	var _addRemove3 = __webpack_require__(33);
	
	var _addRemove4 = _interopRequireDefault(_addRemove3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: potentially break template out to sub-components
	exports.default = {
	    bindings: {
	        available: '=',
	        selected: '=',
	        displayProperty: '=?'
	    },
	    controller: _addRemove2.default,
	    controllerAs: 'addRemove',
	    template: _addRemove4.default
	};

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function swapOut(items, from, to) {
	    angular.forEach(items, function (item) {
	        from.splice(from.indexOf(item), 1);
	        to.push(item);
	    });
	}
	
	var RcAddRemoveController = function () {
	    RcAddRemoveController.$inject = ["$element", "Usage"];
	    function RcAddRemoveController($element, Usage) {
	        'ngInject';
	
	        _classCallCheck(this, RcAddRemoveController);
	
	        $element.addClass('rc-add-remove');
	        Usage.register('addRemove');
	
	        this.addRem = [];
	        this.addSel = [];
	        this.available = this.available || [];
	        this.selected = this.selected || [];
	        this.displayProperty = this.displayProperty || '';
	    }
	
	    _createClass(RcAddRemoveController, [{
	        key: 'addAll',
	        value: function addAll() {
	            this.selected = this.selected.concat(this.available);
	            this.available = [];
	            this.addRem = [];
	        }
	    }, {
	        key: 'makeAllAvailable',
	        value: function makeAllAvailable() {
	            swapOut(this.addSel, this.selected, this.available);
	            this.addSel = [];
	        }
	    }, {
	        key: 'makeAllSelected',
	        value: function makeAllSelected() {
	            swapOut(this.addRem, this.available, this.selected);
	            this.addRem = [];
	        }
	    }, {
	        key: 'makeAvailable',
	        value: function makeAvailable(item) {
	            this.available.push(item);
	            this.selected.splice(this.selected.indexOf(item), 1);
	        }
	    }, {
	        key: 'makeSelected',
	        value: function makeSelected(item) {
	            this.selected.push(item);
	            this.available.splice(this.available.indexOf(item), 1);
	        }
	    }, {
	        key: 'removeAll',
	        value: function removeAll() {
	            this.available = this.available.concat(this.selected);
	            this.selected = [];
	            this.addSel = [];
	        }
	    }]);
	
	    return RcAddRemoveController;
	}();
	
	exports.default = RcAddRemoveController;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcAddRemoveLargeDirective;
	
	var _addRemoveLarge = __webpack_require__(31);
	
	var _addRemoveLarge2 = _interopRequireDefault(_addRemoveLarge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should likely become a non-data-mutating component
	function RcAddRemoveLargeDirective() {
	    return {
	        restrict: 'A',
	        template: _addRemoveLarge2.default
	    };
	}

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcAddRemoveSmallDirective;
	
	var _addRemoveSmall = __webpack_require__(32);
	
	var _addRemoveSmall2 = _interopRequireDefault(_addRemoveSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should likely become a non-data-mutating component
	function RcAddRemoveSmallDirective() {
	    return {
	        restrict: 'A',
	        template: _addRemoveSmall2.default
	    };
	}

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _listview = __webpack_require__(21);
	
	var _listview2 = _interopRequireDefault(_listview);
	
	var _groupbox = __webpack_require__(16);
	
	var _groupbox2 = _interopRequireDefault(_groupbox);
	
	var _addRemove = __webpack_require__(93);
	
	var _addRemove2 = _interopRequireDefault(_addRemove);
	
	var _addRemoveDirective = __webpack_require__(96);
	
	var _addRemoveDirective2 = _interopRequireDefault(_addRemoveDirective);
	
	var _addRemoveDirective3 = __webpack_require__(95);
	
	var _addRemoveDirective4 = _interopRequireDefault(_addRemoveDirective3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.addRemove', [_listview2.default.name, _groupbox2.default.name]).component('rcAddRemove', _addRemove2.default)
	/* TODO: Refactor to components */
	.directive('rcAddRemoveSmall', _addRemoveDirective2.default).directive('rcAddRemoveLarge', _addRemoveDirective4.default);

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _alert = __webpack_require__(100);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _alert3 = __webpack_require__(34);
	
	var _alert4 = _interopRequireDefault(_alert3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        type: '@',
	        timeoutMs: '@timeout',
	        closeButton: '&',
	        showIcon: '&',
	        ossInfo: '&', // Cannot be changed to '&' because it can take strings or variables
	        onClose: '&',
	        focus: '&'
	    },
	    controller: _alert2.default,
	    controllerAs: 'rcAlertCtrl',
	    template: _alert4.default,
	    transclude: true
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _alertController = __webpack_require__(101);
	
	var _alertController2 = _interopRequireDefault(_alertController);
	
	var _alertOss = __webpack_require__(35);
	
	var _alertOss2 = _interopRequireDefault(_alertOss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        tla: '&'
	    },
	    controller: _alertController2.default,
	    controllerAs: 'rcAlertOssCtrl',
	    template: _alertOss2.default
	};

/***/ },
/* 100 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcAlertController = function () {
	    RcAlertController.$inject = ["$scope", "$element", "$timeout", "Usage"];
	    function RcAlertController($scope, $element, $timeout, Usage) {
	        'ngInject';
	
	        _classCallCheck(this, RcAlertController);
	
	        Usage.register('alert');
	
	        this.$scope = $scope;
	        this.$element = $element;
	        this.$timeout = $timeout;
	    }
	
	    _createClass(RcAlertController, [{
	        key: 'close',
	        value: function close() {
	            this.onClose();
	            this.closeAlert = true;
	        }
	    }, {
	        key: 'getAlertClasses',
	        value: function getAlertClasses() {
	            return [this.getTypeClass(), this.showIcon() !== false ? 'show-icon' : null, this.closeAlert ? 'close-alert' : null];
	        }
	    }, {
	        key: 'getTypeClass',
	        value: function getTypeClass() {
	            return this.type || 'info';
	        }
	    }, {
	        key: 'isClosable',
	        value: function isClosable() {
	            return this.closeButton() !== false;
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.onClose = angular.isFunction(this.onClose) ? this.onClose : angular.noop;
	            this.timeoutMs = angular.isDefined(this.timeoutMs) ? this.timeoutMs : null;
	
	            this.$scope.$watch(function () {
	                return _this.focus();
	            }, function (val) {
	                if (val && typeof val === 'boolean' && _this.isClosable()) {
	                    _this.$scope.$evalAsync(function () {
	                        _this.$element.find('a')[0].focus();
	                    });
	                }
	            });
	
	            if (this.timeoutMs && /^\d+$/.test(this.timeoutMs)) {
	                this.$timeout(function () {
	                    if (!_this.closeAlert) {
	                        _this.close();
	                    }
	                }, parseInt(this.timeoutMs, 10));
	            }
	        }
	    }]);
	
	    return RcAlertController;
	}();
	
	exports.default = RcAlertController;

/***/ },
/* 101 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcAlertOssController = function () {
	    function RcAlertOssController() {
	        'ngInject';
	
	        _classCallCheck(this, RcAlertOssController);
	    }
	
	    _createClass(RcAlertOssController, [{
	        key: 'display',
	        value: function display() {
	            return this.tla() === true || this.isTla();
	        }
	    }, {
	        key: 'isTla',
	        value: function isTla() {
	            var tla = this.tla();
	            return angular.isString(tla) && tla.trim().length > 0;
	        }
	    }]);
	
	    return RcAlertOssController;
	}();
	
	exports.default = RcAlertOssController;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _alert = __webpack_require__(98);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _alertComponent = __webpack_require__(99);
	
	var _alertComponent2 = _interopRequireDefault(_alertComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.alert', [_usage2.default.name]).component('rcAlert', _alert2.default).component('rcAlertOss', _alertComponent2.default);

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _alerts = __webpack_require__(104);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _alerts3 = __webpack_require__(36);
	
	var _alerts4 = _interopRequireDefault(_alerts3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        alerts: '=',
	        position: '@'
	    },
	    controller: _alerts2.default,
	    controllerAs: 'rcAlertsCtrl',
	    template: _alerts4.default
	};

/***/ },
/* 104 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcAlertsController = function () {
	    RcAlertsController.$inject = ["$element", "Usage"];
	    function RcAlertsController($element, Usage) {
	        'ngInject';
	
	        _classCallCheck(this, RcAlertsController);
	
	        $element.addClass('rc-alerts');
	        Usage.register('alerts');
	    }
	
	    _createClass(RcAlertsController, [{
	        key: 'getAlertsClasses',
	        value: function getAlertsClasses() {
	            if (angular.isString(this.position) && this.position.trim().length > 0) {
	                return ['rc-alerts-positioned', this.position];
	            }
	            return '';
	        }
	    }]);
	
	    return RcAlertsController;
	}();
	
	exports.default = RcAlertsController;

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcAlertsProvider;
	function RcAlertsProvider() {
	
	    $rcAlertsService.$inject = ["$rootScope", "$timeout"];
	    var defaults = this.defaults = {
	        icon: true,
	        closeButton: true,
	        tla: '',
	        timeout: 10000,
	        onClose: angular.noop,
	        clearOnChangeEvent: false,
	        stateChangeEvent: '$routeChangeSuccess',
	        focus: false
	    };
	
	    this.clearOnChangeEvent = function () {
	        defaults.clearOnChangeEvent = true;
	        return this;
	    };
	
	    this.config = function (configObj) {
	        angular.extend(defaults, configObj);
	        return this;
	    };
	
	    this.focusAlerts = function () {
	        defaults.focus = true;
	    };
	
	    this.$get = $rcAlertsService;
	
	    function $rcAlertsService($rootScope, $timeout) {
	        'ngInject';
	
	        var alert = {};
	
	        alert.alerts = [];
	
	        // TODO: See about refactoring to a single JSON object. 9 arguments is a bit overmuch...
	        alert.add = function (message, title, type, icon, closeButton, tla, timeout, onClose, focus) {
	            if (!!(timeout || defaults.timeout) && !onClose) {
	                onClose = function onClose(index) {
	                    alert.remove(index);
	                };
	            }
	
	            removeFocusFromAlerts();
	
	            alert.alerts.push({
	                message: message,
	                title: title,
	                type: type,
	                icon: typeof icon === 'boolean' ? icon : defaults.icon,
	                closeButton: typeof closeButton === 'boolean' ? closeButton : defaults.closeButton,
	                tla: tla || defaults.tla,
	                timeout: typeof timeout === 'boolean' || !!timeout ? timeout : defaults.timeout,
	                onClose: angular.isFunction(onClose) ? onClose : defaults.onClose,
	                focus: typeof focus === 'boolean' ? focus : defaults.focus
	            });
	
	            return alert;
	        };
	
	        alert.error = function (message, title, icon, closeButton, tla, timeout, onClose) {
	            return alert.add(message, title, 'error', icon, closeButton, tla, timeout, onClose);
	        };
	
	        alert.success = function (message, title, icon, closeButton, tla, timeout, onClose) {
	            return alert.add(message, title, 'success', icon, closeButton, tla, timeout, onClose);
	        };
	
	        alert.warning = function (message, title, icon, closeButton, tla, timeout, onClose) {
	            return alert.add(message, title, 'warning', icon, closeButton, tla, timeout, onClose);
	        };
	
	        alert.info = function (message, title, icon, closeButton, tla, timeout, onClose) {
	            return alert.add(message, title, 'info', icon, closeButton, tla, timeout, onClose);
	        };
	
	        alert.clear = function () {
	            alert.alerts.splice(0);
	            return alert;
	        };
	
	        alert.remove = function (index) {
	            if (alert.alerts[index]) {
	                alert.alerts.splice(index, 1);
	            }
	            if (defaults.focus) {
	                removeFocusFromAlerts();
	                focusLastAlert();
	            }
	            return alert;
	        };
	
	        function removeFocusFromAlerts() {
	            for (var index = 0; index < alert.alerts.length; index++) {
	                alert.alerts[index].focus = false;
	            }
	        }
	
	        function focusLastAlert() {
	            if (alert.alerts && !!alert.alerts.length) {
	                $timeout(function () {
	                    alert.alerts[alert.alerts.length - 1].focus = true;
	                });
	            }
	        }
	
	        if (defaults.clearOnChangeEvent) {
	            $rootScope.$on(defaults.stateChangeEvent, function () {
	                alert.clear();
	            });
	        }
	
	        return alert;
	    }
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _alerts = __webpack_require__(103);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	var _alerts3 = __webpack_require__(105);
	
	var _alerts4 = _interopRequireDefault(_alerts3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.alerts', [_usage2.default.name]).component('rcAlerts', _alerts2.default).provider('$rcAlerts', _alerts4.default);

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appTemplateFooter = __webpack_require__(37);
	
	var _appTemplateFooter2 = _interopRequireDefault(_appTemplateFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        footerContent: '<',
	        showFooter: '<'
	    },
	    template: _appTemplateFooter2.default
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appTemplateNavJs = __webpack_require__(38);
	
	var _appTemplateNavJs2 = _interopRequireDefault(_appTemplateNavJs);
	
	var _appTemplateNavJs3 = __webpack_require__(109);
	
	var _appTemplateNavJs4 = _interopRequireDefault(_appTemplateNavJs3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rcAppTemplateNavigationComponent = {
	    template: _appTemplateNavJs2.default,
	    bindings: {
	        navContent: '='
	    },
	    controller: _appTemplateNavJs4.default
	};
	
	exports.default = rcAppTemplateNavigationComponent;

/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppTemplateNavigationController = function () {
	    function AppTemplateNavigationController() {
	        _classCallCheck(this, AppTemplateNavigationController);
	    }
	
	    _createClass(AppTemplateNavigationController, [{
	        key: "isSubnav",
	        value: function isSubnav(item) {
	            return item.sub && !item.url;
	        }
	    }]);
	
	    return AppTemplateNavigationController;
	}();
	
	exports.default = AppTemplateNavigationController;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _appTemplate = __webpack_require__(39);
	
	var _appTemplate2 = _interopRequireDefault(_appTemplate);
	
	var _appTemplate3 = __webpack_require__(111);
	
	var _appTemplate4 = _interopRequireDefault(_appTemplate3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    transclude: true,
	    template: _appTemplate2.default,
	    bindings: {
	        pageTitle: '@',
	        appTitle: '@',
	        navContent: '=',
	        logoLinkUrl: '@?',
	        showUserId: '=',
	        logout: '@?'
	    },
	    controller: _appTemplate4.default
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _appTemplateConstants = __webpack_require__(13);
	
	var CONSTANTS = _interopRequireWildcard(_appTemplateConstants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RC_APP_TEMPLATE_LOGOUT_LINK = CONSTANTS.RC_APP_TEMPLATE_LOGOUT_LINK;
	var RC_APP_TEMPLATE_FOOTER_CONTENT = CONSTANTS.RC_APP_TEMPLATE_FOOTER_CONTENT;
	
	var AppTemplateController = function () {
	    AppTemplateController.$inject = ["$parse", "$scope", "$attrs", "$log", "Usage", "rcUserId"];
	    function AppTemplateController($parse, $scope, $attrs, $log, Usage, rcUserId) {
	        'ngInject';
	
	        _classCallCheck(this, AppTemplateController);
	
	        this.$parse = $parse;
	        this.$scope = $scope;
	        this.$attrs = $attrs;
	        this.$log = $log;
	        this.Usage = Usage;
	        this.rcUserId = rcUserId;
	    }
	
	    _createClass(AppTemplateController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.Usage.register('appTemplate');
	            this.initFooter();
	            this.initNavbar();
	            this.initUserId();
	            this.initLogoLink();
	        }
	    }, {
	        key: 'initLogoLink',
	        value: function initLogoLink() {
	            this.enableLogoLink = true;
	            if (angular.isDefined(this.$attrs.noLogoLink)) {
	                this.enableLogoLink = false;
	            }
	
	            this.logoLinkUrl = this.logoLinkUrl || CONSTANTS.RC_APP_TEMPLATE_HEADER_LOGO_LINK;
	        }
	    }, {
	        key: 'registerNavigation',
	        value: function registerNavigation() {
	            this.showNavBar = true;
	        }
	    }, {
	        key: 'initUserId',
	        value: function initUserId() {
	            var _this = this;
	
	            if (this.showUserId) {
	                this.rcUserId.get().then(function (response) {
	                    _this.userObj = response.data;
	                });
	            }
	        }
	    }, {
	        key: 'initNavbar',
	        value: function initNavbar() {
	            this.logoutLink = this.parseLogout(this.logout);
	            if (this.doesNavContentExist(this.navContent) || this.logoutLink) {
	                this.showNavBar = true;
	            } else {
	                this.showNavBar = false;
	            }
	        }
	    }, {
	        key: 'useDeclarativeNavigation',
	        value: function useDeclarativeNavigation() {
	            return this.showNavBar && this.navContent;
	        }
	    }, {
	        key: 'initFooter',
	        value: function initFooter() {
	            this.showFooter = true;
	            if (angular.isDefined(this.$attrs.hideFooter)) {
	                this.showFooter = false;
	            }
	
	            if (this.$attrs.footerContent) {
	                var parsedFooterContent = this.$parse(this.$attrs.footerContent)(this.$scope.$parent);
	                if (parsedFooterContent === false) {
	                    // Deprecated code - in 3.3.0, remove the footer-content=false behavior
	                    // This will also let us remove $parse, $scope, and $log
	                    this.$log.warn('Setting footer-content="false" to hide the footer is deprecated. Use the hide-footer attribute.');
	                    this.showFooter = false;
	                } else {
	                    // This does not setup any bindings. If folks complain, we can re-add a binding in 3.3.0
	                    this.footerContent = parsedFooterContent;
	                }
	            } else {
	                this.footerContent = RC_APP_TEMPLATE_FOOTER_CONTENT;
	            }
	        }
	    }, {
	        key: 'parseLogout',
	        value: function parseLogout(logout) {
	            if (angular.isString(logout)) {
	                if (logout.toLowerCase() === 'true') {
	                    return RC_APP_TEMPLATE_LOGOUT_LINK;
	                } else if (logout.toLowerCase() === 'false') {
	                    return null;
	                } else {
	                    return logout;
	                }
	            }
	            if (typeof logout === 'boolean' && !logout) {
	                return null;
	            }
	            return RC_APP_TEMPLATE_LOGOUT_LINK;
	        }
	    }, {
	        key: 'doesNavContentExist',
	        value: function doesNavContentExist(navContent) {
	            if (navContent) {
	                if (navContent.length > 0) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    }]);
	
	    return AppTemplateController;
	}();
	
	exports.default = AppTemplateController;

/***/ },
/* 112 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$document", "rcSeamlessUi", "rcFeatureTests", function ($document, rcSeamlessUi, rcFeatureTests) {
	    'ngInject';
	
	    rcFeatureTests.runFeatureTests();
	
	    // If in a portal, strip off header/footer
	    if (rcSeamlessUi.isInSeamlessUIMode()) {
	        $document.find('body').addClass(PORTAL_CLASS);
	    }
	}];
	
	var PORTAL_CLASS = 'ric-portal';

/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcAppTemplateService() {
	    var self = this;
	    this.activeElements = [];
	
	    var isNotInNav = function isNotInNav(target) {
	        var test = target;
	        while (test.parentElement !== null) {
	            if (angular.element(test).hasClass('rc-app-template-navigation')) {
	                return false;
	            }
	            test = test.parentElement;
	        }
	        return true;
	    };
	
	    var clear = function clear(element) {
	        if (isNotInNav(element.target)) {
	            angular.forEach(self.activeElements, function (e) {
	                e.isVisible = false;
	            });
	            self.activeElements = [];
	            self.el.off('click', clear);
	        }
	    };
	
	    this.setElement = function (e) {
	        self.el = e;
	    };
	
	    this.addActive = function (item) {
	        if (self.activeElements.length === 0) {
	            self.el.on('click', clear);
	        }
	        item.isVisible = true;
	        self.activeElements.push(item);
	    };
	    this.removeActive = function (item) {
	        var indexInActiveItems = self.activeElements.indexOf(item);
	        if (indexInActiveItems !== -1) {
	            self.activeElements.splice(indexInActiveItems, 1);
	        }
	        item.isVisible = false;
	        if (self.activeElements.length === 0) {
	            self.el.off('click', clear);
	        }
	    };
	}
	
	exports.default = rcAppTemplateService;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _hoverIntent = __webpack_require__(17);
	
	var _hoverIntent2 = _interopRequireDefault(_hoverIntent);
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _seamlessUi = __webpack_require__(11);
	
	var _seamlessUi2 = _interopRequireDefault(_seamlessUi);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _target = __webpack_require__(12);
	
	var _target2 = _interopRequireDefault(_target);
	
	var _navigation = __webpack_require__(9);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _slideMenu = __webpack_require__(24);
	
	var _slideMenu2 = _interopRequireDefault(_slideMenu);
	
	var _appTemplate = __webpack_require__(13);
	
	var _appTemplate2 = __webpack_require__(113);
	
	var _appTemplate3 = _interopRequireDefault(_appTemplate2);
	
	var _appTemplate4 = __webpack_require__(110);
	
	var _appTemplate5 = _interopRequireDefault(_appTemplate4);
	
	var _appTemplateNavJs = __webpack_require__(108);
	
	var _appTemplateNavJs2 = _interopRequireDefault(_appTemplateNavJs);
	
	var _appTemplateFooter = __webpack_require__(107);
	
	var _appTemplateFooter2 = _interopRequireDefault(_appTemplateFooter);
	
	var _appTemplate6 = __webpack_require__(112);
	
	var _appTemplate7 = _interopRequireDefault(_appTemplate6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.appTemplate', [_hoverIntent2.default.name, _keyboardNavigation2.default.name, _seamlessUi2.default.name, _usage2.default.name, _utils2.default.name, _target2.default.name, _navigation2.default.name, _slideMenu2.default.name])
	// Public components
	.component('rcAppTemplate', _appTemplate5.default).component('rcAppTemplateFooter', _appTemplateFooter2.default).service('rcAppTemplateService', _appTemplate3.default)
	
	// Internal component
	.component('rcAppTemplateNavJs', _appTemplateNavJs2.default).constant('RC_APP_TEMPLATE_FOOTER_CONTENT', _appTemplate.RC_APP_TEMPLATE_FOOTER_CONTENT).constant('RC_APP_TEMPLATE_LOGOUT_LINK', _appTemplate.RC_APP_TEMPLATE_LOGOUT_LINK).run(_appTemplate7.default);

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var AUTOCOMPLETE_SELECT_EVENT = exports.AUTOCOMPLETE_SELECT_EVENT = 'autocompleteModelSelected';
	/* TODO: Convert to actual service */
	var AUTOCOMPLETE_SERVICES = exports.AUTOCOMPLETE_SERVICES = {
	    circ7: {
	        url: '/uit/ricola/jas/services/station/v2/search',
	        attributes: {
	            templateUrl: 'src/autocomplete/templates/autocomplete-circ7.html',
	            minLength: '2',
	            placeholder: 'Circ-7'
	        },
	        buildListExpression: function buildListExpression(controllerId) {
	            return 'station as station.circ7 for station in getRicolaServiceData(' + controllerId + ', $viewValue)';
	        },
	        getParameters: function getParameters(scope, attrs) {
	            var parameters = {};
	
	            if (angular.isDefined(attrs.routable)) {
	                parameters.routable = scope.$eval(attrs.routable);
	            }
	            return parameters;
	        }
	    },
	    city: {
	        url: '/uit/ricola/jas/services/city/v3/search',
	        attributes: {
	            templateUrl: 'src/autocomplete/templates/autocomplete-city.html',
	            minLength: '2',
	            placeholder: 'City, State'
	        },
	        buildListExpression: function buildListExpression(controllerId) {
	            return 'csc for csc in getRicolaServiceData(' + controllerId + ', $viewValue)';
	        },
	        format: {
	            methodName: 'formatCityForInput',
	            method: function method(csc) {
	                var formatted = '';
	                if (csc) {
	                    formatted += csc.name || '';
	                    if (csc.state && csc.state.abbreviation) {
	                        formatted += formatted.length > 0 ? ', ' + csc.state.abbreviation : csc.state.abbreviation;
	                    }
	                }
	                return formatted;
	            }
	        },
	        getParameters: getCountryAndStateParams
	    },
	    customer: {
	        url: '/uit/ricola/jas/services/customer/search',
	        attributes: {
	            templateUrl: 'src/autocomplete/templates/autocomplete-customer.html',
	            minLength: '3',
	            placeholder: 'Company City, ST'
	        },
	        buildListExpression: function buildListExpression(controllerId) {
	            return 'customer as customer.firmNumber for customer in getRicolaServiceData(' + controllerId + ', $viewValue)';
	        },
	        getParameters: function getParameters(scope, attrs) {
	
	            var parameters = {};
	
	            if (attrs.locationType) {
	                parameters.locationType = scope.$eval(attrs.locationType);
	            }
	
	            if (attrs.ultimateFirmNumber) {
	                parameters.ultimateFirmNumber = scope.$eval(attrs.ultimateFirmNumber);
	            }
	            return parameters;
	        }
	    },
	    person: {
	        url: '/uit/ricola/jas/services/person/v2/search',
	        attributes: {
	            templateUrl: 'src/autocomplete/templates/autocomplete-person.html',
	            minLength: '3',
	            placeholder: 'Name or Employee ID'
	        },
	        buildListExpression: function buildListExpression(controllerId) {
	            return 'person as person.employeeId for person in getRicolaServiceData(' + controllerId + ', $viewValue)';
	        },
	        getParameters: function getParameters(scope, attrs) {
	            return {};
	        }
	    },
	    splc: {
	        url: '/uit/ricola/jas/services/splc/search',
	        attributes: {
	            templateUrl: 'src/autocomplete/templates/autocomplete-splc.html',
	            minLength: '2',
	            placeholder: 'City, State or SPLC'
	        },
	        buildListExpression: function buildListExpression(controllerId) {
	            return 'csc for csc in getRicolaServiceData(' + controllerId + ', $viewValue)';
	        },
	        format: {
	            methodName: 'formatSplcForInput',
	            method: function method(csc) {
	                var formatted = '';
	                if (csc) {
	                    if (csc.name) {
	                        formatted += csc.name;
	                    }
	                    if (csc.state && csc.state.abbreviation) {
	                        formatted += formatted.length > 0 ? ', ' + csc.state.abbreviation : csc.state.abbreviation;
	                    }
	                }
	                return formatted;
	            }
	        },
	        getParameters: getCountryAndStateParams
	    },
	    stcc: {
	        url: '/uit/ricola/jas/services/stcc/v2/search',
	        attributes: {
	            templateUrl: 'src/autocomplete/templates/autocomplete-stcc.html',
	            minLength: '2',
	            placeholder: 'Commodity Code'
	        },
	        buildListExpression: function buildListExpression(controllerId) {
	            return 'commodity as commodity.stcc for commodity in getRicolaServiceData(' + controllerId + ', $viewValue)';
	        },
	        getParameters: function getParameters(scope, attrs) {
	            var parameters = {};
	
	            if (angular.isDefined(attrs.codeLengthOver)) {
	                parameters.codeLengthOver = scope.$eval(attrs.codeLengthOver);
	            }
	
	            if (angular.isDefined(attrs.codeLengthUnder)) {
	                parameters.codeLengthUnder = scope.$eval(attrs.codeLengthUnder);
	            }
	            return parameters;
	        }
	    }
	};
	
	function getCountryAndStateParams(scope, attrs) {
	    var parameters = { countryAbbreviation: 'US' };
	
	    if (angular.isDefined(attrs.countries)) {
	        parameters.countryAbbreviation = getStringArray(scope.$eval(attrs.countries) || attrs.countries);
	    }
	
	    if (angular.isDefined(attrs.states)) {
	        parameters.stateName = getStringArray(scope.$eval(attrs.states) || attrs.states);
	    }
	    return parameters;
	}
	
	function getStringArray(value) {
	    if (angular.isDefined(value)) {
	        if (angular.isArray(value)) {
	            return value;
	        } else if (angular.isString(value)) {
	            return value.split(',');
	        }
	    }
	    return value;
	}

/***/ },
/* 116 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function AutocompleteDropdownController() {
	    var ctrl = this;
	
	    ctrl.showMatches = function () {
	        return ctrl.matches && ctrl.matches.length > 0;
	    };
	
	    ctrl.isActive = function (matchIdx) {
	        return ctrl.active === matchIdx;
	    };
	
	    ctrl.selectActive = function (matchIdx) {
	        ctrl.active = matchIdx;
	    };
	
	    ctrl.selectMatch = function (activeIndex) {
	        ctrl.select({ activeIndex: activeIndex });
	    };
	}
	
	exports.default = AutocompleteDropdownController;

/***/ },
/* 117 */
/***/ function(module, exports) {

	'use strict';
	
	RcAutocompleteController.$inject = ["$scope", "$q", "$timeout", "KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function RcAutocompleteController($scope, $q, $timeout, KEYS) {
	    'ngInject';
	
	    var NAV_KEYS = [KEYS.TAB, KEYS.ENTER, KEYS.ESC, KEYS.UP, KEYS.DOWN];
	
	    var enterOrTabPressed;
	    var fetchingMatches = false;
	    var getCurrentViewValue = angular.noop;
	    var getInputModel = angular.noop;
	    var hasFocus = false;
	    var setMatchRequiredValidity = angular.noop;
	    var waitingToFetchMatches;
	
	    var ctrl = this;
	    ctrl.activeIndex = -1;
	    ctrl.bindInputModelController = bindInputModelController;
	    ctrl.expressionParser = angular.noop;
	    ctrl.focusOnInput = angular.noop;
	    ctrl.handleInputOnBlurEvent = handleInputOnBlurEvent;
	    ctrl.handleKeyDown = handleKeyDown;
	    ctrl.matches = [];
	    ctrl.matchToCurrentModel = matchToCurrentModel;
	    ctrl.modelFormatter = modelFormatter;
	    ctrl.resetMatches = resetMatches;
	    ctrl.select = select;
	    ctrl.setModel = setModel; // Can be overridden by other directives (like multiple)
	    ctrl.setModelToFirstMatch = setModelToFirstMatch;
	
	    // Find a way to move this to the multiple controller only
	    ctrl.removeModel = function (modelValue) {
	        if (angular.isFunction(ctrl.onRemove)) {
	            ctrl.onRemove(formatForCallback(modelValue));
	        }
	    };
	
	    function bindInputModelController(inputModelCtrl) {
	        // plug into $parsers pipeline to handle changes initiated from DOM
	        inputModelCtrl.$parsers.unshift(inputParser);
	        // plug into the parsing pipeline to format the model for display
	        inputModelCtrl.$formatters.push(ctrl.modelFormatter);
	
	        setMatchRequiredValidity = function setMatchRequiredValidity(value) {
	            inputModelCtrl.$setValidity('matchRequired', value);
	        };
	
	        getCurrentViewValue = function getCurrentViewValue() {
	            return inputModelCtrl.$viewValue;
	        };
	
	        getInputModel = function getInputModel() {
	            return inputModelCtrl.$modelValue;
	        };
	    }
	
	    function handleInputOnBlurEvent(event) {
	        hasFocus = false;
	        if (ctrl.matchOnBlur && getCurrentViewValue() === getInputModel()) {
	            ctrl.setModelToFirstMatch(getCurrentViewValue());
	            ctrl.resetMatches();
	        }
	    }
	
	    function formatForCallback(item) {
	        var locals = {};
	        locals[ctrl.expressionParser.itemName] = item;
	
	        return {
	            $item: item,
	            $label: ctrl.expressionParser.viewMapper(locals),
	            $model: ctrl.expressionParser.modelMapper(locals)
	        };
	    }
	
	    function getAsyncMatches(inputValue) {
	        var locals = { $viewValue: inputValue };
	        setLoadingIndicator(true);
	
	        // Parent scope will have the match information
	        fetchingMatches = $q.when(ctrl.expressionParser.source(locals)).then(successHandler, failureHandler);
	
	        function successHandler(matched) {
	            /* Multiple async queries may be in flight. Be sure to only display the current one. */
	            if (inputValue === getCurrentViewValue() && hasFocus) {
	                if (matched && matched.length > 0) {
	
	                    ctrl.activeIndex = 0;
	                    ctrl.matches.length = 0;
	
	                    // transform labels
	                    for (var i = 0; i < matched.length; i++) {
	                        locals[ctrl.expressionParser.itemName] = matched[i];
	                        ctrl.matches.push({
	                            label: ctrl.expressionParser.viewMapper(locals),
	                            model: matched[i]
	                        });
	                    }
	
	                    ctrl.query = inputValue;
	                    // reset dropdown position
	                    ctrl.position = ctrl.getDropdownPosition();
	                } else {
	                    resetMatches();
	                }
	                /* Typing quickly and hitting enter or tab should take the very first 'match' and skip the display */
	            } else if (!hasFocus && enterOrTabPressed) {
	                    if (matched && matched.length > 0) {
	                        resetMatches();
	                        ctrl.setModel(matched[0]);
	                        if (angular.isFunction(ctrl.onSelect)) {
	                            ctrl.onSelect(formatForCallback(matched[0]));
	                        }
	                    }
	                }
	            fetchingMatches = false;
	            setLoadingIndicator(false);
	        }
	
	        function failureHandler() {
	            resetMatches();
	            setLoadingIndicator(false);
	        }
	    }
	
	    function handleKeyDown(evt) {
	        // autocomplete is open and an "interesting" key was pressed
	        enterOrTabPressed = false;
	        if (ctrl.matches.length === 0 || NAV_KEYS.indexOf(evt.which) === -1) {
	            return;
	        }
	
	        switch (evt.which) {
	            case KEYS.DOWN:
	                evt.preventDefault();
	                ctrl.activeIndex = (ctrl.activeIndex + 1) % ctrl.matches.length;
	                $scope.$digest();
	                break;
	
	            case KEYS.UP:
	                evt.preventDefault();
	                ctrl.activeIndex = (ctrl.activeIndex ? ctrl.activeIndex : ctrl.matches.length) - 1;
	                $scope.$digest();
	                break;
	
	            case KEYS.ENTER:
	                evt.preventDefault();
	            /* falls through */
	            case KEYS.TAB:
	                enterOrTabPressed = true;
	                if (ctrl.matches.length > 0 && !fetchingMatches) {
	                    $scope.$apply(function () {
	                        ctrl.select(ctrl.activeIndex);
	                    });
	                } else {
	                    hasFocus = false;
	                }
	                break;
	
	            case KEYS.ESC:
	                evt.preventDefault();
	                evt.stopPropagation();
	                resetMatches();
	                $scope.$digest();
	                break;
	
	            default:
	                break;
	        }
	    }
	
	    function inputParser(inputValue) {
	        hasFocus = true;
	
	        if (inputValue && inputValue.length >= (ctrl.minSearch || 1)) {
	
	            if ((ctrl.waitMs || 0) > 0) {
	                if (waitingToFetchMatches) {
	                    $timeout.cancel(waitingToFetchMatches);
	                }
	                waitingToFetchMatches = $timeout(function () {
	                    getAsyncMatches(inputValue);
	                }, ctrl.waitMs);
	            } else {
	                getAsyncMatches(inputValue);
	            }
	        } else {
	            setLoadingIndicator(false);
	            resetMatches();
	        }
	
	        if (ctrl.matchRequired) {
	            if (!inputValue) {
	                // Reset in case user had typed something previously.
	                setMatchRequiredValidity(true);
	                return inputValue;
	            } else {
	                setMatchRequiredValidity(false);
	                return null;
	            }
	        } else {
	            return inputValue;
	        }
	    }
	
	    function matchToCurrentModel() {
	        if (angular.isString(ctrl.ngModel) && ctrl.ngModel.trim().length > 0) {
	            setModelToFirstMatch(ctrl.ngModel);
	        }
	    }
	
	    function modelFormatter(modelValue) {
	        var displayValue;
	
	        if (angular.isFunction(ctrl.customFormatter)) {
	            displayValue = ctrl.customFormatter({ $model: modelValue });
	        } else {
	            var candidateViewValue,
	                emptyViewValue,
	                locals = {};
	
	            // we need to check for this situation and simply return model value if we can't apply custom formatting
	            locals[ctrl.expressionParser.itemName] = modelValue;
	            candidateViewValue = ctrl.expressionParser.viewMapper(locals);
	
	            locals[ctrl.expressionParser.itemName] = '';
	            emptyViewValue = ctrl.expressionParser.viewMapper(locals);
	
	            displayValue = candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	        }
	
	        return displayValue;
	    }
	
	    function resetMatches() {
	        ctrl.matches = [];
	        ctrl.activeIndex = -1;
	    }
	
	    function select(activeIndex) {
	        var parsed = formatForCallback(ctrl.matches[activeIndex].model);
	
	        setMatchRequiredValidity(true);
	
	        ctrl.setModel(parsed.$model);
	        resetMatches();
	
	        // callback
	        if (angular.isFunction(ctrl.onSelect)) {
	            ctrl.onSelect(parsed);
	        }
	
	        // return focus to the input element
	        ctrl.focusOnInput();
	    }
	
	    function setLoadingIndicator(value) {
	        ctrl.loading = value;
	    }
	
	    function setModel(modelValue) {
	        ctrl.ngModel = modelValue;
	        /* If the dev is lazy and does not use a dot in the model the input ng-model has to be set manually */
	        $timeout(function () {
	            var inputModel = getInputModel();
	            if (inputModel === getCurrentViewValue() && inputModel !== modelValue) {
	                ctrl.setInputModel(modelValue);
	            }
	        });
	    }
	
	    /* Shortcut method to avoid the dropdown popping up etc */
	    function setModelToFirstMatch(inputValue) {
	        $q.when(ctrl.expressionParser.source({ $viewValue: inputValue })).then(function (matches) {
	            if (matches.length > 0) {
	                ctrl.setModel(matches[0]);
	            }
	        });
	    }
	}
	
	exports.default = RcAutocompleteController;

/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	RcAutocompleteMultipleController.$inject = ["$scope", "KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function RcAutocompleteMultipleController($scope, KEYS) {
	    'ngInject';
	
	    var removeModelCallback = angular.noop;
	    var setAutocompleteModel = angular.noop;
	
	    var ctrl = this;
	    ctrl.bindAutocompleteController = bindAutocompleteController;
	    ctrl.handleInputOnBlurEvent = handleInputOnBlurEvent;
	    ctrl.handleKeyDown = handleKeyDown;
	    ctrl.inputFormatter = inputFormatter;
	    ctrl.items = [];
	
	    ctrl.keyPressed = keyPressed;
	    ctrl.removeItem = removeItem;
	
	    function arrayContains(array, value) {
	        if (angular.isArray(array)) {
	            for (var i = 0; i < array.length; i++) {
	                if (angular.equals(array[i], value)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	
	    function bindAutocompleteController(autocompleteCtrl) {
	        /* Override original AutocompleteController.setModel */
	        var setModelAlias = autocompleteCtrl.setModel;
	        autocompleteCtrl.setModel = function (modelValue) {
	            if (modelValue && !arrayContains(ctrl.items, modelValue)) {
	                if (angular.isArray(modelValue)) {
	                    ctrl.items = modelValue;
	                } else {
	                    ctrl.items.push(modelValue);
	                }
	            }
	            if (ctrl.items.length > 0) {
	                setModelAlias(ctrl.items);
	            } else {
	                setModelAlias();
	            }
	        };
	
	        ctrl.formatForDisplay = function (modelValue) {
	            return autocompleteCtrl.modelFormatter(modelValue);
	        };
	
	        removeModelCallback = autocompleteCtrl.removeModel;
	        // Local use of overridden setModel
	        setAutocompleteModel = autocompleteCtrl.setModel;
	    }
	
	    function handleInputOnBlurEvent() {
	        setAutocompleteModel(ctrl.items);
	        $scope.$apply();
	    }
	
	    function handleKeyDown(evt) {
	        if (evt.which === KEYS.TAB) {
	            evt.preventDefault();
	        }
	    }
	    /*
	    * Taps into the $formatters array which fires after the input model is set (even outside the autocomplete).
	    * When the model is manually set, the items array needs to be updated accordingly.
	    */
	    function inputFormatter(modelValue) {
	        if (!modelValue || modelValue && modelValue !== ctrl.items) {
	            ctrl.items = [];
	            setAutocompleteModel(modelValue);
	        }
	        return '';
	    }
	
	    function keyPressed(event, index) {
	        if (event.which === KEYS.DELETE) {
	            removeItem(index);
	        }
	    }
	
	    function removeItem(index) {
	        if (ctrl.items.length > index) {
	            var removedValue = ctrl.items.splice(index, 1);
	            removeModelCallback(removedValue[0]);
	        }
	
	        if (ctrl.items.length === 0) {
	            setAutocompleteModel();
	        }
	    }
	}
	
	exports.default = RcAutocompleteMultipleController;

/***/ },
/* 119 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcAutocompleteServiceController = function RcAutocompleteServiceController($scope, $attrs, $http, rcMediaQuery, AUTOCOMPLETE_SERVICES) {
	    'ngInject';
	
	    var _this = this;
	
	    _classCallCheck(this, RcAutocompleteServiceController);
	
	    var serviceConfig = AUTOCOMPLETE_SERVICES[$attrs.rcService.toLowerCase() || ''];
	    if (!serviceConfig) {
	        throw new Error('There is no pre-defined \'' + $attrs.rcService + '\' Ricola service configuration.');
	    }
	
	    this.limit = rcMediaQuery.minSize('large') ? 100 : 10;
	
	    this.processInput = function (input) {
	        var parameters = serviceConfig.getParameters($scope, $attrs);
	        parameters.q = input;
	        parameters.limit = parameters.limit || _this.limit;
	
	        return $http.get(serviceConfig.url, { params: parameters }).then(function (results) {
	            return results.data;
	        });
	    };
	};
	RcAutocompleteServiceController.$inject = ["$scope", "$attrs", "$http", "rcMediaQuery", "AUTOCOMPLETE_SERVICES"];
	
	exports.default = RcAutocompleteServiceController;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcAutocompleteDropdownDirective.$inject = ["$document"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _autocompleteDropdown = __webpack_require__(43);
	
	var _autocompleteDropdown2 = _interopRequireDefault(_autocompleteDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcAutocompleteDropdownDirective($document) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        scope: {
	            matches: '=',
	            query: '=',
	            active: '=',
	            position: '=',
	            select: '&'
	        },
	        template: _autocompleteDropdown2.default,
	        controller: 'RcAutocompleteDropdownController',
	        controllerAs: 'rcAcDropCtrl',
	        bindToController: true,
	        link: AutocompleteDropdownLink
	    };
	
	    function AutocompleteDropdownLink(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        function stopThatPropagation(evt) {
	            evt.stopPropagation();
	        }
	
	        element.bind('mousewheel', stopThatPropagation);
	
	        scope.$on('$destroy', function () {
	            element.unbind('mousewheel', stopThatPropagation);
	        });
	    }
	}
	
	exports.default = rcAutocompleteDropdownDirective;

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	RcAutocompleteInputDirective.$inject = ["AUTOCOMPLETE_SERVICES"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	 * This is used to overcome the issue of trying to do too many things in one directive. When composite directives are
	 * eventually created to manage templating like this, then this can likely be removed (i.e. the composite directive
	 * would already have the transcluded input as well as the service-configured placeholder which has to be on the element
	 * before the link phase)
	 */
	function RcAutocompleteInputDirective(AUTOCOMPLETE_SERVICES) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        priority: 2, // ng-model + 1
	        compile: RcAutocompleteInputCompile
	    };
	
	    function RcAutocompleteInputCompile(element, attrs) {
	        var parent = element[0].parentNode;
	        if (parent.nodeName !== 'RC-AUTOCOMPLETE') {
	            return;
	        }
	
	        // Disable HTML5 Autocomplete feature; as it will get in the way of the dropdown.
	        attrs.$set('autocomplete', 'off');
	        // Add the spyglass icon
	        element.addClass('rc-autocomplete-icon');
	
	        var modelName = parent.getAttribute('ng-model');
	        if (!attrs.ngModel) {
	            attrs.$set('ngModel', modelName);
	        } else if (attrs.ngModel !== modelName) {
	            throw new Error('The "ng-model" used on the <rc-autocomplete> element must be the same as the transcluded <input> "ng-model".');
	        }
	
	        var serviceName = parent.getAttribute('rc-service');
	        if (!attrs.placeholder && serviceName) {
	            var config = AUTOCOMPLETE_SERVICES[serviceName ? serviceName.toLowerCase() : ''];
	            attrs.$set('placeholder', config.attributes.placeholder);
	        }
	    }
	}
	
	exports.default = RcAutocompleteInputDirective;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcAutocompleteDirective.$inject = ["Usage", "$document", "$position", "$compile", "$parse", "$controller", "AutocompleteExpressionParser", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _autocomplete = __webpack_require__(49);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcAutocompleteDirective(Usage, $document, $position, $compile, $parse, $controller, AutocompleteExpressionParser, $timeout) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        require: 'rcAutocomplete',
	        scope: {
	            ngModel: '=',
	            loading: '=?',
	            matchRequired: '@?matchRequired',
	            minSearch: '@?minLength',
	            waitMs: '@?',
	            customFormatter: '&?inputFormatter',
	            onRemove: '&?',
	            onSelect: '&?'
	        },
	        template: _autocomplete2.default,
	        transclude: true,
	        controller: 'RcAutocompleteController',
	        controllerAs: 'rcAcCtrl',
	        bindToController: true,
	        link: RcAutocompleteLink
	    };
	
	    /*
	    * Handles DOM changes and builds out the necessary controller functionality while (hopefully) keeping the controller
	    * ignorant of the elements and various scopes involved.
	    */
	    function RcAutocompleteLink(scope, element, attrs, autocompleteCtrl, transclude) {
	        Usage.register('autocomplete');
	
	        // Transclude provided input element or generate one using parent scope to keep within accessibility of controller
	        transclude(function rcAutocompleteTransclude(clone) {
	            var transcludedInput = getTranscludedInputElement(clone);
	
	            element.append(transcludedInput);
	
	            if (transcludedInput.hasNoScope === true) {
	                delete transcludedInput.hasNoScope;
	                transcludedInput.attr('ng-model', attrs.ngModel);
	                $compile(transcludedInput)(scope.$parent);
	            }
	        });
	
	        // TODO: Consider moving input-element-based logic to RcAutocompleteInputDirective as a link function with the AC-controller
	        // Transcluded input element
	        var inputElement = element.find('input');
	        inputElement.on('blur', autocompleteCtrl.handleInputOnBlurEvent);
	        inputElement.on('focus', addDropDownToBody);
	
	        var dropdownEl;
	        function addDropDownToBody() {
	            scope.$apply(function () {
	                dropdownEl = buildDropdown(attrs.templateUrl, scope);
	                $document.find('body').append(dropdownEl);
	                inputElement.unbind('focus', addDropDownToBody);
	            });
	        }
	
	        /* TODO: Move customFormatter, onRemove, and onSelect to the scope definition when angular version > 1.4
	         * https://github.com/angular/angular.js/commit/6a38dbfd3c34c8f9efff503d17eb3cbeb666d422 */
	        autocompleteCtrl.bindInputModelController(inputElement.controller('ngModel'));
	        autocompleteCtrl.expressionParser = AutocompleteExpressionParser.parse(attrs.listExpression, scope.$parent);
	        autocompleteCtrl.focusOnInput = getFocusOnInput(inputElement);
	        autocompleteCtrl.getDropdownPosition = getDropdrownPositioner(inputElement);
	        autocompleteCtrl.matchOnBlur = angular.isDefined(attrs.matchOnBlur);
	        autocompleteCtrl.multiple = angular.isDefined(attrs.multiple);
	        autocompleteCtrl.setInputModel = buildAttributeSetter(inputElement.attr('ng-model'), inputElement.scope());
	
	        element.on('keydown', autocompleteCtrl.handleKeyDown);
	
	        /* Will set the model to the first available match */
	        if (angular.isDefined(attrs.matchOnInit)) {
	            autocompleteCtrl.matchToCurrentModel();
	        }
	
	        // Actions taken outside the autocomplete should dismiss the dropdown
	        $document.bind('click mousewheel', dismissClickHandler);
	        angular.element(window).bind('resize', dismissClickHandler);
	
	        // var dropdownEl = buildDropdown(attrs.templateUrl, scope);
	        // $document.find('body').append(dropdownEl);
	
	        // cleanup
	        scope.$on('$destroy', function () {
	            $document.unbind('click mousewheel', dismissClickHandler);
	            angular.element(window).unbind('resize', dismissClickHandler);
	            if (dropdownEl) {
	                dropdownEl.remove();
	            }
	        });
	
	        // Keep reference to click handler to unbind it.
	        function dismissClickHandler(event) {
	            if (element[0] !== event.target) {
	                autocompleteCtrl.resetMatches();
	                scope.$digest();
	            }
	        }
	    }
	
	    function buildAttributeSetter(attribute, intendedScope) {
	        var setter = $parse(attribute).assign || angular.noop;
	        if (angular.noop !== setter) {
	            return function (value) {
	                setter(intendedScope, value);
	            };
	        }
	        return setter;
	    }
	
	    function buildDropdown(templateUrl, compileScope) {
	        var dropdownEl = angular.element('<rc-autocomplete-dropdown></rc-autocomplete-dropdown>');
	        dropdownEl.attr({
	            matches: 'rcAcCtrl.matches',
	            active: 'rcAcCtrl.activeIndex',
	            select: 'rcAcCtrl.select(activeIndex)',
	            query: 'rcAcCtrl.query',
	            position: 'rcAcCtrl.position'
	        });
	        // custom item template
	        if (angular.isDefined(templateUrl)) {
	            dropdownEl.attr('template-url', templateUrl);
	        }
	
	        return $compile(dropdownEl)(compileScope);
	    }
	
	    function findProvidedInput(clone) {
	        var transcluded;
	
	        for (var index = 0; index < clone.length; index++) {
	            if (clone[index].tagName === 'INPUT') {
	                transcluded = clone.eq(index);
	            }
	        }
	
	        return transcluded;
	    }
	
	    function getFocusOnInput(inputElement) {
	        return function () {
	            $timeout(function () {
	                inputElement[0].focus();
	            }, 0);
	        };
	    }
	
	    function getDropdrownPositioner(inputElement) {
	        return function () {
	            var position = $position.offset(inputElement);
	            position.top = position.top + inputElement.prop('offsetHeight');
	            return position;
	        };
	    }
	
	    function getTranscludedInputElement(clone) {
	        var transcludedInput = findProvidedInput(clone);
	
	        if (!transcludedInput) {
	            transcludedInput = angular.element('<input></input>');
	            transcludedInput.attr({
	                type: 'text'
	            });
	            transcludedInput.hasNoScope = true;
	        }
	
	        return transcludedInput;
	    }
	}
	
	exports.default = rcAutocompleteDirective;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcAutocompleteMatchDirective.$inject = ["$http", "$templateCache", "$compile", "$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _autocompleteMatch = __webpack_require__(44);
	
	var _autocompleteMatch2 = _interopRequireDefault(_autocompleteMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcAutocompleteMatchDirective($http, $templateCache, $compile, $parse) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        scope: {
	            index: '=',
	            match: '=',
	            query: '='
	        },
	        link: AutocompleteMatchLink
	    };
	
	    function AutocompleteMatchLink(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent);
	        if (tplUrl) {
	            $http.get(tplUrl, { cache: $templateCache }).success(function (tplContent) {
	                element.replaceWith(compileTemplate(tplContent, scope));
	            });
	        } else {
	            element.replaceWith(compileTemplate(_autocompleteMatch2.default, scope));
	        }
	    }
	
	    function compileTemplate(tpl, scope) {
	        return $compile(tpl.trim())(scope);
	    }
	}
	
	exports.default = rcAutocompleteMatchDirective;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcAutocompleteMultipleDirective.$inject = ["KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _autocompleteMultiple = __webpack_require__(45);
	
	var _autocompleteMultiple2 = _interopRequireDefault(_autocompleteMultiple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Plugs into the rcAutocomplete modifying how it handles result selection and input display. */
	function rcAutocompleteMultipleDirective(KEYS) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        require: ['rcAutocompleteMultiple', '^^rcAutocomplete'],
	        template: _autocompleteMultiple2.default,
	        scope: {},
	        controller: 'RcAutocompleteMultipleController',
	        controllerAs: 'rcAcMultiCtrl',
	        link: AutocompleteMultipleLink
	    };
	
	    /* TODO:
	        - accommodate `match-on-init` for an array
	        - accommodate import of line-break delimited values
	    */
	    function AutocompleteMultipleLink(scope, element, attrs, controllers) {
	        var multipleCtrl = controllers[0];
	        var autocompleteCtrl = controllers[1];
	
	        multipleCtrl.bindAutocompleteController(autocompleteCtrl);
	
	        var input = element.parent().find('input').eq(0);
	        input.bind('keydown', multipleCtrl.handleKeyDown);
	        input.bind('blur', multipleCtrl.handleInputOnBlurEvent);
	
	        var inputModelCtrl = input.controller('ngModel');
	        // The existence of the multiple will ensure nothing is ever in the input after a selection is made
	        inputModelCtrl.$formatters.push(multipleCtrl.inputFormatter);
	        // If the model is already set, process it in the extended functionality by forcing a watch using a copy.
	        // TODO: Find a better methodology to get things in sync
	        if (inputModelCtrl.$modelValue) {
	            autocompleteCtrl.setModel(angular.copy(inputModelCtrl.$modelValue));
	        }
	
	        scope.$on('$destroy', function () {
	            input.unbind('blur', multipleCtrl.handleInputOnBlurEvent);
	        });
	    }
	}
	
	exports.default = rcAutocompleteMultipleDirective;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	RcAutocompleteServiceDirective.$inject = ["Usage", "$compile", "$http", "rcMediaQuery", "AUTOCOMPLETE_SERVICES", "limitToFilter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _autocompleteController = __webpack_require__(119);
	
	var _autocompleteController2 = _interopRequireDefault(_autocompleteController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This must run before the rc-autocomplete directive to establish the necessary attributes on the element
	 */
	function RcAutocompleteServiceDirective(Usage, $compile, $http, rcMediaQuery, AUTOCOMPLETE_SERVICES, limitToFilter) {
	    'ngInject';
	
	    var identifier = 0;
	
	    return {
	        restrict: 'A',
	        priority: 2, // ng-model + 1
	        controller: _autocompleteController2.default,
	        compile: RcServiceCompile
	    };
	
	    function RcServiceCompile(element, attrs) {
	        return {
	            pre: RcServicePreLink
	        };
	    }
	
	    function RcServicePreLink(scope, element, attrs, controller) {
	        Usage.register('autocomplete-services');
	
	        var controllerId = ++identifier;
	        var config = AUTOCOMPLETE_SERVICES[attrs.rcService.toLowerCase() || ''];
	        if (!config) {
	            throw new Error('There is no pre-defined \'' + attrs.rcService + '\' Ricola service configuration.');
	        }
	
	        if (angular.isDefined(config.format)) {
	            scope[config.format.methodName] = config.format.method;
	        }
	
	        if (!scope.rcAutocompleteControllerCache) {
	            scope.rcAutocompleteControllerCache = {};
	        }
	        scope.rcAutocompleteControllerCache[controllerId] = controller;
	
	        setAttributeIfUndefined('listExpression', config.buildListExpression(controllerId));
	        setAttributeIfUndefined('tempalteUrl', config.attributes.templateUrl);
	        setAttributeIfUndefined('minLength', config.attributes.minLength);
	        setAttributeIfUndefined('templateUrl', config.attributes.templateUrl);
	        setAttributeIfUndefined('waitMs', '50');
	
	        if (!attrs.inputFormatter && config.format) {
	            attrs.$set('inputFormatter', config.format.methodName + '($model)');
	        }
	
	        /* A single scope may have multiple autocompletes */
	        if (!scope.getRicolaServiceData) {
	            scope.getRicolaServiceData = function (id, input) {
	                return scope.rcAutocompleteControllerCache[id].processInput(input);
	            };
	        }
	
	        /* Make sure the controller cache reference is removed if the element is destroyed */
	        element.on('$destroy', function () {
	            if (scope.rcAutocompleteControllerCache) {
	                delete scope.rcAutocompleteControllerCache[controllerId];
	            }
	        });
	
	        function setAttributeIfUndefined(name, value) {
	            if (angular.isUndefined(attrs[name]) && angular.isDefined(value)) {
	                attrs.$set(name, value);
	            }
	        }
	    }
	}
	
	exports.default = RcAutocompleteServiceDirective;

/***/ },
/* 126 */
/***/ function(module, exports) {

	'use strict';
	
	highlightFilter.$inject = ["$filter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.capitalizeFilter = capitalizeFilter;
	exports.escapeRegexpFilter = escapeRegexpFilter;
	exports.highlightFilter = highlightFilter;
	function capitalizeFilter() {
	    return function (input) {
	        var lower = input.toLowerCase();
	        return lower.substr(0, 1).toUpperCase() + lower.substr(1);
	    };
	}
	
	/* TODO: This should be moved into a Regexp module instead burying here. */
	function escapeRegexpFilter() {
	    return function escapeRegexp(str) {
	        if (angular.isString(str)) {
	            return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	        }
	        return str;
	    };
	}
	
	/* TODO: This should be moved into a Hightlight module ($filterProvider?) instead of burying here. */
	function highlightFilter($filter) {
	    'ngInject';
	
	    return function (str, query, caseSensitive, multiKeyDelimiter) {
	        if (angular.isString(str) && query) {
	            var escapedQuery = $filter('escapeRegexp')(query);
	            var regexpOr = '|';
	            var regexpString = multiKeyDelimiter ? escapedQuery.replace(multiKeyDelimiter, regexpOr) : escapedQuery;
	            var regexpFlags = 'g' + (caseSensitive ? '' : 'i');
	            var queryRegexp = new RegExp(regexpString, regexpFlags);
	            return str.replace(queryRegexp, '<span class="highlight">$&</span>');
	        }
	        return str;
	    };
	}

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	AutocompleteRunBlock.$inject = ["$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _autocompleteCirc = __webpack_require__(40);
	
	var _autocompleteCirc2 = _interopRequireDefault(_autocompleteCirc);
	
	var _autocompleteCity = __webpack_require__(41);
	
	var _autocompleteCity2 = _interopRequireDefault(_autocompleteCity);
	
	var _autocompleteCustomer = __webpack_require__(42);
	
	var _autocompleteCustomer2 = _interopRequireDefault(_autocompleteCustomer);
	
	var _autocompletePerson = __webpack_require__(46);
	
	var _autocompletePerson2 = _interopRequireDefault(_autocompletePerson);
	
	var _autocompleteSplc = __webpack_require__(47);
	
	var _autocompleteSplc2 = _interopRequireDefault(_autocompleteSplc);
	
	var _autocompleteStcc = __webpack_require__(48);
	
	var _autocompleteStcc2 = _interopRequireDefault(_autocompleteStcc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RC_AUTOCOMPLETE_SERVICE_TEMPLATES = {
	    circ7: _autocompleteCirc2.default,
	    city: _autocompleteCity2.default,
	    customer: _autocompleteCustomer2.default,
	    person: _autocompletePerson2.default,
	    splc: _autocompleteSplc2.default,
	    stcc: _autocompleteStcc2.default
	};
	
	function AutocompleteRunBlock($templateCache) {
	    'ngInject';
	
	    for (var template in RC_AUTOCOMPLETE_SERVICE_TEMPLATES) {
	        if (RC_AUTOCOMPLETE_SERVICE_TEMPLATES.hasOwnProperty(template)) {
	            $templateCache.put('src/autocomplete/templates/autocomplete-' + template + '.html', RC_AUTOCOMPLETE_SERVICE_TEMPLATES[template]);
	        }
	    }
	}
	
	exports.default = AutocompleteRunBlock;

/***/ },
/* 128 */
/***/ function(module, exports) {

	'use strict';
	
	AutocompleteExpressionParserService.$inject = ["$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	* A helper service that can parse autocomplete's syntax (string provided by users)
	* Extracted to a separate service for ease of unit testing
	*/
	function AutocompleteExpressionParserService($parse) {
	    'ngInject';
	
	    var service = this;
	
	    var AUTOCOMPLETE_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;
	
	    function throwParseError(expression) {
	        throw new Error('Expected autocomplete specification in form of \'_modelValue_ (as _label_)? for _item_ in _collection_\' but got \'' + expression + '\'.');
	    }
	
	    service.parse = function (expression, intendedScope) {
	        if (!expression) {
	            throwParseError(expression);
	        }
	
	        var match = expression.match(AUTOCOMPLETE_REGEXP);
	        if (!match) {
	            throwParseError(expression);
	        }
	
	        var sourceParse = $parse(match[4]);
	        var viewMapperParse = $parse(match[2] || match[1]);
	        var modelMapperParse = $parse(match[1]);
	
	        return {
	            itemName: match[3],
	            source: function source(locals) {
	                return sourceParse(intendedScope, locals);
	            },
	            viewMapper: function viewMapper(locals) {
	                return viewMapperParse(intendedScope, locals);
	            },
	            modelMapper: function modelMapper(locals) {
	                return modelMapperParse(intendedScope, locals);
	            }
	        };
	    };
	}
	
	exports.default = AutocompleteExpressionParserService;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bindHtml = __webpack_require__(6);
	
	var _bindHtml2 = _interopRequireDefault(_bindHtml);
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _position = __webpack_require__(4);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _autocomplete = __webpack_require__(127);
	
	var _autocomplete2 = _interopRequireDefault(_autocomplete);
	
	var _autocomplete3 = __webpack_require__(115);
	
	var _autocomplete4 = __webpack_require__(126);
	
	var _autocompleteService = __webpack_require__(128);
	
	var _autocompleteService2 = _interopRequireDefault(_autocompleteService);
	
	var _autocompleteDirective = __webpack_require__(125);
	
	var _autocompleteDirective2 = _interopRequireDefault(_autocompleteDirective);
	
	var _autocompleteDirective3 = __webpack_require__(120);
	
	var _autocompleteDirective4 = _interopRequireDefault(_autocompleteDirective3);
	
	var _autocompleteDirective5 = __webpack_require__(121);
	
	var _autocompleteDirective6 = _interopRequireDefault(_autocompleteDirective5);
	
	var _autocomplete5 = __webpack_require__(122);
	
	var _autocomplete6 = _interopRequireDefault(_autocomplete5);
	
	var _autocompleteDirective7 = __webpack_require__(123);
	
	var _autocompleteDirective8 = _interopRequireDefault(_autocompleteDirective7);
	
	var _autocompleteDirective9 = __webpack_require__(124);
	
	var _autocompleteDirective10 = _interopRequireDefault(_autocompleteDirective9);
	
	var _autocomplete7 = __webpack_require__(117);
	
	var _autocomplete8 = _interopRequireDefault(_autocomplete7);
	
	var _autocompleteController = __webpack_require__(116);
	
	var _autocompleteController2 = _interopRequireDefault(_autocompleteController);
	
	var _autocompleteController3 = __webpack_require__(118);
	
	var _autocompleteController4 = _interopRequireDefault(_autocompleteController3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.autocomplete', [_bindHtml2.default.name, _keyboardNavigation2.default.name, _mediaQuery2.default.name, _position2.default.name, _usage2.default.name]).run(_autocomplete2.default).constant('AUTOCOMPLETE_SELECT_EVENT', _autocomplete3.AUTOCOMPLETE_SELECT_EVENT).constant('AUTOCOMPLETE_SERVICES', _autocomplete3.AUTOCOMPLETE_SERVICES).filter('capitalize', _autocomplete4.capitalizeFilter).filter('escapeRegexp', _autocomplete4.escapeRegexpFilter).filter('highlight', _autocomplete4.highlightFilter).service('AutocompleteExpressionParser', _autocompleteService2.default).directive('rcService', _autocompleteDirective2.default).directive('rcAutocompleteDropdown', _autocompleteDirective4.default).directive('input', _autocompleteDirective6.default).directive('rcAutocomplete', _autocomplete6.default).directive('rcAutocompleteMatch', _autocompleteDirective8.default).directive('rcAutocompleteMultiple', _autocompleteDirective10.default).controller('RcAutocompleteController', _autocomplete8.default).controller('RcAutocompleteDropdownController', _autocompleteController2.default).controller('RcAutocompleteMultipleController', _autocompleteController4.default);

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	rcBindHtmlUnsafeCompileDirective.$inject = ["$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcBindHtmlUnsafeCompileDirective($compile) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        scope: {
	            html: '=rcBindHtmlUnsafeCompile'
	        },
	        link: function link(scope, element, attrs) {
	            var watcher = scope.$watch(function () {
	                return scope.html;
	            }, function (value) {
	                element.html(value);
	                $compile(element.contents())(scope);
	            });
	
	            scope.$on('$destroy', function () {
	                watcher();
	            });
	        }
	    };
	}
	
	exports.default = rcBindHtmlUnsafeCompileDirective;

/***/ },
/* 131 */
/***/ function(module, exports) {

	'use strict';
	
	rcBindHtmlUnsafeDirective.$inject = ["$parse", "$timeout", "$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcBindHtmlUnsafeDirective($parse, $timeout, $compile) {
	    'ngInject';
	
	    return {
	        compile: function compile(compileEl, compileAttrs) {
	            var rcBindHtmlGetter = $parse(compileAttrs.rcBindHtmlUnsafe);
	            var shouldCompileGetter = $parse(compileAttrs.compile);
	            $compile.$$addBindingClass(compileEl);
	
	            return function link(scope, element, attrs) {
	                $compile.$$addBindingInfo(element, attrs.rcBindHtmlUnsafe);
	                scope.$watch(attrs.rcBindHtmlUnsafe, bindHtmlWatch);
	
	                function bindHtmlWatch() {
	                    // Retrieve what may be compilable html
	                    var html = rcBindHtmlGetter(scope);
	                    if (angular.isDefined(html) && shouldCompileGetter(scope)) {
	                        $timeout(function () {
	                            element.append(tryToCompile(html));
	                        });
	                    } else {
	                        element.html(html || '');
	                    }
	                }
	
	                /* TODO: Not completely pleased with this solution. If it is marked for compile, then this should not be necessary but
	                 * the rcAlert currently does not require the developer to specify. */
	                function tryToCompile(html) {
	                    try {
	                        return $compile(html)(scope);
	                    } catch (err) {
	                        return html;
	                    }
	                }
	            };
	        }
	    };
	}
	
	exports.default = rcBindHtmlUnsafeDirective;

/***/ },
/* 132 */
/***/ function(module, exports) {

	'use strict';
	
	buttonDirective.$inject = ["Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function buttonDirective(Usage) {
	    'ngInject';
	
	    return {
	        restrict: 'EAC',
	        link: function link(scope, element, attrs) {
	            Usage.register('button');
	        }
	    };
	}
	
	exports.default = buttonDirective;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _button = __webpack_require__(132);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.button', [_usage2.default.name]).directive('button', _button2.default);

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendarController = __webpack_require__(140);
	
	var _calendarController2 = _interopRequireDefault(_calendarController);
	
	var _calendarDay = __webpack_require__(50);
	
	var _calendarDay2 = _interopRequireDefault(_calendarDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        item: '&'
	    },
	    require: {
	        popupCtrl: '^rcCalendarPopup'
	    },
	    controller: _calendarController2.default,
	    controllerAs: 'rcCalDayCtrl',
	    template: _calendarDay2.default
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendarController = __webpack_require__(142);
	
	var _calendarController2 = _interopRequireDefault(_calendarController);
	
	var _calendarMonth = __webpack_require__(51);
	
	var _calendarMonth2 = _interopRequireDefault(_calendarMonth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        item: '&'
	    },
	    controller: _calendarController2.default,
	    controllerAs: 'rcCalMCtrl',
	    template: _calendarMonth2.default
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendarController = __webpack_require__(143);
	
	var _calendarController2 = _interopRequireDefault(_calendarController);
	
	var _calendarPopup = __webpack_require__(53);
	
	var _calendarPopup2 = _interopRequireDefault(_calendarPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    // TODO: This feels a bit like a rehash of directive values. combine?
	    bindings: {
	        customHolidays: '&',
	        disabledDates: '&',
	        focusedDate: '&',
	        isRange: '&',
	        minimumDate: '&',
	        maximumDate: '&',
	        okButton: '&',
	        onComplete: '&',
	        selectedDate: '&',
	        todayButton: '&',
	        upHolidays: '&'
	    },
	    transclude: {
	        controls: '?rc-calendar-controls',
	        content: '?rc-calendar-content'
	    },
	    controller: _calendarController2.default,
	    controllerAs: 'rcCalPopCtrl',
	    template: _calendarPopup2.default
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendarControllerScroll = __webpack_require__(144);
	
	var _calendarControllerScroll2 = _interopRequireDefault(_calendarControllerScroll);
	
	var _calendarScrollContent = __webpack_require__(54);
	
	var _calendarScrollContent2 = _interopRequireDefault(_calendarScrollContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {},
	    require: {
	        popupCtrl: '^rcCalendarPopup'
	    },
	    controller: _calendarControllerScroll2.default,
	    controllerAs: 'rcCalScrlCtrl',
	    template: _calendarScrollContent2.default
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendarWeekHeaders = __webpack_require__(55);
	
	var _calendarWeekHeaders2 = _interopRequireDefault(_calendarWeekHeaders);
	
	var _calendarControllerWeek = __webpack_require__(145);
	
	var _calendarControllerWeek2 = _interopRequireDefault(_calendarControllerWeek);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {},
	    controller: _calendarControllerWeek2.default,
	    controllerAs: 'rcCalWHCtrl',
	    template: _calendarWeekHeaders2.default
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _calendarWeek = __webpack_require__(56);
	
	var _calendarWeek2 = _interopRequireDefault(_calendarWeek);
	
	var _calendarController = __webpack_require__(146);
	
	var _calendarController2 = _interopRequireDefault(_calendarController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        item: '&'
	    },
	    template: _calendarWeek2.default,
	    controller: _calendarController2.default,
	    controllerAs: 'rcCalWeekCtrl'
	};

/***/ },
/* 140 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcCalendarDayController = function () {
	    RcCalendarDayController.$inject = ["$scope", "$element", "$timeout", "KEYS"];
	    function RcCalendarDayController($scope, $element, $timeout, KEYS) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarDayController);
	
	        this.$scope = $scope;
	        this.$element = $element;
	        this.$timeout = $timeout;
	        this.KEYS = KEYS;
	    }
	
	    _createClass(RcCalendarDayController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.day = this.item();
	            this.disabled = this.popupCtrl.isDisabled(this.day);
	
	            if (this.popupCtrl.isFocused(this.day)) {
	                this.$timeout(function () {
	                    _this.$element[0].focus();
	                }, 0, false);
	            }
	
	            addDayClasses(this.$element, this.day, this.disabled);
	            addDayAttributes(this.$element, this.day);
	        }
	    }, {
	        key: '$postLink',
	        value: function $postLink() {
	            var _this2 = this;
	
	            this.$element.on('click', function () {
	                _this2.select();
	            });
	
	            this.$element.on('keydown', function (event) {
	                switch (event.keyCode) {
	                    case _this2.KEYS.ENTER:
	                    // fall through
	                    case _this2.KEYS.SPACE:
	                        _this2.select();
	                        event.preventDefault();
	                        break;
	                    default: // do nothing
	                }
	            });
	
	            // Listen for parent selection changes to highlight elements
	            this.$scope.$on('rcCalendarSelectionUpdate', function (event, data) {
	                if (_this2.day && data.startTime && data.endTime) {
	                    refreshSelectionClasses(_this2.$element, _this2.day.date.getTime(), data.startTime, data.endTime);
	                }
	            });
	        }
	    }, {
	        key: 'number',
	        value: function number() {
	            return this.day && this.day.date.getDate() || '';
	        }
	    }, {
	        key: 'select',
	        value: function select() {
	            var _this3 = this;
	
	            if (!this.disabled) {
	                this.$scope.$apply(function () {
	                    _this3.popupCtrl.select(_this3.day);
	                });
	            }
	        }
	    }]);
	
	    return RcCalendarDayController;
	}();
	
	exports.default = RcCalendarDayController;
	
	
	function addDayClasses(element, day, disabled) {
	    if (angular.isDefined(day)) {
	        element.addClass('rc-calendar-date');
	        element.addClass(disabled === true ? 'rc-calendar-disabled' : '');
	
	        element.addClass(day.isToday ? 'rc-calendar-today' : '');
	        element.addClass(day.isHoliday ? 'rc-calendar-holiday' : '');
	        element.addClass(day.isFirstOfMonth ? 'rc-calendar-fom' : '');
	        element.addClass(day.isLastOfMonth ? 'rc-calendar-lom' : '');
	    }
	}
	
	function addDayAttributes(element, day) {
	    if (angular.isDefined(day)) {
	        element.attr('tabindex', '0');
	        element.attr('title', day.title);
	    }
	}
	
	var SELECTED_CLASS = 'rc-calendar-selected';
	var START_CLASS = 'rc-calendar-start';
	var END_CLASS = 'rc-calendar-end';
	
	function refreshSelectionClasses(element, time, lowerLimit, upperLimit) {
	    if (time >= lowerLimit && time <= upperLimit) {
	        element.addClass(SELECTED_CLASS);
	        if (lowerLimit === upperLimit && lowerLimit === time) {
	            element.addClass(START_CLASS);
	            element.addClass(END_CLASS);
	        } else {
	            if (time === lowerLimit) {
	                element.addClass(START_CLASS);
	            } else {
	                element.removeClass(START_CLASS);
	            }
	
	            if (time === upperLimit) {
	                element.addClass(END_CLASS);
	            } else {
	                element.removeClass(END_CLASS);
	            }
	        }
	    } else if (element.hasClass(SELECTED_CLASS)) {
	        element.removeClass(SELECTED_CLASS);
	        element.removeClass(START_CLASS);
	        element.removeClass(END_CLASS);
	    }
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _calendarPopupDefault = __webpack_require__(52);
	
	var _calendarPopupDefault2 = _interopRequireDefault(_calendarPopupDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Manages the input model indformation between the calendar popup and the ng-model of
	 * the <input> element
	 */
	
	var RcCalendarController = function () {
	    RcCalendarController.$inject = ["$element", "$scope", "$timeout", "rcCalendarModelConverter", "rcCalendarManager"];
	    function RcCalendarController($element, $scope, $timeout, rcCalendarModelConverter, rcCalendarManager) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarController);
	
	        this.$element = $element;
	        this.$scope = $scope;
	        this.$timeout = $timeout;
	        this.rcCalendarModelConverter = rcCalendarModelConverter;
	        this.rcCalendarManager = rcCalendarManager;
	    }
	
	    // Added to the modelController's $formatters array via input directive
	
	
	    _createClass(RcCalendarController, [{
	        key: 'dateFormatter',
	        value: function dateFormatter(model) {
	            // Sync the displayed calendar to the model if it is manually set
	            this.refreshPopup();
	
	            return this.customFormatter ? this.customFormatter({ $model: model }) : this.rcCalendarModelConverter.formatForDisplay(model);
	        }
	    }, {
	        key: 'onSelectionComplete',
	        value: function onSelectionComplete(selected) {
	            this.togglePopup();
	
	            if (selected) {
	                this.setModel(selected);
	            }
	        }
	    }, {
	        key: 'refreshPopup',
	        value: function refreshPopup() {
	            var _this = this;
	
	            if (this.rcCalendarManager.isOpen(this.$scope)) {
	                this.$timeout(function () {
	                    _this.$scope.$broadcast('rcCalendarPopupRefresh');
	                });
	            }
	        }
	    }, {
	        key: 'setModel',
	        value: function setModel(model) {
	            this.setInputModel(model);
	            this.onModelChange({ '$model': model });
	            this.refreshPopup();
	        }
	    }, {
	        key: 'togglePopup',
	        value: function togglePopup() {
	            if (this.isInputDisabled() !== true) {
	                var isOpen = this.rcCalendarManager.isOpen(this.$scope);
	
	                if (isOpen) {
	                    this.rcCalendarManager.close(this.$scope);
	                } else {
	                    this.rcCalendarManager.open(this.$scope, this.$element, _calendarPopupDefault2.default);
	                }
	
	                this.focusCalendarButton = !isOpen;
	            }
	        }
	    }, {
	        key: 'syncDisabledState',
	        value: function syncDisabledState(isDisabled) {
	            this.$element.attr('disabled', isDisabled);
	            this.$element.find('button').attr('disabled', isDisabled);
	            this.$element.find('input').attr('disabled', isDisabled);
	
	            if (isDisabled) {
	                this.rcCalendarManager.close(this.$scope);
	            }
	        }
	    }]);
	
	    return RcCalendarController;
	}();
	
	exports.default = RcCalendarController;

/***/ },
/* 142 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcCalendarMonthController = function () {
	    function RcCalendarMonthController() {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarMonthController);
	    }
	
	    _createClass(RcCalendarMonthController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var item = this.item();
	            this.heading = item.heading || '';
	            this.weeks = item.weeks || [];
	        }
	    }]);
	
	    return RcCalendarMonthController;
	}();
	
	exports.default = RcCalendarMonthController;

/***/ },
/* 143 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MAX_DATE = exports.MAX_DATE = new Date(8640000000000000);
	var MIN_DATE = exports.MIN_DATE = new Date(-8640000000000000);
	
	// TODO: decompose further...this still feels heavy?
	
	var RcCalendarPopupController = function () {
	    RcCalendarPopupController.$inject = ["$scope", "$element", "$timeout", "rcDate", "rcCalendarDate"];
	    function RcCalendarPopupController($scope, $element, $timeout, rcDate, rcCalendarDate) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarPopupController);
	
	        this.$scope = $scope;
	        this.$element = $element;
	        this.$timeout = $timeout;
	        this.rcDate = rcDate;
	        this.rcCalendarDate = rcCalendarDate;
	    }
	
	    _createClass(RcCalendarPopupController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.multiSelect = !!this.isRange();
	            this.maxDate = this.rcDate.normalizeTime(this.maximumDate()) || MAX_DATE;
	            this.minDate = this.rcDate.normalizeTime(this.minimumDate()) || MIN_DATE;
	            this.disabledMap = this.buildDisabledMap(this.disabledDates());
	        }
	    }, {
	        key: '$postLink',
	        value: function $postLink() {
	            var _this = this;
	
	            /* Refresh depends on content controller being available. Must run after child initialization */
	            this.$scope.$evalAsync(function () {
	                _this.refreshDisplay();
	            });
	
	            this.$scope.$on('rcCalendarPopupRefresh', function () {
	                _this.refreshDisplay();
	            });
	        }
	    }, {
	        key: 'buildDisabledMap',
	        value: function buildDisabledMap(dates) {
	            var _this2 = this;
	
	            var map = {};
	
	            if (angular.isArray(dates)) {
	                dates.forEach(function (date) {
	                    map[_this2.rcDate.normalizeTime(date).getTime()] = true;
	                });
	            }
	
	            return map;
	        }
	
	        // TODO: Promise structure for cancel/complete?
	
	    }, {
	        key: 'cancel',
	        value: function cancel() {
	            this.onComplete({
	                $selected: null
	            });
	        }
	
	        // TODO: Promise structure for cancel/complete?
	
	    }, {
	        key: 'complete',
	        value: function complete() {
	            this.onComplete({
	                $selected: this.selected
	            });
	        }
	    }, {
	        key: 'getMonth',
	        value: function getMonth(date) {
	            if (monthWithin(date, this.minDate, this.maxDate)) {
	                return this.rcCalendarDate.getCalendarMonth(date, {
	                    includeUpHolidays: this.upHolidays() || false,
	                    customHolidays: this.customHolidays() || null
	                });
	            }
	            return null;
	        }
	    }, {
	        key: 'focusToday',
	        value: function focusToday() {
	            this.focused = this.rcDate.normalizeTime(new Date());
	            this.contentCtrl.buildDateView(this.focused);
	            this.updateSelectedHighlighting();
	        }
	    }, {
	        key: 'isCompleteSelection',
	        value: function isCompleteSelection() {
	            if (this.multiSelect) {
	                return angular.isArray(this.selected) && this.selected.length === 2 && this.selected.every(function (entry) {
	                    return angular.isDate(entry);
	                });
	            }
	            return angular.isDate(this.selected);
	        }
	    }, {
	        key: 'isDisabled',
	        value: function isDisabled(calendarDay) {
	            if (calendarDay) {
	                var time = calendarDay.date.getTime();
	                return valueOutside(time, this.minDate.getTime(), this.maxDate.getTime()) || this.disabledMap[time] === true;
	            }
	            return false;
	        }
	    }, {
	        key: 'isFocused',
	        value: function isFocused(calendarDay) {
	            if (calendarDay) {
	                var time = angular.isDate(calendarDay) ? calendarDay.getTime() : calendarDay.date.getTime();
	                return time === this.focused.getTime();
	            }
	            return false;
	        }
	    }, {
	        key: 'refreshDisplay',
	        value: function refreshDisplay() {
	            this.selected = angular.copy(this.selectedDate());
	            this.focused = this.rcDate.normalizeTime(
	            // 1. selected date
	            this.selected && this.selected[0] || this.selected ||
	            // 2. focused-date
	            this.focused ||
	            // 3. today
	            new Date());
	
	            this.contentCtrl.buildDateView(this.focused);
	            this.updateSelectedHighlighting();
	        }
	    }, {
	        key: 'select',
	        value: function select(calendarDay) {
	            if (!calendarDay) {
	                this.selected = null;
	            } else if (this.multiSelect) {
	                if (!angular.isArray(this.selected)) {
	                    this.selected = [];
	                }
	
	                if (this.selected.length === 2) {
	                    this.selected.length = 0;
	                }
	
	                if (this.selected.length === 1) {
	                    if (this.selected[0].getTime() > calendarDay.date.getTime()) {
	                        this.selected.unshift(calendarDay.date);
	                    } else {
	                        this.selected.push(calendarDay.date);
	                    }
	                } else {
	                    this.selected.push(calendarDay.date);
	                }
	            } else {
	                this.selected = calendarDay.date;
	            }
	
	            if (!this.okButton() && this.isCompleteSelection()) {
	                this.complete();
	            }
	
	            this.updateSelectedHighlighting();
	        }
	    }, {
	        key: 'setContentController',
	        value: function setContentController(ctrl) {
	            this.contentCtrl = ctrl;
	        }
	    }, {
	        key: 'showOkButton',
	        value: function showOkButton() {
	            return !!this.okButton() && this.isCompleteSelection();
	        }
	    }, {
	        key: 'updateSelectedHighlighting',
	        value: function updateSelectedHighlighting() {
	            var _this3 = this;
	
	            // Must happen after render but does not require a $digest
	            this.$timeout(function () {
	                var data = {};
	                if (_this3.multiSelect && angular.isArray(_this3.selected)) {
	                    if (_this3.selected.length === 1) {
	                        var firstTime = _this3.rcDate.normalizeTime(_this3.selected[0]).getTime();
	                        data.startTime = firstTime;
	                        data.endTime = firstTime;
	                    } else if (_this3.selected.length === 2) {
	                        data.startTime = _this3.rcDate.normalizeTime(_this3.selected[0]).getTime();
	                        data.endTime = _this3.rcDate.normalizeTime(_this3.selected[1]).getTime();
	                    }
	                } else if (angular.isDate(_this3.selected)) {
	                    var selectedTime = _this3.rcDate.normalizeTime(_this3.selected).getTime();
	                    data.startTime = selectedTime;
	                    data.endTime = selectedTime;
	                }
	
	                _this3.$scope.$broadcast('rcCalendarSelectionUpdate', data);
	            }, 0, false);
	        }
	    }]);
	
	    return RcCalendarPopupController;
	}();
	
	exports.default = RcCalendarPopupController;
	
	
	function getFirstEntry(month) {
	    var week = month.weeks[0];
	    for (var index = 0; index < week.length; index++) {
	        if (week[index]) {
	            return week[index].date;
	        }
	    }
	}
	
	function monthWithin(date, min, max) {
	    if (angular.isDate(date)) {
	        var year = date.getFullYear();
	        var month = date.getMonth();
	
	        if (valueOutside(year, min.getFullYear(), max.getFullYear())) {
	            return false;
	        } else if (year === min.getFullYear() && valueOutside(month, min.getMonth(), max.getMonth())) {
	            return false;
	        }
	        return true;
	    }
	    return false;
	}
	
	function valueOutside(value, min, max) {
	    return value < min || value > max;
	}

/***/ },
/* 144 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MAX_MONTHS = 2;
	
	/**
	 * Calendar content-block. Highly dependent upon rc-calendar-popup controller.
	 */
	
	var RcCalendarScrollContentController = function () {
	    RcCalendarScrollContentController.$inject = ["$scope", "rcDate", "KEYS"];
	    function RcCalendarScrollContentController($scope, rcDate, KEYS) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarScrollContentController);
	
	        this.$scope = $scope;
	        this.rcDate = rcDate;
	        this.KEYS = KEYS;
	    }
	
	    _createClass(RcCalendarScrollContentController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.popupCtrl.setContentController(this);
	        }
	
	        // API used by the popup controller to set the data displayed
	
	    }, {
	        key: 'buildDateView',
	        value: function buildDateView(date) {
	            if (angular.isDate(date)) {
	                this.months = [];
	                // generate month, preceding and following months
	                for (var index = MAX_MONTHS * -1; index <= MAX_MONTHS; index++) {
	                    var seedDate = this.rcDate.buildNormalizedDate(date.getFullYear(), date.getMonth() + index, 1);
	                    var month = this.popupCtrl.getMonth(seedDate);
	                    if (month) {
	                        this.months.push(month);
	                    }
	                }
	            }
	        }
	    }, {
	        key: 'cycleNextMonth',
	        value: function cycleNextMonth() {
	            var seedDate = new Date(getFirstEntry(this.months[this.months.length - 1]));
	            seedDate.setMonth(seedDate.getMonth() + 1);
	            seedDate.setDate(1);
	
	            var month = this.popupCtrl.getMonth(seedDate);
	
	            if (month) {
	                this.popupCtrl.focused = seedDate;
	                this.months.push(month);
	                this.months.shift();
	            }
	        }
	    }, {
	        key: 'cyclePreviousMonth',
	        value: function cyclePreviousMonth(focusLastDay) {
	            var seedDate = new Date(getFirstEntry(this.months[0]));
	            seedDate.setMonth(seedDate.getMonth() - 1);
	            seedDate.setDate(1);
	
	            var month = this.popupCtrl.getMonth(seedDate);
	
	            if (month) {
	                this.popupCtrl.focused = !focusLastDay ? seedDate : this.rcDate.buildNormalizedDate(seedDate.getFullYear(), seedDate.getMonth() + 1, 0);
	                this.months.unshift(month);
	                this.months.pop();
	            }
	        }
	    }, {
	        key: 'onBoundary',
	        value: function onBoundary(boundary, event) {
	            if (boundary === 'top') {
	                this.cyclePreviousMonth(event.keyCode === this.KEYS.TAB && event.shiftKey === true);
	            } else if (boundary === 'bottom') {
	                this.cycleNextMonth();
	            }
	        }
	    }]);
	
	    return RcCalendarScrollContentController;
	}();
	
	exports.default = RcCalendarScrollContentController;
	
	
	function getFirstEntry(month) {
	    var week = month.weeks[0];
	    for (var index = 0; index < week.length; index++) {
	        if (week[index]) {
	            return week[index].date;
	        }
	    }
	}

/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	
	var RcCalendarWeekHeadersController = function RcCalendarWeekHeadersController() {
	    'ngInject';
	
	    _classCallCheck(this, RcCalendarWeekHeadersController);
	
	    this.days = DAY_NAMES;
	};
	
	exports.default = RcCalendarWeekHeadersController;

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcCalendarWeekController = function () {
	    RcCalendarWeekController.$inject = ["$element"];
	    function RcCalendarWeekController($element) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarWeekController);
	
	        $element.addClass('rc-calendar-week');
	    }
	
	    _createClass(RcCalendarWeekController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.week = this.item() || [];
	        }
	    }]);
	
	    return RcCalendarWeekController;
	}();
	
	exports.default = RcCalendarWeekController;

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	RcCalendarInputDirective.$inject = ["$parse", "rcCalendarModelConverter"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = RcCalendarInputDirective;
	
	/*
	 * Provides access to ng-model by augmenting the calendar controller functionality
	 */
	function RcCalendarInputDirective($parse, rcCalendarModelConverter) {
	    'ngInject';
	
	    return {
	        require: ['?ngModel', '?^^rcCalendar'],
	        link: RcCalendarInputLink
	    };
	
	    function RcCalendarInputLink(scope, element, attrs, controllers) {
	        var _controllers = _slicedToArray(controllers, 2);
	
	        var modelCtrl = _controllers[0];
	        var calendarCtrl = _controllers[1];
	
	
	        if (modelCtrl && calendarCtrl) {
	            (function () {
	                // Add formatter
	                modelCtrl.$formatters.push(function (value) {
	                    return calendarCtrl.dateFormatter(value);
	                });
	
	                calendarCtrl.getInputModel = function () {
	                    return modelCtrl.$modelValue;
	                };
	
	                var assignInputModel = $parse(attrs.ngModel).assign;
	                calendarCtrl.setInputModel = function (value) {
	                    assignInputModel(scope, value);
	                };
	
	                calendarCtrl.isInputDisabled = function () {
	                    return element[0].disabled;
	                };
	
	                element.bind('blur', function () {
	                    var typed = modelCtrl.$viewValue;
	                    if (typed) {
	                        var parsed = rcCalendarModelConverter.parseDate(typed);
	                        if (!angular.equals(parsed, modelCtrl.$modelValue)) {
	                            calendarCtrl.setModel(parsed); // different than calendarCtrl.setInputModel
	                        }
	                    }
	                    scope.$apply();
	                });
	
	                attrs.$observe('disabled', function (isDisabled) {
	                    calendarCtrl.syncDisabledState(isDisabled);
	                });
	            })();
	        }
	    }
	}

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcCalendarDirective.$inject = ["$compile", "$log", "Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = rcCalendarDirective;
	
	var _calendar = __webpack_require__(141);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _calendar3 = __webpack_require__(57);
	
	var _calendar4 = _interopRequireDefault(_calendar3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* TODO: Add button onclick attr to the rc-calendar to allow custom things for picker button. */
	function rcCalendarDirective($compile, $log, Usage) {
	    'ngInject';
	
	    return {
	        scope: {
	            appHolidays: '&',
	            customFormatter: '&?',
	            disabledDates: '=?',
	            focusedDate: '=?',
	            holidays: '&',
	            maxDate: '&',
	            minDate: '&',
	            okButton: '@',
	            onModelChange: '&',
	            pickRange: '@',
	            todayButton: '@'
	        },
	        restrict: 'E',
	        transclude: true,
	        template: _calendar4.default,
	        controller: _calendar2.default,
	        controllerAs: 'rcCalCtrl',
	        bindToController: true,
	        compile: RcCalendarCompile
	    };
	
	    // The 'rc-input-model' is used as a non-bound, helper attribute to
	    // set the generated input's 'ng-model' variable
	    function RcCalendarCompile(element, attrs) {
	        if (element[0].hasAttribute('ng-model')) {
	            $log.warn('Use of the \'ng-model\' on the <rc-calendar> element is deprecated. ' + 'If an <input> has _NOT_ been transcluded with its own \'ng-model\' attribute, ' + 'please use the \'rc-input-model\' attribute instead.');
	            $log.warn(element[0]);
	
	            if (!element[0].hasAttribute('rc-input-model')) {
	                attrs.$set('rcInputModel', attrs.ngModel);
	                element.attr('rc-input-model', attrs.ngModel);
	            }
	        }
	        return RcCalendarLink;
	    }
	
	    // Needs tightening up between conroller/directive functions
	    function RcCalendarLink(scope, element, attrs, calendarCtrl, transclude) {
	        Usage.register('calendar');
	
	        transclude(function (clone) {
	            var transcludedInput = getTranscludedInputElement(clone);
	            setInputAttributes(transcludedInput, attrs);
	
	            // Add to the DOM before compiling to allow proper rendering of other <input> templates (validation)
	            var buttonAddon = element.children().eq(0);
	            var buttonFixElement = buttonAddon.children().eq(0);
	            buttonAddon[0].insertBefore(transcludedInput[0], buttonFixElement[0]);
	
	            if (transcludedInput.hasNoScope === true) {
	                delete transcludedInput.hasNoScope;
	                $compile(transcludedInput)(scope.$parent);
	            }
	        });
	
	        /* Disabled state can come from the calendar or the input but should apply to both at all times. */
	        var inputElement = element.find('input');
	        attrs.$observe('disabled', function (isDisabled) {
	            calendarCtrl.syncDisabledState(isDisabled);
	        });
	    }
	
	    function syncDisabledState(calendarEl, inputEl, buttonEl) {
	        return function (state) {
	            calendarEl.attr('disabled', state);
	            inputEl.attr('disabled', state);
	            buttonEl.attr('disabled', state);
	        };
	    }
	
	    function getTranscludedInputElement(clone) {
	        var transcludedInput = findProvidedInput(clone);
	
	        if (!transcludedInput) {
	            transcludedInput = angular.element('<input></input>');
	            transcludedInput.attr({
	                type: 'text'
	            });
	            transcludedInput.hasNoScope = true;
	        }
	
	        return transcludedInput;
	    }
	
	    function findProvidedInput(clone) {
	        var transcluded = void 0;
	
	        for (var index = 0; index < clone.length; index++) {
	            if (clone[index].tagName === 'INPUT') {
	                transcluded = clone.eq(index);
	            }
	        }
	
	        return transcluded;
	    }
	
	    function setInputAttributes(input, attrs) {
	        if (input) {
	            var inputModel = input.attr('ng-model');
	            if (angular.isUndefined(inputModel)) {
	                if (angular.isUndefined(attrs.rcInputModel)) {
	                    throw new Error('The \'rc-input-model\' attribute must be defined on the <rc-calendar> ' + 'if an input has not been transcluded.');
	                } else {
	                    input.attr('ng-model', attrs.rcInputModel);
	                }
	            } else if (angular.isDefined(inputModel) && angular.isDefined(attrs.rcInputModel) && inputModel !== attrs.rcInputModel) {
	                $log.warn('The \'rc-input-model\' attribute of the <rc-calendar> "' + attrs.rcInputModel + '" does not reference ' + ('the same model as the transcluded <input>s \'ng-model\' "' + inputModel + '"'));
	                $log.warn(input);
	            }
	            // Disable HTML5 Autocomplete feature; as it will get in the way of the dropdown.
	            input.attr('autocomplete', 'off');
	        }
	    }
	}

/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return function firstLetterFilter(value) {
	        if (angular.isString(value) && value.length >= 1) {
	            return value.slice(0, 1);
	        }
	        return value;
	    };
	};

/***/ },
/* 150 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	/* Provides calendar-specific data objects.
	 * There is a bit of brittleness due to the getTime() comparisons but those should probably be private methods. */
	
	var RcCalendarDateService = function () {
	    RcCalendarDateService.$inject = ["rcDate", "rcHoliday"];
	    function RcCalendarDateService(rcDate, rcHoliday) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarDateService);
	
	        this.rcDate = rcDate;
	        this.rcHoliday = rcHoliday;
	    }
	
	    _createClass(RcCalendarDateService, [{
	        key: 'buildCalendarDay',
	        value: function buildCalendarDay(date, upHolidayMap, customHolidayMap) {
	            if (angular.isDate(date)) {
	                var holidayMap = upHolidayMap || {};
	                var customMap = customHolidayMap || {};
	
	                return {
	                    date: date,
	                    isToday: this.rcDate.isToday(date),
	                    isFirstOfMonth: date.getDate() === 1,
	                    isLastOfMonth: isLastOfMonth(date),
	                    isHoliday: angular.isDefined(holidayMap[date.getTime()]) || angular.isDefined(customMap[date.getTime()]),
	                    title: this.buildCalendarTitle(date, holidayMap, customMap)
	                };
	            }
	            return {};
	        }
	    }, {
	        key: 'buildCalendarTitle',
	        value: function buildCalendarTitle(date, upHolidayMap, customHolidayMap) {
	            var title = '';
	
	            if (this.rcDate.isToday(date)) {
	                title += 'Today';
	            }
	
	            var upDay = upHolidayMap && upHolidayMap[date.getTime()];
	            if (upDay) {
	                title += title.length > 0 ? ' / ' + upDay : upDay;
	            }
	
	            var custom = customHolidayMap && customHolidayMap[date.getTime()];
	            if (custom) {
	                title += title.length > 0 ? ' / ' + custom : custom;
	            }
	
	            return title;
	        }
	    }, {
	        key: 'buildCustomTimeMap',
	        value: function buildCustomTimeMap(entries) {
	            var map = {};
	
	            if (entries && entries.length > 0) {
	                for (var index = 0; index < entries.length; index++) {
	                    var date = entries[index].date;
	                    if (angular.isDate(date)) {
	                        map[this.rcDate.normalizeTime(date).getTime()] = entries[index].name;
	                    }
	                }
	            }
	
	            return map;
	        }
	    }, {
	        key: 'convertToCalendarDays',
	        value: function convertToCalendarDays(dates, locals) {
	            var days = [];
	
	            if (angular.isArray(dates) && dates.length > 0) {
	                var upHolidayMap = {};
	                var customHolidayMap = {};
	
	                if (locals) {
	                    upHolidayMap = locals.includeUpHolidays === true ? this.rcHoliday.getUpHolidayTimeMap(dates[0].getFullYear()) : {};
	                    customHolidayMap = this.buildCustomTimeMap(locals.customHolidays);
	                }
	
	                var indexDate = void 0;
	                for (var index = 0; index < dates.length; index++) {
	                    indexDate = dates[index];
	                    days.push(this.buildCalendarDay(dates[index], upHolidayMap, customHolidayMap));
	                }
	            }
	
	            return days;
	        }
	    }, {
	        key: 'convertToCalendarWeeks',
	        value: function convertToCalendarWeeks(calendarDays) {
	            var weeks = [];
	
	            if (angular.isArray(calendarDays) && calendarDays.length > 0) {
	                // Prefix undefined values back to Sunday
	                for (var prefix = calendarDays[0].date.getDay() - 1; prefix >= 0; prefix--) {
	                    calendarDays.unshift(void 0);
	                }
	                // Postfix any missing days
	                var suffix = 6 - calendarDays.length % 7;
	                for (; suffix > -1 && suffix !== 6; suffix--) {
	                    calendarDays.push(void 0);
	                }
	
	                for (var index = 0; index < calendarDays.length; index += 7) {
	                    weeks.push(calendarDays.slice(index, index + 7));
	                }
	            }
	
	            return weeks;
	        }
	    }, {
	        key: 'getCalendarMonth',
	        value: function getCalendarMonth(date, locals) {
	            var calendarMonth = {};
	
	            if (angular.isDate(date)) {
	                var calendarDays = this.convertToCalendarDays(this.rcDate.monthFor(date), locals);
	
	                calendarMonth.heading = MONTH_NAMES[date.getMonth()] + ' ' + date.getFullYear();
	                calendarMonth.weeks = this.convertToCalendarWeeks(calendarDays);
	            }
	
	            return calendarMonth;
	        }
	    }]);
	
	    return RcCalendarDateService;
	}();
	
	exports.default = RcCalendarDateService;
	
	
	function isLastOfMonth(date) {
	    if (angular.isDate(date)) {
	        var end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
	        return date.getDate() === end.getDate();
	    }
	    return false;
	}

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RENDERING_CLASS = 'rendering';
	
	/* Allows only one open calendar at a time */
	
	var RcCalendarManagerService = function () {
	    RcCalendarManagerService.$inject = ["$document", "$compile", "$timeout", "rcMediaQuery", "rcCalendarPosition", "KEYS"];
	    function RcCalendarManagerService($document, $compile, $timeout, rcMediaQuery, rcCalendarPosition, KEYS) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarManagerService);
	
	        this.documentBody = $document.find('body');
	        this.$compile = $compile;
	        this.$timeout = $timeout;
	        this.rcMediaQuery = rcMediaQuery;
	        this.rcCalendarPosition = rcCalendarPosition;
	        this.escapeKey = KEYS.ESC;
	
	        this.current = null;
	
	        this.bindWindowEvents();
	    }
	
	    _createClass(RcCalendarManagerService, [{
	        key: 'bindWindowEvents',
	        value: function bindWindowEvents() {
	            var _this = this;
	
	            var theWindow = angular.element(window);
	            // Lightweight 'open' calendar closers :)
	            theWindow.bind('resize', function () {
	                if (_this.current !== null) {
	                    _this.close(_this.current.scope);
	                }
	            });
	            theWindow.bind('keydown', function (event) {
	                if (event.keyCode === _this.escapeKey && _this.current !== null) {
	                    _this.close(_this.current.scope);
	                }
	            });
	        }
	    }, {
	        key: 'open',
	        value: function open(scope, sourceElement, template) {
	            var _this2 = this;
	
	            if (this.current !== null) {
	                this.close(this.current.scope);
	            }
	
	            var popup = angular.element(template);
	            popup.addClass(RENDERING_CLASS); // hides while rendering
	
	            this.current = {
	                popup: popup,
	                scope: scope,
	                source: sourceElement,
	                childScope: scope.$new()
	            };
	
	            this.documentBody.append(this.current.popup);
	            this.$compile(this.current.popup)(this.current.childScope);
	
	            if (this.rcMediaQuery.minSize('medium')) {
	                // Must be measured after all rendering or measurements are incomplete
	                this.$timeout(function () {
	                    _this2.current.popup.css(_this2.rcCalendarPosition.getInlineCss(_this2.current.source, _this2.current.popup));
	                    _this2.current.popup.removeClass(RENDERING_CLASS); // stops hiding
	                });
	            } else {
	                    this.current.popup.css(this.rcCalendarPosition.getInlineCss(this.current.source, this.current.popup));
	                    this.lockBodyForMobile();
	
	                    this.current.popup.removeClass(RENDERING_CLASS); // stops hiding
	                }
	        }
	    }, {
	        key: 'lockBodyForMobile',
	        value: function lockBodyForMobile() {
	            this.current.pagePosition = {
	                top: this.documentBody[0].scrollTop,
	                left: this.documentBody[0].scrollLeft
	            };
	
	            this.documentBody[0].scrollTop = 0;
	            this.documentBody[0].scrollLeft = 0;
	            this.documentBody.addClass('rc-calendar-open');
	        }
	    }, {
	        key: 'unlockBodyForMobile',
	        value: function unlockBodyForMobile() {
	            if (this.current.pagePosition) {
	                this.documentBody[0].scrollTop = this.current.pagePosition.top;
	                this.documentBody[0].scrollLeft = this.current.pagePosition.left;
	            }
	            this.documentBody.removeClass('rc-calendar-open');
	        }
	    }, {
	        key: 'isOpen',
	        value: function isOpen(scope) {
	            return scope && this.current && scope === this.current.scope;
	        }
	    }, {
	        key: 'close',
	        value: function close(scope) {
	            if (this.isOpen(scope)) {
	                this.current.childScope.$destroy();
	                this.unlockBodyForMobile();
	                this.current.popup.remove();
	                this.current = null;
	            }
	        }
	    }]);
	
	    return RcCalendarManagerService;
	}();
	
	exports.default = RcCalendarManagerService;

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SEPARATOR_REGEX = /\s*,\s*|\s*;\s*|\s*-\s+|\s+-\s*/g;
	var DEFAULT_SEPARATOR = ' - ';
	
	var CalendarModelConverterService = function () {
	    CalendarModelConverterService.$inject = ["rcDate"];
	    function CalendarModelConverterService(rcDate) {
	        'ngInject';
	
	        _classCallCheck(this, CalendarModelConverterService);
	
	        this.rcDate = rcDate;
	    }
	
	    _createClass(CalendarModelConverterService, [{
	        key: 'formatForDisplay',
	        value: function formatForDisplay(model) {
	            if (angular.isDate(model)) {
	                return dateToString(model);
	            } else if (angular.isArray(model)) {
	                var range = dateToString(model[0]);
	                if (model.length > 1) {
	                    range += DEFAULT_SEPARATOR + dateToString(model[1]);
	                }
	                return range;
	            }
	
	            return model;
	        }
	    }, {
	        key: 'parseDate',
	        value: function parseDate(inputString) {
	            if (angular.isUndefined(inputString)) {
	                return inputString;
	            }
	            /* Separator is either:
	             * 1. comma or semicolon with 0+ spaces before and/or after,
	             * 2. dash with 1+ spaces before and/or after, or
	             * 3. dash if there's only one in the string. */
	            var separator = inputString.match(SEPARATOR_REGEX);
	            if (!separator) {
	                separator = inputString.match(/-/g);
	            }
	
	            if (separator && separator.length === 1) {
	                var dateRange = inputString.split(separator);
	                for (var i = 0; i < dateRange.length; i++) {
	                    var newDate = this.rcDate.convertToDate(dateRange[i]);
	                    if (angular.isDate(newDate) && newDate.toString() === 'Invalid Date') {
	                        continue;
	                    } else {
	                        dateRange[i] = newDate;
	                    }
	                }
	                return dateRange;
	            }
	
	            return this.rcDate.convertToDate(inputString);
	        }
	    }]);
	
	    return CalendarModelConverterService;
	}();
	
	exports.default = CalendarModelConverterService;
	
	
	function dateToString(date) {
	    if (angular.isDate(date)) {
	        var year = date.getFullYear();
	        var month = ('0' + (date.getMonth() + 1)).slice(-2);
	        var day = ('0' + date.getDate()).slice(-2);
	        return month + '/' + day + '/' + year;
	    }
	    return '';
	}

/***/ },
/* 153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcCalendarPositionService = function () {
	    RcCalendarPositionService.$inject = ["$window", "$position", "rcMediaQuery"];
	    function RcCalendarPositionService($window, $position, rcMediaQuery) {
	        'ngInject';
	
	        _classCallCheck(this, RcCalendarPositionService);
	
	        this.$window = $window;
	        this.$position = $position;
	        this.rcMediaQuery = rcMediaQuery;
	    }
	
	    _createClass(RcCalendarPositionService, [{
	        key: 'buildDesktopCss',
	        value: function buildDesktopCss(calendarElement, popupElement) {
	            var verticallyAdjusted = false;
	            // div.button-addon element
	            var target = calendarElement.children().eq(0);
	            var offset = this.$position.offset(target);
	
	            var css = {
	                top: offset.top,
	                left: offset.left
	            };
	
	            // Align below, else above, else adjust to vertical space
	            if (this.$window.pageYOffset + this.$window.innerHeight - offset.top - offset.height > popupElement[0].offsetHeight) {
	                css.top = offset.top + offset.height;
	            } else if (offset.top - this.$window.pageYOffset > popupElement[0].offsetHeight) {
	                css.top = offset.top - popupElement[0].offsetHeight;
	            } else {
	                this.sizeContentToAvailableSpace(popupElement);
	                css.top = this.$window.pageYOffset;
	                verticallyAdjusted = true;
	            }
	
	            /* 1. Right of the button
	             * 2. Left of the button (overlay the input),
	             * 3. Match the left of the input (overlays input and button) */
	            if (verticallyAdjusted) {
	                // grab span.buttonfix
	                var buttonSpan = target.find('span');
	                if (this.$window.innerWidth - offset.left - offset.width > popupElement[0].offsetWidth) {
	                    css.left = offset.left + offset.width;
	                } else if (offset.width - buttonSpan[0].offsetWidth > popupElement[0].offsetWidth) {
	                    css.left = offset.left + offset.width - buttonSpan[0].offsetWidth - popupElement[0].offsetWidth;
	                }
	            } else {
	                var fromTheRight = offset.left + offset.width - popupElement[0].offsetWidth;
	                css.left = Math.max(offset.left, fromTheRight);
	            }
	
	            css.top = Math.ceil(css.top) + 'px';
	            css.left = Math.ceil(css.left) + 'px';
	
	            return css;
	        }
	    }, {
	        key: 'buildMobileCss',
	        value: function buildMobileCss(popupElement) {
	            return {
	                width: Math.floor(this.$window.innerWidth) + 'px',
	                height: Math.floor(this.$window.innerHeight) + 'px'
	            };
	        }
	    }, {
	        key: 'getInlineCss',
	        value: function getInlineCss(calendarElement, popupElement) {
	            if (this.rcMediaQuery.minSize('medium')) {
	                return this.buildDesktopCss(calendarElement, popupElement);
	            } else {
	                return this.buildMobileCss(popupElement);
	            }
	        }
	    }, {
	        key: 'sizeContentToAvailableSpace',
	        value: function sizeContentToAvailableSpace(popup) {
	            if (popup[0].offsetHeight > this.$window.innerHeight) {
	                var header = popup.children().eq(0);
	                var content = popup.children().eq(1).children().eq(0);
	
	                content.css({
	                    // 5 pixels seems to make the difference in IE, but only M$ knows why..... :-(
	                    height: Math.floor(this.$window.innerHeight - header[0].offsetHeight - 5) + 'px'
	                });
	            }
	        }
	    }]);
	
	    return RcCalendarPositionService;
	}();
	
	exports.default = RcCalendarPositionService;

/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Cache previously generated months
	var MONTHS = {};
	var DATE_REGEX = /^(0?[1-9]|1[012])[\\\-.: \/]?([^0-9][1-9]|0[1-9]|[12][0-9]|3[01])[\\\-.: \/]?([0-9]{2}|[0-9]{4})?$/;
	
	/** Utility service for generating and normalizing date objects */
	
	var RcDateService = function () {
	    function RcDateService() {
	        'ngInject';
	
	        _classCallCheck(this, RcDateService);
	    }
	
	    _createClass(RcDateService, [{
	        key: 'buildNormalizedDate',
	        value: function buildNormalizedDate(year, month, day) {
	            return new Date(year, month, day, 0, 0, 0, 0);
	        }
	    }, {
	        key: 'convertToDate',
	        value: function convertToDate(stringValue) {
	            if (angular.isDefined(stringValue)) {
	                var matches = stringValue.match(DATE_REGEX);
	                if (matches) {
	                    var first = scrubDigit(matches[1]);
	                    var second = scrubDigit(matches[2]);
	                    var year = scrubDigit(matches[3]);
	
	                    if (angular.isUndefined(year)) {
	                        year = new Date().getFullYear();
	                    }
	
	                    return this.normalizeTime(new Date(first + '/' + second + '/' + parseTwoDigitYear(year)));
	                }
	            }
	            return stringValue;
	        }
	    }, {
	        key: 'isToday',
	        value: function isToday(date) {
	            if (angular.isDate(date)) {
	                return this.normalizeTime(new Date()).getTime() === this.normalizeTime(date).getTime();
	            }
	            return false;
	        }
	    }, {
	        key: 'monthFor',
	        value: function monthFor(date) {
	            if (!angular.isDate(date)) {
	                return [];
	            }
	
	            var month = MONTHS[date.getMonth() + '-' + date.getFullYear()] || [];
	
	            if (month.length === 0) {
	                var index = this.buildNormalizedDate(date.getFullYear(), date.getMonth(), 1);
	                var monthEnd = this.buildNormalizedDate(date.getFullYear(), date.getMonth() + 1, 0).getTime();
	
	                for (; index.getTime() <= monthEnd; index.setDate(index.getDate() + 1)) {
	                    month.push(new Date(index));
	                }
	
	                MONTHS[date.getMonth() + '-' + date.getFullYear()] = month;
	            }
	
	            return month;
	        }
	    }, {
	        key: 'normalizeTime',
	        value: function normalizeTime(date) {
	            if (angular.isDate(date)) {
	                return this.buildNormalizedDate(date.getFullYear(), date.getMonth(), date.getDate());
	            }
	            return date;
	        }
	    }]);
	
	    return RcDateService;
	}();
	
	exports.default = RcDateService;
	
	
	function scrubDigit(value) {
	    if (value) {
	        return value.replace(/[^\d]/, '');
	    }
	    return value;
	}
	/*
	 * JS engines are inconsistent on 2 digit year implementations:
	 * Year value '00' for IE & FF is 1900 but in Chrome its 2000
	 * Year value '50' for IE & FF is 1950 but in Chrome its 1950 <-- not handled yet
	 * This pushes low numbers up and high numbers down with a rough, 30-year mechanism.
	 * Lifted from Ricola 2!
	 */
	function parseTwoDigitYear(value) {
	    if (angular.isString(value)) {
	        value = parseInt(value, 10);
	    }
	    if (value > 99) {
	        return value;
	    }
	    var year = new Date().getFullYear();
	    // current year + 30 < value ? 19xx : 20xx
	    return (Math.floor(year / 100) - (year % 100 + 30 < value ? 1 : 0)) * 100 + value;
	}

/***/ },
/* 155 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* Cache of previously caculated holidays by year */
	var HOLIDAYS = {};
	
	var RcHolidayService = function () {
	    RcHolidayService.$inject = ["rcDate"];
	    function RcHolidayService(rcDate) {
	        'ngInject';
	
	        _classCallCheck(this, RcHolidayService);
	
	        this.rcDate = rcDate;
	        this.onConstruct();
	    }
	
	    // Init cache with most likely year
	
	
	    _createClass(RcHolidayService, [{
	        key: 'onConstruct',
	        value: function onConstruct() {
	            var today = new Date();
	            HOLIDAYS[today.getFullYear()] = this.buildUpHolidayTimeMap(today.getFullYear());
	        }
	    }, {
	        key: 'isUpHoliday',
	        value: function isUpHoliday(date) {
	            if (angular.isDate(date)) {
	                var normalized = this.rcDate.normalizeTime(date);
	                var map = this.getUpHolidayTimeMap(normalized);
	                return angular.isDefined(map[normalized.getTime()]);
	            }
	            return false;
	        }
	    }, {
	        key: 'getUpHolidayTimeMap',
	        value: function getUpHolidayTimeMap(date) {
	            if (angular.isDate(date)) {
	                var yearOfHolidays = HOLIDAYS[date.getFullYear()];
	
	                if (!yearOfHolidays) {
	
	                    yearOfHolidays = this.buildUpHolidayTimeMap(date.getFullYear());
	                    HOLIDAYS[date.getFullYear()] = yearOfHolidays;
	                }
	                return yearOfHolidays;
	            }
	            return {};
	        }
	
	        /* build a fresh map **/
	
	    }, {
	        key: 'buildUpHolidayTimeMap',
	        value: function buildUpHolidayTimeMap(year) {
	            var map = {};
	
	            map[this.newYearsDay(year).getTime()] = 'New Year\'s Day';
	            map[this.presidentsDay(year).getTime()] = 'President\'s Day';
	            map[this.goodFriday(year).getTime()] = 'Good Friday';
	            map[this.memorialDay(year).getTime()] = 'Memorial Day';
	            map[this.independenceDay(year).getTime()] = 'Independence Day';
	            map[this.laborDay(year).getTime()] = 'Labor Day';
	            map[this.thanksgivingDay(year).getTime()] = 'Thanksgiving Day';
	            map[this.thanksgivingFriday(year).getTime()] = 'Day After Thanksgiving';
	            map[this.christmasEve(year).getTime()] = 'Christmas Eve';
	            map[this.christmasDay(year).getTime()] = 'Christmas Day';
	            map[this.newYearsEve(year).getTime()] = 'New Year\'s Eve';
	
	            return map;
	        }
	    }, {
	        key: 'christmasEve',
	        value: function christmasEve(year) {
	            return this.rcDate.buildNormalizedDate(year, 11, 24);
	        }
	    }, {
	        key: 'christmasDay',
	        value: function christmasDay(year) {
	            return this.rcDate.buildNormalizedDate(year, 11, 25);
	        }
	
	        // Public domain per http://www.irt.org/utility/smprint.htm#software
	        // Code from http://www.irt.org/articles/js052/index.htm
	
	    }, {
	        key: 'easter',
	        value: function easter(year) {
	            var C = Math.floor(year / 100),
	                N = year - 19 * Math.floor(year / 19),
	                K = Math.floor((C - 17) / 25),
	                I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15,
	                J = void 0,
	                L = void 0,
	                month = void 0,
	                day = void 0;
	
	            I = I - 30 * Math.floor(I / 30);
	            I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
	            J = year + Math.floor(year / 4) + I + 2 - C + Math.floor(C / 4);
	            J = J - 7 * Math.floor(J / 7);
	            L = I - J;
	            month = 3 + Math.floor((L + 40) / 44);
	            day = L + 28 - 31 * Math.floor(month / 4);
	            return this.rcDate.buildNormalizedDate(year, month - 1, day);
	        }
	    }, {
	        key: 'goodFriday',
	        value: function goodFriday(year) {
	            var friday = new Date(this.easter(year));
	            friday.setDate(friday.getDate() - 2);
	            return this.rcDate.normalizeTime(friday);
	        }
	    }, {
	        key: 'independenceDay',
	        value: function independenceDay(year) {
	            return this.rcDate.buildNormalizedDate(year, 6, 4);
	        }
	    }, {
	        key: 'laborDay',
	        value: function laborDay(year) {
	            var labor = new Date();
	            // First Monday of September
	            for (var index = 1; index < 30; index++) {
	                labor.setFullYear(year, 8, index);
	                if (labor.getDay() === 1) {
	                    return this.rcDate.normalizeTime(labor);
	                }
	            }
	        }
	    }, {
	        key: 'memorialDay',
	        value: function memorialDay(year) {
	            // Work backwards from the month end to find last Monday
	            var memDay = this.rcDate.buildNormalizedDate(year, 5, 0);
	            for (var index = memDay.getDate(); index > 0; index--) {
	                if (memDay.getDay() === 1) {
	                    return memDay;
	                }
	                memDay.setDate(index);
	            }
	        }
	    }, {
	        key: 'newYearsEve',
	        value: function newYearsEve(year) {
	            return this.rcDate.buildNormalizedDate(year, 11, 31);
	        }
	    }, {
	        key: 'newYearsDay',
	        value: function newYearsDay(year) {
	            return this.rcDate.buildNormalizedDate(year, 0, 1);
	        }
	    }, {
	        key: 'presidentsDay',
	        value: function presidentsDay(year) {
	            var presDay = this.rcDate.buildNormalizedDate(year, 1, 1);
	            // Third Monday of February
	            for (var j = 1; j < 29; j++) {
	                presDay.setDate(j);
	                if (presDay.getDay() === 1) {
	                    presDay.setFullYear(year, 1, j + 14);
	                    return this.rcDate.normalizeTime(presDay);
	                }
	            }
	        }
	    }, {
	        key: 'thanksgivingDay',
	        value: function thanksgivingDay(year) {
	            var turkey = new Date();
	            // Fourth Thursday in November
	            for (var j = 1; j < 31; j++) {
	                turkey.setFullYear(year, 10, j);
	                if (turkey.getDay() === 4) {
	                    turkey.setFullYear(year, 10, j + 21);
	                    return this.rcDate.normalizeTime(turkey);
	                }
	            }
	        }
	    }, {
	        key: 'thanksgivingFriday',
	        value: function thanksgivingFriday(year) {
	            var leftovers = new Date(this.thanksgivingDay(year));
	            leftovers.setDate(leftovers.getDate() + 1);
	            return this.rcDate.normalizeTime(leftovers);
	        }
	    }]);
	
	    return RcHolidayService;
	}();
	
	exports.default = RcHolidayService;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _focus = __webpack_require__(15);
	
	var _focus2 = _interopRequireDefault(_focus);
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _position = __webpack_require__(4);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _calendarService = __webpack_require__(150);
	
	var _calendarService2 = _interopRequireDefault(_calendarService);
	
	var _calendarService3 = __webpack_require__(151);
	
	var _calendarService4 = _interopRequireDefault(_calendarService3);
	
	var _calendarServiceModel = __webpack_require__(152);
	
	var _calendarServiceModel2 = _interopRequireDefault(_calendarServiceModel);
	
	var _calendarService5 = __webpack_require__(153);
	
	var _calendarService6 = _interopRequireDefault(_calendarService5);
	
	var _date = __webpack_require__(154);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _holiday = __webpack_require__(155);
	
	var _holiday2 = _interopRequireDefault(_holiday);
	
	var _calendarComponent = __webpack_require__(134);
	
	var _calendarComponent2 = _interopRequireDefault(_calendarComponent);
	
	var _calendarComponent3 = __webpack_require__(135);
	
	var _calendarComponent4 = _interopRequireDefault(_calendarComponent3);
	
	var _calendarComponent5 = __webpack_require__(136);
	
	var _calendarComponent6 = _interopRequireDefault(_calendarComponent5);
	
	var _calendarComponentScroll = __webpack_require__(137);
	
	var _calendarComponentScroll2 = _interopRequireDefault(_calendarComponentScroll);
	
	var _calendarComponent7 = __webpack_require__(139);
	
	var _calendarComponent8 = _interopRequireDefault(_calendarComponent7);
	
	var _calendarComponentWeek = __webpack_require__(138);
	
	var _calendarComponentWeek2 = _interopRequireDefault(_calendarComponentWeek);
	
	var _calendar = __webpack_require__(148);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _calendarDirective = __webpack_require__(147);
	
	var _calendarDirective2 = _interopRequireDefault(_calendarDirective);
	
	var _isolateScroll = __webpack_require__(157);
	
	var _isolateScroll2 = _interopRequireDefault(_isolateScroll);
	
	var _calendarFilter = __webpack_require__(149);
	
	var _calendarFilter2 = _interopRequireDefault(_calendarFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.calendar', [_focus2.default.name, _keyboardNavigation2.default.name, _mediaQuery2.default.name, _position2.default.name, _usage2.default.name, _utils2.default.name]).component('rcCalendarDay', _calendarComponent2.default).component('rcCalendarMonth', _calendarComponent4.default).component('rcCalendarPopup', _calendarComponent6.default).component('rcCalendarScrollContent', _calendarComponentScroll2.default).component('rcCalendarWeek', _calendarComponent8.default).component('rcCalendarWeekHeaders', _calendarComponentWeek2.default).directive('input', _calendarDirective2.default).directive('rcCalendar', _calendar2.default).directive('rcIsolateScroll', _isolateScroll2.default).filter('firstLetter', _calendarFilter2.default).service('rcCalendarDate', _calendarService2.default).service('rcCalendarManager', _calendarService4.default).service('rcCalendarModelConverter', _calendarServiceModel2.default).service('rcCalendarPosition', _calendarService6.default).service('rcDate', _date2.default).service('rcHoliday', _holiday2.default);

/***/ },
/* 157 */
/***/ function(module, exports) {

	'use strict';
	
	RcIsolateScroll.$inject = ["$parse", "KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcIsolateScroll;
	var BOUNDS = {
	    top: 'top',
	    bottom: 'bottom'
	};
	
	// TODO: Abstract to global directive? Kinda calendar-specific right now
	function RcIsolateScroll($parse, KEYS) {
	    'ngInject';
	
	    return {
	        link: RcIsolateScrollLink
	    };
	
	    function RcIsolateScrollLink(scope, element, attrs) {
	        var onBoundary = $parse(attrs.rcIsolateScroll);
	
	        offsetTop();
	
	        // Manage manual scrollbar interaction, otherwise do not interfere with scrolling
	        var mouseKeyDown = false;
	        element.on('mousedown', function (event) {
	            mouseKeyDown = true;
	        });
	        element.on('mouseup', function (event) {
	            mouseKeyDown = false;
	        });
	        element.on('scroll', function (event) {
	            if (mouseKeyDown) {
	                if (distanceToTopEdge() === 0) {
	                    topEdgeHit(event);
	                    offsetTop();
	                } else if (distanceToBottomEdge() === 0) {
	                    bottomEdgeHit(event);
	                    offsetBottom();
	                }
	            }
	        });
	
	        element.on('touchmove', function () {
	            // This needs some smoothing/debouncing
	            if (distanceToTopEdge() === 0) {
	                stopEvent(event);
	                topEdgeHit(event);
	                offsetTop();
	            } else if (distanceToBottomEdge() === 0) {
	                stopEvent(event);
	                bottomEdgeHit(event);
	                offsetBottom();
	            }
	        });
	
	        element.on('wheel', function (event) {
	            var delta = event.deltaY;
	            if (delta < 0 && distanceToTopEdge() <= 0) {
	                stopEvent(event);
	                topEdgeHit(event);
	            } else if (delta > 0 && distanceToBottomEdge() >= 0) {
	                stopEvent(event);
	                bottomEdgeHit(event);
	            }
	        });
	
	        /* IE Strikes Again! >:-(
	         * Although IE fires both the 'wheel' & 'mousewheel' events, the mousewheel causes IE
	         * to bleed scrolling outside its container. Simplest solution would seem that the containing
	         * element kill all mousewheel events, but unfortunately IE needs it to scroll properly.
	         * Go figure....
	         *
	         * Other browsers do not use this non-standard event.
	         * https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel */
	        element.on('mousewheel', function (event) {
	            var delta = event.wheelDelta;
	            if (Math.abs(delta) > 120) {
	                stopEvent(event);
	                // 50 is an arbitrary number that seems to function. Values are ~35 towards top or bottom edge.
	            } else if (delta > 0 && distanceToTopEdge() < 50) {
	                    stopEvent(event);
	                    topEdgeHit(event);
	                    // animation frame smooths IE issues with scroll bar jumping
	                    window.requestAnimationFrame(function () {
	                        offsetTop();
	                    });
	                } else if (delta < 0 && distanceToBottomEdge() > -50) {
	                    stopEvent(event);
	                    bottomEdgeHit(event);
	                    // animation frame smooths IE issues with scroll bar jumping
	                    window.requestAnimationFrame(function () {
	                        offsetBottom();
	                    });
	                }
	        });
	
	        element.on('keydown', function (event) {
	            var keyCode = event.keyCode;
	            var topDistance = distanceToTopEdge();
	            var bottomDistance = distanceToBottomEdge();
	
	            if (topDistance === 0 && keyCode === KEYS.UP) {
	                stopEvent(event);
	                topEdgeHit(event);
	            } else if (bottomDistance === 0 && keyCode === KEYS.DOWN) {
	                stopEvent(event);
	                bottomEdgeHit(event);
	            } else if (keyCode === KEYS.TAB) {
	                if (event.shiftKey) {
	                    handleShiftTab(event, topDistance, bottomDistance);
	                } else if (bottomDistance === 0 && hasClassName(event.target, 'rc-calendar-lom')) {
	                    stopEvent(event);
	                    bottomEdgeHit(event);
	                }
	            }
	        });
	
	        function handleShiftTab(event, topDistance, bottomDistance) {
	            // Adjust to top as the user reverse-tabs
	            if (topDistance < 100 && topDistance > 0 && event.target.offsetTop < 200) {
	                element[0].scrollTop = 0;
	            } else if (topDistance === 0 && hasClassName(event.target, 'rc-calendar-fom') && inFirstWeek(event.target)) {
	                stopEvent(event);
	                topEdgeHit(event);
	            }
	        }
	
	        function hasClassName(el, name) {
	            return el.className.indexOf(name) !== -1;
	        }
	
	        function inFirstWeek(target) {
	            var days = element.find('rc-calendar-day');
	            for (var index = 0; index < 7; index++) {
	                if (days[index] === target) {
	                    return true;
	                }
	            }
	            return false;
	        }
	
	        function offsetBottom() {
	            element[0].scrollTop = element[0].scrollHeight - element[0].offsetHeight - 1;
	        }
	
	        function offsetTop() {
	            element[0].scrollTop = 1;
	        }
	
	        function distanceToBottomEdge() {
	            return element[0].scrollTop + element[0].offsetHeight - element[0].scrollHeight;
	        }
	
	        function distanceToTopEdge() {
	            return element[0].scrollTop;
	        }
	
	        function stopEvent(event) {
	            event.stopPropagation();
	            event.preventDefault();
	            event.returnValue = false;
	        }
	
	        function bottomEdgeHit(event) {
	            applyForBoundary(BOUNDS.bottom, event);
	        }
	
	        function topEdgeHit(event) {
	            applyForBoundary(BOUNDS.top, event);
	        }
	
	        function applyForBoundary(boundary, event) {
	            scope.$apply(function () {
	                onBoundary(scope, {
	                    $boundary: boundary,
	                    $event: event
	                });
	            });
	        }
	    }
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkbox = __webpack_require__(159);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _checkbox3 = __webpack_require__(58);
	
	var _checkbox4 = _interopRequireDefault(_checkbox3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  bindings: {},
	  controller: _checkbox2.default,
	  controllerAs: 'chkCtrl',
	  template: _checkbox4.default,
	  transclude: true
	};

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CHECKED_CLASS = 'rc-checkbox-checked';
	var DISABLED_CLASS = 'rc-checkbox-disabled';
	var FOCUS_CLASS = 'rc-checkbox-focus';
	/* Mainly provides CSS class changes to reflect element state child changes */
	
	var RcCheckboxController = function () {
	    RcCheckboxController.$inject = ["$element"];
	    function RcCheckboxController($element) {
	        'ngInject';
	
	        _classCallCheck(this, RcCheckboxController);
	
	        this.$element = $element;
	    }
	
	    _createClass(RcCheckboxController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            // Prevent hidden template label click from escaping checkbox (SID #186479)
	            this.$element.on('click', function (event) {
	                if (event.target.nodeName === 'LABEL') {
	                    event.stopPropagation(); // preventDefault() breaks the link to the input
	                }
	            });
	        }
	    }, {
	        key: 'setCheckedState',
	        value: function setCheckedState(state) {
	            if (state === true) {
	                this.$element.addClass(CHECKED_CLASS);
	            } else {
	                this.$element.removeClass(CHECKED_CLASS);
	            }
	        }
	    }, {
	        key: 'setDisabledState',
	        value: function setDisabledState(state) {
	            if (state === true) {
	                this.$element.addClass(DISABLED_CLASS);
	            } else {
	                this.$element.removeClass(DISABLED_CLASS);
	            }
	        }
	    }, {
	        key: 'setFocusState',
	        value: function setFocusState(state) {
	            if (state === true) {
	                this.$element.addClass(FOCUS_CLASS);
	            } else {
	                this.$element.removeClass(FOCUS_CLASS);
	            }
	        }
	    }, {
	        key: 'setInputType',
	        value: function setInputType(type) {
	            if (angular.isString(type)) {
	                this.$element.addClass('type-' + type);
	            }
	        }
	    }]);
	
	    return RcCheckboxController;
	}();
	
	exports.default = RcCheckboxController;

/***/ },
/* 160 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = ["$timeout", function ($timeout) {
	    'ngInject';
	
	    return {
	        require: ['?ngModel', '?^rcCheckbox'],
	        link: RcCheckboxInputLink
	    };
	
	    function RcCheckboxInputLink(scope, element, attrs, controllers) {
	        var _controllers = _slicedToArray(controllers, 2);
	
	        var modelCtrl = _controllers[0];
	        var checkCtrl = _controllers[1];
	
	
	        if (checkCtrl) {
	            checkCtrl.setInputType(attrs.type);
	
	            bindDOMChangeHandlers();
	
	            if (modelCtrl) {
	                bindModelChangeHandlers();
	            }
	        }
	
	        function bindDOMChangeHandlers() {
	            attrs.$observe('disabled', function (value) {
	                checkCtrl.setDisabledState(value);
	            });
	
	            element.on('focus blur', function (event) {
	                checkCtrl.setFocusState(event.type === 'focus');
	            });
	        }
	
	        function bindModelChangeHandlers() {
	            var toggle = function toggle() {
	                if (checkCtrl.$debouncedState) {
	                    $timeout.cancel(checkCtrl.$debouncedState);
	                }
	                checkCtrl.$debouncedState = $timeout(function () {
	                    checkCtrl.setCheckedState(element[0].checked);
	                }, 0, false);
	            };
	
	            // Handles user input state changes
	            modelCtrl.$viewChangeListeners.push(toggle);
	            // Captures programmatic state changes
	            modelCtrl.$formatters.push(function (model) {
	                toggle();
	                return model;
	            });
	        }
	    }
	}];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkbox = __webpack_require__(158);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _checkboxDirective = __webpack_require__(160);
	
	var _checkboxDirective2 = _interopRequireDefault(_checkboxDirective);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.checkbox', []).component('rcCheckbox', _checkbox2.default).directive('input', _checkboxDirective2.default);

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	clearableDirective.$inject = ["Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function clearableDirective(Usage) {
	    'ngInject';
	
	    var getClearableItem = function getClearableItem(element) {
	        return angular.element(element.parent()[0].querySelector('.rc-clearable-icon'));
	    };
	
	    var hasButton = function hasButton(element) {
	        return getClearableItem(element).length;
	    };
	
	    var hasNoButton = function hasNoButton(element) {
	        return !hasButton(element);
	    };
	
	    var clearInput = function clearInput(el) {
	        el.val('');
	        el.triggerHandler('input');
	        getClearableItem(el).parent().remove();
	    };
	
	    var addCloseButton = function addCloseButton(el) {
	        el.after('<div class="close-touch-area noselect"><a class="inverted close icon rc-clearable-icon"></a></div>');
	        el.next().bind('click', function () {
	            clearInput(el);
	        });
	    };
	
	    function isEnabled(attrs) {
	        if (attrs.rcClearable === 'no') {
	            return false;
	        } else if (attrs.type !== 'text') {
	            return false;
	        }
	        return true;
	    }
	
	    return {
	        restrict: 'E',
	        require: '?ngModel',
	        priority: 0,
	        link: function link(scope, element, attrs, ctrl) {
	            if (!ctrl) {
	                return;
	            }
	            if (!isEnabled(attrs)) {
	                return;
	            }
	
	            Usage.register('clearable');
	
	            element.parent().addClass('rc-clearable');
	
	            var clearableIconCheck = function clearableIconCheck() {
	                var value = ctrl.$viewValue;
	                if (value && hasNoButton(element)) {
	                    addCloseButton(element);
	                } else if (!value && hasButton(element)) {
	                    clearInput(element);
	                }
	            };
	            ctrl.$viewChangeListeners.push(clearableIconCheck);
	        }
	    };
	}
	
	exports.default = clearableDirective;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _clearable = __webpack_require__(162);
	
	var _clearable2 = _interopRequireDefault(_clearable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.clearable', [_usage2.default.name]).directive('input', _clearable2.default);

/***/ },
/* 164 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var COMMAND_URL = exports.COMMAND_URL = '/myup/loadMenu';

/***/ },
/* 165 */
/***/ function(module, exports) {

	'use strict';
	
	commandFactory.$inject = ["$http", "$parse", "$q", "COMMAND_URL"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function commandFactory($http, $parse, $q, COMMAND_URL) {
	    'ngInject';
	
	    var service = this;
	
	    service.lookup = function (command, params, options) {
	        var errorReply = void 0;
	        var parmList = params;
	        var deferred = $q.defer(); // todo checkme
	        if (typeof command === 'undefined' || command === '') {
	            errorReply = {
	                message: 'Required command parameter is undefined.',
	                status: 400
	            };
	
	            deferred.reject(errorReply);
	            return deferred.promise;
	        }
	        parmList.suiFunctionCommand = command;
	        var promise = $http.get(COMMAND_URL, { 'params': parmList });
	        var reply = {};
	
	        promise.then(function (response) {
	            if (response.data.result !== '0') {
	                errorReply = {
	                    message: 'Bad result returned from service',
	                    status: response.data.result
	                };
	                deferred.reject(errorReply);
	            }
	            if (response.data.data[0]) {
	                reply.label = response.data.data[0].label;
	                reply.url = response.data.data[0].url;
	                deferred.resolve(reply);
	            } else {
	                reply.label = '';
	                reply.url = '';
	                deferred.resolve(reply);
	            }
	        }, function (reason) {
	            errorReply = {
	                message: reason.data,
	                status: reason.status
	            };
	            deferred.reject(errorReply);
	        });
	        reply.$promise = promise;
	        return deferred.promise;
	    };
	}
	
	exports.default = commandFactory;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _command = __webpack_require__(164);
	
	var _command2 = __webpack_require__(165);
	
	var _command3 = _interopRequireDefault(_command2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.command', []).constant('COMMAND_URL', _command.COMMAND_URL).service('commandFactory', _command3.default);

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_ID_SERVICE_URL = exports.USER_ID_SERVICE_URL = '/uit/ricola/2.5/service/env.inc';

/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	
	rcCompactDirective.$inject = ["$parse", "Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcCompactDirective($parse, Usage) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            Usage.register('compact');
	            if (attrs.rcCompact) {
	                scope.$watch(function () {
	                    return $parse(attrs.rcCompact)(scope);
	                }, function (bool) {
	                    addClass(!!bool);
	                });
	            } else {
	                addClass(true);
	            }
	
	            function addClass(bool) {
	                if (bool) {
	                    element.addClass('compact');
	                } else {
	                    element.removeClass('compact');
	                }
	            }
	        }
	    };
	}
	
	exports.default = rcCompactDirective;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _compact = __webpack_require__(168);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.compact', [_usage2.default.name]).directive('rcCompact', _compact2.default);

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var COMPONENTS = {};
	
	var componentsRequire = __webpack_require__(303);
	var components = componentsRequire.keys();
	
	for (var i = 0; i < components.length; i++) {
	    var file = components[i];
	    if (includeComponent(file)) {
	        var component = componentsRequire(file).default;
	        if (component && component.name) {
	            var capName = component.name.split('rc.').pop();
	            COMPONENTS['' + capName.substr(0, 1).toUpperCase() + capName.substr(1)] = component;
	        }
	    }
	}
	
	exports.default = COMPONENTS;
	
	
	function includeComponent(fileName) {
	    // What is __DEV__? See the build/fixtures/ricola.info.js file for context
	    if (false) {
	        return true;
	    }
	    return fileName.indexOf('./_') === -1;
	}

/***/ },
/* 171 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcContentReplaceDirective;
	function RcContentReplaceDirective() {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        link: RcContentReplaceLink
	    };
	
	    function RcContentReplaceLink(scope, element, attrs) {
	        scope.$watch(function () {
	            return scope.$eval(attrs.rcContentReplace);
	        }, function (value) {
	            if (value) {
	                element.empty();
	                element.append(value);
	            }
	        });
	    }
	}

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	rcFocusDirective.$inject = ["$timeout", "$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcFocusDirective($timeout, $parse) {
	    'ngInject';
	
	    return {
	        link: function link(scope, element, attrs) {
	            var hasFocus = false,
	                condition = $parse(attrs.rcFocus);
	
	            /* can't use attrs.$observe because actual attribute value may not change */
	            scope.$watch(function () {
	                return condition(scope);
	            }, function (focus) {
	                if (focus) {
	                    $timeout(setFocus);
	                } else if (hasFocus) {
	                    $timeout(removeFocus);
	                }
	            });
	
	            element.bind('blur', removeFocus);
	
	            function setFocus() {
	                if (element[0].select) {
	                    element[0].select();
	                }
	                element[0].focus();
	                hasFocus = true;
	            }
	
	            function removeFocus() {
	                var assignable = condition.assign;
	                if (angular.isFunction(assignable)) {
	                    assignable(scope, false);
	                }
	                element[0].blur(); /* Double fires on blur, but w/e */
	                hasFocus = false;
	            }
	        }
	    };
	}
	
	exports.default = rcFocusDirective;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _groupbox = __webpack_require__(174);
	
	var _groupbox2 = _interopRequireDefault(_groupbox);
	
	var _groupbox3 = __webpack_require__(59);
	
	var _groupbox4 = _interopRequireDefault(_groupbox3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        heading: '@'
	    },
	    transclude: true,
	    controller: _groupbox2.default,
	    controllerAs: 'rcGBCtrl',
	    template: _groupbox4.default
	};

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcGroupboxController = function () {
	    RcGroupboxController.$inject = ["Usage"];
	    function RcGroupboxController(Usage) {
	        'ngInject';
	
	        _classCallCheck(this, RcGroupboxController);
	
	        Usage.register('groupbox');
	    }
	
	    _createClass(RcGroupboxController, [{
	        key: 'setHeading',
	        value: function setHeading(element) {
	            this.heading = element;
	        }
	    }]);
	
	    return RcGroupboxController;
	}();
	
	exports.default = RcGroupboxController;

/***/ },
/* 175 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcGroupboxHeadingDirective;
	function RcGroupboxHeadingDirective() {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        transclude: true,
	        template: '',
	        require: '^rcGroupbox',
	        link: RcGroupboxHeadingLink
	    };
	
	    function RcGroupboxHeadingLink(scope, element, attr, groupboxCtrl, transclude) {
	        groupboxCtrl.setHeading(transclude(scope, angular.noop));
	    }
	}

/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HOVER_TRIGGERS = exports.HOVER_TRIGGERS = [{
	    name: 'rcHoverintent',
	    trigger: 'mouseenter',
	    cancel: 'mouseleave'
	}, {
	    name: 'rcHoverleave',
	    trigger: 'mouseleave',
	    cancel: 'mouseenter'
	}];

/***/ },
/* 177 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/*
	While hover states shouldn't be used to trigger essential features, they're still nice to help
	provide feedback to the user on non-touch devices.  The problem is that hover states get in the way
	of touch devices (they appear to be sticky).
	
	This directive will manage a class on the HTML element so that we can stop hover from showing on
	touch-enabled devices.  Dual-mode (touch- AND mouse-enabled) devices are supported too:  hover will
	be disabled for touchstart but remain enabled for mouseenter.
	
	To stop hover on touch-enabled devices, add a ".hover-stop :hover" selector to the styles applied to
	the normal state of the element.  This will override the normal hover styles so the element looks
	exactly like its default state.
	    Refer to this example:
	        ** BEFORE (hover fails by being sticky on touch-enabled devices) **
	            a {
	                background: $normal-bg;
	                &:hover {
	                    background: $hover-bg;
	                }
	                &:active {
	                    background: $active-bg;
	                }
	            }
	        ** AFTER (hover fixed by mimicking normal state on touch-enabled devices) **
	            a {
	                @include hover-stop {
	                    background: $normal-bg;
	                }
	                &:hover {
	                    background: $hover-bg;
	                }
	                &:active {
	                    background: $active-bg;
	                }
	            }
	
	The directive works by presuming these events:
	    TOUCH-ENABLED   MOUSE-ENABLED
	    -------------   -------------
	    touchstart      -
	    touchmove       -
	    touchend        -
	    mouseover       mouseover
	    mousemove       mousemove
	    mousedown       mousedown
	    mouseup         mouseup
	    click           click
	*/
	function hoverStopDirective() {
	    var STOP_CLASS = 'hover-stop';
	
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attributes) {
	            scope.isMouseEnabled = true;
	
	            element.bind('touchstart', function () {
	                /* Next mouseenter is from touch, so skip adding the class. */
	                scope.isMouseEnabled = false;
	                element.addClass(STOP_CLASS);
	            });
	
	            element.bind('mouseenter', function () {
	                if (scope.isMouseEnabled) {
	                    element.removeClass(STOP_CLASS);
	                }
	                scope.isMouseEnabled = false;
	            });
	        }
	    };
	}
	
	exports.default = hoverStopDirective;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hoverStop = __webpack_require__(177);
	
	var _hoverStop2 = _interopRequireDefault(_hoverStop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.hoverStop', []).directive('hoverStop', _hoverStop2.default);

/***/ },
/* 179 */
/***/ function(module, exports) {

	'use strict';
	
	rcIconDirective.$inject = ["Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcIconDirective(Usage) {
	    'ngInject';
	
	    return {
	        restrict: 'EA',
	        template: '<span class="icon"></span>',
	        transclude: true,
	        link: function link(scope, element, attrs) {
	            Usage.register('icon');
	            var userClasses = attrs.class;
	
	            // Copy over the user classes to the internal span
	            angular.element(element[0].querySelector('.icon')).addClass(userClasses);
	        }
	    };
	}
	
	exports.default = rcIconDirective;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _icon = __webpack_require__(179);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.icon', [_usage2.default.name]).directive('rcIcon', _icon2.default);

/***/ },
/* 181 */
/***/ function(module, exports) {

	'use strict';
	
	rcInfiniteScrollDirective.$inject = ["$log", "$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcInfiniteScrollDirective($log, $compile) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        scope: {
	            rcInfiniteScroll: '&',
	            rcInfiniteScrollComplete: '@?'
	        },
	        link: function link(scope, element) {
	            var loadingIndicator = angular.element('<span ng-class="{hidden: !loading, finished: rcInfiniteScrollComplete}">Loading...</span>');
	            function getMoreData() {
	                scope.loading = true;
	                $log.debug('Getting more data....');
	                scope.$parent.$apply(function () {
	                    scope.rcInfiniteScroll();
	                });
	            }
	            function onComplete() {
	                scope.loading = false;
	                $log.debug('Finished getting data');
	                if (scope.rcInfiniteScrollComplete === 'true') {
	                    scope.finished = true;
	                }
	            }
	
	            scope.loading = false;
	            scope.finished = false;
	            loadingIndicator = $compile(loadingIndicator)(scope);
	            element.append(loadingIndicator);
	            element.on('scroll', function (e) {
	                var t = e.target;
	                if (t.scrollTop + t.offsetHeight === t.scrollHeight) {
	                    if (scope.rcInfiniteScrollComplete !== 'true') {
	                        getMoreData();
	                    }
	                }
	            });
	            scope.$on('rcScroll.complete', onComplete);
	        }
	    };
	}
	
	exports.default = rcInfiniteScrollDirective;

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	RcInputFieldWrapper.$inject = ["$rcInputFieldWrapper", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function RcInputFieldWrapper($rcInputFieldWrapper, $timeout) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        priority: 2,
	        compile: function compile(compileEl) {
	            // If it's a input, do not apply to radio, button, or checkbox elements
	            if ($rcInputFieldWrapper.shouldNotWrapField(compileEl)) {
	                return;
	            }
	            return {
	                pre: function pre($scope, el, attrs) {
	                    var size = attrs.size;
	                    var sizeAttr = size ? ' size="' + size + '" ' : '';
	                    var selectEl = el[0].nodeName === 'SELECT';
	                    var selectAttr = selectEl ? ' select="select" ' : '';
	                    var wrappableElement = el;
	
	                    var classList = 'rc-input-wrapper';
	                    if (el.hasClass('expand')) {
	                        classList += ' expand';
	                    }
	
	                    if (el.parent().hasClass('button-addon')) {
	                        wrappableElement = el.parent();
	                    }
	                    wrappableElement.wrap('<div class="' + classList + '" ' + sizeAttr + ' ' + selectAttr + '>');
	
	                    // Don't leave wrappers lying around... SID#187012
	                    $scope.$on('$destroy', function () {
	                        var wrapper = wrappableElement.parent();
	                        if (wrapper.hasClass('rc-input-wrapper')) {
	                            wrapper.remove();
	                        }
	                    });
	                }
	            };
	        }
	    };
	}
	
	exports.default = RcInputFieldWrapper;

/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function RcInputFieldWrapperService() {
	    var wrapper = this;
	
	    wrapper.shouldNotWrapField = function (el) {
	        if (el[0].nodeName === 'INPUT') {
	            var blacklistedTypes = ['radio', 'checkbox', 'button', 'submit', 'reset'];
	            if (blacklistedTypes.indexOf(el.attr('type')) !== -1) {
	                return true;
	            }
	        }
	        return false;
	    };
	    wrapper.getInputFieldWrapperFor = function (el) {
	        if (el.parent().parent().hasClass('rc-input-wrapper')) {
	            return el.parent().parent();
	        }
	        if (el.parent().hasClass('rc-input-wrapper')) {
	            return el.parent();
	        }
	        return angular.element();
	    };
	}
	
	exports.default = RcInputFieldWrapperService;

/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var KEYS = exports.KEYS = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    PAGEUP: 33,
	    PAGEDOWN: 34,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	};

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	inputGroupDirective.$inject = ["$parse", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function inputGroupDirective($parse, $timeout) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        compile: function compile(compileEl, compileAttrs) {
	            compileEl.addClass('rc-input-group');
	            return linkFn;
	        }
	    };
	
	    function linkFn(scope, element, attrs) {
	        var isHorizontal = $parse(attrs.horizontal)(scope) ? 'horizontal' : '',
	            isFullWidth = $parse(attrs.fullWidth)(scope) ? 'full-width' : '';
	
	        element.addClass(isHorizontal);
	        element.addClass(isFullWidth);
	
	        if (isHorizontal) {
	            $timeout(function () {
	                var firstInputType = element.find('input')[0].type.toLowerCase();
	                element.addClass('rc-' + firstInputType + '-group');
	            });
	        }
	    }
	}
	
	exports.default = inputGroupDirective;

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	rcListviewDirective.$inject = ["$parse", "Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcListviewDirective($parse, Usage) {
	    'ngInject';
	
	    return {
	        restrict: 'EA',
	        compile: function compile(compileEl, compileAttrs) {
	            compileEl.addClass('rc-listview');
	            var inset = $parse(compileAttrs.inset)();
	            if (typeof inset === 'boolean' && !inset) {
	                compileEl.addClass('rc-listview-full-width');
	            }
	            return function link(scope, element, attrs) {
	                Usage.register('listview');
	                element.addClass('rc-listview');
	            };
	        }
	    };
	}
	
	exports.default = rcListviewDirective;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loadingBackdrop = __webpack_require__(60);
	
	var _loadingBackdrop2 = _interopRequireDefault(_loadingBackdrop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcLoadingBackdropDirective() {
	    return {
	        restrict: 'EA',
	        template: _loadingBackdrop2.default
	    };
	}
	
	exports.default = rcLoadingBackdropDirective;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _loading = __webpack_require__(61);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcLoadingContentDirective() {
	    return {
	        restrict: 'EA',
	        template: _loading2.default
	    };
	}
	
	exports.default = rcLoadingContentDirective;

/***/ },
/* 189 */
/***/ function(module, exports) {

	'use strict';
	
	rcLoadingDirective.$inject = ["$compile", "$document", "Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcLoadingDirective($compile, $document, Usage) {
	    'ngInject';
	
	    function compileElement(html, scope) {
	        var element = angular.element(html);
	
	        element.attr('ng-style', 'zIndex');
	        element.attr('ng-class', '{\'rc-loading-inline\': inline}');
	
	        return $compile(element)(scope);
	    }
	
	    return {
	        scope: {
	            condition: '=rcLoading',
	            message: '@'
	        },
	        link: function link($scope, element, attrs) {
	            Usage.register('loading');
	            $scope.inline = typeof attrs.inline === 'undefined' ? false : true;
	            $scope.zIndex = typeof attrs.zIndex === 'undefined' ? {} : { 'z-index': attrs.zIndex };
	
	            var loadingElement = compileElement('<rc-loading-content></rc-loading-content>', $scope);
	            var backdropElement = compileElement('<rc-loading-backdrop></rc-loading-backdrop>', $scope);
	            var affectedElement = $scope.inline ? element : $document.find('body').eq(0);
	
	            $scope.$watch('condition', function (newValue) {
	                if (newValue === true) {
	                    affectedElement.addClass('rc-loading-wrapper');
	                    affectedElement.append(backdropElement);
	                    affectedElement.append(loadingElement);
	                } else {
	                    removeLoading();
	                }
	            });
	
	            // If the scope if blown up, make sure the 'loading' is removed too.
	            $scope.$on('$destroy', removeLoading);
	
	            function removeLoading() {
	                affectedElement.removeClass('rc-loading-wrapper');
	                backdropElement.remove();
	                loadingElement.remove();
	            }
	        }
	    };
	}
	
	exports.default = rcLoadingDirective;

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// FIXME These are deprecated. Use rcMediaQuery.minSize() instead.
	var BREAKPOINTS = exports.BREAKPOINTS = {
	    SMALL: '0px',
	    MEDIUM: '501px',
	    LARGE: '751px',
	    XLARGE: '1025px',
	    XXLARGE: '1201px'
	};

/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	rcMediaQueryService.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcMediaQueryService($window) {
	    'ngInject';
	
	    var service = this;
	
	    service.matches = function (mq) {
	        if (window.matchMedia) {
	            return window.matchMedia(mq).matches;
	        }
	        // TODO This is a hack for IE9 (the main browser without matchmedia)
	        // We hardcode to desktop mode.
	        return true;
	    };
	
	    service.minWidth = function (query) {
	        return service.matches('(min-width: ' + query + ')');
	    };
	
	    var currentSize = function currentSize() {
	        return $window.getComputedStyle(document.body, ':before').getPropertyValue('content').replace(/"/g, '') || 'large';
	    };
	
	    var SIZES = ['small', 'medium', 'large', 'xlarge', 'xxlarge'];
	
	    service.minSize = function (size) {
	        return SIZES.indexOf(currentSize()) >= SIZES.indexOf(size);
	    };
	}
	
	exports.default = rcMediaQueryService;

/***/ },
/* 192 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var migration = angular.module('rc.migration', []);
	var components = ['rcAppTemplate', 'rcAccordion', 'rcAccordionPanel', 'rcAddRemove', 'rcAlert', 'rcAlerts', 'rcAutocomplete', 'rcCalendar', 'rcCheckbox', 'rcGroupbox', 'rcModal', 'rcOfflineIndicator', 'rcOverlay', 'rcRedirector', 'rcSlideMenu', 'rcTable', 'rcTabset', 'rcTab', 'rcWizard', 'rcWizardStep'];
	
	components.forEach(function (component) {
	    migration.directive(component, ["$log", function ($log) {
	        'ngInject';
	
	        return {
	            restrict: 'A',
	            link: function link() {
	                $log.warn('Compatibility Warning: Ricola component \'' + component + '\' is declared as an attribute. It should be declared as an element.');
	            }
	        };
	    }]);
	});
	
	exports.default = migration;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcModalWindowDirective.$inject = ["$window", "$timeout", "$rootScope", "Usage", "$rcModalStack", "rcFeatureTests"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _modal = __webpack_require__(62);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcModalWindowDirective($window, $timeout, $rootScope, Usage, $rcModalStack, rcFeatureTests) {
	    'ngInject';
	
	    var MAX_PERCENTAGE = 95;
	
	    function getTitleHeight(modalElement) {
	        var childElement, titleHeight;
	
	        angular.forEach(modalElement.children(), function (indexElement) {
	            childElement = angular.element(indexElement);
	            if (childElement.hasClass('rc-modal-title')) {
	                titleHeight = childElement.prop('offsetHeight');
	            }
	        });
	
	        return titleHeight;
	    }
	
	    function getMaximumContentDimensions(element) {
	        var style = window.getComputedStyle(element[0]);
	        var maxWidthProp = style.getPropertyValue('max-width'),
	            maxHeightProp = style.getPropertyValue('max-height'),
	            allowed = {
	            width: 0,
	            height: 0
	        };
	
	        // Webkit reports the max-width/height as the percentage when it should be pixels.
	        // TODO: Remove percentage 'if' statements when repaired. https://bugs.webkit.org/show_bug.cgi?id=29084
	        if (maxWidthProp && maxWidthProp !== 'none') {
	            var widthPixelLimit = Math.ceil(window.innerWidth * MAX_PERCENTAGE * 0.01);
	            var cssWidthLimit;
	
	            if (maxWidthProp.indexOf('%') === maxWidthProp.length - 1) {
	                cssWidthLimit = Math.ceil(window.innerWidth * (Math.min(maxWidthProp.replace('%', ''), MAX_PERCENTAGE) * 0.01));
	            } else if (maxWidthProp.indexOf('px') === maxWidthProp.length - 2) {
	                cssWidthLimit = maxWidthProp.replace('px', '');
	            } else {
	                throw new Error('The rc-modal CSS max-width expects a percentage or pixel definition at or below 95%. Provided:  ' + maxWidthProp);
	            }
	
	            allowed.width = Math.min(widthPixelLimit, cssWidthLimit) - style.getPropertyValue('padding-left').replace('px', '') - style.getPropertyValue('padding-right').replace('px', '');
	        }
	
	        if (maxHeightProp && maxHeightProp !== 'none') {
	            var heightPixelLimit = Math.ceil(window.innerHeight * MAX_PERCENTAGE * 0.01);
	            var cssPixelLimit;
	
	            if (maxHeightProp.indexOf('%') === maxHeightProp.length - 1) {
	                cssPixelLimit = Math.ceil(window.innerHeight * (Math.min(maxHeightProp.replace('%', ''), MAX_PERCENTAGE) * 0.01));
	            } else if (maxHeightProp.indexOf('px') === maxHeightProp.length - 2) {
	                cssPixelLimit = maxHeightProp.replace('px', '');
	            } else {
	                throw new Error('The rc-modal CSS max-height expects a percentage or pixel definition at or below 95%. Provided: ' + maxHeightProp);
	            }
	
	            allowed.height = Math.min(heightPixelLimit, cssPixelLimit) - style.getPropertyValue('padding-top').replace('px', '') - style.getPropertyValue('padding-bottom').replace('px', '');
	        }
	
	        return allowed;
	    }
	
	    function postLink(scope, element, attrs) {
	        Usage.register('modal');
	
	        scope.windowClass = attrs.windowClass || '';
	        scope.title = attrs.title || '';
	        scope.includeCancel = (attrs.includeCancel || 'true') === 'true';
	
	        scope.cancelModal = function () {
	            var topModal = $rcModalStack.getTop();
	            if (topModal) {
	                $rcModalStack.dismiss(topModal.key, 'cancelled');
	            }
	        };
	
	        // TODO: remove if we can collapse template to root element
	        angular.forEach(element.find('div'), function (indexEl) {
	            var modalElement = angular.element(indexEl);
	            if (modalElement.hasClass('rc-modal')) {
	                scope.$$modalElement = modalElement;
	            }
	        });
	
	        // Set the max pixel dimensions allowed according to the window
	        var resizeMaxDimensions = function resizeMaxDimensions() {
	            if (scope.$$debouncedResize) {
	                $timeout.cancel(scope.$$debouncedResize);
	            }
	            // Timeout will run after angular rendering cycles
	            scope.$$debouncedResize = $timeout(function () {
	                var maxAllowedDimensions = getMaximumContentDimensions(scope.$$modalElement);
	                scope.maxHeight = Math.ceil(maxAllowedDimensions.height - getTitleHeight(scope.$$modalElement)) + 'px';
	                scope.maxWidth = Math.ceil(maxAllowedDimensions.width) + 'px';
	            }, 100);
	        };
	
	        resizeMaxDimensions();
	
	        angular.element($window).bind('resize', resizeMaxDimensions);
	        scope.$on('$destroy', function () {
	            angular.element($window).unbind('resize', resizeMaxDimensions);
	        });
	
	        scope.$$modalElement.on('mousewheel', function (event) {
	            event.stopPropagation();
	            return false;
	        });
	
	        // If CSS Transitions are supported, we can bind to the transitionEnd event
	        if (rcFeatureTests.cssTransition()) {
	            element.on('transitionend', function (e) {
	                $rootScope.$broadcast('$rcModalHeightUpdated');
	            });
	        }
	
	        scope.$watch(function () {
	            if (scope.$$offsetHeight) {
	                $timeout.cancel(scope.$$offsetHeight);
	            }
	
	            scope.$$offsetHeight = $timeout(function () {
	                var heightOffset = Math.ceil(scope.$$modalElement.prop('offsetHeight') / 2 * -1) + 'px';
	                scope.$$modalElement.css({
	                    'margin-top': heightOffset
	                });
	            }, 0, false) // Do not $digest unless you like infinity.....and beyond.
	            .then(function () {
	                // If CSS Transitions are *not* supported, we have to broadcast manually
	                // See above for context
	                if (!rcFeatureTests.cssTransition()) {
	                    $rootScope.$broadcast('$rcModalHeightUpdated');
	                }
	            });
	        });
	    }
	
	    return {
	        restrict: 'EA',
	        scope: {
	            index: '@',
	            title: '@rcModalTitle'
	        },
	        transclude: true,
	        template: _modal2.default,
	        link: postLink
	    };
	}
	
	exports.default = rcModalWindowDirective;

/***/ },
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function $rcModalProvider() {
	    $rcModalService.$inject = ["$injector", "$rootScope", "$q", "$http", "$templateCache", "$controller", "$rcModalStack"];
	    var options = this.options = {};
	
	    this.$get = $rcModalService;
	
	    function $rcModalService($injector, $rootScope, $q, $http, $templateCache, $controller, $rcModalStack) {
	        'ngInject';
	
	        var $rcModal = {};
	
	        $rcModal.open = function (modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	
	            // prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	                result: modalResultDeferred.promise,
	                opened: modalOpenedDeferred.promise,
	                close: function close(result) {
	                    $rcModalStack.close(modalInstance, result);
	                },
	                dismiss: function dismiss(reason) {
	                    $rcModalStack.dismiss(modalInstance, reason);
	                }
	            };
	
	            // merge and clean up options
	            modalOptions = angular.extend({}, options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	
	            // verify options
	            if (!modalOptions.template && !modalOptions.templateUrl) {
	                throw new Error('One of template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	            templateAndResolvePromise.then(function resolveSuccess(tplAndVars) {
	
	                var modalScope = (modalOptions.scope || $rootScope).$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                var ctrlInstance,
	                    ctrlLocals = {};
	                var resolveIter = 1;
	
	                // controllers
	                if (modalOptions.controller) {
	                    ctrlLocals.$scope = modalScope;
	                    ctrlLocals.$modalInstance = modalInstance;
	                    angular.forEach(modalOptions.resolve, function (value, key) {
	                        ctrlLocals[key] = tplAndVars[resolveIter++];
	                    });
	
	                    ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                    if (modalOptions.controllerAs) {
	                        modalScope[modalOptions.controllerAs] = ctrlInstance;
	                    }
	                }
	
	                $rcModalStack.open(modalInstance, {
	                    scope: modalScope,
	                    deferred: modalResultDeferred,
	                    content: tplAndVars[0],
	                    windowClass: modalOptions.windowClass,
	                    title: modalOptions.title,
	                    includeCancel: modalOptions.includeCancel
	                });
	            }, function resolveError(reason) {
	                modalResultDeferred.reject(reason);
	            });
	
	            templateAndResolvePromise.then(function () {
	                modalOpenedDeferred.resolve(true);
	            }, function () {
	                modalOpenedDeferred.reject(false);
	            });
	
	            return modalInstance;
	        };
	
	        return $rcModal;
	
	        function getTemplatePromise(modalOptions) {
	            return modalOptions.template ? $q.when(modalOptions.template) : $http.get(modalOptions.templateUrl, { cache: $templateCache }).then(function (result) {
	                return result.data;
	            });
	        }
	
	        function getResolvePromises(resolves) {
	            var promisesArr = [];
	            angular.forEach(resolves, function (value, key) {
	                if (angular.isFunction(value) || angular.isArray(value)) {
	                    promisesArr.push($q.when($injector.invoke(value)));
	                }
	            });
	            return promisesArr;
	        }
	    }
	}
	
	exports.default = $rcModalProvider;

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	$rcModalStackService.$inject = ["$document", "$compile", "$rootScope", "$$rcStackedMap"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function $rcModalStackService($document, $compile, $rootScope, $$rcStackedMap) {
	    'ngInject';
	
	    var OPENED_MODAL_CLASS = 'rc-modal-open';
	
	    var backdropDomEl, backdropScope;
	    var openedWindows = $$rcStackedMap.createNew();
	    var $rcModalStack = this;
	
	    function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	            topBackdropIndex = i;
	        }
	        return topBackdropIndex;
	    }
	
	    $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
	        if (backdropScope) {
	            backdropScope.index = newBackdropIndex;
	        }
	    });
	
	    function removeModalWindow(modalInstance) {
	
	        var body = $document.find('body').eq(0);
	        var modalWindow = openedWindows.get(modalInstance).value;
	
	        // clean up the stack
	        openedWindows.remove(modalInstance);
	
	        // remove window DOM element
	        modalWindow.modalDomEl.remove();
	        modalWindow.modalScope.$destroy();
	
	        checkRemoveBackdrop();
	        body.toggleClass(OPENED_MODAL_CLASS, openedWindows.length() > 0);
	    }
	
	    function checkRemoveBackdrop() {
	        // remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	            backdropScope.$destroy();
	            backdropDomEl.remove();
	        }
	    }
	
	    function moveBackdropBehind(modalInstance) {
	        // move top-most modal over backdrop
	        if (modalInstance && backdropDomEl) {
	            backdropDomEl.after(modalInstance.value.modalDomEl);
	        }
	    }
	
	    $rcModalStack.open = function (modalInstance, modal) {
	
	        openedWindows.add(modalInstance, {
	            deferred: modal.deferred,
	            modalScope: modal.scope
	        });
	
	        var body = $document.find('body').eq(0),
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	            backdropScope = $rootScope.$new(true);
	            backdropScope.index = currBackdropIndex;
	            // TODO: Change to use rc-overlay when it can be more easily overriden on the fly
	            backdropDomEl = $compile('<div class="rc-modal-overlay"></div>')(backdropScope);
	        }
	
	        var angularDomEl = angular.element('<rc-modal-window></rc-modal-window>');
	        angularDomEl.attr('window-class', modal.windowClass);
	        angularDomEl.attr('index', openedWindows.length() - 1);
	        angularDomEl.attr('rc-modal-title', modal.title);
	        angularDomEl.attr('include-cancel', modal.includeCancel);
	        angularDomEl.html(modal.content);
	
	        var modalDomEl = $compile(angularDomEl)(modal.scope);
	        openedWindows.top().value.modalDomEl = modalDomEl;
	
	        body.append(backdropDomEl);
	        body.append(modalDomEl);
	        body.addClass(OPENED_MODAL_CLASS);
	    };
	
	    $rcModalStack.close = function (modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        if (modalWindow) {
	            modalWindow.deferred.resolve(result);
	            removeModalWindow(modalInstance);
	        }
	
	        moveBackdropBehind(openedWindows.top());
	    };
	
	    $rcModalStack.dismiss = function (modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        if (modalWindow) {
	            modalWindow.deferred.reject(reason);
	            removeModalWindow(modalInstance);
	        }
	
	        moveBackdropBehind(openedWindows.top());
	    };
	
	    $rcModalStack.dismissAll = function (reason) {
	        var topModal = this.getTop();
	        while (topModal) {
	            this.dismiss(topModal.key, reason);
	            topModal = this.getTop();
	        }
	    };
	
	    $rcModalStack.getTop = function () {
	        return openedWindows.top();
	    };
	}
	
	exports.default = $rcModalStackService;

/***/ },
/* 196 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	* A helper, internal data structure that acts as a map but also allows getting / removing
	* elements in the LIFO order
	*/
	function $$rcStackedMapService() {
	    var service = this;
	
	    service.createNew = function () {
	        var stack = [];
	
	        return {
	            add: function add(key, value) {
	                stack.push({
	                    key: key,
	                    value: value
	                });
	            },
	            get: function get(key) {
	                for (var i = 0; i < stack.length; i++) {
	                    if (key === stack[i].key) {
	                        return stack[i];
	                    }
	                }
	            },
	            keys: function keys() {
	                var keys = [];
	                for (var i = 0; i < stack.length; i++) {
	                    keys.push(stack[i].key);
	                }
	                return keys;
	            },
	            top: function top() {
	                return stack[stack.length - 1];
	            },
	            remove: function remove(key) {
	                var idx = -1;
	                for (var i = 0; i < stack.length; i++) {
	                    if (key === stack[i].key) {
	                        idx = i;
	                        break;
	                    }
	                }
	                return stack.splice(idx, 1)[0];
	            },
	            removeTop: function removeTop() {
	                return stack.splice(stack.length - 1, 1)[0];
	            },
	            length: function length() {
	                return stack.length;
	            }
	        };
	    };
	}
	
	exports.default = $$rcStackedMapService;

/***/ },
/* 197 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    transclude: true,
	    require: {
	        rcAppTemplate: '^?rcAppTemplate'
	    },
	    template: '\n        <div class="rc-app-template-navigation">\n            <ul>\n                <ng-transclude></ng-transclude>\n                <rc-nav-link ng-if="!!$ctrl.rcAppTemplate.logoutLink">\n                    <a class="logout-link" ng-href="{{::$ctrl.rcAppTemplate.logoutLink}}">Logout</a>\n                </rc-nav-link>\n            </ul>\n        </div>\n    '
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(23);
	
	var _navDesktopTransformer = __webpack_require__(63);
	
	var _navDesktopTransformer2 = _interopRequireDefault(_navDesktopTransformer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppTemplateNavigationTranscludedController = function () {
	    AppTemplateNavigationTranscludedController.$inject = ["$element", "$log"];
	    function AppTemplateNavigationTranscludedController($element, $log) {
	        'ngInject';
	
	        _classCallCheck(this, AppTemplateNavigationTranscludedController);
	
	        this.$element = $element;
	        this.$log = $log;
	    }
	
	    _createClass(AppTemplateNavigationTranscludedController, [{
	        key: '$postLink',
	        value: function $postLink() {
	            var appTemplate = (0, _utils.parentAppTemplateNode)(this.$element[0], this.$log);
	            if (appTemplate) {
	                var $container = angular.element(appTemplate.querySelector('.rc-app-template-navigation-container'));
	                $container.append(this.$element.detach());
	            }
	        }
	    }]);
	
	    return AppTemplateNavigationTranscludedController;
	}();
	
	exports.default = {
	    transclude: true,
	    bindings: {
	        logout: '@?'
	    },
	    template: _navDesktopTransformer2.default,
	    controller: AppTemplateNavigationTranscludedController
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _navLink = __webpack_require__(200);
	
	var _navLink2 = _interopRequireDefault(_navLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        url: '@',
	        newWindow: '@',
	        target: '@',
	        label: '@'
	    },
	    transclude: true,
	    template: '\n    <li>\n        <ng-transclude>\n            <a ng-href="{{navLink.url}}" ng-bind="navLink.label"></a>\n        </ng-transclude>\n    </li>\n    ',
	    controller: _navLink2.default,
	    controllerAs: 'navLink'
	};

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppTemplateNavLinkController = function () {
	    AppTemplateNavLinkController.$inject = ["$element"];
	    function AppTemplateNavLinkController($element) {
	        'ngInject';
	
	        _classCallCheck(this, AppTemplateNavLinkController);
	
	        this.$element = $element;
	    }
	
	    _createClass(AppTemplateNavLinkController, [{
	        key: '$postLink',
	        value: function $postLink() {
	            if (this.target) {
	                this.$element.find('a').attr('target', this.target);
	            }
	            if (this.newWindow) {
	                this.$element.find('a').attr('target', '_blank');
	            }
	        }
	    }]);
	
	    return AppTemplateNavLinkController;
	}();
	
	exports.default = AppTemplateNavLinkController;

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    return {
	        restrict: 'E',
	        require: {
	            rcAppTemplate: '^?rcAppTemplate'
	        },
	        link: function link($scope, $el, $attrs, ctrls) {
	            if (ctrls.rcAppTemplate) {
	                ctrls.rcAppTemplate.registerNavigation();
	            }
	        }
	    };
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(23);
	
	var makeSlideMenuNestedNav = function makeSlideMenuNestedNav(parent) {
	    var label = parent.getAttribute('label');
	    var $nestedNav = angular.element('<rc-slide-menu-nested-nav label="' + label + '">');
	    angular.forEach(parent.children, function (child) {
	        // We have to clone each element before appending. Otherwise we miss elements
	        var $child = angular.element(child).clone()[0];
	        var nodeName = child.nodeName;
	
	        if (nodeName === 'RC-NAV-LINK') {
	            $nestedNav.append($child);
	        } else if (nodeName === 'RC-NESTED-NAV') {
	            $nestedNav.append(makeSlideMenuNestedNav($child));
	        }
	    });
	    return $nestedNav;
	}; /* TODO CLEAN ME UP PLEASE */
	
	var SlideMenuAppTemplateNavigationTransformer = function SlideMenuAppTemplateNavigationTransformer($compile, $log) {
	    'ngInject';
	
	    return {
	        priority: 1,
	        compile: function compile($tEl, $attrs) {
	            var clonedEls = $tEl.clone();
	            var $slideMenu = angular.element('<rc-slide-menu-nav>');
	            var $nav = angular.element('<slide-menu-nav>');
	            $slideMenu.append($nav);
	            angular.forEach(clonedEls.children(), function (child) {
	                var nodeName = child.nodeName;
	
	                if (nodeName === 'RC-NAV-LINK') {
	                    $nav.append(child);
	                } else if (nodeName === 'RC-NESTED-NAV') {
	                    $nav.append(makeSlideMenuNestedNav(child));
	                }
	            });
	            return function ($scope, $element) {
	                var appTemplate = (0, _utils.parentAppTemplateNode)($element[0], $log);
	                if (appTemplate) {
	                    var $container = angular.element(appTemplate.querySelector('.rc-app-template-slide-menu-container'));
	                    $container.append($slideMenu);
	                    $compile($container)($scope);
	                }
	            };
	        }
	    };
	};
	SlideMenuAppTemplateNavigationTransformer.$inject = ["$compile", "$log"];
	
	exports.default = SlideMenuAppTemplateNavigationTransformer;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _nestedNav = __webpack_require__(204);
	
	var _nestedNav2 = _interopRequireDefault(_nestedNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        label: '@'
	    },
	    template: '\n        <li\n            rc-hoverintent="nestedNav.makeActive()"\n            rc-hoverleave="nestedNav.makeInactive()"\n            ng-class="{ active: nestedNav.isVisible }">\n\n            <span class="sub" tabindex="0"\n                ng-keydown="nestedNav.keyboardNav($event)"\n                ng-bind="nestedNav.label"></span>\n\n            <ul>\n                <ng-transclude></ng-transclude>\n            </ul>\n        </li>\n    ',
	    controller: _nestedNav2.default,
	    controllerAs: 'nestedNav',
	    transclude: true
	};

/***/ },
/* 204 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NestedNavController = function () {
	    NestedNavController.$inject = ["rcAppTemplateService", "$element", "KEYS"];
	    function NestedNavController(rcAppTemplateService, $element, KEYS) {
	        'ngInject';
	
	        _classCallCheck(this, NestedNavController);
	
	        this.keys = KEYS;
	        this.$element = $element;
	        this.rcAppTemplateService = rcAppTemplateService;
	    }
	
	    _createClass(NestedNavController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.rcAppTemplateService.setElement(this.$element);
	        }
	    }, {
	        key: 'makeActive',
	        value: function makeActive() {
	            this.rcAppTemplateService.addActive(this);
	        }
	    }, {
	        key: 'makeInactive',
	        value: function makeInactive() {
	            this.rcAppTemplateService.removeActive(this);
	        }
	    }, {
	        key: 'keyboardNav',
	        value: function keyboardNav($event) {
	            switch ($event.keyCode) {
	                case this.keys.ENTER:
	                case this.keys.SPACE:
	                    $event.preventDefault();
	                    this.isVisible = !this.isVisible;
	                    break;
	                default: // do nothing
	            }
	        }
	    }]);
	
	    return NestedNavController;
	}();
	
	exports.default = NestedNavController;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slideMenuNavigation = __webpack_require__(64);
	
	var _slideMenuNavigation2 = _interopRequireDefault(_slideMenuNavigation);
	
	var _slideMenuNavigation3 = __webpack_require__(206);
	
	var _slideMenuNavigation4 = _interopRequireDefault(_slideMenuNavigation3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    transclude: {
	        header: '?slideMenuHeader',
	        nav: '?slideMenuNav'
	    },
	    require: {
	        rcAppTemplate: '^?rcAppTemplate'
	    },
	    controller: _slideMenuNavigation4.default,
	    controllerAs: 'slideMenu',
	    template: _slideMenuNavigation2.default
	};

/***/ },
/* 206 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SlideMenuController = function () {
	    SlideMenuController.$inject = ["Usage", "$scope", "$document", "$element"];
	    function SlideMenuController(Usage, $scope, $document, $element) {
	        'ngInject';
	
	        _classCallCheck(this, SlideMenuController);
	
	        this.Usage = Usage;
	        this.$scope = $scope;
	        this.$document = $document;
	        this.$element = $element;
	
	        this.open = false;
	        this.activeLabels = {};
	    }
	
	    _createClass(SlideMenuController, [{
	        key: 'toggleStates',
	        value: function toggleStates() {
	            this.open = !this.open;
	        }
	    }, {
	        key: 'toggleVisibility',
	        value: function toggleVisibility(label) {
	            this.activeLabels[label] = !this.activeLabels[label];
	        }
	    }, {
	        key: 'isActive',
	        value: function isActive(item) {
	            return this.activeLabels[item.label];
	        }
	    }, {
	        key: 'closeMenu',
	        value: function closeMenu(e) {
	            var className = e.target.className,
	                nodeName = e.target.nodeName;
	
	            // TODO is the 'rcBackButton' class necessary? Was removed from the template
	            if (className.indexOf('rc-overlay') > -1 || nodeName === 'A' && className.indexOf('rcBackButton') === -1) {
	                this.open = false;
	            }
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.Usage.register('slidemenu');
	
	            var body = angular.element(this.$document).find('body');
	            this.$scope.$watch('slideMenu.open', function (openVal) {
	                if (typeof openVal !== 'undefined') {
	                    body.toggleClass('rc-slidemenu-open', openVal);
	                    _this.$element.toggleClass('open', openVal);
	                }
	            });
	        }
	    }]);
	
	    return SlideMenuController;
	}();
	
	exports.default = SlideMenuController;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _offlineIndicator = __webpack_require__(208);
	
	var _offlineIndicator2 = _interopRequireDefault(_offlineIndicator);
	
	var _offlineStoreAndForward = __webpack_require__(209);
	
	var _offlineStoreAndForward2 = _interopRequireDefault(_offlineStoreAndForward);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.offline', [_offlineIndicator2.default.name, _offlineStoreAndForward2.default.name]);

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _offlineIndicator = __webpack_require__(65);
	
	var _offlineIndicator2 = _interopRequireDefault(_offlineIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.offline.indicator', []).service('rcOfflineIndicatorService', function () {
	    'ngInject';
	
	    this.registerIndicator = function (scope) {
	        this.scope = scope;
	    };
	    this.setVisible = function (isVisible) {
	        var scope = this.scope;
	        if (scope) {
	            scope.isVisible = isVisible;
	        }
	    };
	}).directive('rcOfflineIndicator', ["rcOfflineIndicatorService", function (rcOfflineIndicatorService) {
	    'ngInject';
	
	    return {
	        restrict: 'EA',
	        scope: {
	            autoShow: '@'
	        },
	        template: _offlineIndicator2.default,
	        link: function link(scope, element, attrs) {
	            scope.autoShow = scope.autoShow !== 'false';
	            rcOfflineIndicatorService.registerIndicator(scope);
	            scope.isVisible = false;
	            scope.$watch('isVisible', function (visible) {
	                if (visible) {
	                    element.addClass('open');
	                } else {
	                    element.removeClass('open');
	                }
	            });
	            if (scope.autoShow) {
	                scope.$on('rcOffline.storeAndForwardIntercepted', function () {
	                    scope.isVisible = true;
	                });
	                scope.$on('rcOffline.storeAndForwardFlushed', function () {
	                    scope.isVisible = false;
	                });
	            }
	            scope.close = function () {
	                scope.isVisible = false;
	            };
	        }
	    };
	}]);

/***/ },
/* 209 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = angular.module('rc.offline.storeAndForward', [])
	/**
	 * @ngdoc service
	 * @name ue.store-and-forward.factory:storeAndForwardRequestInterceptor
	 * @function
	 *
	 * @description
	 *
	 * `storeAndForwardRequestInterceptor` is used to add/remove http requests
	 * to storage.  No configuration on the interceptor is required.
	 *
	 * Don't forget to add the interceptor:
	 *
	 * <pre>
	 *   angular.module('testmodule', ['rc.offline'])
	 *    .config(function($httpProvider) {
	 *      $httpProvider.interceptors.push('rcStoreAndForwardRequestInterceptor');
	 *    });
	 * </pre>
	 */
	.factory('rcStoreAndForwardRequestInterceptor', ["$q", "$injector", function ($q, $injector) {
	    'ngInject';
	
	    var storeAndForward;
	    return {
	        'response': function response(_response) {
	            storeAndForward = storeAndForward || $injector.get('rcStoreAndForward');
	            storeAndForward.flush();
	            return _response;
	        },
	        'responseError': function responseError(rejection) {
	            storeAndForward = storeAndForward || $injector.get('rcStoreAndForward');
	            storeAndForward.add(rejection);
	            return $q.reject(rejection);
	        }
	    };
	}])
	
	/**
	 * @ngdoc service
	 * @name ue.store-and-forward.storeAndForwardProvider
	 * @function
	 *
	 * @description
	 *
	 * `storeAndForwardProvider` is the provider for the to configure
	 * which requests are captured when they fail.
	 *
	 * Configuration is available on the provider
	 *
	 * <pre>
	 *   angular.module('testmodule', ['rc.offline'])
	 *    .config(function(storeAndForwardProvider) {
	 *      storeAndForwardProvider.setFailCodes([0, 503]); // etc.
	 *    });
	 * </pre>
	 */
	.provider('rcStoreAndForward', function () {
	
	    // Private variables
	    var failCode = [0],
	        includeAllFailingRequests = false,
	        localStorageKey = 'rcStoreAndForward.pending',
	        failCodeExceptions = [];
	
	    /**
	    * @ngdoc service
	    * @name ue.store-and-forward.storeAndForward
	    * @function
	    *
	    * @description
	    *
	    * `storeAndForward` is the service to queue failed requests and manage
	    * the `localStorage` persistance.
	    * Configuration is available on the provider
	    *
	    */
	    function StoreAndForward($http, $log, $rootScope) {
	        var pendingRequests = [];
	        var initialFromLocalStorage = localStorage.getItem(localStorageKey);
	        if (initialFromLocalStorage) {
	            pendingRequests = pendingRequests.concat(angular.fromJson(initialFromLocalStorage));
	        }
	
	        this.failCode = failCode;
	        this.includeAllFailingRequests = includeAllFailingRequests;
	        this.failCodeExceptions = failCodeExceptions;
	
	        /**
	        * @ngdoc function
	        * @name ue.store-and-forward.storeAndForward#updateLocalStorage
	        * @methodOf ue.store-and-forward.storeAndForward
	        * @function
	        *
	        * @description
	        * Updates localStorage with the updated pending requests.
	        *
	        * Note: In most cases, this method will never need to be called manually (called by `httpInterceptor`).
	        */
	        this.updateLocalStorage = function () {
	            // Weird IE11 bug; see http://stackoverflow.com/q/21155137
	            if (angular.isFunction(localStorage.removeItem)) {
	                localStorage.removeItem(localStorageKey);
	                localStorage.setItem(localStorageKey, angular.toJson(pendingRequests));
	            }
	        };
	
	        /**
	        * @ngdoc function
	        * @name ue.store-and-forward.storeAndForward#clear
	        * @methodOf ue.store-and-forward.storeAndForward
	        * @function
	        *
	        * @description
	        * Clears all rejected requests from the queue.  Useful to be called when a user is logged out/logged in
	        * or needs a fresh start.
	        *
	        */
	        this.clear = function () {
	            this.pendingRequests.splice(0, this.pendingRequests.length);
	            // Weird IE11 bug; see http://stackoverflow.com/q/21155137
	            if (angular.isFunction(localStorage.removeItem)) {
	                localStorage.removeItem(localStorageKey);
	            }
	        };
	
	        /**
	        * @ngdoc function
	        * @name ue.store-and-forward.storeAndForward#add
	        * @methodOf ue.store-and-forward.storeAndForward
	        * @function
	        *
	        * @description
	        * Adds a rejected request to the pending requests that are persisted to `localStorage`,
	        * assuming the request does not have a status code that has been set to ignore, it is a valid
	        * fail code that has been asked to capture, or if it has been specifically requested to save (via `config.offlineFallback = true`),
	        * or if the global setting to capture all failed requests has been turned on.
	        *
	        * Note: In most cases, this method will never need to be called manually (called by `httpInterceptor`).
	        *
	        * @param {rejection=} rejection The previous request that has been rejected.
	        */
	        this.add = function (rejection) {
	            var notAnExceptionFailCode = this.failCodeExceptions.indexOf(rejection.status) < 0;
	            var isAValidFailCode = this.failCode.indexOf(rejection.status) > -1 && notAnExceptionFailCode;
	            var requestNeedsFallback = !!rejection.config.offlineFallback;
	            var masterIncludeAllFailingRequests = !!this.includeAllFailingRequests;
	            if (requestNeedsFallback || isAValidFailCode || notAnExceptionFailCode && masterIncludeAllFailingRequests) {
	                this.pendingRequests.push(rejection.config);
	                this.updateLocalStorage();
	                $rootScope.$broadcast('rcOffline.storeAndForwardIntercepted');
	            }
	        };
	
	        /**
	        * @ngdoc function
	        * @name ue.store-and-forward.storeAndForward#flush
	        * @methodOf ue.store-and-forward.storeAndForward
	        * @function
	        *
	        * @description
	        * Flushes all pending requests from the queue.  Will be automatically called when
	        * the `storeAndForwardRequestInterceptor` gets a successful response back.  May need to be
	        * manually called if the app implements a specific way of detecting if a user is online.
	        *
	        */
	        this.flush = function () {
	            var _flushReqest = function _flushReqest(config) {
	                delete config.transformRequest;
	                delete config.transformResponse;
	                $http(config).then(function (data, status, headers, _config) {
	                    // Collin: offlineSuccess is added like $http({ offlineSuccess: 'AppService.onSuccess'})
	                    // It allows the user to run some code after the call succeeds.
	                    // For instance, maybe let the user know when something is synced?
	                    if (config.offlineSuccess) {
	                        var el = angular.element(document.querySelector('[ng-app]'));
	                        if (!el) {
	                            el = angular.element(document.querySelector('[ng-controller]'));
	                        }
	                        if (!el) {
	                            el = angular.element(document.querySelector('[ng-view]'));
	                        }
	                        if (!el) {
	                            $log.warn('Unable to find any elements of [ng-view], [ng-app], or [ng-controller].  Unable to inject success function.');
	                        } else {
	                            el.injector().get(config.offlineSuccess.split('.')[0])[config.offlineSuccess.split('.')[1]](data, status, headers, _config);
	                        }
	                    }
	                });
	            };
	            if (this.pendingRequests.length > 0) {
	                localStorage.removeItem(localStorageKey);
	                this.pendingRequests.map(_flushReqest);
	                this.clear();
	                $rootScope.$broadcast('rcOffline.storeAndForwardFlushed');
	            }
	        };
	        this.pendingRequests = pendingRequests;
	        this.localStorageKey = localStorageKey;
	        return this;
	    }
	
	    /**
	    * @ngdoc function
	    * @name ue.store-and-forward.storeAndForwardProvider#setFailCodes
	    * @methodOf ue.store-and-forward.storeAndForwardProvider
	    * @function
	    *
	    * @description
	    * sets the valid fail codes that the service will capture and store locally
	    * if a request fails with that code.
	    *
	    * @param {failCodes|Array} failCodes An array of fail codes that should will be used to
	    * determine if a failed request should be persisted or not.
	    *
	    * <pre>
	    *   angular.module('testmodule', ['ue.store-and-forward'])
	    *    .config(function(storeAndForwardProvider) {
	    *      storeAndForwardProvider.setFailCodes([0, 503]);
	    *    });
	    * </pre>
	    */
	    this.setFailCodes = function (failCodes) {
	        failCode = failCodes;
	    };
	
	    /**
	    * @ngdoc function
	    * @name ue.store-and-forward.storeAndForwardProvider#setIncludeAllFailingRequests
	    * @methodOf ue.store-and-forward.storeAndForwardProvider
	    * @function
	    *
	    * @description
	    * Sets the functionality to override all other settings and include all failing requests.
	    *
	    * <pre>
	    *   angular.module('testmodule', ['ue.store-and-forward'])
	    *    .config(function(storeAndForwardProvider) {
	    *      storeAndForwardProvider.includeAllFailingRequests(true);
	    *    });
	    * </pre>
	    */
	    this.setIncludeAllFailingRequests = function (bool) {
	        includeAllFailingRequests = bool;
	    };
	
	    /**
	    * @ngdoc function
	    * @name ue.store-and-forward.storeAndForwardProvider#setLocalStorageKey
	    * @methodOf ue.store-and-forward.storeAndForwardProvider
	    * @function
	    *
	    * @description
	    * Sets the namespace for the localstorage variables
	    *
	    * @param {key|String} key A key that the localStorage items will be namespaced under.
	    * It is recommended to use this to avoid namespace collisions.
	    *
	    * <pre>
	    *   angular.module('testmodule', ['ue.store-and-forward'])
	    *    .config(function(storeAndForwardProvider) {
	    *      storeAndForwardProvider.setLocalStorageKey('testmodule');
	    *    });
	    * </pre>
	    */
	    this.setLocalStorageKey = function (key) {
	        localStorageKey = key;
	    };
	
	    /**
	    * @ngdoc function
	    * @name ue.store-and-forward.storeAndForwardProvider#setFailCodeExceptions
	    * @methodOf ue.store-and-forward.storeAndForwardProvider
	    * @function
	    *
	    * @description
	    * sets the invalid fail codes that the service should ignore.
	    *
	    * @param {exceptions|Array} exceptions An array of error codes that the service should ignore.
	    *
	    * <pre>
	    *   angular.module('testmodule', ['rc.offline'])
	    *    .config(function(storeAndForwardProvider) {
	    *      // this says, ignore all 404 failures and status code 1 failures.
	    *      storeAndForwardProvider.setFailCodeExceptions([404,1]);
	    *    });
	    * </pre>
	    */
	    this.setFailCodeExceptions = function (exceptions) {
	        failCodeExceptions = exceptions;
	    };
	
	    // Method for instantiating
	    this.$get = ["$http", "$log", "$rootScope", function ($http, $log, $rootScope) {
	        'ngInject';
	
	        return new StoreAndForward($http, $log, $rootScope);
	    }];
	}).config(["rcStoreAndForwardProvider", function (rcStoreAndForwardProvider) {
	    'ngInject';
	
	    rcStoreAndForwardProvider.setFailCodes([0]);
	    rcStoreAndForwardProvider.setFailCodeExceptions([404]);
	}]);

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _overlay = __webpack_require__(66);
	
	var _overlay2 = _interopRequireDefault(_overlay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcOverlayDirective() {
	    return {
	        template: _overlay2.default,
	        scope: {
	            opacity: '@',
	            z: '@'
	        }
	    };
	}
	
	exports.default = rcOverlayDirective;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(28);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _placeholderDirective = __webpack_require__(212);
	
	var _placeholderDirective2 = _interopRequireDefault(_placeholderDirective);
	
	var _placeholderDirective3 = __webpack_require__(213);
	
	var _placeholderDirective4 = _interopRequireDefault(_placeholderDirective3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.placeholder', [_usage2.default.name]).directive('placeholder', _placeholderDirective2.default).directive('placeholder', _placeholderDirective4.default); /* IE9 Polyfill shim */

/***/ },
/* 212 */
/***/ function(module, exports) {

	'use strict';
	
	placeholderInputDirective.$inject = ["$parse", "Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function placeholderInputDirective($parse, Usage) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        compile: function compile(compileEl, compileAttrs) {
	            var animateAttr = $parse(compileAttrs.placeholderAnimate)();
	            if (animateAttr || typeof animateAttr === 'undefined') {
	                compileEl.addClass('placeholder-animate');
	            }
	            return linkFn;
	
	            function linkFn(scope, element, attrs) {
	                Usage.register('placeholder');
	
	                attrs.$observe('placeholder', function (val) {
	                    element.attr('placeholder', val);
	                });
	            }
	        }
	    };
	}
	
	exports.default = placeholderInputDirective;

/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	placeholderSelectDirective.$inject = ["$interpolate"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function placeholderSelectDirective($interpolate) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        require: '?ngModel',
	        priority: 1, // We want this to run before ngOptions
	        compile: function compile(compileEl, compileAttrs) {
	            if (!compileAttrs.ngModel) {
	                return;
	            }
	            if (compileEl[0].tagName !== 'SELECT') {
	                return;
	            }
	            var defaultOptionTemplate = angular.element('<option value="" class="rc-select-placeholder"></option>');
	            compileEl.prepend(defaultOptionTemplate);
	
	            return {
	                pre: function pre(scope, element, attrs, ngModel) {
	                    var placeholderValue = attrs.placeholder;
	                    var placeholder = element[0].querySelector('.rc-select-placeholder');
	                    placeholder.textContent = '​' + placeholderValue;
	                    var modelValue = scope.$eval(attrs.ngModel);
	                    if (!modelValue) {
	                        ngModel.$setViewValue('');
	                        element[0].selectedIndex = 0;
	                    }
	                },
	                post: function post(scope, element, attrs, ngModel) {
	                    function checkScope() {
	                        var modelValue = scope.$eval(attrs.ngModel);
	                        if (!modelValue) {
	                            element.addClass('rc-select-placeholder');
	                        } else {
	                            element.removeClass('rc-select-placeholder');
	                        }
	                    }
	                    checkScope();
	                    scope.$watch(attrs.ngModel, checkScope);
	                }
	            };
	        }
	    };
	}
	
	exports.default = placeholderSelectDirective;

/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	$positionService.$inject = ["$document", "$window"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * A set of utility methods that can be use to retrieve position of DOM elements.
	 * It is meant to be used where we need to absolute-position DOM elements in
	 * relation to other, existing elements (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	function $positionService($document, $window) {
	    'ngInject';
	
	    var service = this;
	
	    function getStyle(el, cssprop) {
	        if (el.currentStyle) {
	            // IE
	            return el.currentStyle[cssprop];
	        } else if ($window.getComputedStyle) {
	            return $window.getComputedStyle(el)[cssprop];
	        }
	        // finally try and get inline style
	        return el.style[cssprop];
	    }
	
	    /**
	     * Checks if a given element is statically positioned
	     * @param {object} element - raw DOM element
	     */
	    function isStaticPositioned(element) {
	        return (getStyle(element, 'position') || 'static') === 'static';
	    }
	
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given element
	     * @param {object} element
	     */
	    var parentOffsetEl = function parentOffsetEl(element) {
	        var docDomEl = $document[0];
	        var offsetParent = element.offsetParent || docDomEl;
	        while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent)) {
	            offsetParent = offsetParent.offsetParent;
	        }
	        return offsetParent || docDomEl;
	    };
	
	    service.position = function (element) {
	        var elBCR = this.offset(element);
	        var offsetParentBCR = {
	            top: 0,
	            left: 0
	        };
	        var offsetParentEl = parentOffsetEl(element[0]);
	        if (offsetParentEl !== $document[0]) {
	            offsetParentBCR = this.offset(angular.element(offsetParentEl));
	            if (!offsetParentEl.nodeName.match(/body/gi)) {
	                offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	                offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	            }
	        }
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || element.prop('offsetWidth'),
	            height: boundingClientRect.height || element.prop('offsetHeight'),
	            top: elBCR.top - offsetParentBCR.top,
	            left: elBCR.left - offsetParentBCR.left
	        };
	    };
	
	    service.offset = function (element) {
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || element.prop('offsetWidth'),
	            height: boundingClientRect.height || element.prop('offsetHeight'),
	            top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop) - ($document[0].documentElement.clientTop || 0),
	            left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft) - ($document[0].documentElement.clientLeft || 0)
	        };
	    };
	
	    service.positionElements = function (hostEl, targetEl, positionStr, appendToBody) {
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0],
	            pos1 = positionStrParts[1] || 'center';
	
	        var hostElPos, targetElWidth, targetElHeight, targetElPos;
	
	        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	
	        targetElWidth = targetEl.prop('offsetWidth');
	        targetElHeight = targetEl.prop('offsetHeight');
	
	        var shiftWidth = {
	            center: function center() {
	                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	            },
	            left: function left() {
	                return hostElPos.left;
	            },
	            right: function right() {
	                return hostElPos.left + hostElPos.width;
	            }
	        };
	
	        var shiftHeight = {
	            center: function center() {
	                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	            },
	            top: function top() {
	                return hostElPos.top;
	            },
	            bottom: function bottom() {
	                return hostElPos.top + hostElPos.height;
	            }
	        };
	
	        switch (pos0) {
	            case 'right':
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: shiftWidth[pos0]()
	                };
	                break;
	            case 'left':
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: hostElPos.left - targetElWidth
	                };
	                break;
	            case 'bottom':
	                targetElPos = {
	                    top: shiftHeight[pos0](),
	                    left: shiftWidth[pos1]()
	                };
	                break;
	            default:
	                targetElPos = {
	                    top: hostElPos.top - targetElHeight,
	                    left: shiftWidth[pos1]()
	                };
	                break;
	        }
	
	        return targetElPos;
	    };
	}
	
	exports.default = $positionService;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _modal = __webpack_require__(8);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _loading = __webpack_require__(22);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reauthenticate = __webpack_require__(216);
	
	var _reauthenticate2 = _interopRequireDefault(_reauthenticate);
	
	var _reauthenticate3 = __webpack_require__(217);
	
	var _reauthenticate4 = _interopRequireDefault(_reauthenticate3);
	
	var _reauthenticate5 = __webpack_require__(218);
	
	var _reauthenticate6 = _interopRequireDefault(_reauthenticate5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.reauthenticate', [_usage2.default.name, _modal2.default.name, _loading2.default.name]).config(_reauthenticate2.default).directive('rcReauthenticateIframeOnload', _reauthenticate4.default).provider('ReauthenticateInterceptor', _reauthenticate6.default);

/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["$httpProvider", function ($httpProvider) {
	    'ngInject';
	
	    $httpProvider.interceptors.push('ReauthenticateInterceptor');
	}];

/***/ },
/* 217 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcReauthenticateIframeOnloadDirective() {
	    return {
	        restrict: 'A',
	        scope: {
	            callback: '&rcReauthenticateIframeOnload'
	        },
	        link: function link(scope, element, attrs) {
	            element.on('load', function (value) {
	                scope.callback({
	                    locationHref: element[0].contentWindow.location.href
	                });
	            });
	        }
	    };
	}
	
	exports.default = rcReauthenticateIframeOnloadDirective;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reauthenticate = __webpack_require__(67);
	
	var _reauthenticate2 = _interopRequireDefault(_reauthenticate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReauthenticateInterceptorProvider() {
	    var defaults = this.defaults = {
	        retryLastRequest: true,
	        retryAllPreviousRequests: false,
	        showReauthModal: true,
	        reauthEvent: 'RcAuthentication',
	        successEvent: 'RcAuthenticationSuccess'
	    };
	
	    this.config = function (configObj) {
	        angular.extend(defaults, configObj);
	        return this;
	    };
	
	    this.retryLastRequest = function (value) {
	        if (typeof value !== 'undefined') {
	            defaults.retryLastRequest = !!value;
	
	            if (defaults.retryLastRequest) {
	                defaults.retryAllPreviousRequests = false;
	            }
	        }
	
	        return this;
	    };
	
	    this.retryAllPreviousRequests = function (value) {
	        if (typeof value !== 'undefined') {
	            defaults.retryAllPreviousRequests = !!value;
	
	            if (defaults.retryAllPreviousRequests) {
	                defaults.retryLastRequest = false;
	            }
	        }
	
	        return this;
	    };
	
	    function containsLogin(response) {
	        if (typeof response !== 'undefined') {
	            var data = response.data;
	            if (angular.isString(data)) {
	                // Normal Siteminder possibilities
	                if (data.indexOf('LOGINFORM') > 0) {
	                    return data.indexOf('smauthreason') > 0 || data.indexOf('smagentname') > 0 || data.indexOf('smquerydata') > 0;
	                }
	                // Latent network SiteMinder response: "This page is used to hold your data while you are being authorized for your request."
	                if (data.indexOf('AUTOSUBMIT') > 0 && data.indexOf('SMPostPreserve')) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	
	    function isAuthenticationError(response) {
	        if (typeof response !== 'undefined') {
	            var status = response.status;
	            return typeof status !== 'undefined' && status === 401;
	        }
	        return false;
	    }
	
	    this.$get = ["$q", "$injector", "$cacheFactory", function ($q, $injector, $cacheFactory) {
	        'ngInject';
	
	        ReauthModalController.$inject = ["$scope", "$modalInstance"];
	        var interceptor = {};
	        var requestBuffer = [];
	        var modalInstance = false;
	        var $http;
	
	        function showReauthModal(bool) {
	            $injector.get('$rootScope').$broadcast(defaults.reauthEvent);
	            if (bool) {
	                $cacheFactory.get('$http').removeAll();
	                if (modalInstance === false) {
	                    modalInstance = $injector.get('$rcModal').open({
	                        template: _reauthenticate2.default,
	                        controller: ReauthModalController,
	                        includeCancel: false
	                    });
	
	                    modalInstance.result.then(successfulLogin, destroyModalInstance);
	                }
	            }
	        }
	
	        /** @ngInject */
	        function ReauthModalController($scope, $modalInstance) {
	            var loginUrl;
	            // Latency issues
	            $scope.isLoading = true;
	
	            $scope.verifyLocationHref = function (locationHref) {
	                var currentUrl = locationHref.split('?')[0];
	                if (loginUrl && loginUrl !== currentUrl) {
	                    $modalInstance.close('Authenticated');
	                } else {
	                    $scope.isLoading = false;
	                    loginUrl = currentUrl;
	                }
	            };
	        }
	
	        function retryRequest(config, deferred) {
	
	            function success(response) {
	                deferred.resolve(response);
	            }
	
	            function error(response) {
	                deferred.reject(response);
	            }
	
	            $http = $http || $injector.get('$http');
	            $http(config).then(success, error);
	        }
	
	        function retryBufferedRequests() {
	            for (var i = 0; i < requestBuffer.length; i++) {
	                retryRequest(requestBuffer[i].config, requestBuffer[i].deferred);
	            }
	            requestBuffer = [];
	        }
	
	        function successfulLogin(value) {
	            // Register the usage of the module (since they are now authenticated)
	            $injector.get('Usage').register('reauthenticate');
	            $injector.get('$rootScope').$broadcast(defaults.successEvent);
	            /*
	            * Clear all previous $http responses to avoid cached SiteMinder 200 status login HTML.
	            * Angular's default $http cache uses the url & all parameters as the key so it is easier
	            * to clear everything than try to match it.
	            */
	            $injector.get('$cacheFactory').get('$http').removeAll();
	
	            retryBufferedRequests();
	            destroyModalInstance();
	        }
	
	        function destroyModalInstance() {
	            modalInstance = false;
	        }
	
	        function getBufferedRequestPromise(config) {
	            var deferred = $q.defer();
	
	            if (defaults.retryLastRequest) {
	                requestBuffer = [];
	            }
	
	            requestBuffer.push({
	                config: config,
	                deferred: deferred
	            });
	
	            return deferred.promise;
	        }
	
	        function rejectResponse401(response) {
	            response.status = 401;
	            response.statusText = 'Unauthorized';
	            return $q.reject(response);
	        }
	
	        interceptor.response = function (response) {
	
	            if (containsLogin(response)) {
	                showReauthModal(defaults.showReauthModal);
	
	                if (defaults.retryLastRequest || defaults.retryAllPreviousRequests) {
	                    return getBufferedRequestPromise(response.config);
	                }
	
	                return rejectResponse401(response);
	            }
	            return response || $q.when(response);
	        };
	
	        interceptor.responseError = function (response) {
	
	            if (isAuthenticationError(response)) {
	                showReauthModal(defaults.showReauthModal);
	
	                if (defaults.retryLastRequest || defaults.retryAllPreviousRequests) {
	                    return getBufferedRequestPromise(response.config);
	                }
	
	                return rejectResponse401(response);
	            }
	            return $q.reject(response);
	        };
	
	        interceptor.triggerModal = function () {
	            showReauthModal(true);
	        };
	
	        return interceptor;
	    }];
	}
	
	exports.default = ReauthenticateInterceptorProvider;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _redirector = __webpack_require__(222);
	
	var _redirector2 = _interopRequireDefault(_redirector);
	
	var _redirector3 = __webpack_require__(220);
	
	var _redirector4 = _interopRequireDefault(_redirector3);
	
	var _redirector5 = __webpack_require__(221);
	
	var _redirector6 = _interopRequireDefault(_redirector5);
	
	var _redirector7 = __webpack_require__(223);
	
	var _redirector8 = _interopRequireDefault(_redirector7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.redirector', [_usage2.default.name, _utils2.default.name]).filter('msToS', _redirector2.default).controller('rcRedirectorCtrl', _redirector4.default).directive('rcRedirector', _redirector6.default).provider('$rcRedirector', _redirector8.default);

/***/ },
/* 220 */
/***/ function(module, exports) {

	'use strict';
	
	rcRedirectorCtrl.$inject = ["$parse", "$timeout", "$window", "$http", "$rcRedirector", "rcUserId"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcRedirectorCtrl($parse, $timeout, $window, $http, $rcRedirector, rcUserId) {
	    'ngInject';
	
	    var self = this;
	    this.timeout = getDefault('timeout');
	    this.redirectTo = getDefault('redirectTo');
	    this.serviceUrl = getDefault('serviceUrl');
	
	    if (!!this.timeout && angular.isNumber(this.timeout)) {
	        this.timeoutFn = $timeout(function () {
	            $window.location = self.redirectTo;
	        }, this.timeout);
	    }
	
	    this.info = $rcRedirector.getUrlActions();
	
	    rcUserId.get().then(function (response) {
	        self.info.userId = response.data.userId;
	        $http.get(self.serviceUrl, {
	            params: self.info
	        });
	    });
	
	    function getDefault(name) {
	        if (name === 'timeout' && self[name]) {
	            return $parse(self[name])(); /* convert to number */
	        }
	        return self[name] || $rcRedirector.defaults[name];
	    }
	}
	
	exports.default = rcRedirectorCtrl;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcRedirectorDirective.$inject = ["$timeout", "$window"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _redirector = __webpack_require__(68);
	
	var _redirector2 = _interopRequireDefault(_redirector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcRedirectorDirective($timeout, $window) {
	    'ngInject';
	
	    return {
	        template: _redirector2.default,
	        scope: {
	            timeout: '@',
	            redirectTo: '@',
	            serviceUrl: '@'
	        },
	        bindToController: true,
	        controller: 'rcRedirectorCtrl',
	        controllerAs: 'redirector',
	        transclude: true
	    };
	}
	
	exports.default = rcRedirectorDirective;

/***/ },
/* 222 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = msToSFilter;
	function msToSFilter() {
	    return millisecondsToSeconds;
	
	    function millisecondsToSeconds(ms, showSeconds) {
	        var seconds = ms / 1000,
	            suffix = showSeconds ? ' seconds' : '';
	        return seconds + (seconds === 1 ? suffix.slice(0, -1) : suffix);
	    }
	}

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcRedirectorProvider() {
	    rcRedirectorService.$inject = ["$injector"];
	    var defaults = this.defaults = {
	        serviceUrl: '',
	        redirectTo: '',
	        timeout: '5000',
	        actions: [{
	            key: 'path',
	            action: '$location.path'
	        }, {
	            key: 'domain',
	            action: '$location.$$host'
	        }, {
	            key: 'referrer',
	            action: '$window.document.referrer'
	        }, {
	            key: 'query',
	            action: '$location.search'
	        }]
	    };
	
	    this.config = function (configObj) {
	        angular.extend(defaults, configObj);
	        return this;
	    };
	
	    this.addAction = function (key, action) {
	        if (key.key && key.action) {
	            defaults.action.push(key);
	        } else {
	            defaults.actions.push({
	                key: key,
	                action: action
	            });
	        }
	        return this;
	    };
	
	    this.addActions = function (actions) {
	        for (var i = 0; i < actions.length; i++) {
	            this.addAction(actions[i]);
	        }
	        return this;
	    };
	
	    this.setServiceUrl = function (service) {
	        defaults.serviceUrl = service;
	        return this;
	    };
	
	    this.setRedirect = function (url) {
	        defaults.redirectTo = url;
	        return this;
	    };
	
	    this.setTimeout = function (timeout) {
	        defaults.timeout = timeout;
	        return this;
	    };
	
	    this.$get = rcRedirectorService;
	
	    function rcRedirectorService($injector) {
	        'ngInject';
	
	        var service = {};
	
	        service.defaults = defaults;
	
	        service.getUrlActions = function () {
	            var actionObj = {};
	            for (var i = 0; i < defaults.actions.length; i++) {
	                actionObj[defaults.actions[i].key] = getAction(defaults.actions[i].action);
	            }
	            return actionObj;
	        };
	
	        return service;
	
	        function getAction(action) {
	            var actionArr = action.split('.');
	            try {
	                var svc = $injector.get(actionArr.shift());
	                var method = actionArr.shift();
	
	                /* only accepts three "levels" of calling, e.g. service.do.that.thing won't work */
	                if (actionArr.length) {
	                    return svc[method][actionArr.shift()];
	                } else {
	                    return angular.isFunction(svc[method]) ? svc[method]() : svc[method];
	                }
	            } catch (exception) {
	                return null;
	            }
	        }
	    }
	}
	
	exports.default = rcRedirectorProvider;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _ric2compat = __webpack_require__(226);
	
	var _ric2compat2 = _interopRequireDefault(_ric2compat);
	
	var _ric2compat3 = __webpack_require__(225);
	
	var _ric2compat4 = _interopRequireDefault(_ric2compat3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.ric2compat', [_utils2.default.name, _ric2compat4.default.name]).run(_ric2compat2.default);

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ric2compatModule = void 0; // This is a port of the jbus functionality from Ricola 2.
	// Note: we're disabling a number of linter rules here. This file
	// is considered a one-off and we shouldn't willy-nilly disable rules
	// in other locations!
	
	/* eslint max-depth: 0*/
	/* eslint angular/json-functions: 0*/
	/* eslint angular/typecheck-string: 0*/
	/* eslint angular/typecheck-object: 0*/
	/* eslint angular/interval-service: 0*/
	/* eslint curly: 0*/
	
	/* !
	 * jQuery postMessage - v1.0 - 8/26/2011
	 *
	 * Copyright (c) 2011 "zachleat" Zach Leatherman
	 * Copyright (c) 2009 "Cowboy" Ben Alman
	 * Dual licensed under the MIT and GPL licenses.
	 * http://jquery.org/license
	 */
	
	/* Forked from http://benalman.com/projects/jquery-postmessage-plugin/
	 * http://benalman.com/about/license/
	 */
	
	// Script: jQuery postMessage: Cross-domain scripting goodness
	//
	// *Version: 1.0, Last updated: 8/24/2011*
	//
	// Project Home - http://benalman.com/projects/jquery-postmessage-plugin/
	// GitHub       - http://github.com/cowboy/jquery-postmessage/
	// Source       - http://github.com/cowboy/jquery-postmessage/raw/master/jquery.ba-postmessage.js
	// (Minified)   - http://github.com/cowboy/jquery-postmessage/raw/master/jquery.ba-postmessage.min.js (0.9kb)
	//
	// About: License
	//
	// Copyright (c) 2009 "Cowboy" Ben Alman,
	// Dual licensed under the MIT and GPL licenses.
	// http://benalman.com/about/license/
	//
	// About: Examples
	//
	// This working example, complete with fully commented code, illustrates one
	// way in which this plugin can be used.
	//
	// Iframe resizing - http://benalman.com/code/projects/jquery-postmessage/examples/iframe/
	//
	// About: Support and Testing
	//
	// Information about what version or versions of jQuery this plugin has been
	// tested with and what browsers it has been tested in.
	//
	// jQuery Versions - 1.3.2
	// Browsers Tested - Internet Explorer 6-8, Firefox 3, Safari 3-4, Chrome, Opera 9.
	//
	// About: Release History
	//
	// 0.6 - (8/24/2011) Using window.name instead of hash, added queueing (otherwise limited to one per 100ms delay)
	// 0.5 - (9/11/2009) Improved cache-busting
	// 0.4 - (8/25/2009) Initial release
	
	(function () {
	    var jqmock = {};
	
	    // $.param
	    // Modified from Zepto.js
	    // https://github.com/madrobby/zepto/blob/master/src/ajax.js#L345
	    function serialize(params, obj, traditional, scope) {
	        var type,
	            array = angular.isArray(obj),
	            hash = angular.isObject(obj);
	        angular.forEach(obj, function (value, key) {
	            // CHANGE: Replace jQuery.type with youmightnotneedjquery approach
	            type = Object.prototype.toString.call(value).replace(/^\[object (.+)\]$/, '$1').toLowerCase();
	            if (scope) key = traditional ? scope : scope + '[' + (hash || type === 'object' || type === 'array' ? key : '') + ']';
	            // handle data in serializeArray() format
	            if (!scope && array) params.add(value.name, value.value);
	            // recurse into nested objects
	            else if (type === 'array' || !traditional && type === 'object') serialize(params, value, traditional, key);else params.add(key, value);
	        });
	    }
	
	    jqmock.param = function (obj, traditional) {
	        var params = [];
	        params.add = function (k, v) {
	            this.push(escape(k) + '=' + escape(v));
	        };
	        serialize(params, obj, traditional);
	        return params.join('&').replace(/%20/g, '+');
	    };
	
	    '$:nomunge'; // Used by YUI compressor.
	
	    // A few vars used in non-awesome browsers.
	    var receive_interval_id,
	        send_interval_id,
	        targets = [],
	        message_queue = {},
	
	
	    // A var used in awesome browsers.
	    rm_callback,
	
	
	    // A few convenient shortcuts.
	    FALSE = !1,
	
	
	    // Reused internal strings.
	    postMessage = 'postMessage',
	        addEventListener = 'addEventListener',
	        _p_receiveMessage,
	
	
	    // I couldn't get window.postMessage to actually work in Opera 9.64!
	    // CHANGE - Removed Opera sniff
	    has_postMessage = window[postMessage];
	
	    // Method: jQuery.postMessage
	    //
	    // This method will call window.postMessage if available, setting the
	    // targetOrigin parameter to the base of the target_url parameter for maximum
	    // security in browsers that support it. If window.postMessage is not available,
	    // the target window's location.hash will be used to pass the message. If an
	    // object is passed as the message param, it will be serialized into a string
	    // using the jQuery.param method.
	    //
	    // Usage:
	    //
	    // > jQuery.postMessage( message, target_url [, target ] );
	    //
	    // Arguments:
	    //
	    //  message - (String) A message to be passed to the other frame.
	    //  message - (Object) An object to be serialized into a params string, using
	    //    the jQuery.param method.
	    //  target_url - (String) The URL of the other frame this window is
	    //    attempting to communicate with. This must be the exact URL (including
	    //    any query string) of the other window for this script to work in
	    //    browsers that don't support window.postMessage.
	    //  target - (Object) A reference to the other frame this window is
	    //    attempting to communicate with. If omitted, defaults to `parent`.
	    //
	    // Returns:
	    //
	    //  Nothing.
	
	    jqmock[postMessage] = function (message, target_origin, target, delay) {
	        if (!target_origin) {
	            return;
	        }
	
	        // Serialize the message if not a string. Note that this is the only real
	        // jQuery dependency for this script. If removed, this script could be
	        // written as very basic JavaScript.
	        message = typeof message === 'string' ? message : jqmock.param(message);
	
	        // Default to parent if unspecified.
	        target = target || parent;
	
	        if (has_postMessage) {
	            // The browser supports window.postMessage, so call it with a targetOrigin
	            // set appropriately, based on the target_url parameter.
	            target[postMessage](message, target_origin);
	        } else {
	            // The browser does not support window.postMessage, so set the location
	            // of the target to target_url#message. A bit ugly, but it works! A cache
	            // bust parameter is added to ensure that repeat messages trigger the
	            // callback.
	            var index = -1;
	            for (var j = 0, k = targets.length; j < k; j++) {
	                if (targets[j] === target) {
	                    index = j;
	                    break;
	                }
	            }
	            if (index === -1) {
	                index = targets.length;
	                targets.push(target);
	            }
	
	            if (!message_queue[index]) {
	                message_queue[index] = [];
	            }
	            message_queue[index].push({ source: location.href, message: message });
	
	            send_interval_id && clearInterval(send_interval_id);
	            send_interval_id = null;
	
	            send_interval_id = setInterval(function () {
	                for (var i in message_queue) {
	                    targets[i].name = JSON.stringify(message_queue[i]);
	                }
	                // reset
	                targets = [];
	                message_queue = {};
	            }, delay);
	        }
	    };
	
	    // Method: jQuery.receiveMessage
	    //
	    // Register a single callback for either a window.postMessage call, if
	    // supported, or if unsupported, for any change in the current window
	    // location.hash. If window.postMessage is supported and source_origin is
	    // specified, the source window will be checked against this for maximum
	    // security. If window.postMessage is unsupported, a polling loop will be
	    // started to watch for changes to the location.hash.
	    //
	    // Note that for simplicity's sake, only a single callback can be registered
	    // at one time. Passing no params will unbind this event (or stop the polling
	    // loop), and calling this method a second time with another callback will
	    // unbind the event (or stop the polling loop) first, before binding the new
	    // callback.
	    //
	    // Also note that if window.postMessage is available, the optional
	    // source_origin param will be used to test the event.origin property. From
	    // the MDC window.postMessage docs: This string is the concatenation of the
	    // protocol and "://", the host name if one exists, and ":" followed by a port
	    // number if a port is present and differs from the default port for the given
	    // protocol. Examples of typical origins are https://example.org (implying
	    // port 443), http://example.net (implying port 80), and http://example.com:8080.
	    //
	    // Usage:
	    //
	    // > jQuery.receiveMessage( callback [, source_origin ] [, delay ] );
	    //
	    // Arguments:
	    //
	    //  callback - (Function) This callback will execute whenever a <jQuery.postMessage>
	    //    message is received, provided the source_origin matches. If callback is
	    //    omitted, any existing receiveMessage event bind or polling loop will be
	    //    canceled.
	    //  source_origin - (String) If window.postMessage is available and this value
	    //    is not equal to the event.origin property, the callback will not be
	    //    called.
	    //  source_origin - (Function) If window.postMessage is available and this
	    //    function returns false when passed the event.origin property, the
	    //    callback will not be called.
	    //  delay - (Number) An optional zero-or-greater delay in milliseconds at
	    //    which the polling loop will execute (for browser that don't support
	    //    window.postMessage). If omitted, defaults to 100.
	    //
	    // Returns:
	    //
	    //  Nothing!
	
	    jqmock.receiveMessage = _p_receiveMessage = function p_receiveMessage(callback, source_origin, delay, retrieve_window) {
	        if (has_postMessage) {
	            // Since the browser supports window.postMessage, the callback will be
	            // bound to the actual event associated with window.postMessage.
	
	            if (callback) {
	                // Unbind an existing callback if it exists.
	                rm_callback && _p_receiveMessage();
	
	                // Bind the callback. A reference to the callback is stored for ease of
	                // unbinding.
	                rm_callback = function rm_callback(e) {
	                    if (typeof source_origin === 'string' && e.origin !== source_origin || angular.isFunction(source_origin) && source_origin(e.origin) === FALSE) {
	                        return FALSE;
	                    }
	                    callback(e);
	                };
	            }
	
	            if (window[addEventListener]) {
	                window[callback ? addEventListener : 'removeEventListener']('message', rm_callback, FALSE);
	            } else {
	                window[callback ? 'attachEvent' : 'detachEvent']('onmessage', rm_callback);
	            }
	        } else {
	            // Since the browser sucks, a polling loop will be started, and the
	            // callback will be called whenever window.name changes.
	
	            receive_interval_id && clearInterval(receive_interval_id);
	            receive_interval_id = null;
	
	            if (callback) {
	                delay = delay || 100;
	
	                receive_interval_id = setInterval(function () {
	                    var raw_messages = window.name;
	
	                    if (raw_messages) {
	                        window.name = '';
	                        var messages = JSON.parse(raw_messages),
	                            source;
	
	                        for (var j = 0, k = messages.length; j < k; j++) {
	                            source = retrieve_window(messages[j].source);
	                            if (source !== false) {
	                                callback({ source: source, data: messages[j].message });
	                            }
	                        }
	                    }
	                }, delay);
	            }
	        }
	    };
	
	    // CHANGE: Bind to window, so jbus can use it
	    window.$jbusjquery = jqmock;
	})();
	
	// JBUS Code
	(function () {
	
	    /*
	    Pass in a window object, like window, window.top, window.self, window.parent.
	    Returns whether or not you have JavaScript access to the context.
	    RETURNS FALSE IF THE CONTEXTS ARE THE SAME
	    */
	    // TODO Test
	    var $canUseContext = function $canUseContext(compareTo, objName) {
	        if (window.self === compareTo) {
	            return false;
	        } else {
	            var names = (objName || 'location.href').split('.');
	            try {
	                for (var j = 0, k = names.length; j < k; j++) {
	                    if (!compareTo[names[j]]) {
	                        // must EXIST
	                        return false;
	                    }
	                    compareTo = compareTo[names[j]];
	                }
	                return true;
	            } catch (e) {
	                return false;
	            }
	        }
	    };
	
	    // CHANGE: Swap out Ricola.log for angular.noop. We could use $log later if we want.
	    var conlog = angular.noop;
	
	    // TODO:
	    // Add Angular hooks
	
	    /*
	     * Limitations:
	     * In IE7 and prior requires unique URLS on iframes when sending from a child to top.
	     */
	
	    // Can access top window (top != window) & Ricola exists there (use top jbus)
	    var ricolajbus;
	    ricolajbus = $canUseContext(top, 'Ricola') ? top.Ricola.jbus : function () {
	        var events = {},
	            xDomain = {
	            // These properties are for IE<8 support
	            POSTMESSAGE_INTERVAL: 50,
	            // Warning, this must be > POSTMESSAGE_INTERVAL * 2
	            POSTMESSAGE_BATCH_SEND_DELAY: 50,
	
	            isListening: false,
	            targets: {},
	            targetsCounter: 0,
	            trigger: function trigger(eventName, data, excludeWindow) // optional
	            {
	                // make sure data is not an HTML node
	                if (data && !data.nodeType && xDomain.targetsCounter > 0) {
	                    var windows = xDomain.targets,
	                        message = eventName + ',' + JSON.stringify(data);
	
	                    for (var domain in windows) {
	                        for (var j = 0, k = windows[domain].length; j < k; j++) {
	                            if (windows[domain][j] !== excludeWindow) {
	                                window.$jbusjquery.postMessage(message, domain, windows[domain][j], xDomain.POSTMESSAGE_BATCH_SEND_DELAY);
	                            }
	                        }
	                    }
	                } else {
	                    conlog('Trigger data must be object literal for cross-domain.');
	                }
	            },
	            listen: function listen() {
	                xDomain.isListening = true;
	
	                window.$jbusjquery.receiveMessage(function (event) {
	                    var parsed = xDomain.parseMessage(event.data);
	                    // Make sure the message fits our format
	                    if (parsed) {
	                        ricolajbus.triggerFromCrossDomain(parsed.eventName, event.source, parsed.data);
	                    }
	                },
	                // urls to allow messages from
	                function (sourceDomain) {
	                    var windows = xDomain.targets;
	                    for (var domain in windows) {
	                        if (domain.indexOf(sourceDomain) === 0) {
	                            return true;
	                        }
	                    }
	                    return false;
	                }, xDomain.POSTMESSAGE_INTERVAL,
	                // Used only by IE<8.
	                function (url) {
	                    // retrieve window from URL
	                    var source = window.$('iframe').filter(function () {
	                        var iframeUrl = window.$(this).attr('src');
	                        if (url !== iframeUrl) {
	                            return false;
	                        }
	                        return true;
	                    });
	
	                    if (source.length > 1) {
	                        // Could make this slightly better by making event.source return an array of windows in this case.
	                        // Then excludeWindow would be an array.
	                        conlog('jbus: Cross domain requires unique urls on iframes, but a duplicate url was found (' + url + '). Callback cancelled.');
	                        return false;
	                    }
	
	                    // if no source iframe is found on this page, assume the message came from the top.
	                    return source.length ? source.get(0).contentWindow : top;
	                });
	            },
	            parseMessage: function parseMessage(message) {
	                // eventName,json-encoded-data
	                var match = message.match(/([^,]*),(.*)/i);
	                if (match && match.length >= 3) {
	                    return {
	                        eventName: match[1],
	                        data: JSON.parse(match[2])
	                    };
	                }
	
	                return null;
	            },
	            registerTarget: function registerTarget(targetDomain, iframes) {
	                var t = xDomain.targets;
	
	                if (window !== top) {
	                    // upstream to top level jbus only
	                    t[targetDomain] = [top];
	                    xDomain.targetsCounter++;
	                } else {
	                    // make sure this runs after DOM available.
	                    // could use event.origin but not available in IE7
	                    if (!t[targetDomain]) {
	                        t[targetDomain] = [];
	                    }
	
	                    window.$(iframes).filter('iframe').onEmpty(function () {}).each(function () {
	                        t[targetDomain].push(this.contentWindow);
	                        xDomain.targetsCounter++;
	                    });
	                }
	
	                // Start listening for requests, if we haven't started already
	
	                if ($canUseContext(top, 'Ricola')) {
	                    // Can access top window (top != window) & Ricola exists there (use top jbus)
	                } else if ($canUseContext(top)) {
	                        // Can access top window (top != window) but Ricola does not exist there (use own jbus)
	                        //      OR top == window
	                    } else if (xDomain.targetsCounter > 0 && !xDomain.isListening) {
	                            // x-domain: parent and child window
	                            xDomain.listen();
	                        }
	            }
	        };
	
	        /* clear out any previous window.name messages
	         * only for IE7, see postmessage.js
	         * See: http://git-dev.uit.tla.uprr.com:9080/user-experience/ricola3/issues/284#note_5581
	        if (window.name && xDomain.parseMessage(window.name.replace(/^\d+&/, ''))) {
	            window.name = '';
	        }
	        */
	
	        function _trigger(event, excludeWindow, args) {
	            if (events[event]) {
	                // Cross Domain Triggering!
	                // first argument only
	                xDomain.trigger(event, args[0], excludeWindow);
	
	                // go backwards
	                for (var i = events[event].length - 1; i >= 0; i--) {
	                    var evt = events[event][i];
	                    if (evt) {
	                        var ret;
	                        try {
	                            ret = evt[0].apply({ id: i, event: event, key: evt[1] }, args);
	                        } catch (e) {
	                            // "Cannot execute code from a freed script"
	                            // This try/catch is just precautionairy.  The i-frames should unsubscribe jbus events onunload.
	                            conlog('jbus: trigger ERROR.  A destroyed i-frame may not have fired its unload event.', e);
	                            ret = null;
	                        }
	                        if (ret === false) {
	                            return false;
	                        }
	                    }
	                }
	            }
	        }
	
	        return {
	            addCrossDomain: xDomain.registerTarget,
	            getEvents: function getEvents() {
	                return events;
	            },
	            subscribe: function subscribe(event, callback, key) {
	                if (!events[event]) {
	                    events[event] = [];
	                }
	                var id = events[event].length;
	                events[event].push([callback, key]);
	                return id;
	            },
	            triggerFromCrossDomain: function triggerFromCrossDomain(event, excludeWindow) {
	                return _trigger(event, excludeWindow, Array.prototype.slice.call(arguments, 2));
	            },
	            trigger: function trigger(event) {
	                return _trigger(event, null, Array.prototype.slice.call(arguments, 1));
	            },
	            unsubscribe: function unsubscribe(event, callbackOrKey) // arg can match against the callback, OR the key provided in subscribe (usually the window)
	            {
	                if (events[event]) {
	                    // if !arg, then match against currentWindow / window
	                    var callbackOrKeyIndex = angular.isFunction(callbackOrKey) ? 0 : 1;
	                    for (var i = 0; i < events[event].length; i++) {
	                        if (events[event][i] && events[event][i][callbackOrKeyIndex] === callbackOrKey) {
	                            delete events[event][i];
	                        }
	                    }
	                }
	            },
	            unsubscribeAll: function unsubscribeAll(currentWindow) // delete all events which match window
	            {
	                angular.forEach(events, function (val, event) {
	                    ricolajbus.unsubscribe(event, currentWindow);
	                });
	            }
	        };
	    }();
	
	    // Modification - use Angular
	    angular.element(window).on('unload', function () {
	        ricolajbus.unsubscribeAll(window);
	    });
	
	    // Integrate into Angular
	    ric2compatModule = angular.module('rc.ric2compat.jbus', [_utils2.default.name]).run(["rcUtils", function (rcUtils) {
	        'ngInject';
	
	        var ric = rcUtils.Ricola;
	        ric.jbus = ricolajbus;
	    }]).run(["$rootScope", "$timeout", function ($rootScope, $timeout) {
	        'ngInject';
	        // Construct and send JBUS events. Used by MyUP Portal
	
	        $timeout(function () {
	            $rootScope.$on('rc.smartmenu.selected', function (event, data) {
	                var item = data.item;
	                var elementToSend = angular.element('<a href="' + item.url + '">' + item.label + '</a>')[0];
	                var ret = ricolajbus.trigger('ricolaSmartMenuSelected', elementToSend);
	                if (ret === false) {
	                    data.event.preventDefault();
	                    data.event.stopPropagation();
	                }
	            });
	        });
	    }]).factory('jbus', function () {
	        return ricolajbus;
	    });
	})();
	
	exports.default = ric2compatModule;

/***/ },
/* 226 */
/***/ function(module, exports) {

	'use strict';
	
	aliasRicolaLogs.$inject = ["rcUtils"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function aliasRicolaLogs(rcUtils) {
	    'ngInject';
	
	    var Ricola = rcUtils.Ricola;
	    Ricola.log = {
	        debug: angular.noop,
	        error: angular.noop,
	        fatal: angular.noop,
	        info: angular.noop,
	        init: angular.noop,
	        trace: angular.noop,
	        warn: angular.noop
	    };
	}
	
	exports.default = aliasRicolaLogs;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _scroll = __webpack_require__(228);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _scroll3 = __webpack_require__(229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.scroll', [_utils2.default.name]).controller('ScrollerController', _scroll2.default).directive('rcScroll', _scroll3.rcScrollDirective).directive('rcScroller', _scroll3.rcScrollerDirective).directive('rcScrollIf', _scroll3.rcScrollIfDirective);

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	ScrollerCtrl.$inject = ["$scope", "$element"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function ScrollerCtrl($scope, $element) {
	    'ngInject';
	
	    var ctrl = this;
	    ctrl.isScrollable = function (elem) {
	        var s = elem[0].style;
	        return s.overflowY === 'scroll' || s.overflowY === 'auto';
	    };
	    ctrl.scrollIntoView = function (targetElem) {
	        var e = targetElem[0];
	        var s = $element[0];
	        var isAbove = e.offsetTop < s.scrollTop;
	        var isBelow = e.offsetTop + e.offsetHeight > s.scrollTop + s.offsetHeight;
	        if (isBelow) {
	            s.scrollTop = e.offsetTop + e.offsetHeight - s.offsetHeight;
	        } else if (isAbove) {
	            s.scrollTop = e.offsetTop;
	        }
	    };
	}
	
	exports.default = ScrollerCtrl;

/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	rcScrollDirective.$inject = ["$parse"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rcScrollDirective = rcScrollDirective;
	exports.rcScrollerDirective = rcScrollerDirective;
	exports.rcScrollIfDirective = rcScrollIfDirective;
	function rcScrollDirective($parse) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        compile: function compile($element, attrs) {
	            var fn = $parse(attrs.rcScroll);
	            return function rcEventHandler(scope, element) {
	                /* TODO: We should probably throw in a convient way to adjust throttle and set it by default. */
	                element.on('scroll', function (event) {
	                    scope.$apply(function () {
	                        fn(scope, {
	                            $event: event
	                        });
	                    });
	                });
	            };
	        }
	    };
	}
	
	function rcScrollerDirective() {
	    return {
	        restrict: 'A',
	        controller: 'ScrollerController'
	    };
	}
	
	function rcScrollIfDirective() {
	    return {
	        restrict: 'A',
	        require: '^rcScroller',
	        link: function link(scope, elem, attrs, scrollerCtrl) {
	            scope.$watch(attrs.rcScrollIf, function (conditionMet) {
	                if (conditionMet) {
	                    scrollerCtrl.scrollIntoView(elem);
	                }
	            });
	        }
	    };
	}

/***/ },
/* 230 */
/***/ function(module, exports) {

	'use strict';
	
	rcSeamlessUiService.$inject = ["$window"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcSeamlessUiService($window) {
	    'ngInject';
	
	    var SEAMLESS_UI_CLASS = 'ricSeamlessUI';
	    this.isInSeamlessUIMode = function () {
	        try {
	            return angular.element($window.frameElement).hasClass(SEAMLESS_UI_CLASS);
	        } catch (e) {
	            return false;
	        }
	    };
	    this.openUrl = function (url, label) {
	        $window.top.uit.sui.component.tabs.getTab($window).create({ url: url, label: label });
	    };
	}
	
	exports.default = rcSeamlessUiService;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _select = __webpack_require__(232);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.select', [_keyboardNavigation2.default.name]).directive('select', _select2.default);

/***/ },
/* 232 */
/***/ function(module, exports) {

	'use strict';
	
	selectDirective.$inject = ["KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function selectDirective(KEYS) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        require: '?^^form',
	        link: function link(scope, element, attrs, formController) {
	            if (formController) {
	                (function () {
	                    var $formElement = angular.element(element[0].form);
	                    element.on('keydown', function (event) {
	                        if (event.which === KEYS.ENTER) {
	                            event.preventDefault();
	                            if (formController.$valid) {
	                                $formElement.triggerHandler('submit');
	                            }
	                        }
	                    });
	                })();
	            }
	        }
	    };
	}
	
	exports.default = selectDirective;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slideMenuNavJs = __webpack_require__(69);
	
	var _slideMenuNavJs2 = _interopRequireDefault(_slideMenuNavJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	exports.default = {
	    bindings: {
	        navContent: '='
	    },
	    controller: function () {
	        function SlideMenuNavJsController() {
	            _classCallCheck(this, SlideMenuNavJsController);
	        }
	
	        _createClass(SlideMenuNavJsController, [{
	            key: 'isSubnav',
	            value: function isSubnav(item) {
	                return item.sub && !item.url;
	            }
	        }]);
	
	        return SlideMenuNavJsController;
	    }(),
	    template: _slideMenuNavJs2.default
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slideMenuNestedNav = __webpack_require__(235);
	
	var _slideMenuNestedNav2 = _interopRequireDefault(_slideMenuNestedNav);
	
	var _slideMenuNestedNav3 = __webpack_require__(70);
	
	var _slideMenuNestedNav4 = _interopRequireDefault(_slideMenuNestedNav3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        label: '@'
	    },
	    require: {
	        'rcSlideMenuNav': '^rcSlideMenuNav'
	    },
	    template: _slideMenuNestedNav4.default,
	    controller: _slideMenuNestedNav2.default,
	    controllerAs: 'nestedNav',
	    transclude: true
	};

/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NestedNavController = function () {
	    function NestedNavController() {
	        _classCallCheck(this, NestedNavController);
	    }
	
	    _createClass(NestedNavController, [{
	        key: "toggleVisibility",
	        value: function toggleVisibility() {
	            this.rcSlideMenuNav.toggleVisibility(this.label);
	        }
	    }, {
	        key: "isActive",
	        value: function isActive() {
	            return this.rcSlideMenuNav.isActive(this);
	        }
	    }]);
	
	    return NestedNavController;
	}();
	
	exports.default = NestedNavController;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slideMenu = __webpack_require__(71);
	
	var _slideMenu2 = _interopRequireDefault(_slideMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    transclude: true,
	    template: _slideMenu2.default
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _modal = __webpack_require__(8);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _seamlessUi = __webpack_require__(11);
	
	var _seamlessUi2 = _interopRequireDefault(_seamlessUi);
	
	var _smartAnchor = __webpack_require__(238);
	
	var _smartAnchor2 = _interopRequireDefault(_smartAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.smartAnchor', [_modal2.default.name, _seamlessUi2.default.name]).directive('rcSmartAnchor', _smartAnchor2.default);

/***/ },
/* 238 */
/***/ function(module, exports) {

	'use strict';
	
	rcSmartAnchorDirective.$inject = ["rcSeamlessUi", "$rcModal"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcSmartAnchorDirective(rcSeamlessUi, $rcModal) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        scope: {
	            href: '@',
	            target: '@',
	            title: '@',
	            modalConfig: '='
	        },
	        compile: function compile(_element, _attrs, transclude) {
	            return function link(scope, element, attrs) {
	                if (attrs.modalConfig === void 0) {
	                    if (scope.target === void 0) {
	                        element.attr('target', '_blank');
	                    } else if (scope.target !== '_blank') {
	                        var firstChar = scope.target.slice(0, 1);
	                        var specialTargetIndicator = '_';
	                        if (firstChar === specialTargetIndicator) {
	                            throw new Error('rcSmartAnchor only accepts target attr of \'_blank\' or new window name.');
	                        }
	                    }
	                    if (rcSeamlessUi.isInSeamlessUIMode()) {
	                        var url = element.attr('href');
	                        var label = element.attr('title') || url;
	                        element.on('click', function (e) {
	                            e.preventDefault();
	                            rcSeamlessUi.openUrl(url, label);
	                        });
	                    }
	                } else {
	                    var defaultModalConfig = {
	                        templateUrl: scope.href,
	                        title: scope.title || scope.href
	                    };
	                    element.on('click', function (e) {
	                        e.preventDefault();
	                        $rcModal.open(scope.modalConfig || defaultModalConfig);
	                    });
	                }
	            };
	        }
	    };
	}
	
	exports.default = rcSmartAnchorDirective;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _position = __webpack_require__(4);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _target = __webpack_require__(12);
	
	var _target2 = _interopRequireDefault(_target);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _smartMenu = __webpack_require__(240);
	
	var _smartMenu2 = __webpack_require__(241);
	
	var _smartMenu3 = _interopRequireDefault(_smartMenu2);
	
	var _smartMenu4 = __webpack_require__(243);
	
	var _smartMenu5 = _interopRequireDefault(_smartMenu4);
	
	var _smartMenuDirective = __webpack_require__(242);
	
	var _smartMenuDirective2 = _interopRequireDefault(_smartMenuDirective);
	
	var _smartMenu6 = __webpack_require__(244);
	
	var _smartMenu7 = _interopRequireDefault(_smartMenu6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.smartMenu', [_keyboardNavigation2.default.name, _mediaQuery2.default.name, _position2.default.name, _target2.default.name, _usage2.default.name]).constant('SMART_MENU_URL', _smartMenu.SMART_MENU_URL).constant('RICOLA_SERVICE_URL', _smartMenu.RICOLA_SERVICE_URL).constant('SMART_MENU_SERVICES', _smartMenu.SMART_MENU_SERVICES).constant('SMART_MENU_SUMMARY_SERVICES', _smartMenu.SMART_MENU_SUMMARY_SERVICES).constant('SMART_MENU_ERROR', _smartMenu.SMART_MENU_ERROR).controller('rcSmartMenuController', _smartMenu3.default).directive('rcSmartMenu', _smartMenu5.default).directive('rcSmartMenuContent', _smartMenuDirective2.default).service('$$smartMenuService', _smartMenu7.default);

/***/ },
/* 240 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var SMART_MENU_URL = exports.SMART_MENU_URL = '/myup/secure/jas/loadMenu';
	var RICOLA_SERVICE_URL = exports.RICOLA_SERVICE_URL = '/uit/ricola/jas/services/';
	var SMART_MENU_SERVICES = exports.SMART_MENU_SERVICES = {
	    chassisid: 'chassisId',
	    cif: 'cif',
	    circ7: 'circ7',
	    city333: 'city333',
	    containervanid: 'containerVanId',
	    eotid: 'eotId',
	    equipmentid: 'equipmentId',
	    firm: 'firm',
	    id: 'id',
	    locomotiveid: 'locomotiveId',
	    piggybackflatcarid: 'piggybackFlatCarId',
	    seamlessui: 'seamlessui',
	    splc: 'splc',
	    target: 'target',
	    trainid: 'trainId',
	    userid: 'userId',
	    yardtrack: 'yardTrack'
	};
	var SMART_MENU_SUMMARY_SERVICES = exports.SMART_MENU_SUMMARY_SERVICES = {
	    circ7: 'circ7',
	    trainid: 'train',
	    userid: 'person'
	};
	var SMART_MENU_ERROR = exports.SMART_MENU_ERROR = {
	    INVALID_TYPE: 'The rc-smart-menu directive requires a valid type. Please refer to the documentation and choose a valid type.',
	    INVALID_SUMMARY_ATTR: 'The summary attribute is only valid with trainId, userId, or circ7.',
	    INVALID_GENERIC_USAGE: 'The generic smartmenu requires custom content. Please use the menu-items or additional-content attributes to pass content to the directive.'
	};

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	rcSmartMenuController.$inject = ["$scope", "$rootScope", "$$smartMenuService", "KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcSmartMenuController($scope, $rootScope, $$smartMenuService, KEYS) {
	    'ngInject';
	
	    var ctrl = this,
	        queriedItems = [],
	        queriedSummary = [];
	    ctrl.handleCallback = handleCallback;
	    ctrl.hasSummaryContent = hasSummaryContent;
	    ctrl.isOpen = false;
	    ctrl.publishClick = publishClick;
	    ctrl.toggleSmartMenu = toggleSmartMenu;
	
	    $scope.$watch('value', function (current, previous) {
	        if (current !== previous) {
	            resetAllItems();
	        }
	    });
	
	    resetAllItems();
	
	    function closeMenu() {
	        ctrl.isOpen = false;
	    }
	
	    function displaySmartMenuContent() {
	        var missingMenuItems = menuDataRequired(),
	            missingSummary = summaryDataRequired();
	
	        if (missingMenuItems || missingSummary) {
	            var menuServiceConfig = $$smartMenuService.configure(ctrl.type, ctrl.value, ctrl.additionalParams);
	            if (missingMenuItems) {
	                menuServiceConfig.getMenuItems().then(function (results) {
	                    queriedItems = results.data.data || [];
	                    if (queriedItems.length === 0) {
	                        queriedItems.push({
	                            error: true,
	                            label: 'An error has occurred.' // TODO: i18n
	                        });
	                    }
	                    updateMenuItems();
	                    ctrl.repositionMenu();
	                });
	            }
	            if (missingSummary) {
	                menuServiceConfig.getSummaryItems().then(function (results) {
	                    queriedSummary = results.data.data || [];
	                    updateSummary();
	                    ctrl.repositionMenu();
	                });
	            }
	        } else {
	            updateMenuItems();
	            updateSummary();
	            ctrl.repositionMenu();
	        }
	    }
	
	    function handleCallback(event, item) {
	        if (isNotValidKeyUp(event)) {
	            return;
	        }
	
	        if (angular.isDefined(ctrl.callback)) {
	            ctrl.callback({ item: item });
	        }
	
	        if (item.closeOnClick || angular.isString(item.closeOnClick) && item.closeOnClick.toLowerCase() === 'true') {
	            closeMenu();
	        }
	    }
	
	    function hasSummaryContent() {
	        return ctrl.showSummary && ctrl.summaryContent && ctrl.summaryContent.length > 0 || ctrl.summaryAdditions && ctrl.summaryAdditions.length > 0;
	    }
	
	    function isNotValidKeyUp(event) {
	        return event.type === 'keyup' && event.which !== KEYS.ENTER;
	    }
	
	    function menuDataRequired() {
	        if (ctrl.type !== 'generic' && $$smartMenuService.serviceExists(ctrl.type)) {
	            return ctrl.menuItems.length === 0 || ctrl.menuAdditions && ctrl.menuAdditions.length === ctrl.menuItems.length;
	        }
	        return false;
	    }
	
	    function openMenu() {
	        ctrl.menuPosition = { zIndex: -10000 };
	        ctrl.isOpen = true;
	        displaySmartMenuContent();
	    }
	
	    function publishClick($event, item) {
	        $rootScope.$emit('rc.smartmenu.selected', { event: $event, item: item });
	    }
	
	    function resetAllItems() {
	        ctrl.summaryContent = ctrl.summaryAdditions || [];
	        ctrl.menuItems = ctrl.menuAdditions || [];
	    }
	
	    function summaryDataRequired() {
	        if (ctrl.showSummary && $$smartMenuService.summaryExists(ctrl.type)) {
	            return ctrl.summaryContent.length === 0 || ctrl.summaryAdditions && ctrl.summaryContent.length === ctrl.summaryAdditions.length;
	        }
	        return false;
	    }
	
	    function toggleSmartMenu(event) {
	        if (isNotValidKeyUp(event)) {
	            return;
	        }
	        event.stopPropagation();
	        // Signal the smart menu is opening
	        $rootScope.$emit('rc.smartmenu.opening', $scope.$id); // isolate to service
	
	        if (ctrl.isOpen) {
	            closeMenu();
	        } else {
	            openMenu();
	        }
	    }
	
	    function updateMenuItems() {
	        ctrl.menuItems = ctrl.menuAdditions ? ctrl.menuAdditions.concat(queriedItems) : queriedItems;
	    }
	
	    function updateSummary() {
	        ctrl.summaryContent = ctrl.summaryAdditions ? ctrl.summaryAdditions.concat(queriedSummary) : queriedSummary;
	    }
	}
	
	exports.default = rcSmartMenuController;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _smartMenuContent = __webpack_require__(73);
	
	var _smartMenuContent2 = _interopRequireDefault(_smartMenuContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcSmartMenuContentDirective() {
	    return {
	        restrict: 'EA',
	        template: _smartMenuContent2.default,
	        link: rcSmartMenuContentLink
	    };
	
	    function rcSmartMenuContentLink(scope, element, attrs) {
	        // Clicks outside the menu will close the menu.
	        element.bind('click', function (event) {
	            event.stopPropagation();
	        });
	    }
	}
	
	exports.default = rcSmartMenuContentDirective;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcSmartMenuDirective.$inject = ["$rootScope", "$position", "$window", "$document", "$timeout", "$compile", "Usage", "$$smartMenuService", "rcMediaQuery", "SMART_MENU_ERROR", "KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _smartMenu = __webpack_require__(72);
	
	var _smartMenu2 = _interopRequireDefault(_smartMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * TODO: Breaking change - change attribute names to menu-additions and summary-additions for clarity
	 *       Possible change SmartMenu to element only directive requiring type and key attributes
	 *       (currently 'type' as defined by the rc-smart-menu argument and 'value')
	 */
	function rcSmartMenuDirective($rootScope, $position, $window, $document, $timeout, $compile, Usage, $$smartMenuService, rcMediaQuery, SMART_MENU_ERROR, KEYS) {
	    'ngInject';
	
	    var keyNavigation = [KEYS.UP, KEYS.DOWN, KEYS.PAGEUP, KEYS.PAGEDOWN];
	    var scrollEvents = 'click scroll mousewheel keyup';
	
	    return {
	        restrict: 'EA',
	        require: 'rcSmartMenu',
	        template: _smartMenu2.default,
	        transclude: true,
	        scope: {
	            type: '@rcSmartMenu',
	            value: '@',
	            menuAdditions: '=menuItems',
	            summaryAdditions: '=additionalContent',
	            showSummary: '=summary',
	            callback: '&',
	            additionalParams: '=',
	            closeOnClick: '='
	        },
	        controller: 'rcSmartMenuController',
	        controllerAs: 'rcSMCtrl',
	        bindToController: true,
	        link: rcSmartMenuLink
	    };
	
	    function rcSmartMenuLink(scope, element, attrs, smController) {
	        Usage.register('smartmenu');
	
	        validateControllerAttributes(smController);
	        smController.repositionMenu = repositionMenu;
	
	        var contentMenu;
	        var bodyEl = $document.find('body');
	        var windowEl = angular.element(window);
	
	        bodyEl.on('click scroll mousewheel keyup', debouncedHideMenu);
	        windowEl.on('resize', debouncedHideMenu);
	
	        // Close when another smart menu opens
	        var deregister = $rootScope.$on('rc.smartmenu.opening', function (event, scopeId) {
	            if (scopeId !== scope.$id) {
	                smController.isOpen = false;
	            }
	        });
	
	        scope.$on('$destroy', function () {
	            bodyEl.unbind('click scroll mousewheel keyup', debouncedHideMenu);
	            windowEl.unbind('resize', debouncedHideMenu);
	            deregister();
	
	            if (contentMenu) {
	                contentMenu.remove();
	            }
	        });
	
	        function buildContentMenu() {
	            var menuEl = angular.element('<rc-smart-menu-content>');
	            menuEl.attr({
	                'class': 'rc-smart-menu-content',
	                'ng-show': 'rcSMCtrl.isOpen',
	                'ng-style': '{ top: rcSMCtrl.menuPosition.top + \'px\', left: rcSMCtrl.menuPosition.left + \'px\', \'z-index\': menuPosition.zIndex }'
	            });
	            return menuEl;
	        }
	
	        function buildDebouncedHidePromise(validatingCallback) {
	            if (angular.isFunction(validatingCallback)) {
	                return $timeout(function () {
	                    if (validatingCallback()) {
	                        smController.isOpen = false;
	                    }
	                }, 30);
	            }
	
	            return $timeout(function () {
	                smController.isOpen = false;
	            }, 30);
	        }
	
	        // Need to invesitgate using $position more effectively to reduce this code
	        function calculateMenuPosition(linkEl, contentEl) {
	            var placement = $position.offset(linkEl),
	                parentTop = placement.top;
	
	            /* Desktop sizing. Attempt to align right, then left, or backspace to fit underneath */
	            if (rcMediaQuery.minSize('medium')) {
	
	                var smartMenuLinkWidth = linkEl.prop('offsetWidth'),
	                    offsetLeft = $position.offset(linkEl).left,
	                    scrollbar = $window.innerWidth - bodyEl.prop('offsetWidth') - 2,
	                    rightSideCheck = offsetLeft + smartMenuLinkWidth + contentEl.prop('offsetWidth') + scrollbar;
	
	                if ($window.innerWidth < rightSideCheck) {
	                    var elementWidth = contentEl.prop('offsetWidth');
	                    if (offsetLeft - elementWidth > 0) {
	                        placement.left -= elementWidth;
	                    } else {
	                        placement.top = Math.ceil(parentTop + linkEl.prop('offsetHeight'));
	                        placement.left = Math.floor(Math.min(placement.left, rightSideCheck - $window.innerWidth)) * -1;
	                    }
	                } else {
	                    placement.left += smartMenuLinkWidth;
	                }
	
	                if (placement.top === parentTop) {
	                    var offsetBottom = $window.pageYOffset + $window.innerHeight - $position.offset(linkEl).top - contentEl.prop('offsetHeight');
	                    placement.top += offsetBottom < 0 ? offsetBottom : 0;
	                }
	            } else {
	                placement.top = Math.ceil(parentTop + linkEl.prop('offsetHeight'));
	                placement.left = 0;
	            }
	
	            return placement;
	        }
	
	        var debouncedHidePromise;
	        function debouncedHideMenu(event) {
	            if (debouncedHidePromise) {
	                $timeout.cancel(debouncedHidePromise);
	            }
	
	            if (smController.isOpen) {
	                if (event.type === 'resize' || event.type === 'click') {
	                    debouncedHidePromise = buildDebouncedHidePromise();
	                } else if (mayCauseScroll(event)) {
	                    debouncedHidePromise = buildDebouncedHidePromise(hasChangedPosition);
	                }
	            }
	        }
	
	        function hasChangedPosition() {
	            var newLinkPosition = $position.offset(element);
	            if (scope.linkPosition.top !== newLinkPosition.top) {
	                scope.linkPosition = newLinkPosition;
	                return true;
	            }
	            return false;
	        }
	
	        function mayCauseScroll(event) {
	            return event.type === 'scroll' || event.type === 'mousewheel' || keyNavigation.indexOf(event.which) > -1;
	        }
	
	        var repositioningPromise;
	        function repositionMenu() {
	            if (!contentMenu) {
	                contentMenu = buildContentMenu();
	                bodyEl.append(contentMenu);
	                $compile(contentMenu)(scope);
	            }
	
	            if (repositioningPromise) {
	                $timeout.cancel(repositioningPromise);
	            }
	
	            repositioningPromise = $timeout(function () {
	                scope.linkPosition = $position.offset(element);
	                smController.menuPosition = calculateMenuPosition(element, adjustWidthForScroll(contentMenu));
	            });
	        }
	    }
	
	    /*
	     * This is a hack due to absolutely-positioned, scrollable elements
	     * seem to overlap their content with the scroll bar.
	     * If an HTML/CSS solution is available, it should be used instead.
	     */
	    function adjustWidthForScroll(element) {
	        element.css({ width: '' });
	        var difference = element[0].offsetWidth - element[0].clientWidth;
	        if (difference > 0) {
	            element.css({ width: element[0].offsetWidth + difference + 'px' });
	        }
	        return element;
	    }
	
	    function validateControllerAttributes(smController) {
	        if (smController.type !== 'generic' && !$$smartMenuService.serviceExists(smController.type)) {
	            throw new Error(SMART_MENU_ERROR.INVALID_TYPE);
	            // TODO: Does this matter if the summary attribute is '=' ?
	        } else if (smController.showSummary && !$$smartMenuService.summaryExists(smController.type)) {
	                throw new Error(SMART_MENU_ERROR.INVALID_SUMMARY_ATTR);
	            } else if (smController.type === 'generic' && !smController.summaryAdditions && !smController.menuAdditions) {
	                throw new Error(SMART_MENU_ERROR.INVALID_GENERIC_USAGE);
	            }
	    }
	}
	
	exports.default = rcSmartMenuDirective;

/***/ },
/* 244 */
/***/ function(module, exports) {

	'use strict';
	
	$$smartMenuService.$inject = ["$http", "SMART_MENU_URL", "RICOLA_SERVICE_URL", "SMART_MENU_SERVICES", "SMART_MENU_SUMMARY_SERVICES"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function $$smartMenuService($http, SMART_MENU_URL, RICOLA_SERVICE_URL, SMART_MENU_SERVICES, SMART_MENU_SUMMARY_SERVICES) {
	    'ngInject';
	
	    var service = this;
	
	    service.configure = function (type, key, additionalParams) {
	        return {
	            getMenuItems: function getMenuItems() {
	                var parameters = { params: {} };
	                parameters.params[SMART_MENU_SERVICES[type.toLowerCase()]] = key;
	
	                if (angular.isObject(additionalParams)) {
	                    /* The MyUP smart menu service requires the 'suiSmartMenu' to respond properly
	                     * when additional parameters are included to know which is the primary type */
	                    parameters.params.suiSmartMenu = SMART_MENU_SERVICES[type.toLowerCase()];
	                    angular.forEach(additionalParams, function (value, paramKey) {
	                        parameters.params[paramKey] = value;
	                    });
	                }
	
	                return $http.get(SMART_MENU_URL, parameters);
	            },
	            getSummaryItems: function getSummaryItems() {
	                var url = '' + RICOLA_SERVICE_URL + SMART_MENU_SUMMARY_SERVICES[type.toLowerCase()] + '/summary';
	                return $http.get(url, {
	                    params: { 'id': key }
	                });
	            }
	        };
	    };
	
	    service.serviceExists = function (type) {
	        return type && typeof SMART_MENU_SERVICES[type.toLowerCase()] !== 'undefined';
	    };
	
	    service.summaryExists = function (type) {
	        return type && typeof SMART_MENU_SUMMARY_SERVICES[type.toLowerCase()] !== 'undefined';
	    };
	}
	
	exports.default = $$smartMenuService;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _infiniteScroll = __webpack_require__(19);
	
	var _infiniteScroll2 = _interopRequireDefault(_infiniteScroll);
	
	var _keyboardNavigation = __webpack_require__(3);
	
	var _keyboardNavigation2 = _interopRequireDefault(_keyboardNavigation);
	
	var _mediaQuery = __webpack_require__(5);
	
	var _mediaQuery2 = _interopRequireDefault(_mediaQuery);
	
	var _position = __webpack_require__(4);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _utils = __webpack_require__(2);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _table = __webpack_require__(246);
	
	var _table2 = __webpack_require__(247);
	
	var _table3 = _interopRequireDefault(_table2);
	
	var _tableDirective = __webpack_require__(248);
	
	var _tableDirective2 = _interopRequireDefault(_tableDirective);
	
	var _tableDirective3 = __webpack_require__(249);
	
	var _tableDirective4 = _interopRequireDefault(_tableDirective3);
	
	var _tableDirective5 = __webpack_require__(252);
	
	var _tableDirective6 = _interopRequireDefault(_tableDirective5);
	
	var _tableDirective7 = __webpack_require__(254);
	
	var _tableDirective8 = _interopRequireDefault(_tableDirective7);
	
	var _tableDirective9 = __webpack_require__(255);
	
	var _tableDirective10 = _interopRequireDefault(_tableDirective9);
	
	var _tableDirective11 = __webpack_require__(250);
	
	var filterComponents = _interopRequireWildcard(_tableDirective11);
	
	var _tableDirective12 = __webpack_require__(257);
	
	var _tableDirective13 = __webpack_require__(258);
	
	var _tableDirective14 = _interopRequireDefault(_tableDirective13);
	
	var _tableDirective15 = __webpack_require__(251);
	
	var _tableDirective16 = _interopRequireDefault(_tableDirective15);
	
	var _tableDirective17 = __webpack_require__(256);
	
	var _tableDirective18 = _interopRequireDefault(_tableDirective17);
	
	var _table4 = __webpack_require__(253);
	
	var _table5 = __webpack_require__(259);
	
	var _table6 = _interopRequireDefault(_table5);
	
	var _table7 = __webpack_require__(260);
	
	var _table8 = _interopRequireDefault(_table7);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.table', [_infiniteScroll2.default.name, _keyboardNavigation2.default.name, _mediaQuery2.default.name, _position2.default.name, _usage2.default.name, _utils2.default.name, _table8.default.name]).constant('tablePhases', _table.RC_TABLE_PHASES).constant('TOGGLE_PRIORITY_1', (0, _table.RC_TABLE_TOGGLE_PRIORITIES_FN)(1)).constant('TOGGLE_PRIORITY_2', (0, _table.RC_TABLE_TOGGLE_PRIORITIES_FN)(2)).constant('TOGGLE_PRIORITY_3', (0, _table.RC_TABLE_TOGGLE_PRIORITIES_FN)(3)).constant('TOGGLE_PRIORITY_4', (0, _table.RC_TABLE_TOGGLE_PRIORITIES_FN)(4)).constant('TOGGLE_PRIORITY_5', (0, _table.RC_TABLE_TOGGLE_PRIORITIES_FN)(5)).constant('TOGGLE_PRIORITY_6', (0, _table.RC_TABLE_TOGGLE_PRIORITIES_FN)(6)).controller('rcTableController', _table3.default).directive('columnPriorities', _tableDirective2.default).directive('duplicateControls', _tableDirective4.default).directive('tableInfiniteScroll', _tableDirective6.default).directive('toggleColumns', _tableDirective8.default).directive('toggleDropdown', _tableDirective10.default).directive('hideControls', _tableDirective12.rcTableHideControlsDirective).directive('tableMode', _tableDirective12.rcTableReflowDirective).directive('showFilter', _tableDirective12.rcTableFiltersDirective).directive('tableTextFilter', filterComponents.tableTextFilter).directive('rcTable', _tableDirective14.default).directive('rcTable', _tableDirective16.default).directive('rcTable', _tableDirective18.default).directive('rcTable', _table4.legacyRcTableConfigurationDirective) // this one creates an <rc-table> element
	.directive('rcTable', _table4.rcTableDirective).factory('RcTableParams', _table6.default);

/***/ },
/* 246 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RC_TABLE_TOGGLE_PRIORITIES_FN = RC_TABLE_TOGGLE_PRIORITIES_FN;
	var RC_TABLE_PHASES = exports.RC_TABLE_PHASES = {
	    preTransclusion1: 1.3,
	    preTransclusion2: 1.2,
	    tableTransclusion: 1.1,
	    postTransclusion: 2,
	    legacyWrapping: 3
	};
	
	/* 20em, 30em, 40em, ... */
	function RC_TABLE_TOGGLE_PRIORITIES_FN(input) {
	    var increment = 10;
	    return input * increment + increment + "em";
	}

/***/ },
/* 247 */
/***/ function(module, exports) {

	'use strict';
	
	rcTableController.$inject = ["$scope", "$timeout", "RcTableParams", "$rcFixedTableElements", "KEYS"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * @ngdoc object
	 * @name rcTable.directive:rcTable.rcTableController
	 *
	 * @description
	 * Each {@link rcTable.directive:rcTable rcTable} directive creates an instance of `rcTableController`
	 */
	function rcTableController($scope, $timeout, RcTableParams, $rcFixedTableElements, KEYS) {
	    'ngInject';
	
	    var ctrl = this;
	    $scope.$loading = false;
	
	    if ($scope.params) {
	        return;
	    }
	
	    $scope.params = new RcTableParams();
	    $scope.params.settings().$scope = $scope;
	
	    var delayFilter = function () {
	        var timer = 0;
	        return function (callback, ms) {
	            $timeout.cancel(timer);
	            timer = $timeout(callback, ms);
	        };
	    }();
	
	    $scope.$watch('params.$params', function (newParams, oldParams) {
	        $scope.params.settings().$scope = $scope;
	
	        if (!angular.equals(newParams.filter, oldParams.filter)) {
	            delayFilter(function () {
	                $scope.params.reload();
	            }, $scope.params.settings().filterDelay);
	        } else {
	            $scope.params.reload();
	        }
	    }, true);
	    $scope.toggleGroups = $scope.params.toggleGroups();
	    $scope.sortBy = function (column, event) {
	        if (event.type === 'keyup' && event.which !== KEYS.ENTER) {
	            return;
	        }
	        var parsedSortable = $scope.parse(column.sortable);
	        if (!parsedSortable) {
	            return;
	        }
	        var defaultSort = $scope.params.settings().defaultSort;
	        var inverseSort = defaultSort === 'asc' ? 'desc' : 'asc';
	        var sorting = $scope.params.sorting() && $scope.params.sorting()[parsedSortable] && $scope.params.sorting()[parsedSortable] === defaultSort;
	        var sortingParams = event.ctrlKey || event.metaKey ? $scope.params.sorting() : {};
	        sortingParams[parsedSortable] = sorting ? inverseSort : defaultSort;
	        $scope.params.parameters({
	            sorting: sortingParams
	        });
	    };
	
	    $scope.$watchCollection('params.data', $rcFixedTableElements.refreshFixedElements);
	    $scope.$on('$rcModalHeightUpdated', $rcFixedTableElements.refreshFixedElements);
	
	    ctrl.handleInfiniteScroll = function () {
	        $scope.params.doInfiniteScroll();
	    };
	}
	
	exports.default = rcTableController;

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	columnPrioritiesDirective.$inject = ["$timeout", "tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function columnPrioritiesDirective($timeout, tablePhases) {
	    'ngInject';
	
	    var addPriorityClassesToCells = function addPriorityClassesToCells(priorities, cells) {
	        angular.forEach(cells, function (cell, index) {
	            angular.element(cell).addClass('rc-priority-' + priorities[index % priorities.length]);
	        });
	    };
	    return {
	        restrict: 'A',
	        require: 'rcTable',
	        priority: tablePhases.postTransclusion,
	        compile: function compile(tElement, tAttrs) {
	            // We convert single quotes to double quotes because it is strict JSON. SID#149365
	            var priorities = angular.fromJson(tAttrs.columnPriorities.replace(/'/g, '"'));
	
	            // Find the tds we wish to add classes to
	            // Will choose the first <tr> row either in the tbody or directly on the table
	            // TODO This is strictly convention, but we should allow for more flexibility when defining tables
	            var getTds = function getTds(table) {
	                var inTbody = table.querySelector('tbody > tr');
	                var tr = inTbody || table.querySelector('> tr');
	                return angular.element(tr.querySelectorAll('td'));
	            };
	
	            var tds = getTds(tElement[0]);
	
	            if (tds.length !== priorities.length) {
	                throw new Error('Number of columns (' + tds.length + ') must equal number of priorities (' + priorities.length + ') given in columnPriorities.');
	            }
	            var cells = Array.prototype.slice.call(tds).concat(Array.prototype.slice.call(tElement.find('th')));
	            addPriorityClassesToCells(priorities, cells);
	            return function (scope, element, attrs) {
	                scope.columnPriorities = priorities;
	                scope.$on('rc.table.thead.ready', function () {
	                    $timeout(function () {
	                        var ths = Array.prototype.slice.call(element.find('th'));
	                        addPriorityClassesToCells(priorities, ths);
	                    });
	                });
	            };
	        }
	    };
	}
	
	exports.default = columnPrioritiesDirective;

/***/ },
/* 249 */
/***/ function(module, exports) {

	'use strict';
	
	duplicateControlsDirective.$inject = ["$compile", "tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function duplicateControlsDirective($compile, tablePhases) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        // set this higher than all the other directives so this can run last
	        // and duplicate ANY controls that are added to the control div
	        priority: tablePhases.postTransclusion,
	        require: 'rcTable',
	        compile: function compile(tElement, tAttrs) {
	            if (!angular.isDefined(tAttrs.params)) {
	                throw new Error('duplicateControls directive can not be used without rcTable directive.');
	            }
	            return function (scope, element, attrs) {
	                var container = angular.element(element[0].querySelector('.rc-table-container'));
	                var controls = angular.element(element[0].querySelector('.rc-table-controls'));
	                container.append($compile(controls.clone())(scope));
	            };
	        }
	    };
	}
	
	exports.default = duplicateControlsDirective;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.tableTextFilter = tableTextFilter;
	
	var _tableText = __webpack_require__(75);
	
	var _tableText2 = _interopRequireDefault(_tableText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tableTextFilter() {
	    return {
	        restrict: 'A',
	        template: _tableText2.default
	    };
	}

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcHeaderAndColumnsDirective.$inject = ["$parse", "$templateCache", "tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tableHeader = __webpack_require__(74);
	
	var _tableHeader2 = _interopRequireDefault(_tableHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcHeaderAndColumnsDirective($parse, $templateCache, tablePhases) {
	    'ngInject';
	
	    return {
	        priority: tablePhases.preTransclusion1,
	        restrict: 'E',
	        require: 'rcTable',
	        compile: function compile(tElement, tAttrs) {
	            var i = 0,
	                columns = [],
	                row;
	            // IE 8 fix :not(.ng-table-group) selector
	            angular.forEach(angular.element(tElement.find('tr')), function (tr) {
	                tr = angular.element(tr);
	                if (!tr.hasClass('rc-table-group') && !row) {
	                    row = tr;
	                }
	            });
	            if (!row) {
	                return;
	            }
	            var tableRowElements = row.find('th');
	            if (!tableRowElements.length) {
	                tableRowElements = row.find('td');
	            }
	            angular.forEach(tableRowElements, function (item) {
	                var el = angular.element(item);
	                var ignoreCell = el.attr('ignore-cell');
	                if (angular.isDefined(ignoreCell) && ignoreCell === 'true') {
	                    return;
	                }
	                var parsedAttribute = function parsedAttribute(attr, defaultValue) {
	                    return function (scope) {
	                        return $parse(el.attr('x-data-' + attr) || el.attr('data-' + attr) || el.attr(attr))(scope, {
	                            $columns: columns
	                        }) || defaultValue;
	                    };
	                };
	
	                var parsedTitle = parsedAttribute('title', ' '),
	                    headerTemplateURL = parsedAttribute('header', false),
	                    filter = parsedAttribute('filter', false)(),
	                    filterTemplateURL = false,
	                    filterName = false;
	
	                if (filter && filter.$$name) {
	                    filterName = filter.$$name;
	                    delete filter.$$name;
	                }
	                if (filter && filter.templateURL) {
	                    filterTemplateURL = filter.templateURL;
	                    delete filter.templateURL;
	                }
	
	                el.attr('data-title-text', parsedTitle()); // this used in responsive table
	
	                var isReflowMode = !!tAttrs.tableMode && tAttrs.tableMode.toLowerCase() === 'reflow';
	
	                var REFLOW_CELL_LABEL_CLASS = 'rc-table-cell-label';
	                if (isReflowMode) {
	                    // if they are using reflow mode, need to prepend a pseudo <b> label
	                    // into each <td> cell to serve as inline labels
	                    el.prepend('<b class="' + REFLOW_CELL_LABEL_CLASS + '">' + el.attr('data-title-text') + '</b>');
	                }
	
	                var parsedSortable = parsedAttribute('sortable', false);
	                var sortableTitle = parsedSortable();
	
	                columns.push({
	                    id: i++,
	                    title: parsedTitle,
	                    sortable: parsedSortable,
	                    class: el.attr('x-data-header-class') || el.attr('data-header-class') || el.attr('header-class'),
	                    tabindex: sortableTitle && '0' || void 0,
	                    sortIndex: function sortIndex(scope) {
	                        var sortOrder = scope.params.sorting();
	                        var j = 0;
	                        for (var title in sortOrder) {
	                            /* Ignore inheritied properties. */
	                            if (sortOrder.hasOwnProperty(title)) {
	                                if (title === sortableTitle) {
	                                    return 'sort-index-' + j;
	                                }
	                                j++;
	                            }
	                        }
	                    },
	                    filter: filter,
	                    filterTemplateURL: filterTemplateURL,
	                    filterName: filterName,
	                    headerTemplateURL: headerTemplateURL,
	                    filterData: el.attr('filter-data') ? el.attr('filter-data') : null,
	                    show: el.attr('ng-show') ? function (scope) {
	                        return $parse(el.attr('ng-show'))(scope);
	                    } : function () {
	                        return true;
	                    }
	                });
	            });
	
	            var templates = {
	                header: tAttrs.templateHeader ? tAttrs.templateHeader : null
	            };
	
	            // create or apply headers
	            // TODO this should be its own directive, probably!
	            var thead = tElement.find('thead');
	            if (!thead.length) {
	                // Apply the standard header
	                var headerTemplateHtml = '<thead>' + (templates.header ? $templateCache.get(templates.header) : _tableHeader2.default) + '</thead>';
	                var headerTemplate = angular.element(headerTemplateHtml);
	                tElement.find('thead').remove();
	                tElement.find('table').prepend(headerTemplate);
	            } else {
	                // TODO This sorting logic is a subset of what's in the header template
	                // We should remove it from the header template and perform it all here.
	                var headerItems = thead.find('th');
	                for (var j = 0; j < headerItems.length; j++) {
	                    var th = angular.element(headerItems[j]);
	                    if (columns[j] && columns[j].sortable()) {
	                        th.attr('ng-class', '{ "sortable": parse($columns[' + j + '].sortable), "sort-asc": params.sorting()[parse($columns[' + j + '].sortable)] === "asc" , "sort-desc": params.sorting()[parse($columns[' + j + '].sortable)] === "desc" }');
	                        th.attr('ng-click', 'sortBy($columns[' + j + '], $event)');
	                        th.attr('ng-keyup', 'sortBy($columns[' + j + '], $event)');
	                        th.addClass('sort-index-0'); // This is hardcoded; I don't think we support any other sort indexes
	                    }
	                }
	            }
	            return function link($scope, $el, attrs) {
	                $scope.$watch(attrs.params, function (params) {
	                    if (angular.isUndefined(params)) {
	                        return;
	                    }
	                    $scope.paramsModel = $parse(attrs.params);
	                    $scope.params = params;
	                }, true);
	                $scope.$columns = columns;
	            };
	        }
	    };
	}
	
	exports.default = rcHeaderAndColumnsDirective;

/***/ },
/* 252 */
/***/ function(module, exports) {

	'use strict';
	
	tableInfiniteScrollDirective.$inject = ["tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function tableInfiniteScrollDirective(tablePhases) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        priority: tablePhases.postTransclusion,
	        require: 'rcTable',
	        link: function link(scope, element, attrs, ctrl) {
	            var tableParent = angular.element(element[0].querySelector('.rc-table-parent'));
	            tableParent.addClass('rc-table-scroll-container');
	            tableParent.on('scroll', function (e) {
	                var t = e.target;
	                var scrollContainerHeight = t.scrollHeight,
	                    currentScrollPosition = t.scrollTop + t.offsetHeight;
	                if (currentScrollPosition >= scrollContainerHeight) {
	                    ctrl.handleInfiniteScroll();
	                }
	            });
	        }
	    };
	}
	
	exports.default = tableInfiniteScrollDirective;

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	rcTableDirective.$inject = ["Usage", "$parse", "$timeout", "tablePhases"];
	legacyRcTableConfigurationDirective.$inject = ["$compile", "tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rcTableDirective = rcTableDirective;
	exports.legacyRcTableConfigurationDirective = legacyRcTableConfigurationDirective;
	/**
	 * @ngdoc directive
	 * @name rcTable.directive:rcTable
	 * @restrict A
	 *
	 * @description
	 * Directive that instantiates {@link rcTable.directive:rcTable.rcTableController rcTableController}.
	 */
	function rcTableDirective(Usage, $parse, $timeout, tablePhases) {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        priority: tablePhases.postTransclusion,
	        scope: false,
	        require: 'rcTable',
	        link: function link(scope, element, attrs, ctrl) {
	            element = element.find('table');
	            Usage.register('table');
	
	            scope.$loading = false;
	
	            // add in expand all
	            scope.getExpandAllText = function (params) {
	                if (params.$hideRows) {
	                    return 'Expand All';
	                }
	                return 'Collapse All';
	            };
	
	            scope.parse = function (text) {
	                return angular.isDefined(text) ? text(scope) : '';
	            };
	
	            angular.forEach(scope.columns, function (column) {
	                var def;
	                if (!column.filterData) {
	                    return;
	                }
	                def = $parse(column.filterData)(scope, {
	                    $column: column
	                });
	                if (!(angular.isObject(def) && angular.isObject(def.promise))) {
	                    throw new Error('Function ' + column.filterData + ' must be instance of $q.defer()');
	                }
	                delete column.filterData;
	                return def.promise.then(function (data) {
	                    if (!angular.isArray(data)) {
	                        data = [];
	                    }
	                    data.unshift({
	                        title: '-',
	                        id: ''
	                    });
	                    column.data = data;
	                });
	            });
	
	            $timeout(function () {
	                scope.$emit('rc.table.thead.ready');
	            });
	
	            if (!element.hasClass('rc-table')) {
	                element.addClass('rc-table');
	            }
	
	            // If the developer has not provided any other means to handle a table
	            // that may not fit horizontally on the page, read that as: they are not
	            // using another mode that will handle a table that is too wide, assign
	            // this safe/catch all class.
	            //
	            // Should toggle columns be included in this list? Without coupling it
	            // with column priorities it doesn't do much automagically to control
	            // the width of the table.
	            if (!angular.isDefined(attrs.columnPriorities)) {
	                element.parent().addClass('rc-table-overflow');
	            }
	        }
	    };
	}
	
	/*
	 * This directive enables use of the legacy <table rc-table> form of this component.
	 * We should plan to remove this in a future major release.
	 *
	 * Known bug: When a <table rc-table> is the root of most transcluded content, this will not work.
	 * The workaround is to wrap the table in a <div>, or (better yet) to use the standard <rc-table> wrapper.
	 */
	function legacyRcTableConfigurationDirective($compile, tablePhases) {
	    'ngInject';
	
	    return {
	        priority: tablePhases.legacyWrapping, // this should go first
	        scope: false,
	        restrict: 'A',
	        terminal: true,
	        compile: function compile(tEl, tAttr) {
	            if (tEl[0].tagName !== 'TABLE') {
	                throw new Error('Attribute directive `rc-table` can only be used on <table></table> elements.', tEl[0].tagName);
	            }
	            var params = tAttr.rcTable;
	            tEl.removeAttr('rc-table');
	
	            var additionalAttributes = '';
	            ['hide-controls', 'table-mode', 'duplicate-controls', 'no-row-hover', 'column-priorities', 'fixed-headers', 'fixed-footers', 'toggle-columns'].forEach(function (tableDirective) {
	                var normalized = tAttr.$normalize(tableDirective);
	                if (angular.isDefined(tAttr[normalized])) {
	                    var tableDirectiveVal = tAttr[normalized];
	                    tableDirectiveVal = tableDirectiveVal.replace(/\"/g, '\'');
	                    additionalAttributes += ' ' + tableDirective + ' ="' + tableDirectiveVal + ' "';
	                    tEl.removeAttr(tableDirective);
	                }
	            });
	
	            tEl.wrap('<rc-table params="' + params + '" ' + additionalAttributes + '>');
	            return function link($scope, $el) {
	                // Weirdness: if the element is at the root of a new scope (i.e. from an ng-include),
	                // the $el that's returned is the table, not the <rc-table>. It's unclear why!
	                if ($el[0].nodeName === 'TABLE') {
	                    $el = $el.parent();
	                }
	                $compile($el)($scope);
	            };
	        }
	    };
	}

/***/ },
/* 254 */
/***/ function(module, exports) {

	'use strict';
	
	toggleColumnsDirective.$inject = ["$timeout", "$window", "$log", "rcUtils", "rcMediaQuery", "$rcFixedTableElements", "TOGGLE_PRIORITY_1", "TOGGLE_PRIORITY_2", "TOGGLE_PRIORITY_3", "TOGGLE_PRIORITY_4", "TOGGLE_PRIORITY_5", "TOGGLE_PRIORITY_6", "tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function toggleColumnsDirective($timeout, $window, $log, rcUtils, rcMediaQuery, $rcFixedTableElements, TOGGLE_PRIORITY_1, TOGGLE_PRIORITY_2, TOGGLE_PRIORITY_3, TOGGLE_PRIORITY_4, TOGGLE_PRIORITY_5, TOGGLE_PRIORITY_6, tablePhases) {
	    'ngInject';
	    // TODO - make this extendable somehow
	
	    var TOGGLE_PRIORITIES = [TOGGLE_PRIORITY_1, TOGGLE_PRIORITY_2, TOGGLE_PRIORITY_3, TOGGLE_PRIORITY_4, TOGGLE_PRIORITY_5, TOGGLE_PRIORITY_6, 'persist', 'hidden'];
	    var TOGGLE_PRIORITIES_MAP = {};
	    TOGGLE_PRIORITIES_MAP[1] = TOGGLE_PRIORITY_1;
	    TOGGLE_PRIORITIES_MAP[2] = TOGGLE_PRIORITY_2;
	    TOGGLE_PRIORITIES_MAP[3] = TOGGLE_PRIORITY_3;
	    TOGGLE_PRIORITIES_MAP[4] = TOGGLE_PRIORITY_4;
	    TOGGLE_PRIORITIES_MAP[5] = TOGGLE_PRIORITY_5;
	    TOGGLE_PRIORITIES_MAP[6] = TOGGLE_PRIORITY_6;
	    TOGGLE_PRIORITIES_MAP.persist = 'persist';
	    TOGGLE_PRIORITIES_MAP.hidden = 'hidden';
	    var updateNgClassForCells = function updateNgClassForCells(cells, useIndex) {
	        angular.forEach(cells, function (cell, index) {
	            index = useIndex ? '$index' : index;
	            cell = angular.element(cell);
	            var newAttr = '{ "rc-toggle-cell-hidden": !rcToggled[' + index + '].on && rcToggled[' + index + '].forced, "rc-toggle-cell-visible": rcToggled[' + index + '].on && rcToggled[' + index + '].forced';
	
	            var existingNgClass = cell.attr('ng-class');
	            if (existingNgClass) {
	                existingNgClass = existingNgClass.replace(/[{}]/g, '');
	                newAttr += ',' + existingNgClass;
	            }
	            newAttr += '}';
	            cell.attr('ng-class', newAttr);
	        });
	    };
	    return {
	        restrict: 'A',
	        priority: tablePhases.preTransclusion2,
	        require: 'rcTable',
	        compile: function compile(tElement, tAttrs) {
	            tElement = tElement.find('table');
	            if (tElement.hasClass('rc-toggle')) {
	                return;
	            }
	            tElement.addClass('rc-toggle');
	            var columnPrioritiesAttr = void 0;
	            if (tAttrs.columnPriorities) {
	                columnPrioritiesAttr = tAttrs.columnPriorities.replace(/'/g, '"');
	            }
	            var priorities = angular.fromJson(columnPrioritiesAttr);
	
	            // The user has provided the set of `td` elements, but we only have the ng-repeat template for the `th`.
	            // So we use the actual index values for the former, and '$index' for the latter.
	            // Can we improve on this?
	            updateNgClassForCells(tElement.find('td'));
	            updateNgClassForCells(tElement.find('th'), true);
	
	            return function postLink(scope, iElement, iAttrs) {
	                scope.showToggleDropdown = true;
	                scope.rcToggled = {};
	                var columnsAlreadySet = false;
	
	                scope.rcToggleColumn = function (columnIndex, visible) {
	                    var forced = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	
	                    scope.rcToggled[columnIndex] = {
	                        on: visible,
	                        forced: forced
	                    };
	                    $rcFixedTableElements.refreshFixedElements();
	                };
	
	                scope.$watch('$columns', function (newValue, oldValue) {
	                    if (!columnsAlreadySet) {
	                        columnsAlreadySet = true;
	                        angular.forEach(scope.$columns, function (c, index) {
	                            scope.rcToggleColumn(index, true, false);
	                        });
	                    }
	                });
	
	                var updateColumnToggleStateByMediaQuery = function updateColumnToggleStateByMediaQuery() {
	                    // find what the current minWidth is (start at lowest first)
	                    var shouldBeVisibleArray = TOGGLE_PRIORITIES.map(function (ems) {
	                        if (ems === 'persist') {
	                            return ems;
	                        } else if (ems === 'hidden') {
	                            return false;
	                        }
	                        return rcMediaQuery.minWidth(ems);
	                    });
	                    // for each column
	                    scope.$columns.forEach(function ($column, idx) {
	                        // if the state hasn't been forced visible/hidden
	                        if (!scope.rcToggled[idx].forced) {
	                            var visibility = shouldBeVisibleArray[// true/false
	                            TOGGLE_PRIORITIES.indexOf( // 2, etc
	                            TOGGLE_PRIORITIES_MAP[priorities[idx]] // 20em, etc
	                            )];
	                            if (!angular.isDefined(visibility)) {
	                                // should we display a warning if they use a priority level that is not defined?
	                                $log.warn('Attempting to use columnPriority "' + priorities[idx] + '" with no associated width defined. Available priorities: ' + priorities.join(', '));
	                            }
	                            // update the column's checkbox model
	                            scope.rcToggleColumn(idx, visibility, false);
	                        }
	                    });
	                };
	                if (priorities) {
	                    $timeout(function () {
	                        updateColumnToggleStateByMediaQuery();
	                    });
	                    angular.element($window).on('resize', rcUtils.throttle(250, function () {
	                        updateColumnToggleStateByMediaQuery();
	                    }));
	                }
	            };
	        }
	    };
	}
	
	exports.default = toggleColumnsDirective;

/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	
	toggleDropdownDirective.$inject = ["$window", "$document", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function toggleDropdownDirective($window, $document, $timeout) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        // FIXME This is really ugly jquery-ey code. It should be rewritten to be more Angularish.
	        link: function link(scope, element) {
	            var div = element.find('div').eq(0);
	            var hideDropdown = function hideDropdown(e) {
	                div.removeClass('rc-visible');
	                $document.off('click', hideDropdown);
	            };
	
	            var toggle = function toggle(e) {
	                e.stopPropagation();
	                div.toggleClass('rc-visible');
	
	                // Ensure we don't hide the dropdown when user clicks inside it
	                div.on('click', function (clickEvent) {
	                    clickEvent.stopPropagation();
	                });
	
	                $document.on('click', hideDropdown);
	            };
	            element.find('button').on('click', toggle);
	        }
	    };
	}
	
	exports.default = toggleDropdownDirective;

/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	rcAddUserClassesDirective.$inject = ["tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcAddUserClassesDirective(tablePhases) {
	    'ngInject';
	
	    var ROW_HOVER_CLASS = 'rc-hover';
	    var ROW_STRIPE_CLASS = 'rc-stripes';
	    var TABLE_LAYOUT_CLASS = 'rc-table-layout';
	    return {
	        restrict: 'E',
	        priority: tablePhases.postTransclusion,
	        require: 'rcTable',
	        compile: function compile(tEl, tAttr) {
	            // FIXME this is such a hack, we can probably find a better way to do this
	            return function link($scope, $el, $attr, ctrl) {
	                var table = $el.find('table');
	                var classList = table.attr('class'),
	                    parent = table.parent();
	                var usefulClasses = classList.split(' ').filter(function (e) {
	                    return ['ng-class', 'rc-table', 'rc-hover', 'rc-stripes', 'ng-scope'].indexOf(e) === -1;
	                }).forEach(function (e) {
	                    parent.addClass(e);
	                });
	
	                table.addClass(TABLE_LAYOUT_CLASS);
	                table.addClass(ROW_STRIPE_CLASS);
	
	                if (angular.isUndefined($attr.noRowHover)) {
	                    table.addClass(ROW_HOVER_CLASS);
	                }
	            };
	        }
	    };
	}
	
	exports.default = rcAddUserClassesDirective;

/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	
	rcTableReflowDirective.$inject = ["tablePhases"];
	rcTableFiltersDirective.$inject = ["tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rcTableHideControlsDirective = rcTableHideControlsDirective;
	exports.rcTableReflowDirective = rcTableReflowDirective;
	exports.rcTableFiltersDirective = rcTableFiltersDirective;
	function rcTableHideControlsDirective() {
	    return {
	        restrict: 'A',
	        require: 'rcTable',
	        link: function link($scope, $el, attrs) {
	            $scope.$watch(attrs.hideControls, function (value) {
	                $scope.hideControls = value;
	            });
	        }
	    };
	}
	
	function rcTableReflowDirective(tablePhases) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        priority: tablePhases.postTransclusion,
	        require: 'rcTable',
	        compile: function compile(tEl, tAttrs) {
	            var isReflowMode = tAttrs.tableMode.toLowerCase() === 'reflow';
	            if (isReflowMode) {
	                var table = tEl.find('table');
	                table.addClass('rc-table-reflow');
	            }
	        }
	    };
	}
	
	function rcTableFiltersDirective(tablePhases) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        priority: tablePhases.postTransclusion,
	        require: 'rcTable',
	        link: function link($scope, $el, attr, ctrl) {
	            // FIXME we'd like to use ctrl here but the table wrapper template doesn't have access to the controller yet
	            $scope.showFilter = true;
	        }
	    };
	}

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	tableWrapperDirective.$inject = ["tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tableWrapper = __webpack_require__(76);
	
	var _tableWrapper2 = _interopRequireDefault(_tableWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tableWrapperDirective(tablePhases) {
	    'ngInject';
	
	    return {
	        priority: tablePhases.tableTransclusion,
	        restrict: 'E',
	        scope: true,
	        transclude: true,
	        controller: 'rcTableController',
	        controllerAs: 'rcTable',
	        template: _tableWrapper2.default,
	        link: function link($scope, $el, attrs, ctrl, $transclude) {
	            $transclude(function (clone, transScope) {
	                var entryPoint = angular.element($el[0].querySelector('.rc-table-parent'));
	                entryPoint.append(clone);
	
	                // We're adding all these watchers because they are primitives set on the child scope,
	                // and part of the public 'table API'. It would sure be nice to remove these.
	                // Perhaps we can deprecate and create a new API for them!
	                ['$columns', '$data', '$groups'].forEach(function (scopeVal) {
	                    $scope.$watch(scopeVal, function (newVal) {
	                        transScope[scopeVal] = newVal;
	                    });
	                });
	
	                // FIXME these ones are just used internally, I bet we could move them to the controller!
	                ['parse', 'showToggleDropdown', 'toggleGroups', 'sortBy', 'params', 'showFilter', 'rcToggled'].forEach(function (scopeVal) {
	                    $scope.$watch(scopeVal, function (newVal) {
	                        transScope[scopeVal] = newVal;
	                    });
	                });
	            });
	        }
	    };
	}
	
	exports.default = tableWrapperDirective;

/***/ },
/* 259 */
/***/ function(module, exports) {

	'use strict';
	
	RcTableParamsFactory.$inject = ["$q", "$log"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * @ngdoc service
	 * @name rcTable.factory:RcTableParams
	 * @description Parameters manager for rcTable
	 */
	function RcTableParamsFactory($q, $log) {
	    'ngInject';
	
	    var isNumber = function isNumber(n) {
	        return !isNaN(parseFloat(n)) && isFinite(n);
	    };
	    var RcTableParams = function RcTableParams(baseParameters, baseSettings) {
	        var self = this,
	            log = function log() {
	            if (settings.debugMode && $log.debug) {
	                $log.debug.apply(this, arguments);
	            }
	        };
	
	        this.data = [];
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#parameters
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Set new parameters or get current parameters
	         *
	         * @param {string} newParameters      New parameters
	         * @param {string} parseParamsFromUrl Flag if parse parameters like in url
	         * @returns {Object} Current parameters or `this`
	         */
	        this.parameters = function (newParameters) {
	            var parseParamsFromUrl = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            if (angular.isDefined(newParameters)) {
	                angular.forEach(newParameters, function (value, key) {
	                    if (parseParamsFromUrl && key.indexOf('[') >= 0) {
	                        var keys = key.split(/\[(.*)\]/).reverse();
	                        var lastKey = '';
	                        for (var i = 0, len = keys.length; i < len; i++) {
	                            var name = keys[i];
	                            if (name !== '') {
	                                var v = value;
	                                value = {};
	                                value[lastKey = name] = isNumber(v) ? parseFloat(v) : v;
	                            }
	                        }
	                        if (lastKey === 'sorting') {
	                            params[lastKey] = {};
	                        }
	                        params[lastKey] = angular.extend(params[lastKey] || {}, value[lastKey]);
	                    } else {
	                        params[key] = isNumber(newParameters[key]) ? parseFloat(newParameters[key]) : newParameters[key];
	                    }
	                });
	                // Just a hack to ensure even newParameters get initialized
	                if (Object.keys(newParameters).length === 0) {
	                    params.fakekeyvalue = 'something else';
	                }
	                log('rcTable: set parameters', params);
	                return this;
	            }
	            return params;
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#settings
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Set new settings for table
	         *
	         * @param {string} newSettings New settings or undefined
	         * @returns {Object} Current settings or `this`
	         */
	        this.settings = function (newSettings) {
	            if (angular.isDefined(newSettings)) {
	                settings = angular.extend(settings, newSettings);
	                return this;
	            }
	            return settings;
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#filter
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Return current filter else set current filter
	         *
	         * @param {string} filter New filter
	         * @returns {Object} Current filter or `this`
	         */
	        this.filter = function (filter) {
	            return angular.isDefined(filter) ? this.parameters({
	                'filter': filter
	            }) : params.filter;
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#sorting
	         * @methodOf rcTable.factory:RcTableParams
	         * @description If 'sorting' parameter is not set, return current sorting. Otherwise set current sorting.
	         *
	         * @param {string} sorting New sorting
	         * @returns {Object} Current sorting or `this`
	         */
	        this.sorting = function (sorting) {
	            if (arguments.length === 2) {
	                var sortArray = {};
	                sortArray[sorting] = arguments[1];
	                this.parameters({
	                    'sorting': sortArray
	                });
	                return this;
	            }
	            return angular.isDefined(sorting) ? this.parameters({
	                'sorting': sorting
	            }) : params.sorting;
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#isSortBy
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Checks sort field
	         *
	         * @param {string} field     Field name
	         * @param {string} direction Direction of sorting 'asc' or 'desc'
	         * @returns {Array} Return true if field sorted by direction
	         */
	        this.isSortBy = function (field, direction) {
	            return angular.isDefined(params.sorting[field]) && params.sorting[field] === direction;
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#orderBy
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Return object of sorting parameters for angular filter
	         *
	         * @returns {Array} Array like: [ '-name', '+age' ]
	         */
	        this.orderBy = function () {
	            var sorting = [];
	            for (var column in params.sorting) {
	                if (params.sorting.hasOwnProperty(column)) {
	                    sorting.push((params.sorting[column] === 'asc' ? '+' : '-') + column);
	                }
	            }
	            return sorting;
	        };
	
	        this.doInfiniteScroll = function () {
	            var deferred = $q.defer();
	            var s = this;
	            settings.onInfiniteScroll(deferred, s);
	            deferred.promise.then(function (newData) {
	                log('got more data from infiniteScroll');
	                s.data = settings.$scope.$data = newData;
	                settings.$scope.$emit('rcTableAfterReloadData');
	            });
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#getData
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Called when updated some of parameters for get new data
	         * @param {Object} $defer promise object
	         * @param {Object} params New parameters
	         */
	        this.getData = function ($defer, params) {
	            if (angular.isArray(this.data) && angular.isObject(params)) {
	                $defer.resolve(this.data);
	            } else {
	                $defer.resolve([]);
	            }
	        };
	
	        this.onInfiniteScroll = function ($defer, params) {
	            $defer.resolve([]);
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#getGroups
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Return groups for table grouping
	         */
	        this.getGroups = function ($defer, column) {
	            var defer = $q.defer();
	
	            defer.promise.then(function (data) {
	                var groups = {};
	                angular.forEach(data, function (item) {
	                    if (item.isRcTableGroup) {
	                        // Do not regroup those that have been grouped
	                        groups[item.value] = item;
	                    } else {
	                        var groupName = angular.isFunction(column) ? column(item) : item[column];
	
	                        groups[groupName] = groups[groupName] || {
	                            data: [],
	                            isRcTableGroup: true,
	                            value: groupName
	                        };
	                        groups[groupName].data.push(item);
	                    }
	                });
	                var result = [];
	                for (var i in groups) {
	                    if (groups.hasOwnProperty(i)) {
	                        result.push(groups[i]);
	                    }
	                }
	                log('rcTable: refresh groups', result);
	                $defer.resolve(result);
	            });
	            this.getData(defer, self);
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#url
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Return groups for table grouping
	         *
	         * @param {boolean} asString flag indicates return array of string or object
	         * @returns {Array} If asString = true will be return array of url string parameters else key-value object
	         */
	        this.url = function () {
	            var asString = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	            var pairs = asString ? [] : {};
	
	            var setValue = function setValue(name, val) {
	                if (asString) {
	                    pairs.push(name + '=' + val);
	                } else {
	                    pairs[name] = val;
	                }
	            };
	            angular.forEach(params, function (value, key) {
	                var item = params[key],
	                    name = encodeURIComponent(key);
	                if (angular.isObject(item)) {
	                    for (var subkey in item) {
	                        if (!angular.isUndefined(item[subkey]) && item[subkey] !== '') {
	                            var pname = name + '[' + encodeURIComponent(subkey) + ']';
	                            setValue(pname, item[subkey]);
	                        }
	                    }
	                } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== '') {
	                    setValue(name, encodeURIComponent(item));
	                }
	            });
	            return pairs;
	        };
	
	        /**
	         * @ngdoc method
	         * @name rcTable.factory:RcTableParams#reload
	         * @methodOf rcTable.factory:RcTableParams
	         * @description Reload table data
	         */
	        this.reload = function () {
	            var $defer = $q.defer(),
	                s = this;
	
	            settings.$loading = true;
	            if (settings.groupBy) {
	                settings.getGroups($defer, settings.groupBy, this);
	            } else {
	                settings.getData($defer, this);
	            }
	            log('rcTable: reload data');
	            $defer.promise.then(function (data) {
	                settings.$loading = false;
	                log('rcTable: current scope', settings.$scope);
	                if (!settings.$scope) {
	                    log('Warning: Attempted to reload table with no data source defined');
	                    return;
	                }
	                if (settings.groupBy) {
	                    s.data = settings.$scope.$groups = data;
	                } else {
	                    s.data = settings.$scope.$data = data;
	                }
	                settings.$scope.$emit('rcTableAfterReloadData');
	            });
	        };
	
	        this.isGroupedBy = function () {
	            return !!this.settings().groupBy;
	        };
	
	        this.toggleGroups = function () {
	            var deferred = $q.defer();
	            var s = this;
	            var groupBy = this.settings().groupBy;
	            this.getGroups(deferred, groupBy);
	            return deferred.promise.then(function (data) {
	                s.$hideRows = !s.$hideRows;
	                angular.forEach(data, function ($group) {
	                    $group.$hideRows = s.$hideRows;
	                });
	            });
	        };
	
	        var params = this.$params = {
	            filter: {},
	            sorting: {},
	            group: {}
	        };
	        var settings = {
	            $scope: null, // set by rcTable controller
	            $loading: false,
	            data: null, // allows data to be set when table is initialized
	            groupBy: null,
	            defaultSort: 'asc',
	            filterDelay: 750,
	            getGroups: this.getGroups,
	            getData: this.getData,
	            onInfiniteScroll: this.onInfiniteScroll
	        };
	
	        this.settings(baseSettings);
	        this.parameters(baseParameters, true);
	        return this;
	    };
	    return RcTableParams;
	}
	
	exports.default = RcTableParamsFactory;

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	fixedElementFactory.$inject = ["$window", "$position", "$timeout", "$compile", "tablePhases", "options"];
	fixedFootersDirective.$inject = ["$window", "$position", "$timeout", "$compile", "tablePhases"];
	fixedElementsService.$inject = ["$rootScope"];
	fixedHeadersDirective.$inject = ["$window", "$position", "$timeout", "$compile", "tablePhases"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// TODO Lots of jquery stuff in here. I feel this can be angular-ized, but when I tried it did not perform properly
	// TODO Lots of differences between 'uniscroll' and 'fixed scrolling' behavior - can we abstract this? Subclasses maybe?
	// TODO This is not well tested. Might be best to implement as integration tests?
	function fixedElementFactory($window, $position, $timeout, $compile, tablePhases, options) {
	    'ngInject';
	
	    var linkFn = function linkFn($scope, $el, attrs) {
	        // Due to wrapping at the table level, the actual $el we want is two levels deep
	
	        $el = $el.find('table');
	        var elementClone = angular.element($el[0].querySelector(options.selector + '.rc-clone')),
	            fixedElement = $el.find(options.selector).eq(0);
	        $el.addClass(options.fixedElementClass);
	
	        var scrollDelay = attrs.scrollDelay || 150;
	        var fixedElementOffset;
	        var tableDomReady = false;
	        var widthSetFromScroll = 0;
	        var widthInitialized = false;
	        var scrollableContainer = $window;
	
	        var getScrollableDimensions = function getScrollableDimensions() {
	            if (scrollableContainer === $window) {
	                return $position.offset(angular.element(document.body));
	            } else {
	                return $position.offset(angular.element(scrollableContainer));
	            }
	        };
	
	        var updateElementSize = function updateElementSize() {
	            var cloneDimensions = $position.offset(elementClone);
	            var scrollableDimensions = getScrollableDimensions();
	            var parent = $el.parent()[0];
	
	            // We cache this, so we don't incur a repaint cost each time
	            var differentWidth = widthSetFromScroll !== cloneDimensions.width;
	            if (differentWidth || !widthInitialized) {
	                widthSetFromScroll = cloneDimensions.width;
	                fixedElement.css('width', widthSetFromScroll + 'px');
	                widthInitialized = true;
	            }
	            var windowScrolling = scrollableContainer === $window ? 0 : window.pageYOffset;
	            var stickyTopPosition = options.stickyPosition(scrollableDimensions, windowScrolling, cloneDimensions, parent, scrollableContainer);
	            fixedElement.css('top', stickyTopPosition + 'px');
	            fixedElement.css('left', cloneDimensions.left - window.pageXOffset + 'px');
	
	            // Experimenting with fixed header widths
	            var tds = angular.element(elementClone[0].querySelectorAll(options.cellSelector));
	            var tableWidths = [];
	            angular.forEach(tds, function (header) {
	                tableWidths.push($position.offset(angular.element(header)).width);
	            });
	
	            var fixedTds = angular.element(fixedElement[0].querySelectorAll(options.cellSelector));
	            angular.forEach(fixedTds, function (header, index) {
	                angular.element(header).css('width', tableWidths[index] + 'px');
	            });
	
	            // If our table horizontally scrolls, the width of the parent div could be less than the cloned header.
	            // This causes the cloned div to display outside the parent viewport, and appears 'on top' of scrollbars.
	            // So! We need to clip the header.
	            var clipLeft = parent.scrollLeft;
	            var containerDimensions = parent.clientWidth;
	
	            var clipRight = containerDimensions + clipLeft;
	            fixedElement.css('clip', 'rect(0px, ' + clipRight + 'px, ' + (cloneDimensions.height + 2) + 'px, ' + clipLeft + 'px)');
	        };
	
	        var removeSticky = function removeSticky() {
	            if ($el.hasClass(options.fixedElementEnabledClass)) {
	                // turn the fixed header "off" (only if its on)
	                elementClone.addClass('ng-hide');
	                $el.removeClass(options.fixedElementEnabledClass);
	                fixedElement.css('top', '');
	                fixedElement.css('width', '');
	                widthInitialized = false;
	            }
	        };
	
	        var addSticky = function addSticky() {
	            if (!$el.hasClass(options.fixedElementEnabledClass)) {
	                // turn the fixed header "on" (only once)
	                elementClone.removeClass('ng-hide');
	                $el.addClass(options.fixedElementEnabledClass);
	                updateElementSize();
	            }
	        };
	
	        // We delay determining whether the table is in "uniscroll" mode until its height has been set
	        // This is particularly useful when the table is hidden by default (inside a twistie, for example)
	        var setScrollableContainer = function setScrollableContainer() {
	            var IE_PX_VARIANCE = 1;
	            var parent = $el.parent()[0];
	            if (parent.offsetHeight > 0) {
	                tableDomReady = true;
	
	                // Q: What's the deal with this magic 1, and the Math.abs hack?
	                // A: See SID#171469 and jsbin fexif/2. In particular IE<=11 show scrollHeight as 1px larger
	                //   than offsetHeight, which disables 'uniscroll mode'. Unclear why this happens. Other attempts such as
	                //   taking getBoundingClientRect() and rounding it work in IE11, but not IE9.
	                //   Since the 1px value is a known value, we're just taking it into account.
	                //   Another interesting note: if you change the window's font-size from 14px to 13px (or 15px),
	                //   the scrollHeight and offsetHeight show up as equal.
	                if (parent.offsetHeight < parent.scrollHeight && parent.offsetHeight + IE_PX_VARIANCE < parent.scrollHeight) {
	                    scrollableContainer = parent;
	                }
	                return true;
	            }
	            return false;
	        };
	
	        var initialize = function initialize() {
	            // If the container is scrollable, use that
	            if (setScrollableContainer()) {
	                updateTheadPosition(false);
	            }
	        };
	
	        var scrollableOffset = function scrollableOffset() {
	            if (scrollableContainer === $window) {
	                return $window.pageYOffset;
	            } else {
	                return scrollableContainer.scrollTop;
	            }
	        };
	
	        var updateTheadPosition = function updateTheadPosition(calledFromScroll) {
	            if (!tableDomReady) {
	                setScrollableContainer();
	            }
	            if (tableDomReady && fixedElement) {
	                fixedElementOffset = $position.offset(fixedElement);
	                if (calledFromScroll) {
	                    widthSetFromScroll = $position.offset(fixedElement).width;
	                }
	
	                var elementOffset = $position.offset($el);
	                var currentScrollableOffset = scrollableOffset(),
	                    scrollableDimensions = getScrollableDimensions();
	
	                var containerSize = $position.offset($el.parent());
	
	                var stickyStatus = options.stickyStatusEnabled(currentScrollableOffset, scrollableDimensions, elementOffset, scrollableContainer, fixedElementOffset, containerSize);
	                // TODO - test scrolling conditions - Don't know how to override pageYOffset property to mock it out
	                if (stickyStatus.isPassedTopOfTable && !stickyStatus.isPassedBottomOfTable) {
	                    addSticky();
	                    updateElementSize();
	                } else if ((!stickyStatus.isPassedTopOfTable || stickyStatus.isPassedBottomOfTable) && $el.hasClass(options.fixedElementEnabledClass)) {
	                    removeSticky();
	                }
	            }
	        };
	        // $timeout(initialize);
	        // We do not want to call $timeout here, this causes a problem
	        initialize();
	
	        var handleScroll = function handleScroll() {
	            $window.requestAnimationFrame(function () {
	                if (setScrollableContainer()) {
	                    updateTheadPosition(true);
	                }
	            });
	        };
	
	        // Event handlers
	        $el.parent().on('scroll', handleScroll);
	        angular.element($window).on('scroll', handleScroll);
	        angular.element($window).on('resize', updateElementSize);
	
	        $scope.$on('rcUpdateFixedTableElements', handleScroll);
	    };
	
	    return {
	        restrict: 'A',
	        scope: false,
	        priority: tablePhases.preTransclusion2,
	        require: 'rcTable',
	        compile: function compile($el, attrs) {
	            var fixedElement = $el.find(options.selector).eq(0);
	            if (fixedElement.hasClass('rc-fixed')) {
	                return;
	            }
	
	            fixedElement.addClass('rc-fixed');
	
	            var elementClone = fixedElement.clone();
	            var cloneWithScope = elementClone;
	            cloneWithScope.addClass('ng-hide rc-clone');
	            cloneWithScope.removeClass('rc-fixed');
	            fixedElement.after(cloneWithScope);
	            elementClone = cloneWithScope;
	            return linkFn;
	        }
	    };
	}
	
	function fixedHeadersDirective($window, $position, $timeout, $compile, tablePhases) {
	    return fixedElementFactory($window, $position, $timeout, $compile, tablePhases, {
	        fixedElementClass: 'rc-fixed-thead',
	        fixedElementEnabledClass: 'fixed-thead-on',
	        selector: 'thead',
	        cellSelector: 'th',
	
	        stickyPosition: function stickyPosition(scrollableDimensions, windowScrolling, cloneDimensions) {
	            return scrollableDimensions.top - windowScrolling;
	        },
	        stickyStatusEnabled: function stickyStatusEnabled(currentScrollableOffset, scrollableDimensions, elementOffset, scrollableContainer, fixedElementOffset, containerSize) {
	            var difference = currentScrollableOffset + scrollableDimensions.top - elementOffset.top;
	            var pageYOffset = currentScrollableOffset;
	
	            var passedBottomOfTable = function passedBottomOfTable() {
	                if (scrollableContainer === $window) {
	                    return difference >= elementOffset.height - fixedElementOffset.height;
	                } else {
	                    return false;
	                }
	            };
	            return {
	                isPassedTopOfTable: difference > 0,
	                isPassedBottomOfTable: passedBottomOfTable()
	            };
	        }
	    });
	}
	
	function fixedFootersDirective($window, $position, $timeout, $compile, tablePhases) {
	    'ngInject';
	
	    return fixedElementFactory($window, $position, $timeout, $compile, tablePhases, {
	        fixedElementClass: 'rc-fixed-tfoot',
	        fixedElementEnabledClass: 'fixed-tfoot-on',
	        selector: 'tfoot',
	        cellSelector: 'td',
	
	        stickyPosition: function stickyPosition(scrollableDimensions, windowScrolling, cloneDimensions, parent, scrollableContainer) {
	            var height = scrollableContainer === $window ? scrollableDimensions.height : parent.clientHeight + 1;
	            return scrollableDimensions.top + height - windowScrolling - cloneDimensions.height;
	        },
	        stickyStatusEnabled: function stickyStatusEnabled(currentScrollableOffset, scrollableDimensions, elementOffset, scrollableContainer, fixedElementOffset, containerSize) {
	            var scrollableHeight = scrollableDimensions.height;
	            var bottomOfWindow = elementOffset.height + elementOffset.top;
	            var topOfTable = elementOffset.top;
	            var bottomOfTable = containerSize.height + containerSize.top;
	            var windowBottom = currentScrollableOffset + scrollableHeight;
	
	            var isItReallyPassedTop = function isItReallyPassedTop() {
	                if (scrollableContainer === $window) {
	                    return windowBottom > topOfTable + fixedElementOffset.height;
	                } else {
	                    return true;
	                }
	            };
	
	            var isItReallyPassedBottom = function isItReallyPassedBottom() {
	                if (scrollableContainer === $window) {
	                    return windowBottom > bottomOfTable;
	                } else {
	                    return bottomOfWindow < bottomOfTable;
	                }
	            };
	
	            return {
	                isPassedTopOfTable: isItReallyPassedTop(),
	                isPassedBottomOfTable: isItReallyPassedBottom()
	            };
	        }
	    });
	}
	
	function fixedElementsService($rootScope) {
	    'ngInject';
	
	    var fixedElements = this;
	    fixedElements.refreshFixedElements = function () {
	        $rootScope.$broadcast('rcUpdateFixedTableElements');
	    };
	}
	
	exports.default = angular.module('rc.table.sticky', []).service('$rcFixedTableElements', fixedElementsService).directive('fixedHeaders', fixedHeadersDirective).directive('fixedFooters', fixedFootersDirective);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _contentReplace = __webpack_require__(7);
	
	var _contentReplace2 = _interopRequireDefault(_contentReplace);
	
	var _tabsComponent = __webpack_require__(262);
	
	var _tabsComponent2 = _interopRequireDefault(_tabsComponent);
	
	var _tabsComponent3 = __webpack_require__(264);
	
	var _tabsComponent4 = _interopRequireDefault(_tabsComponent3);
	
	var _tabsComponentTabset = __webpack_require__(263);
	
	var _tabsComponentTabset2 = _interopRequireDefault(_tabsComponentTabset);
	
	var _tabsServiceTabset = __webpack_require__(269);
	
	var _tabsServiceTabset2 = _interopRequireDefault(_tabsServiceTabset);
	
	var _tabsDirectiveTab = __webpack_require__(268);
	
	var _tabsDirectiveTab2 = _interopRequireDefault(_tabsDirectiveTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.tabs', [_usage2.default.name, _contentReplace2.default.name]).component('rcTab', _tabsComponent2.default).component('rcTabset', _tabsComponent4.default).component('rcTabsetHeader', _tabsComponentTabset2.default).directive('rcTabHeading', _tabsDirectiveTab2.default).service('RcTabsetHeaderScroll', _tabsServiceTabset2.default);

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tabsController = __webpack_require__(265);
	
	var _tabsController2 = _interopRequireDefault(_tabsController);
	
	var _tab = __webpack_require__(77);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        initActive: '&',
	        disabled: '=?',
	        heading: '@?',
	        onSelect: '&select',
	        onDeselect: '&deselect'
	    },
	    controller: _tabsController2.default,
	    controllerAs: 'rcTabCtrl',
	    require: {
	        tabsetCtrl: '^rcTabset'
	    },
	    template: _tab2.default,
	    transclude: true
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tabsControllerTabset = __webpack_require__(266);
	
	var _tabsControllerTabset2 = _interopRequireDefault(_tabsControllerTabset);
	
	var _tabsetHeader = __webpack_require__(78);
	
	var _tabsetHeader2 = _interopRequireDefault(_tabsetHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {
	        tabs: '&'
	    },
	    controller: _tabsControllerTabset2.default,
	    controllerAs: 'rcTsHdrCtrl',
	    require: {
	        tabsetCtrl: '^rcTabset'
	    },
	    template: _tabsetHeader2.default
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tabsController = __webpack_require__(267);
	
	var _tabsController2 = _interopRequireDefault(_tabsController);
	
	var _tabset = __webpack_require__(79);
	
	var _tabset2 = _interopRequireDefault(_tabset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    bindings: {},
	    controller: _tabsController2.default,
	    controllerAs: 'rcTabsetCtrl',
	    template: _tabset2.default,
	    transclude: true
	};

/***/ },
/* 265 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcTabController = function () {
	    RcTabController.$inject = ["$scope", "$element", "$attrs", "$parse", "$log"];
	    function RcTabController($scope, $element, $attrs, $parse, $log) {
	        'ngInject';
	
	        _classCallCheck(this, RcTabController);
	
	        $element.addClass('rc-tab');
	
	        this.$scope = $scope;
	        // Required by tabsetCtrl
	        this.$element = $element;
	        this.$log = $log;
	        this.parsedActive = $parse($attrs.active);
	
	        this.onConstruct();
	    }
	
	    _createClass(RcTabController, [{
	        key: 'onConstruct',
	        value: function onConstruct() {
	            var _this = this;
	
	            this.$scope.$evalAsync(function () {
	                _this.tabsetCtrl.scrollToActiveHeader();
	            });
	
	            this.$element.on('click', function () {
	                _this.tabsetCtrl.scrollToActiveHeader();
	            });
	
	            this.$scope.$on('$destroy', function () {
	                _this.tabsetCtrl.remove(_this);
	            });
	
	            this.bindActive();
	        }
	    }, {
	        key: 'select',
	        value: function select() {
	            this.active = true;
	            this.onSelect();
	        }
	    }, {
	        key: 'deselect',
	        value: function deselect() {
	            this.active = false;
	            this.onDeselect();
	        }
	    }, {
	        key: 'setHeading',
	        value: function setHeading(heading) {
	            this.heading = heading;
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            if (angular.isUndefined(this.active)) {
	                this.active = !!this.initActive();
	            }
	
	            this.tabsetCtrl.add(this);
	        }
	
	        /* TODO: In version 3.3.0? MOST of this can be traded for a simple "active: '=?'" binding
	         * in the component along with a single $watch. At that point $attrs, $parse, $log can
	         * also likely be removed. The warning will hopefully break the habit if it is used. */
	
	    }, {
	        key: 'bindActive',
	        value: function bindActive() {
	            var _this2 = this;
	
	            var getParentActive = angular.noop;
	            var setParentActive = angular.noop;
	
	            if (this.parsedActive !== angular.noop) {
	                (function () {
	                    _this2.active = _this2.parsedActive(_this2.$scope.$parent);
	                    var assignment = _this2.parsedActive.assign;
	
	                    // String boolean.... BAD!
	                    if (!assignment) {
	                        _this2.$log.warn('Setting the rc-tab "active" attribute with a string boolean is deprecated. ' + 'Future Ricola 3 versions may throw $compile errors when the "active" ' + 'attribute is set this way. Please use "init-active" instead.');
	
	                        // Manual 2-way bind to parent.... even worse
	                        // Should improve when no longer supporting string boolean
	                    } else {
	                            (function () {
	                                var parentScope = _this2.$scope.$parent;
	
	                                getParentActive = function getParentActive() {
	                                    return _this2.parsedActive(parentScope);
	                                };
	
	                                setParentActive = function setParentActive(value) {
	                                    assignment(parentScope, value);
	                                };
	
	                                // Ensure undefined values are clarified
	                                if (angular.isUndefined(getParentActive())) {
	                                    setParentActive(false);
	                                }
	
	                                var removeParentWatch = parentScope.$watch(getParentActive, function (current, previous) {
	                                    if (current !== previous && current !== _this2.active) {
	                                        _this2.active = current;
	                                    }
	                                });
	
	                                _this2.$scope.$on('$destroy', removeParentWatch);
	                            })();
	                        }
	                })();
	            }
	
	            this.$scope.$watch('rcTabCtrl.active', function (current, previous) {
	                if (current !== previous) {
	                    if (current === true) {
	                        _this2.tabsetCtrl.scrollToActiveHeader();
	                    }
	                    // TODO: Remove when active: '=?' added to component
	                    if (current !== getParentActive()) {
	                        setParentActive(current);
	                    }
	                }
	            });
	        }
	    }]);
	
	    return RcTabController;
	}();
	
	exports.default = RcTabController;

/***/ },
/* 266 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ENABLE_SCROLL = 'rc-tab-headings-scrollable';
	var WINDOW_EVENT = 'resize';
	var SCROLL_PROP = 'scrollLeft';
	
	var RcTabsetHeaderController = function () {
	    RcTabsetHeaderController.$inject = ["$scope", "$element", "$window", "$timeout", "RcTabsetHeaderScroll"];
	    function RcTabsetHeaderController($scope, $element, $window, $timeout, RcTabsetHeaderScroll) {
	        'ngInject';
	
	        var _this = this;
	
	        _classCallCheck(this, RcTabsetHeaderController);
	
	        $element.addClass('rc-tabset-header');
	
	        this.$scope = $scope;
	        this.$element = $element;
	        this.$timeout = $timeout;
	        this.scrollManager = RcTabsetHeaderScroll;
	
	        angular.element($window).on(WINDOW_EVENT, function () {
	            _this.setDebouncedAdjustment();
	        });
	
	        this.$scope.$on('$destroy', function () {
	            angular.element($window).on(WINDOW_EVENT, function () {
	                _this.setDebouncedAdjustment();
	            });
	        });
	
	        this.onConstruct();
	    }
	
	    _createClass(RcTabsetHeaderController, [{
	        key: 'onConstruct',
	        value: function onConstruct() {
	            var _this2 = this;
	
	            this.$scope.$watch(angular.noop, function () {
	                _this2.setDebouncedAdjustment();
	            });
	
	            this.$element.on('click', function (event) {
	                var clickedElement = angular.element(event.target);
	
	                if (clickedElement.hasClass('rc-tabset-scroll-right')) {
	                    _this2.scrollManager.setNextScrollLeft(_this2.$element);
	                } else if (clickedElement.hasClass('rc-tabset-scroll-left')) {
	                    _this2.scrollManager.setPreviousScrollLeft(_this2.$element);
	                }
	            });
	        }
	    }, {
	        key: 'select',
	        value: function select(tab) {
	            if (!tab.disabled) {
	                this.tabsetCtrl.select(tab);
	                this.scrollManager.setScrollLeftToActiveHeading(this.$element);
	            }
	        }
	    }, {
	        key: 'setDebouncedAdjustment',
	        value: function setDebouncedAdjustment() {
	            var _this3 = this;
	
	            if (this.debouncedAdjustment) {
	                this.$timeout.cancel(this.debouncedAdjustment);
	            }
	
	            this.debouncedAdjustment = this.$timeout(function () {
	                if (_this3.scrollManager.headingsExceedWidth(_this3.$element)) {
	                    _this3.$element.addClass(ENABLE_SCROLL);
	                } else {
	                    _this3.$element.removeClass(ENABLE_SCROLL);
	                }
	                _this3.scrollManager.setScrollLeftToActiveHeading(_this3.$element);
	            }, 50, false);
	        }
	    }]);
	
	    return RcTabsetHeaderController;
	}();
	
	exports.default = RcTabsetHeaderController;

/***/ },
/* 267 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcTabsetController = function () {
	    RcTabsetController.$inject = ["$scope", "$element", "Usage", "RcTabsetHeaderScroll"];
	    function RcTabsetController($scope, $element, Usage, RcTabsetHeaderScroll) {
	        'ngInject';
	
	        _classCallCheck(this, RcTabsetController);
	
	        Usage.register('tabs');
	        $element.addClass('rc-tabset');
	
	        this.tabs = [];
	        this.$scope = $scope;
	        this.$element = $element;
	        this.scrollManager = RcTabsetHeaderScroll;
	
	        this.onConstruct();
	    }
	
	    _createClass(RcTabsetController, [{
	        key: 'onConstruct',
	        value: function onConstruct() {
	            var _this = this;
	
	            this.$scope.$evalAsync(function () {
	                var noActiveTab = true;
	
	                angular.forEach(_this.tabs, function (tab) {
	                    if (tab.active === true) {
	                        noActiveTab = false;
	                    }
	                });
	
	                if (noActiveTab && _this.tabs.length > 0) {
	                    _this.tabs[0].active = true;
	                }
	            });
	        }
	
	        /**
	         * The tab index is not always correct due to slow-priority directives like ng-repeat.
	         * This _should_ provide a rough cut of where in the rendered order the tab should go
	         * when it is added.
	         */
	
	    }, {
	        key: 'add',
	        value: function add(tabCtrl) {
	            var index = indexOfChild(this.$element, tabCtrl.$element);
	            if (index >= this.tabs.length) {
	                this.tabs.push(tabCtrl);
	            } else {
	                this.tabs.splice(index, 0, tabCtrl);
	            }
	
	            if (tabCtrl.active === true) {
	                tabCtrl.select();
	            }
	        }
	    }, {
	        key: 'select',
	        value: function select(tabCtrl) {
	            tabCtrl.select();
	            angular.forEach(this.tabs, function (tab) {
	                if (tab.active && tab !== tabCtrl) {
	                    tab.deselect();
	                }
	            });
	        }
	    }, {
	        key: 'remove',
	        value: function remove(tabCtrl) {
	            var index = this.tabs.indexOf(tabCtrl);
	
	            if (index < 1) {
	                this.tabs.length = 0;
	            } else {
	                this.tabs.splice(index, 1);
	
	                if (this.tabs.length > index) {
	                    this.tabs[index].select;
	                } else {
	                    this.tabs[this.tabs.length - 1].select();
	                }
	            }
	        }
	    }, {
	        key: 'scrollToActiveHeader',
	        value: function scrollToActiveHeader() {
	            var tabsetHeader = this.$element.find('rc-tabset-header').eq(0);
	            this.scrollManager.setScrollLeftToActiveHeading(tabsetHeader);
	        }
	    }]);
	
	    return RcTabsetController;
	}();
	
	exports.default = RcTabsetController;
	
	
	function indexOfChild(tabsetElement, tabElement) {
	    var tabElements = tabsetElement.find('rc-tab');
	
	    for (var index = 0; index < tabElements.length; index++) {
	        if (tabElement[0] === tabElements[index]) {
	            return index;
	        }
	    }
	
	    return -1;
	}

/***/ },
/* 268 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = RcTabHeadingDirective;
	function RcTabHeadingDirective() {
	    'ngInject';
	
	    return {
	        restrict: 'E',
	        require: '^rcTab',
	        transclude: true,
	        link: RcTabHeadingLink
	    };
	
	    function RcTabHeadingLink(scope, elm, attrs, tabCtrl, transclude) {
	        /* TODO: Investigate further...
	         * This is a VERY odd scenario: When the tab's heading attribute is set AND the developer
	         * also chooses to add the rc-tab-heading element then the attribute value will override
	         * for reasons I cannot currently discern. Tab controller value is set, but then is reset
	         * somehow during the tab heading iteration. Late-evaluation fixes this and the
	         * rc-tab-heading value is respected. */
	        scope.$evalAsync(function () {
	            tabCtrl.setHeading(transclude(scope, angular.noop));
	        });
	    }
	}

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SCROLL_LEFT = 'scrollLeft';
	var DEBOUNCED = {};
	
	// TODO: Work in requestAnimationFrame maneuvers to smooth the transistions
	
	var RcTabsetHeaderScrollService = function () {
	    RcTabsetHeaderScrollService.$inject = ["$timeout"];
	    function RcTabsetHeaderScrollService($timeout) {
	        'ngInject';
	
	        _classCallCheck(this, RcTabsetHeaderScrollService);
	
	        this.$timeout = $timeout;
	    }
	
	    _createClass(RcTabsetHeaderScrollService, [{
	        key: 'findActive',
	        value: function findActive(tabsetHeader) {
	            var headings = tabsetHeader.find('div');
	            for (var i = 0; i < headings.length; i++) {
	                if (headings.eq(i).hasClass('active')) {
	                    return headings.eq(i);
	                }
	            }
	        }
	    }, {
	        key: 'headingsExceedWidth',
	        value: function headingsExceedWidth(tabsetHeader) {
	            var children = tabsetHeader.children();
	            var width = tabsetHeader[0].offsetWidth;
	            var heading = void 0;
	
	            for (var index = 0; index < children.length; index++) {
	                heading = children.eq(index);
	                if (heading.hasClass('rc-tab-heading')) {
	                    width -= heading[0].offsetWidth;
	                }
	            }
	
	            return width < 0;
	        }
	    }, {
	        key: 'setNextScrollLeft',
	        value: function setNextScrollLeft(tabsetHeader) {
	            var currentValue = tabsetHeader[0].scrollLeft;
	            var headings = tabsetHeader.find('div');
	            var nextValue = 0;
	
	            for (var index = 0; index < headings.length; index++) {
	                if (nextValue <= currentValue) {
	                    nextValue += headings[index].offsetWidth;
	                }
	            }
	
	            return tabsetHeader.prop(SCROLL_LEFT, nextValue);
	        }
	    }, {
	        key: 'setPreviousScrollLeft',
	        value: function setPreviousScrollLeft(tabsetHeader) {
	            var currentValue = tabsetHeader[0].scrollLeft;
	            var headings = tabsetHeader.find('div');
	            var previousValue = 0;
	
	            for (var index = 0; index < headings.length; index++) {
	                previousValue += headings[index].offsetWidth;
	
	                if (previousValue >= currentValue) {
	                    // back off by 1 element width
	                    previousValue -= headings[index].offsetWidth;
	                    index = headings.length;
	                }
	            }
	
	            return tabsetHeader.prop(SCROLL_LEFT, previousValue);
	        }
	    }, {
	        key: 'setScrollLeftToActiveHeading',
	        value: function setScrollLeftToActiveHeading(tabsetHeader) {
	            var _this = this;
	
	            if (DEBOUNCED[tabsetHeader[0]]) {
	                this.$timeout.cancel(DEBOUNCED[tabsetHeader[0]]);
	            }
	
	            DEBOUNCED[tabsetHeader[0]] = this.$timeout(function () {
	                var currentValue = tabsetHeader[0].scrollLeft;
	                var scrollLeft = currentValue;
	
	                if (tabsetHeader.hasClass('rc-tab-headings-scrollable')) {
	                    var headings = tabsetHeader.find('div');
	                    // first heading should be offset by button width
	                    var buttonWidth = headings[0].offsetLeft;
	                    var active = _this.findActive(tabsetHeader);
	
	                    // Under the left button: align left
	                    if (active[0].offsetLeft - buttonWidth < currentValue) {
	                        scrollLeft = active[0].offsetLeft - buttonWidth;
	                        // Under the right button
	                    } else if (active[0].offsetLeft + active[0].offsetWidth > currentValue + tabsetHeader[0].offsetWidth - buttonWidth) {
	                            // Heading too wide: align left
	                            if (active[0].offsetWidth > tabsetHeader[0].offsetWidth) {
	                                scrollLeft = active[0].offsetLeft - buttonWidth;
	                                // Align right
	                            } else {
	                                    scrollLeft = active[0].offsetLeft + active[0].offsetWidth + buttonWidth - tabsetHeader[0].offsetWidth;
	                                }
	                        }
	                }
	
	                tabsetHeader.prop(SCROLL_LEFT, scrollLeft);
	            }, 0, false);
	        }
	    }]);
	
	    return RcTabsetHeaderScrollService;
	}();
	
	exports.default = RcTabsetHeaderScrollService;

/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcTargetDirective() {
	    return {
	        restrict: 'A',
	        scope: {
	            target: '=rcTarget'
	        },
	        link: function link(scope, element, attrs) {
	            if (angular.isDefined(scope.target)) {
	                element.attr('target', scope.target);
	            }
	        }
	    };
	}
	
	exports.default = rcTargetDirective;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _bindHtml = __webpack_require__(6);
	
	var _bindHtml2 = _interopRequireDefault(_bindHtml);
	
	var _position = __webpack_require__(4);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _tooltip = __webpack_require__(272);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _tooltipDirective = __webpack_require__(273);
	
	var _tooltipDirective2 = _interopRequireDefault(_tooltipDirective);
	
	var _tooltipDirective3 = __webpack_require__(274);
	
	var _tooltipDirective4 = _interopRequireDefault(_tooltipDirective3);
	
	var _tooltipDirectiveUnsafe = __webpack_require__(275);
	
	var _tooltipDirectiveUnsafe2 = _interopRequireDefault(_tooltipDirectiveUnsafe);
	
	var _tooltip3 = __webpack_require__(277);
	
	var _tooltip4 = _interopRequireDefault(_tooltip3);
	
	var _tooltip5 = __webpack_require__(276);
	
	var _tooltip6 = _interopRequireDefault(_tooltip5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.tooltip', [_bindHtml2.default.name, _position2.default.name, _usage2.default.name]).directive('rcTooltip', _tooltip2.default).directive('rcTooltipPopup', _tooltipDirective2.default).directive('rcTooltipHtmlUnsafe', _tooltipDirective4.default).directive('rcTooltipHtmlUnsafePopup', _tooltipDirectiveUnsafe2.default).service('tooltipService', _tooltip4.default).provider('$tooltip', _tooltip6.default);

/***/ },
/* 272 */
/***/ function(module, exports) {

	'use strict';
	
	rcTooltipDirective.$inject = ["$tooltip"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcTooltipDirective($tooltip) {
	    'ngInject';
	
	    return $tooltip('rcTooltip', 'tooltip', 'mouseenter');
	}
	
	exports.default = rcTooltipDirective;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tooltipPopup = __webpack_require__(81);
	
	var _tooltipPopup2 = _interopRequireDefault(_tooltipPopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcTooltipPopupDirective() {
	    return {
	        restrict: 'EA',
	        scope: {
	            content: '@',
	            placement: '@',
	            animation: '&',
	            isOpen: '&'
	        },
	        template: _tooltipPopup2.default
	    };
	}
	
	exports.default = rcTooltipPopupDirective;

/***/ },
/* 274 */
/***/ function(module, exports) {

	'use strict';
	
	rcTooltipUnsafeDirective.$inject = ["$tooltip"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcTooltipUnsafeDirective($tooltip) {
	    'ngInject';
	
	    return $tooltip('rcTooltipHtmlUnsafe', 'tooltip', 'mouseenter');
	}
	
	exports.default = rcTooltipUnsafeDirective;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tooltipHtmlUnsafePopup = __webpack_require__(80);
	
	var _tooltipHtmlUnsafePopup2 = _interopRequireDefault(_tooltipHtmlUnsafePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcTooltipHtmlUnsafePopupDirective() {
	    return {
	        restrict: 'EA',
	        scope: {
	            content: '@',
	            placement: '@',
	            animation: '&',
	            isOpen: '&'
	        },
	        template: _tooltipHtmlUnsafePopup2.default
	    };
	}
	
	exports.default = rcTooltipHtmlUnsafePopupDirective;

/***/ },
/* 276 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	function $tooltipProvider() {
	    // The default options tooltip and popover.
	    TooltipService.$inject = ["$window", "$compile", "$timeout", "$parse", "$document", "$position", "$interpolate", "Usage", "tooltipService"];
	    var defaultOptions = {
	        placement: 'top',
	        animation: true,
	        popupDelay: 500,
	        hoverTimeoutMills: 1200
	    };
	
	    // Default hide triggers for each show trigger
	    var triggerMap = {
	        'mouseenter': 'mouseleave',
	        'click': 'click',
	        'focus': 'blur'
	    };
	
	    // The options specified to the provider globally.
	    var globalOptions = {};
	
	    /**
	     * `options({})` allows global configuration of all tooltips in the
	     * application.
	     *
	     *   var app = angular.module( 'App', ['rc.tooltip.tooltip'], function( $tooltipProvider ) {
	     *     // place tooltips left instead of top by default
	     *     $tooltipProvider.options( { placement: 'left' } );
	     *   });
	     */
	    this.options = function (value) {
	        angular.extend(globalOptions, value);
	        return this;
	    };
	
	    /**
	     * This allows you to extend the set of trigger mappings available. E.g.:
	     *
	     *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	     */
	    this.setTriggers = function setTriggers(triggers) {
	        angular.extend(triggerMap, triggers);
	        return this;
	    };
	
	    /**
	     * This is a helper function for translating camel-case to snake-case.
	     */
	    function snakeCase(name) {
	        var regexp = /[A-Z]/g;
	        var separator = '-';
	        return name.replace(regexp, function (letter, pos) {
	            return (pos ? separator : '') + letter.toLowerCase();
	        });
	    }
	
	    this.$get = TooltipService;
	
	    /**
	     * Returns the actual instance of the $tooltip service.
	     * TODO support multiple triggers
	     */
	    function TooltipService($window, $compile, $timeout, $parse, $document, $position, $interpolate, Usage, tooltipService) {
	        'ngInject';
	
	        return function $tooltip(type, prefix, defaultTriggerShow) {
	            var options = angular.extend({}, defaultOptions, globalOptions);
	
	            /**
	             * Returns an object of show and hide triggers.
	             *
	             * If a trigger is supplied,
	             * it is used to show the tooltip; otherwise, it will use the `trigger`
	             * option passed to the `$tooltipProvider.options` method; else it will
	             * default to the trigger supplied to this directive factory.
	             *
	             * The hide trigger is based on the show trigger. If the `trigger` option
	             * was passed to the `$tooltipProvider.options` method, it will use the
	             * mapped trigger from `triggerMap` or the passed trigger if the map is
	             * undefined; otherwise, it uses the `triggerMap` value of the show
	             * trigger; else it will just use the show trigger.
	             */
	            function getTriggers(trigger) {
	                var show = trigger || options.trigger || defaultTriggerShow;
	                var hide = triggerMap[show] || show;
	                return {
	                    show: show,
	                    hide: hide
	                };
	            }
	
	            var directiveName = snakeCase(type);
	
	            var startSym = $interpolate.startSymbol();
	            var endSym = $interpolate.endSymbol();
	            var template = '<div ' + directiveName + '-popup\n                content="' + startSym + '::ttContent' + endSym + '"\n                placement="' + startSym + '::ttPlacement' + endSym + '"\n                animation="ttAnimation"\n                is-open="ttIsOpen"></div>';
	
	            return {
	                restrict: 'EA',
	                scope: true,
	                compile: function compile(tElem, tAttrs) {
	                    var tooltipLinker = $compile(template);
	
	                    return function link(scope, element, attrs) {
	                        Usage.register('tooltip');
	                        var tooltip;
	                        var transitionTimeout;
	                        var popupTimeout;
	                        var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : true;
	                        var triggers = getTriggers();
	                        var hasRegisteredTriggers = false;
	                        var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	
	                        if (!(!!element[0].nodeName.match(/i|img|button/gi) || element.hasClass('button'))) {
	                            element.addClass('has-tip');
	                        }
	
	                        var positionTooltip = function positionTooltip() {
	                            var position, ttWidth, ttHeight, ttPosition;
	                            // Get the position of the directive element.
	                            position = appendToBody ? $position.offset(element) : $position.position(element);
	                            if (scope.ttPlacement !== 'left') {
	                                // Force a height adjustment for non-left elements
	                                tooltip.css({ left: position.left + 'px' });
	                            }
	
	                            // Get the height and width of the tooltip so we can center it.
	                            ttWidth = tooltip.prop('offsetWidth');
	                            ttHeight = tooltip.prop('offsetHeight');
	
	                            var ttPlacement = getAvailablePlacement(position, ttWidth, ttHeight);
	
	                            // Calculate the tooltip's top and left coordinates to center it with this directive.
	                            switch (ttPlacement) {
	                                case 'right':
	                                    ttPosition = {
	                                        top: position.top + position.height / 2 - ttHeight / 2,
	                                        left: position.left + position.width + 10
	                                    };
	                                    break;
	                                case 'bottom':
	                                    ttPosition = {
	                                        top: position.top + position.height + 10,
	                                        left: position.left
	                                    };
	                                    break;
	                                case 'left':
	                                    ttPosition = {
	                                        top: position.top + position.height / 2 - ttHeight / 2,
	                                        left: position.left - ttWidth - 10
	                                    };
	                                    break;
	                                default:
	                                    ttPosition = {
	                                        top: position.top - ttHeight - 10,
	                                        left: position.left
	                                    };
	                                    break;
	                            }
	
	                            ttPosition.top += 'px';
	                            ttPosition.left += 'px';
	
	                            // Now set the calculated positioning.
	                            tooltip.css(ttPosition);
	                        };
	
	                        function getAvailablePlacement(elementPosition, ttWidth, ttHeight) {
	                            var moveFromTo = function moveFromTo(oldPos, pos) {
	                                var tipElement = angular.element(tooltip[0].querySelector('.tooltip'));
	                                tipElement.removeClass('tip-' + oldPos);
	                                tipElement.addClass('tip-' + pos);
	                                return pos;
	                            };
	
	                            var placement = scope.ttPlacement;
	                            var elementOffset = $position.offset(element);
	                            var cannotFitOnTheLeft = elementPosition.left < ttWidth;
	                            // Rotate to availale space: left-> right-> top-> bottom-> top
	                            if (placement === 'left' && cannotFitOnTheLeft) {
	                                placement = moveFromTo('left', 'right');
	                            }
	                            if (placement === 'right' && elementPosition.left + ttWidth > $window.innerWidth) {
	                                placement = cannotFitOnTheLeft ? moveFromTo('right', 'top') : moveFromTo('right', 'left');
	                            }
	                            if (placement === 'top' && elementOffset.top - ttHeight < $window.scrollY) {
	                                placement = moveFromTo('top', 'bottom');
	                            }
	                            if (placement === 'bottom' && elementOffset.top + ttHeight > $window.scrollY + $window.innerHeight) {
	                                placement = moveFromTo('bottom', 'top');
	                            }
	
	                            return placement;
	                        }
	
	                        // By default, the tooltip is not open.
	                        // TODO add ability to start tooltip opened
	                        scope.ttIsOpen = false;
	
	                        function toggleTooltipBind() {
	                            if (!scope.ttIsOpen) {
	                                showTooltipBind();
	                            } else {
	                                hideTooltipBind();
	                            }
	                        }
	
	                        // Show the tooltip with delay if specified, otherwise show it immediately
	                        function showTooltipBind() {
	                            if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                                return;
	                            }
	                            if (scope.ttPopupDelay) {
	                                popupTimeout = $timeout(show, scope.ttPopupDelay, false);
	                            } else {
	                                show();
	                            }
	                        }
	
	                        var allowTooltipHover = angular.isDefined(attrs[prefix + 'AllowHover']);
	                        var hoverTimeout;
	
	                        function hideTooltipBind() {
	                            if (allowTooltipHover) {
	                                // 1200 "seems" just enough time to be properly cancelled.
	                                var mills = scope.$eval(attrs[prefix + 'AllowHover']) || options.hoverTimeoutMills;
	                                hoverTimeout = $timeout(applyHide, mills);
	                            } else {
	                                applyHide();
	                            }
	                        }
	
	                        function applyHide() {
	                            scope.$apply(function () {
	                                if (!scope.ttHovering) {
	                                    if (hoverTimeout) {
	                                        $timeout.cancel(hoverTimeout);
	                                    }
	                                    hide();
	                                }
	                            });
	                        }
	
	                        function tooltipMouseEnter() {
	                            scope.ttHovering = true;
	                        }
	
	                        function tooltipMouseLeave() {
	                            scope.ttHovering = false;
	                            applyHide();
	                        }
	
	                        // Show the tooltip popup element.
	                        function show() {
	                            if (hoverTimeout) {
	                                // Remove $timeout-delayed if trying to show the same tooltip again
	                                $timeout.cancel(hoverTimeout);
	                                hide();
	                            }
	
	                            // Don't show empty tooltips.
	                            if (!scope.ttContent) {
	                                return angular.noop;
	                            }
	
	                            createTooltip();
	
	                            // If there is a pending remove transition, we must cancel it, lest the
	                            // tooltip be mysteriously removed.
	                            if (transitionTimeout) {
	                                $timeout.cancel(transitionTimeout);
	                            }
	
	                            // Set the initial positioning.
	                            tooltip.css({
	                                top: 0,
	                                left: 0,
	                                display: 'block'
	                            });
	
	                            if (allowTooltipHover) {
	                                tooltip.bind('mouseenter', tooltipMouseEnter);
	                                tooltip.bind('mouseleave', tooltipMouseLeave);
	                            }
	
	                            // Now we add it to the DOM because need some info about it. But it's not
	                            // visible yet anyway.
	                            if (appendToBody) {
	                                $document.find('body').append(tooltip);
	                            } else {
	                                element.after(tooltip);
	                            }
	                            // align tooltip before showing
	                            positionTooltip();
	
	                            // When a tooltip is open, it will close when a user clicks/touches anywere else
	                            // Should be removed if the tooltip is removed
	                            $document.find('body').bind('click touchstart', hide);
	
	                            // And show the tooltip.
	                            scope.ttIsOpen = true;
	                            tooltipService.open(scope);
	                            scope.$digest(); // digest required as $apply is not called
	                        }
	
	                        // Hide the tooltip popup element.
	                        function hide() {
	                            // First things first: we don't show it anymore.
	                            scope.ttIsOpen = false;
	                            tooltipService.close(scope);
	
	                            // if tooltip is going to be shown after delay, we must cancel this
	                            $timeout.cancel(popupTimeout);
	
	                            // And now we remove it from the DOM. However, if we have animation, we
	                            // need to wait for it to expire beforehand.
	                            // FIXME: this is a placeholder for a port of the transitions library.
	                            if (scope.ttAnimation) {
	                                transitionTimeout = $timeout(removeTooltip, 500);
	                            } else {
	                                removeTooltip();
	                            }
	                        }
	
	                        function createTooltip() {
	                            // There can only be one tooltip element per directive shown at once.
	                            if (tooltip) {
	                                removeTooltip();
	                            }
	                            tooltip = tooltipLinker(scope, function () {});
	
	                            // Get contents rendered into the tooltip
	                            scope.$digest();
	                        }
	
	                        function removeTooltip() {
	                            if (tooltip) {
	                                $document.find('body').unbind('click touchstart', hide);
	
	                                tooltip.remove();
	                                tooltip = null;
	                            }
	                        }
	
	                        /**
	                         * Observe the relevant attributes.
	                         */
	                        attrs.$observe(type, function (val) {
	                            scope.ttContent = val;
	
	                            if (!val && scope.ttIsOpen) {
	                                hide();
	                            }
	                        });
	
	                        if (angular.isUndefined(attrs[prefix + 'Placement'])) {
	                            attrs[prefix + 'Placement'] = options.placement;
	                        }
	
	                        attrs.$observe(prefix + 'Placement', function (val) {
	                            scope.ttPlacement = angular.isDefined(val) ? val : options.placement;
	                        });
	
	                        if (angular.isUndefined(attrs[prefix + 'PopupDelay'])) {
	                            attrs[prefix + 'PopupDelay'] = options.popupDelay;
	                        }
	
	                        attrs.$observe(prefix + 'PopupDelay', function (val) {
	                            var delay = parseInt(val, 10);
	                            scope.ttPopupDelay = !isNaN(delay) ? delay : options.popupDelay;
	                        });
	
	                        var unregisterTriggers = function unregisterTriggers() {
	                            if (hasRegisteredTriggers) {
	                                element.unbind(triggers.show, showTooltipBind);
	                                element.unbind(triggers.hide, hideTooltipBind);
	                            }
	                        };
	
	                        var unregisterTriggerFunction = function unregisterTriggerFunction() {};
	
	                        if (angular.isUndefined(attrs[prefix + 'Trigger'])) {
	                            attrs[prefix + 'Trigger'] = options.trigger || defaultTriggerShow;
	                        }
	
	                        attrs.$observe(prefix + 'Trigger', function (val) {
	                            unregisterTriggers();
	                            unregisterTriggerFunction();
	
	                            triggers = getTriggers(val);
	
	                            if (angular.isFunction(triggers.show)) {
	                                unregisterTriggerFunction = scope.$watch(function () {
	                                    return triggers.show(scope, element, attrs);
	                                }, function (valSet) {
	                                    return valSet ? $timeout(show) : $timeout(hide);
	                                });
	                            } else {
	                                if (triggers.show === triggers.hide) {
	                                    element.bind(triggers.show, toggleTooltipBind);
	                                } else {
	                                    element.bind(triggers.show, showTooltipBind);
	                                    element.bind(triggers.hide, hideTooltipBind);
	                                }
	                            }
	
	                            hasRegisteredTriggers = true;
	                        });
	
	                        var animation = scope.$eval(attrs[prefix + 'Animation']);
	                        scope.ttAnimation = angular.isDefined(animation) ? !!animation : options.animation;
	
	                        attrs.$observe(prefix + 'AppendToBody', function (val) {
	                            appendToBody = angular.isDefined(val) ? $parse(val)(scope) : appendToBody;
	                        });
	
	                        // if a tooltip is attached to <body> we need to remove it on
	                        // location change as its parent scope will probably not be destroyed
	                        // by the change.
	                        if (appendToBody) {
	                            scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
	                                if (scope.ttIsOpen) {
	                                    hide();
	                                }
	                            });
	                        }
	
	                        // Make sure tooltip is destroyed and removed.
	                        scope.$on('$destroy', function onDestroyTooltip() {
	                            $timeout.cancel(transitionTimeout);
	                            $timeout.cancel(popupTimeout);
	                            $timeout.cancel(hoverTimeout);
	                            unregisterTriggers();
	                            unregisterTriggerFunction();
	                            removeTooltip();
	                        });
	                    };
	                }
	            };
	        };
	    }
	}
	
	exports.default = $tooltipProvider;

/***/ },
/* 277 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function tooltipService() {
	    var service = this;
	    var openScope = null;
	
	    service.open = function (tooltipScope) {
	        if (openScope) {
	            openScope.ttIsOpen = false;
	        }
	        openScope = tooltipScope;
	    };
	    service.close = function (tooltipScope) {
	        if (openScope === tooltipScope) {
	            openScope = null;
	        }
	    };
	}
	
	exports.default = tooltipService;

/***/ },
/* 278 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RC_USAGE_URL = exports.RC_USAGE_URL = '/uit/ricola/analytics/diy_rr_stats.gif';
	var RC_USAGE_DP_URL = exports.RC_USAGE_DP_URL = '16873';

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _usage = __webpack_require__(280);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsageProvider = function () {
	    function UsageProvider() {
	        _classCallCheck(this, UsageProvider);
	
	        this.defaults = {
	            flushOnAppBootstrap: false,
	            RC_USAGE_SUBMIT_INTERVAL: 1500,
	            locationChangeEvent: '$locationChangeStart',
	            isDisabled: false
	        };
	    }
	
	    _createClass(UsageProvider, [{
	        key: 'setFlushOnBootstrap',
	        value: function setFlushOnBootstrap(s) {
	            this.defaults.flushOnAppBootstrap = s;
	        }
	    }, {
	        key: 'setLocationChangeEvent',
	        value: function setLocationChangeEvent(e) {
	            this.defaults.locationChangeEvent = e;
	        }
	    }, {
	        key: 'setSubmitInterval',
	        value: function setSubmitInterval(i) {
	            this.defaults.RC_USAGE_SUBMIT_INTERVAL = i;
	        }
	    }, {
	        key: 'disableUsageTracking',
	        value: function disableUsageTracking() {
	            this.defaults.isDisabled = true;
	        }
	    }, {
	        key: '$get',
	        value: ["$interval", "$http", "$location", "$rootScope", "rcUtils", "RC_USAGE_URL", "RC_USAGE_DP_URL", function $get($interval, $http, $location, $rootScope, rcUtils, RC_USAGE_URL, RC_USAGE_DP_URL) {
	            'ngInject';
	
	            return new _usage2.default(this.defaults, {
	                $interval: $interval,
	                $http: $http,
	                $location: $location,
	                $rootScope: $rootScope,
	                rcUtils: rcUtils,
	                RC_USAGE_URL: RC_USAGE_URL,
	                RC_USAGE_DP_URL: RC_USAGE_DP_URL
	            });
	        }]
	    }]);
	
	    return UsageProvider;
	}();
	
	exports.default = UsageProvider;

/***/ },
/* 280 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UsageService = function () {
	    function UsageService(defaults, deps) {
	        var _this = this;
	
	        _classCallCheck(this, UsageService);
	
	        this.defaults = defaults;
	
	        this.$interval = deps.$interval;
	        this.$http = deps.$http;
	        this.$location = deps.$location;
	        this.$rootScope = deps.$rootScope;
	        this.RC_USAGE_URL = deps.RC_USAGE_URL;
	        this.rcUtils = deps.rcUtils;
	        this.RC_USAGE_DP_URL = deps.RC_USAGE_DP_URL;
	
	        this.pending = [];
	        this.submitted = false;
	        this.flushOnAppBootstrap = this.defaults.flushOnAppBootstrap;
	        this.inProgress = null;
	        this.isDisabled = this.defaults.isDisabled;
	
	        this.$rootScope.$on(this.defaults.locationChangeEvent, function (ev, next, current) {
	            if (next === current) {
	                if (_this.flushOnAppBootstrap) {
	                    _this.$$stop();
	                    _this.$$submit();
	                }
	            } else {
	                _this.$$stop();
	                _this.$$submit();
	            }
	        });
	    }
	
	    _createClass(UsageService, [{
	        key: "progress",
	        value: function progress(newProgress) {
	            if (newProgress) {
	                this.inProgress = newProgress;
	            } else {
	                return this.inProgress;
	            }
	        }
	    }, {
	        key: "$$submit",
	        value: function $$submit() {
	            if (this.submitting || this.pending.length === 0) {
	                this.$$stop();
	                return;
	            }
	            var toSubmit = {};
	            var index = this.pending.length;
	            var url = this.pending[0].url;
	            while (index--) {
	                var component = this.pending.pop();
	                if (!angular.isDefined(toSubmit[component.name])) {
	                    toSubmit[component.name] = 1;
	                } else {
	                    toSubmit[component.name]++;
	                }
	            }
	            this.$http.get(this.RC_USAGE_URL, {
	                params: angular.extend(toSubmit, {
	                    _ts: new Date().getTime(),
	                    diy_ID: this.RC_USAGE_DP_URL,
	                    url: url,
	                    v: this.rcUtils.Ricola.info.version
	                })
	            });
	            this.submitting = true;
	            this.$$stop();
	        }
	    }, {
	        key: "$$stop",
	        value: function $$stop() {
	            this.$interval.cancel(this.inProgress);
	            this.submitting = false;
	            this.inProgress = null;
	        }
	    }, {
	        key: "$$start",
	        value: function $$start() {
	            this.inProgress = this.$interval(this.$$submit.bind(this), this.defaults.RC_USAGE_SUBMIT_INTERVAL);
	        }
	    }, {
	        key: "register",
	        value: function register(name) {
	            if (!this.isDisabled) {
	                this.pending.push({
	                    name: name,
	                    url: this.$location.absUrl()
	                });
	                if (!this.inProgress) {
	                    this.$$start();
	                }
	            }
	        }
	    }]);
	
	    return UsageService;
	}();
	
	exports.default = UsageService;

/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	// A polyfill for Function.prototype.bind (needed for Android 2.3, BB7, PhantomJS 1.x)
	// Source: https://github.com/conversocial/phantomjs-polyfill/blob/master/bind-polyfill.js
	
	/* eslint no-extend-native: 0*/
	/* eslint angular/typecheck-function: 0*/
	if (typeof Function.prototype.bind !== 'function') {
	    Function.prototype.bind = function bind(obj) {
	        var args = Array.prototype.slice.call(arguments, 1),
	            self = this,
	            nop = function nop() {},
	            bound = function bound() {
	            return self.apply(this instanceof nop ? this : obj || {}, args.concat(Array.prototype.slice.call(arguments)));
	        };
	        nop.prototype = this.prototype || {};
	        bound.prototype = new nop();
	        return bound;
	    };
	}

/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	
	// requestAnimationFrame polyfill by Erik Moller. fixes from Paul Irish and Tino Zijdel
	
	// MIT license
	
	/* eslint angular/timeout-service: 0*/
	
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	
	    if (!window.requestAnimationFrame) {
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = window.setTimeout(function () {
	                callback(currTime + timeToCall);
	            }, timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    }
	
	    if (!window.cancelAnimationFrame) {
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	    }
	})();

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcFeatureTestsService() {
	    this.runFeatureTests = function () {
	        cssAnimations();
	        cssTransitions();
	    };
	
	    this.cssTransition = function () {
	        return !angular.element(document.querySelector('body')).hasClass('no-css-transition');
	    };
	
	    function cssAnimations() {
	        // CSS Animations test - https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Using_CSS_animations/Detecting_CSS_animation_support
	        var elm = document.createElement('div');
	        var animation = false,
	            animationstring = 'animation',
	            keyframeprefix = '',
	            domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
	            pfx = '';
	
	        if (typeof elm.style.animationName !== 'undefined') {
	            animation = true;
	        }
	
	        if (!animation) {
	            for (var i = 0; i < domPrefixes.length; i++) {
	                if (typeof elm.style[domPrefixes[i] + 'AnimationName'] !== 'undefined') {
	                    pfx = domPrefixes[i];
	                    animationstring = pfx + 'Animation';
	                    keyframeprefix = '-' + pfx.toLowerCase() + '-';
	                    animation = true;
	                    break;
	                }
	            }
	        }
	        if (!animation) {
	            angular.element(document.querySelector('body')).addClass('no-css-animation');
	        }
	    }
	
	    function cssTransitions() {
	        var elm = document.createElement('div'),
	            domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
	            transitions = false;
	
	        if (elm.style.transition !== 'undefined') {
	            transitions = true;
	        } else {
	            for (var i = 0; i < domPrefixes.length; i++) {
	                if (typeof elm.style[domPrefixes[i] + 'Transition'] !== 'undefined') {
	                    transitions = true;
	                    break;
	                }
	            }
	        }
	
	        if (!transitions) {
	            angular.element(document.querySelector('body')).addClass('no-css-transition');
	        }
	    }
	}
	
	exports.default = rcFeatureTestsService;

/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	rcUtilsService.$inject = ["$timeout", "$rootScope", "$window"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcUtilsService($timeout, $rootScope, $window) {
	    'ngInject';
	
	    var service = this;
	
	    /* Use to identify object class.
	       Is thing a date?                getClass(thing) === 'Date'
	       Is thing an array?              getClass(thing) === 'Array'
	       Is thing a regular expression?  getClass(thing) === 'RegExp'
	       etc. */
	    service.getClass = function (thing) {
	        return Object.prototype.toString.call(thing).slice('[object '.length, -']'.length);
	    };
	
	    service.throttle = function (delay, noTrailing, callback, debounceMode) {
	        var timeoutId,
	            lastExec = 0;
	
	        if (typeof noTrailing !== 'boolean') {
	            debounceMode = callback;
	            callback = noTrailing;
	            noTrailing = false;
	        }
	
	        var wrapper = function wrapper() {
	            var that = this,
	                elapsed = new Date().getTime() - lastExec,
	                args = arguments,
	                exec = function exec() {
	                lastExec = new Date().getTime();
	                callback.apply(that, args);
	            },
	                clear = function clear() {
	                timeoutId = null;
	            };
	
	            if (debounceMode && !timeoutId) {
	                exec();
	            }
	            if (timeoutId) {
	                $timeout.cancel(timeoutId);
	            }
	            if (!debounceMode && elapsed > delay) {
	                exec();
	            } else if (noTrailing !== true) {
	                timeoutId = $timeout(debounceMode ? clear : exec, !debounceMode ? delay - elapsed : delay);
	            }
	        };
	
	        return wrapper;
	    };
	
	    // any string prefixed with $$ will be replaced as part of the build process
	    service.Ricola = {
	        info: {
	            version: '3.2.6',
	            description: 'Union Pacific\'s responsive, mobile-first component library built with AngularJS and Foundation.'.replace('&#x27;', '\''),
	            contributors: 'Cary Smith,Doug Stock,Matt Steele',
	            angularVersion: '>=1.5.0',
	            foundationVersion: '5.5.2',
	            buildDate: '2016-06-28T16:02:04.990Z',
	            repositoryUrl: 'http://git-dev.uit.tla.uprr.com:9080/user-experience/ricola3.git'
	        }
	    };
	
	    $window.Ricola = service.Ricola;
	}
	
	exports.default = rcUtilsService;

/***/ },
/* 285 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcUserId = function () {
	    RcUserId.$inject = ["$http", "USER_ID_SERVICE_URL"];
	    function RcUserId($http, USER_ID_SERVICE_URL) {
	        'ngInject';
	
	        _classCallCheck(this, RcUserId);
	
	        this.$http = $http;
	        this.USER_ID_SERVICE_URL = USER_ID_SERVICE_URL;
	    }
	
	    _createClass(RcUserId, [{
	        key: 'get',
	        value: function get(config) {
	            return this.$http.get(this.USER_ID_SERVICE_URL, angular.extend({
	                transformResponse: function transformResponse(response) {
	                    try {
	                        var json = angular.fromJson(response);
	                        if (!!json.userId && json.userId === '(none)') {
	                            json.userId = '';
	                        }
	                        return json;
	                    } catch (exception) {
	                        return response;
	                    }
	                }
	            }, config));
	        }
	    }]);
	
	    return RcUserId;
	}();
	
	exports.default = RcUserId;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angularMessages = __webpack_require__(27);
	
	var _angularMessages2 = _interopRequireDefault(_angularMessages);
	
	var _bindHtml = __webpack_require__(6);
	
	var _bindHtml2 = _interopRequireDefault(_bindHtml);
	
	var _inputFieldWrapper = __webpack_require__(20);
	
	var _inputFieldWrapper2 = _interopRequireDefault(_inputFieldWrapper);
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _validation = __webpack_require__(294);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	var _validationDirective = __webpack_require__(293);
	
	var _validationDirective2 = _interopRequireDefault(_validationDirective);
	
	var _validation3 = __webpack_require__(287);
	
	var rcValidationConfigs = _interopRequireWildcard(_validation3);
	
	var _validationService = __webpack_require__(295);
	
	var _validationService2 = _interopRequireDefault(_validationService);
	
	var _validation4 = __webpack_require__(296);
	
	var rcValidationUtils = _interopRequireWildcard(_validation4);
	
	var _validationDirective3 = __webpack_require__(288);
	
	var _validationDirective4 = _interopRequireDefault(_validationDirective3);
	
	var _validationDirective5 = __webpack_require__(289);
	
	var _validationDirective6 = _interopRequireDefault(_validationDirective5);
	
	var _validationDirective7 = __webpack_require__(290);
	
	var _validationDirective8 = _interopRequireDefault(_validationDirective7);
	
	var _validationDirective9 = __webpack_require__(292);
	
	var _validationDirective10 = _interopRequireDefault(_validationDirective9);
	
	var _validationDirective11 = __webpack_require__(291);
	
	var _validationDirective12 = _interopRequireDefault(_validationDirective11);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.validation', [_angularMessages2.default, _bindHtml2.default.name, _inputFieldWrapper2.default.name, _usage2.default.name, _validation2.default.name, _validationDirective2.default.name]).config(rcValidationConfigs.rcValidateCounterConfig).config(rcValidationConfigs.rcRequiredConfig).config(rcValidationConfigs.rcDefaultValidatorsConfig).value('rcValidationGetLabelFor', rcValidationUtils.rcValidationGetLabelFor).service('$rcValidators', _validationService2.default).directive('rcValidateCounter', _validationDirective4.default).directive('rcFormErrors', _validationDirective6.default).directive('rcInputFieldErrors', _validationDirective8.default).directive('rcRequired', (0, _validationDirective10.default)('rcRequired')).directive('ngRequired', (0, _validationDirective10.default)('ngRequired')).directive('required', (0, _validationDirective10.default)('required')).directive('input', _validationDirective12.default).directive('select', _validationDirective12.default).directive('textarea', _validationDirective12.default);

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	rcValidateCounterConfig.$inject = ["rcValidationErrorMessagesProvider"];
	rcRequiredConfig.$inject = ["rcValidationErrorMessagesProvider"];
	rcDefaultValidatorsConfig.$inject = ["rcValidationErrorMessagesProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rcValidateCounterConfig = rcValidateCounterConfig;
	exports.rcRequiredConfig = rcRequiredConfig;
	exports.rcDefaultValidatorsConfig = rcDefaultValidatorsConfig;
	function rcValidateCounterConfig(rcValidationErrorMessagesProvider) {
	    'ngInject';
	
	    rcValidationErrorMessagesProvider.addErrorMessage('rcCharacterCounter', '{{fieldLabel}} is too long.');
	}
	
	function rcRequiredConfig(rcValidationErrorMessagesProvider) {
	    'ngInject';
	
	    rcValidationErrorMessagesProvider.addErrorMessage('rcRequired', '{{fieldLabel}} is required.');
	}
	
	function rcDefaultValidatorsConfig(rcValidationErrorMessagesProvider) {
	    'ngInject';
	    // Required is special
	
	    rcValidationErrorMessagesProvider.addErrorMessage('required', '{{fieldLabel}} is required.');
	
	    var builtinValidators = ['min', 'max', 'number', 'minlength', 'maxlength', 'pattern', 'url', 'week', 'month', 'time', 'datetimelocal'];
	
	    angular.forEach(builtinValidators, function (validator) {
	        rcValidationErrorMessagesProvider.addErrorMessage(validator);
	    });
	}

/***/ },
/* 288 */
/***/ function(module, exports) {

	'use strict';
	
	rcValidateCounterDirective.$inject = ["$compile", "$parse", "$log"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function rcValidateCounterDirective($compile, $parse, $log) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        require: ['?ngModel', '^?form'],
	        link: function link(scope, element, attrs, ctrls) {
	            if (ctrls.length !== 2) {
	                $log.warn('An ng-model and a parent form are required to use `rc-validate-counter`.');
	                return;
	            }
	
	            var modelCtrl = ctrls[0];
	
	            var charsLeftScope = scope.$new();
	            var updateCharsLeft = function updateCharsLeft() {
	                charsLeftScope.charsLeft = modelCtrl.$viewValue ? charLimit - modelCtrl.$viewValue.length : charLimit;
	                charsLeftScope.overCharLimit = charsLeftScope.charsLeft < 0;
	            };
	
	            charsLeftScope.rcValidateCounter = $parse(attrs.rcValidateCounter)();
	
	            // Initial setup
	            var charLimit = parseInt(charsLeftScope.rcValidateCounter, 10);
	            charsLeftScope.overCharLimit = false;
	            updateCharsLeft();
	
	            // Setup element wrapper and character counter
	            element.parent().addClass('rc-character-counter-wrapper');
	            var charsLeft = angular.element('<span class="characters-left" ng-bind="charsLeft" ng-class="{\'over-limit\': overCharLimit}"></span>');
	            charsLeft = $compile(charsLeft)(charsLeftScope);
	            element.after(charsLeft);
	
	            modelCtrl.$validators.rcCharacterCounter = function (modelValue, viewValue) {
	                var characters = (viewValue || '').length;
	                return charLimit - characters >= 0;
	            };
	
	            scope.$watch(function () {
	                return modelCtrl.$viewValue;
	            }, function () {
	                updateCharsLeft();
	            });
	
	            var validationOptions = {
	                errorText: 'Over Limit'
	            };
	        }
	    };
	}
	
	exports.default = rcValidateCounterDirective;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	RcFormErrorsDirective.$inject = ["$timeout", "$rootScope"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationRcFormErrors = __webpack_require__(82);
	
	var _validationRcFormErrors2 = _interopRequireDefault(_validationRcFormErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RcFormErrorsDirective($timeout, $rootScope) {
	    'ngInject';
	
	    return {
	        restrict: 'EA',
	        require: '^form',
	        scope: true,
	        template: _validationRcFormErrors2.default,
	        link: function link($scope, el, attrs, formController) {
	            $scope.showErrors = false;
	            $scope.$formController = formController;
	
	            $scope.$watch(function () {
	                return formController.$invalid && formController.$submitted && hasErrorsToShow();
	            }, function (newVal) {
	                $scope.showErrors = newVal;
	                if (newVal) {
	                    $rootScope.$broadcast('$rcFormErrorsDisplayed', formController);
	                }
	            });
	
	            $scope.$watch('$formController.$$rcRegisteredInputs', function (newVal) {
	                $scope.errors = newVal;
	            });
	
	            function hasErrorsToShow() {
	                if (angular.isArray($scope.errors)) {
	                    return $scope.errors.some(hasModelControllerShowError);
	                }
	                return false;
	            }
	
	            function hasModelControllerShowError(error) {
	                if (error.modelController && error.modelController.showError) {
	                    return true;
	                }
	            }
	        }
	    };
	}
	
	exports.default = RcFormErrorsDirective;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	RcInputFieldErrors.$inject = ["$document", "rcValidationErrorMessages", "$interpolate", "$compile"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validationRcInputFieldErrors = __webpack_require__(83);
	
	var _validationRcInputFieldErrors2 = _interopRequireDefault(_validationRcInputFieldErrors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RcInputFieldErrors($document, rcValidationErrorMessages, $interpolate, $compile) {
	    'ngInject';
	
	    var determineErrorMessage = function determineErrorMessage(value, customErrorMessages) {
	        if (angular.isString(customErrorMessages)) {
	            return customErrorMessages;
	        } else {
	            if (angular.isObject(customErrorMessages) && customErrorMessages[value.label]) {
	                return customErrorMessages[value.label];
	            } else {
	                return value.message;
	            }
	        }
	    };
	
	    function init($scope, $el, attrs, ctrls) {
	        var formController = ctrls[0];
	        if (angular.isUndefined($scope.ngModelController)) {
	            $scope.ngModelController = formController[$scope.ngModelName];
	        }
	        var modelController = $scope.ngModelController;
	        var customErrorMessages = $scope.customErrorMessages;
	        var setErrorState = function setErrorState(value) {
	            modelController.showError = value;
	        };
	
	        $scope.fieldLabel = attrs.fieldLabel || 'This field';
	        $scope.errorMessages = [];
	        $scope.clickable = angular.isDefined($scope.focusOnClick);
	
	        function addValidator(key) {
	            var errorObj = rcValidationErrorMessages.getErrorMessage(key);
	            if (errorObj) {
	                var message = determineErrorMessage(errorObj, customErrorMessages);
	                message = message.replace('{{fieldLabel}}', '<span class="rc-error-text-label">{{::fieldLabel}}</span>');
	                errorObj.message = $interpolate(message)($scope);
	                $scope.errorMessages.push(errorObj);
	            }
	        }
	
	        /* Add error messages for configured validation */
	        angular.forEach(Object.keys(modelController.$validators), addValidator);
	        angular.forEach(Object.keys(modelController.$asyncValidators), addValidator);
	
	        // Parsing validators don't get added to the $validators pipeline
	        // If there is a $parser set on this, it's possible there is a special validator set
	        // See http://www.yearofmoo.com/2014/09/taming-forms-in-angularjs-1-3.html#html5-validators-and-parse-errors
	        // It'd be nice to only register the specific validators that have been added, rather than all of them.
	        if (modelController.$parsers.length > 0) {
	            ['number', 'date', 'time', 'datetimelocal', 'week', 'month'].forEach(addValidator);
	        }
	
	        $scope.$watch('ngModelController.$valid', function rcInputFieldErrorsValidModelWatcher(isValid) {
	            if (modelController.showError && isValid) {
	                setErrorState(false);
	            }
	        });
	
	        // TODO Binding to form submit doesn't feel "angular-y", I bet there is a better way
	        angular.element(modelController.el[0].form).on('submit', function () {
	            setErrorState(modelController.$invalid);
	            $scope.$apply();
	        });
	
	        // We add this to the $scope so we don't have to rely on a $name, see #202
	        $scope.form = formController;
	        $scope.$watch('form.$pristine', function rcInputFieldErrorsCleanFormWatcher(newVal) {
	            if (newVal) {
	                setErrorState(false);
	            }
	        });
	
	        $scope.focus = function () {
	            if ($scope.focusOnClick) {
	                var inputElement = $scope.focusOnClick;
	                inputElement[0].focus();
	            }
	        };
	
	        $scope.$on('$destroy', function () {
	            delete $scope.ngModelController;
	            delete $scope.ngModelName;
	            delete $scope.focusOnClick;
	        });
	
	        var checkErrorState = function checkErrorState() {
	            // Are there any errors on the field that aren't 'required'?
	            var showErrors;
	
	            if (!formController || formController.$submitted) {
	                showErrors = Object.keys(modelController.$error).length > 0;
	            } else {
	                showErrors = Object.keys(modelController.$error).filter(function (i) {
	                    return !(i === 'required' || i === 'rcRequired' || i === 'ngRequired');
	                }).length > 0;
	            }
	
	            setErrorState(showErrors);
	        };
	
	        var pendingAsyncWatch = null;
	        // When the asynchronous validators complete their work, check the error state
	        // Note: this looks like an interesting alternative to $watch. Let's keep an eye on it!
	        // https://github.com/angular/angular.js/issues/10768
	        var registerAsyncWatch = function registerAsyncWatch() {
	            if (Object.keys(modelController.$asyncValidators).length === 0) {
	                return;
	            }
	
	            if (pendingAsyncWatch) {
	                return pendingAsyncWatch;
	            }
	
	            return $scope.$watch('ngModelController.$pending', function (newVal, oldVal) {
	                // When the async operator has finished, run through checks
	                if (angular.isUndefined(newVal) && angular.isDefined(oldVal) && modelController.$dirty) {
	                    // If there is a pending $watch, deregister it
	                    if (pendingAsyncWatch) {
	                        pendingAsyncWatch();
	                        pendingAsyncWatch = null;
	                    }
	                    checkErrorState();
	                }
	            });
	        };
	
	        modelController.el.on('blur', function () {
	            pendingAsyncWatch = registerAsyncWatch();
	            checkErrorState();
	            $scope.$apply();
	        });
	    }
	
	    return {
	        restrict: 'EA',
	        require: ['?^form'],
	        scope: {
	            ngModelController: '=?',
	            ngModelName: '@?',
	            customErrorMessages: '=',
	            focusOnClick: '=?'
	        },
	        template: _validationRcInputFieldErrors2.default,
	        link: function link($scope, $el, attrs, ctrls) {
	            // TODO At some point we should deprecate the ngModelController attribute
	            // I believe using ngModelName is a better developer experience in every way
	            if (angular.isDefined($scope.ngModelController) || angular.isDefined($scope.ngModelName)) {
	                init($scope, $el, attrs, ctrls);
	            }
	        }
	    };
	}
	
	exports.default = RcInputFieldErrors;

/***/ },
/* 291 */
/***/ function(module, exports) {

	'use strict';
	
	RcInputFieldErrorWrapper.$inject = ["$compile", "rcValidationGetLabelFor", "$log", "$rcInputFieldWrapper"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function RcInputFieldErrorWrapper($compile, rcValidationGetLabelFor, $log, $rcInputFieldWrapper) {
	    'ngInject';
	
	    var getLabelText = function getLabelText(labelEl) {
	        if (labelEl) {
	            return labelEl.textContent.replace(/\:$/, '');
	        }
	        return 'This field';
	    };
	
	    var resolveLabelText = function resolveLabelText(customErrorLabel, el) {
	        if (customErrorLabel) {
	            return customErrorLabel;
	        }
	        return getLabelText(rcValidationGetLabelFor(el));
	    };
	
	    var validationPreconditions = function validationPreconditions(modelController, formController, element) {
	        // If it's not wrapped, don't apply it
	        if ($rcInputFieldWrapper.shouldNotWrapField(element)) {
	            return false;
	        }
	
	        if (!modelController) {
	            $log.warn('Validation requires an "ng-model" attribute', element[0]);
	            return false;
	        }
	
	        var none = function none(arr) {
	            return Object.keys(arr).length === 0;
	        };
	
	        // If no validators or parsers are registered, it's unnecessary
	        var $validators = modelController.$validators;
	        var $parsers = modelController.$parsers;
	        var $asyncValidators = modelController.$asyncValidators;
	
	        if (none($validators) && none($parsers) && none($asyncValidators)) {
	            return false;
	        }
	
	        return true;
	    };
	
	    // We're adding $$rcValidationModels to the $scope here
	    // Why? So we can pass it to the <rc-input-wrapper> directive
	    // without requiring the user to pass in a 'name' attribute on this or the form
	    var addNgModelToScope = function addNgModelToScope($scope, identifier, modelController) {
	        if (!$scope.$$rcValidationModels) {
	            $scope.$$rcValidationModels = {};
	        }
	        $scope.$$rcValidationModels[identifier] = modelController;
	    };
	
	    var link = function link($scope, el, attrs, ctrls) {
	        var modelController = ctrls[0],
	            formController = ctrls[1];
	
	        if (!validationPreconditions(modelController, formController, el)) {
	            return;
	        }
	        /* The model name and scope ID provide a unique identifier when an
	         * input is used in a repeater since the scope is not isolate
	         * (i.e. $$rcValidationModels might overwrite a key by accident) */
	        var uniqueModelID = attrs.ngModel.replace(/[\.\[\]]/g, '_') + '_' + $scope.$id;
	        addNgModelToScope($scope, uniqueModelID, modelController);
	
	        var labelText = resolveLabelText(attrs.errorLabel, el[0]);
	        modelController.el = el;
	
	        if (angular.isUndefined(attrs.manualErrorsList)) {
	            var fieldErrors = angular.element('<div></div>');
	            fieldErrors.attr({
	                'rc-input-field-errors': '',
	                'ng-model-controller': '$$rcValidationModels.' + uniqueModelID,
	                'field-label': labelText
	            });
	
	            if (attrs.customErrorMessages) {
	                fieldErrors.attr({
	                    'custom-error-messages': attrs.customErrorMessages
	                });
	            }
	
	            // Append it outside of the rc-input-wrapper .parent()
	            $rcInputFieldWrapper.getInputFieldWrapperFor(el).after(fieldErrors);
	            $compile(fieldErrors)($scope);
	        }
	
	        if (formController && formController.$name) {
	            $scope.$watch(formController.$name + '.$pristine', function rcInputFieldErrorWrapperCleanFormWatcher(newVal) {
	                if (newVal) {
	                    var inputWrapper = $rcInputFieldWrapper.getInputFieldWrapperFor(el);
	                    inputWrapper.removeClass('rc-validate-error');
	                }
	            });
	        }
	
	        // Register component with the form's controller
	        // TODO Is there a way to move this initialization out of here?
	        if (formController) {
	            if (!formController.$$rcRegisteredInputs) {
	                formController.$$rcRegisteredInputs = [];
	            }
	
	            // Add registered inputs to the elements in an unsorted fashion
	            formController.$$rcRegisteredInputs.push({
	                modelController: modelController,
	                element: el,
	                $scope: $scope,
	                fieldLabel: labelText
	            });
	
	            // Then, sort them based on registered form order
	            // Note: this only works with forms, not ngForm.
	            // I don't know how to grab an ngForm's elements in an ordered fashion.
	            if (el[0].form) {
	                var sortedFormElements = el[0].form.elements,
	                    elementsInArray = [];
	                for (var i = 0; i < sortedFormElements.length; i++) {
	                    elementsInArray.push(sortedFormElements[i]);
	                }
	
	                formController.$$rcRegisteredInputs.sort(function (a, b) {
	                    var aEl = a.element[0],
	                        bEl = b.element[0],
	                        aIndex = elementsInArray.indexOf(aEl),
	                        bIndex = elementsInArray.indexOf(bEl);
	
	                    if (aIndex > bIndex) {
	                        return 1;
	                    }
	                    if (aIndex < bIndex) {
	                        return -1;
	                    }
	                    return 0;
	                });
	            }
	
	            $scope.$on('$destroy', function () {
	                formController.$$rcRegisteredInputs = formController.$$rcRegisteredInputs.filter(function (input) {
	                    return input.$scope !== $scope;
	                });
	                delete $scope.$$rcValidationModels[uniqueModelID];
	            });
	        }
	
	        $scope.$watch('$$rcValidationModels.' + uniqueModelID + '.showError', function rcInputFieldErrorWrapperShowErrorWatcher(showError) {
	            var inputWrapper = $rcInputFieldWrapper.getInputFieldWrapperFor(el);
	            if (showError) {
	                inputWrapper.addClass('rc-validate-error');
	            } else {
	                inputWrapper.removeClass('rc-validate-error');
	            }
	        });
	    };
	
	    return {
	        restrict: 'E',
	        priority: 2, // ngModel runs at priority 1, this must run _after_ validators are added to the ngModelController
	        require: ['?ngModel', '?^form'],
	        link: link
	    };
	}
	
	exports.default = RcInputFieldErrorWrapper;

/***/ },
/* 292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function makeRequiredDirective(directiveName) {
	    var requiredClass = 'rc-validate-required';
	    /* Have to manually inject here.. */
	    return ["Usage", "rcValidationGetLabelFor", "$log", "$rcInputFieldWrapper", function (Usage, rcValidationGetLabelFor, $log, $rcInputFieldWrapper) {
	        'ngInject';
	
	        if (directiveName === 'rcRequired') {
	            $log.warn('rc-required is deprecated. Use the normal "required" attribute instead');
	        }
	
	        var addRequiredIndicator = function addRequiredIndicator(element, scope) {
	            var label = rcValidationGetLabelFor(element[0]);
	            if (label) {
	                angular.element(label).addClass('rc-required-label');
	            }
	            var sizeAttr = element.attr('size') || '';
	            if (sizeAttr) {
	                sizeAttr = ' size="' + sizeAttr + '"';
	            }
	            /* Need another wrapper here to style per HF spec:  3px "border" to indicate required. */
	
	            // We assume the input field has been wrapped by the rc-input-field-wrapper directive
	            $rcInputFieldWrapper.getInputFieldWrapperFor(element).addClass(requiredClass);
	        };
	        var removeRequiredIndicator = function removeRequiredIndicator(element, scope) {
	            var label = rcValidationGetLabelFor(element[0]);
	            if (label) {
	                angular.element(label).removeClass('rc-required-label');
	            }
	            $rcInputFieldWrapper.getInputFieldWrapperFor(element).removeClass(requiredClass);
	        };
	        var hasIndicator = function hasIndicator(element) {
	            return $rcInputFieldWrapper.getInputFieldWrapperFor(element).hasClass(requiredClass);
	        };
	        var hasNoIndicator = function hasNoIndicator(element) {
	            return !hasIndicator(element);
	        };
	
	        /* Falsy values (!model) may not be accurate if the input is boolean like a checkbox
	         * Inputs of type="number" can return a null if empty (as apposed to undefined) */
	        var isInvalidModel = function isInvalidModel(model) {
	            return model === null || angular.isUndefined(model) || model === '' || angular.isArray(model) && model.length === 0;
	        };
	
	        return {
	            require: 'ngModel',
	            restrict: 'A',
	            priority: 1,
	            scope: true,
	            link: function link(scope, element, attrs, ctrl) {
	                Usage.register('required');
	                var requiredAttr = attrs[directiveName];
	
	                if (requiredAttr) {
	                    var validationExpr = scope.$eval(requiredAttr);
	                    attrs.$set('validationRequired', requiredAttr === true ? true : validationExpr);
	                } else {
	                    attrs.$set('validationRequired', true);
	                }
	
	                attrs.$observe('validationRequired', function (isRequired) {
	                    if (isRequired && hasNoIndicator(element)) {
	                        addRequiredIndicator(element, scope);
	                    } else if (!isRequired && hasIndicator(element)) {
	                        removeRequiredIndicator(element, scope);
	                    }
	                });
	
	                var validator = function validator(modelValue, viewValue) {
	                    if (attrs.validationRequired && isInvalidModel(modelValue)) {
	                        return false;
	                    }
	                    return true;
	                };
	
	                ctrl.$validators[directiveName] = validator;
	
	                scope.$watch(attrs[directiveName], function (value) {
	                    if (angular.isDefined(value)) {
	                        attrs.$set('validationRequired', value);
	                    }
	                    ctrl.$setValidity(directiveName, validator(ctrl.$modelValue, ctrl.$viewValue));
	                });
	            }
	        };
	    }];
	}
	
	exports.default = makeRequiredDirective;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validation = __webpack_require__(25);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rcValidationModule = angular.module('rc.validation.validators', []);
	
	var rcValidateName = function rcValidateName(name) {
	    return 'rcValidate' + name.charAt(0).toUpperCase() + name.slice(1);
	};
	
	_validation2.default.forEach(function (validator) {
	    rcValidationModule.config(["rcValidationErrorMessagesProvider", function (rcValidationErrorMessagesProvider) {
	        'ngInject';
	
	        rcValidationErrorMessagesProvider.addErrorMessage(validator.name);
	    }]);
	
	    rcValidationModule.directive(rcValidateName(validator.name), function () {
	        return {
	            require: 'ngModel',
	            restrict: 'A',
	            priority: 1,
	            link: function link(scope, element, attrs, ctrl) {
	                ctrl.$validators[validator.name] = function (modelValue, viewValue) {
	                    return ctrl.$isEmpty(viewValue) || validator.test(viewValue);
	                };
	            }
	        };
	    });
	});
	
	exports.default = rcValidationModule;

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function ValidationErrorMessagesProvider() {
	    var errorMessage = this;
	    var defaultErrorMessage = '{{fieldLabel}} format is invalid.';
	
	    var data = {};
	
	    errorMessage.getErrorMessages = function () {
	        var dataAsArray = [];
	        angular.forEach(data, function (value, key) {
	            dataAsArray.push({ label: key, message: value });
	        });
	        return dataAsArray;
	    };
	
	    errorMessage.getErrorMessage = function (type) {
	        var message = data[type];
	
	        if (message) {
	            return { label: type, message: message };
	        }
	    };
	
	    errorMessage.addErrorMessage = function (label) {
	        var message = arguments.length <= 1 || arguments[1] === undefined ? defaultErrorMessage : arguments[1];
	
	        data[label] = message;
	    };
	
	    errorMessage.$get = function () {
	        return {
	            getErrorMessage: errorMessage.getErrorMessage,
	            getErrorMessages: errorMessage.getErrorMessages
	        };
	    };
	}
	
	exports.default = angular.module('rc.validation.provider', []).provider('rcValidationErrorMessages', ValidationErrorMessagesProvider);

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _validation = __webpack_require__(25);
	
	var _validation2 = _interopRequireDefault(_validation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RcValidatorsService = function () {
	    function RcValidatorsService() {
	        _classCallCheck(this, RcValidatorsService);
	    }
	
	    _createClass(RcValidatorsService, [{
	        key: 'passes',
	        value: function passes(validator, input) {
	            var val = _validation2.default.filter(function (i) {
	                return i.name === validator;
	            });
	
	            if (val.length !== 1) {
	                return null;
	            }
	
	            return val[0].test(input);
	        }
	    }]);
	
	    return RcValidatorsService;
	}();
	
	exports.default = RcValidatorsService;

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.rcValidationGetLabelFor = rcValidationGetLabelFor;
	function rcValidationGetLabelFor(element) {
	    var elementId = element.name || element.id;
	    var parentElement = element.form ? element.form : document;
	    var label = parentElement.querySelector('label[for="' + elementId + '"]');
	    if (!label) {
	        var ancestor;
	        for (ancestor = angular.element(element).parent(); ancestor[0] && !(ancestor[0].tagName === 'LABEL' || ancestor[0].tagName === 'BODY');) {
	            ancestor = ancestor.parent();
	        }
	        if (ancestor[0] && ancestor[0].tagName === 'LABEL') {
	            label = ancestor[0];
	        }
	    }
	    return label;
	}

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _usage = __webpack_require__(1);
	
	var _usage2 = _interopRequireDefault(_usage);
	
	var _wizard = __webpack_require__(298);
	
	var _wizard2 = _interopRequireDefault(_wizard);
	
	var _wizard3 = __webpack_require__(299);
	
	var _wizard4 = _interopRequireDefault(_wizard3);
	
	var _wizardDirective = __webpack_require__(300);
	
	var _wizardDirective2 = _interopRequireDefault(_wizardDirective);
	
	var _wizardDirective3 = __webpack_require__(301);
	
	var _wizardDirective4 = _interopRequireDefault(_wizardDirective3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('rc.wizard', [_usage2.default.name]).controller('rcWizardController', _wizard2.default).directive('rcWizard', _wizard4.default).directive('rcWizardPrevNext', _wizardDirective2.default).directive('rcWizardStep', _wizardDirective4.default);

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	rcWizardController.$inject = ["$scope"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * All navigation and indexes are managed according to 'enabled' steps only.
	 */
	function rcWizardController($scope) {
	    'ngInject';
	
	    var allSteps = [];
	    var enabledScopeIds = []; // Tracking mechanism for enabled state changes. Different than enabledSteps.
	    var ctrl = this;
	    ctrl.addStep = addStep;
	    ctrl.currentStep = 0;
	    ctrl.finish = finish;
	    ctrl.enabledSteps = [];
	    ctrl.nextStep = nextStep;
	    ctrl.previousStep = previousStep;
	    ctrl.removeStep = removeStep;
	    ctrl.setActive = setActive;
	    ctrl.validUpTo = validUpTo;
	
	    var unbindStepWatch = $scope.$watch(watchStepChange, watchHandleStepChange);
	    var unbindEnabledWatch = $scope.$watchCollection(watchEnabledScopeIds, refreshEnabledSteps);
	
	    $scope.$on('destroy', function () {
	        unbindStepWatch();
	        unbindEnabledWatch();
	    });
	
	    function addStep(stepScope) {
	        allSteps.push(stepScope);
	        refreshEnabledSteps();
	    }
	
	    function finish() {
	        triggerStepSubmit();
	        if (validateStep(ctrl.enabledSteps[ctrl.currentStep]) && angular.isFunction(ctrl.onFinish)) {
	            ctrl.onFinish();
	        }
	    }
	
	    function nextStep() {
	        triggerStepSubmit();
	        if (validateStep(ctrl.enabledSteps[ctrl.currentStep])) {
	            ctrl.setActive(ctrl.currentStep + 1);
	        }
	    }
	
	    function previousStep() {
	        if (validateStep(ctrl.enabledSteps[ctrl.currentStep - 1])) {
	            ctrl.setActive(ctrl.currentStep - 1);
	        }
	    }
	
	    function refreshEnabledSteps() {
	        ctrl.enabledSteps = allSteps.filter(function (step) {
	            return !!step.enabled;
	        });
	    }
	
	    function removeStep(stepScope) {
	        allSteps.splice(allSteps.indexOf(stepScope), 1);
	        refreshEnabledSteps();
	    }
	
	    function setActive(index) {
	        if (ctrl.enabledSteps[index] && (validUpTo(index) || ctrl.currentStep > index)) {
	            refreshEnabledSteps();
	            ctrl.currentStep = index;
	        }
	    }
	
	    function triggerStepSubmit() {
	        var step = ctrl.enabledSteps[ctrl.currentStep];
	        if (angular.isFunction(step.submitStep)) {
	            step.submitStep();
	        }
	    }
	
	    function watchStepChange() {
	        return ctrl.currentStep;
	    }
	
	    function watchHandleStepChange(value) {
	        if (angular.isNumber(value)) {
	            ctrl.setActive(value);
	        }
	    }
	
	    function watchEnabledScopeIds() {
	        enabledScopeIds.length = 0;
	        for (var i = 0; i < allSteps.length; i++) {
	            if (allSteps[i].enabled) {
	                enabledScopeIds.push(allSteps[i].$id);
	            }
	        }
	        return enabledScopeIds;
	    }
	
	    function validateStep(stepScope) {
	        return stepScope && stepScope.nextStep() && stepScope.isValid;
	    }
	
	    function validUpTo(index) {
	        for (var i = 0; i < index; i++) {
	            if (!ctrl.enabledSteps[i].isValid) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	exports.default = rcWizardController;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcWizardDirective.$inject = ["Usage"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _wizard = __webpack_require__(84);
	
	var _wizard2 = _interopRequireDefault(_wizard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcWizardDirective(Usage) {
	    'ngInject';
	
	    return {
	        restrict: 'EA',
	        scope: {
	            onFinish: '=?', // Should this be '&'?
	            startStep: '=?',
	            currentStep: '=?'
	        },
	        template: _wizard2.default,
	        transclude: true,
	        controller: 'rcWizardController',
	        controllerAs: 'rcWzCtrl',
	        bindToController: true,
	        compile: rcWizardCompile
	    };
	
	    function rcWizardCompile(element, attributes) {
	        element.addClass('rc-wizard');
	        return rcWizardPostLink;
	    }
	
	    function rcWizardPostLink(scope, element, attrs, wizardCtrl) {
	        Usage.register('wizard');
	        // force a one-time evaluation after all non-ng-if steps have been added
	        scope.$evalAsync(function () {
	            if (angular.isDefined(wizardCtrl.startStep)) {
	                wizardCtrl.currentStep = wizardCtrl.startStep;
	            }
	        });
	    }
	}
	
	exports.default = rcWizardDirective;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _wizardPrevNext = __webpack_require__(85);
	
	var _wizardPrevNext2 = _interopRequireDefault(_wizardPrevNext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcWizardStepPrevNextDirective() {
	    return {
	        restrict: 'EA',
	        require: '^rcWizard',
	        template: _wizardPrevNext2.default
	    };
	}
	
	exports.default = rcWizardStepPrevNextDirective;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	rcWizardStepDirective.$inject = ["$parse", "$timeout"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _wizardStep = __webpack_require__(86);
	
	var _wizardStep2 = _interopRequireDefault(_wizardStep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function rcWizardStepDirective($parse, $timeout) {
	    'ngInject';
	
	    return {
	        restrict: 'EA',
	        require: '^rcWizard',
	        template: _wizardStep2.default,
	        transclude: true,
	        scope: {
	            enabled: '=?',
	            heading: '@',
	            nextStep: '&?' // This may be confusing due to rcWizardCtrl.nextStep() function. Rename?
	        },
	        link: rcWizardStepPostLink
	    };
	
	    function rcWizardStepPostLink(scope, element, attrs, wizardCtrl) {
	        var form = angular.element(element.find('form')),
	            formCtrl = form.length ? form.controller('form') : {};
	
	        scope.isActive = isActive;
	        scope.submitStep = submitStep;
	
	        scope.nextStep = scope.nextStep || truthyNoop;
	        scope.enabled = scope.enabled || true;
	
	        scope.$on('$destroy', destroyHandler);
	        scope.$watch(watcher, watchHandler); // Validity watcher for next step
	
	        wizardCtrl.addStep(scope);
	
	        function destroyHandler() {
	            wizardCtrl.removeStep(scope);
	        }
	        // Synchronizes manual changes to the currentStep
	        function isActive() {
	            return wizardCtrl.enabledSteps.indexOf(scope) === wizardCtrl.currentStep;
	        }
	
	        function submitStep() {
	            if (form.length) {
	                $timeout(function () {
	                    form.triggerHandler('submit');
	                    // Required to display form errors on submission or parent form submission (SID ticket #171713 and related SID #158053)
	                    formCtrl.$setSubmitted();
	                });
	            }
	        }
	
	        function watcher() {
	            return scope.nextStep() && formCtrl.$valid;
	        }
	
	        function watchHandler(isValid) {
	            scope.isValid = isValid;
	        }
	    }
	
	    function truthyNoop() {
	        return true;
	    }
	}
	
	exports.default = rcWizardStepDirective;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,r){if(true)module.exports=r();else if("function"==typeof define&&define.amd)define([],r);else{var n=r();for(var t in n)("object"==typeof exports?exports:e)[t]=n[t]}}(this,function(){return function(e){function r(t){if(n[t])return n[t].exports;var i=n[t]={exports:{},id:t,loaded:!1};return e[t].call(i.exports,i,i.exports,r),i.loaded=!0,i.exports}var n={};return r.m=e,r.c=n,r.p="./",r(0)}([function(e,r,n){e.exports=n(3)},function(e,r){"use strict";function n(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(r,"__esModule",{value:!0});var t=function(){function e(e,r){for(var n=0;n<r.length;n++){var t=r[n];t.enumerable=t.enumerable||!1,t.configurable=!0,"value"in t&&(t.writable=!0),Object.defineProperty(e,t.key,t)}}return function(r,n,t){return n&&e(r.prototype,n),t&&e(r,t),r}}(),i=function(){function e(r,t,i,o,a){"ngInject";n(this,e),this.$agf=r,this.$rootScope=t,this.$location=i,this.$window=o,this.settings=a,this.$init()}return e.$inject=["$upAngelfish","$rootScope","$location","$window","settings"],t(e,[{key:"$pageview",value:function(e){this.settings.enabled&&this.$agf.pageview({page:e})}},{key:"$settings",value:function(){return this.settings}},{key:"pageview",value:function(){var e=this.$location.absUrl(),r=e.substring(e.indexOf(this.$window.location.pathname));this.$pageview(r)}},{key:"$init",value:function(){var e=this;this.$rootScope.$on("$locationChangeSuccess",function(r,n,t){var i=function(){return t!==n},o=function(){return e.settings.enableOnServerLoad};(i()||o())&&e.pageview()})}}]),e}(),o=function(){function e(){n(this,e),this.settings={enabled:!0,enableOnServerLoad:!1}}return t(e,[{key:"disable",value:function(){this.settings.enabled=!1}},{key:"enableOnServerLoad",value:function(){this.settings.enableOnServerLoad=!0}},{key:"$get",value:["$upAngelfish","$rootScope","$location","$window",function(e,r,n,t){"ngInject";return new i(e,r,n,t,this.settings)}]}]),e}();r["default"]=o,e.exports=r["default"]},function(e,r,n){"use strict";function t(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(r,"__esModule",{value:!0});var i=n(5),o=t(i);r["default"]=o["default"],e.exports=r["default"]},function(e,r,n){"use strict";function t(e){return e&&e.__esModule?e:{"default":e}}Object.defineProperty(r,"__esModule",{value:!0});var i=n(2),o=t(i),a=n(1),s=t(a);r["default"]=angular.module("up-angular-analytics",[]).constant("$upAngelfish",o["default"]).provider("AngelfishAnalytics",s["default"]).run(["AngelfishAnalytics",function(e){}]),e.exports=r["default"]},function(e,r){var n=!0,t=null,i=!1;Array.prototype.indexOf||(Array.prototype.indexOf=function(e,r){var n=this.length>>>0,t=Number(r)||0,t=0>t?Math.ceil(t):Math.floor(t);for(0>t&&(t+=n);n>t;t++)if(t in this&&this[t]===e)return t;return-1});var o="040";!function(e,r,a,s,u){function c(e){if(!e||!e.url)return n;var r=escape(e.q?e.q:s.i),r=r+("="+T.visitorId+"."+T.visitStartTime),r=r+("."+f(q.source.replace(/\&/g,""))+"%26"+f(q.medium.replace(/\&/g,""))+"%26"+f(q.campaign.replace(/\&/g,""))+"%26"+f(q.keyword.replace(/\&/g,""))+"%26"+f(q.content.replace(/\&/g,"")));return e.url.indexOf("?")>0?e.url+"&"+r:e.url+"?"+r}function f(e){return encodeURIComponent(decodeURIComponent(e.toString()))}function d(e,r){if(e&&0!==e.length&&"function"==typeof r)for(var n in e)if(e.hasOwnProperty(n)&&r(n)===i)break}function l(e,n,t,i){var o=e+"="+O("auto"!=s.d?s.d:r.domain)+"."+n+";";if(t){if("session"!==t){var a="";i&&(a=new Date,a.setTime(a.getTime()+i*("min"===t?6e4:864e5)),a=a.toUTCString()),o+="expires="+a+";"}}else o+="expires=Thu, 01-Jan-1970 00:00:01 GMT;";s.j&&(o+="path="+s.j+";"),"auto"!=s.d&&(o+="domain="+s.d+";"),r.cookie=o,M[e]=n}function g(){return Math.ceil((new Date).getTime()/1e3)}function m(){var e=(q.keyword||"").replace(/\&/g,""),e=q.ie?e:f(e),e=T.visitorId+"&"+T.visitStartTime+"&"+T.lastActivityTime+"&"+f((q.source||"").replace(/\&/g,""))+"&"+f((q.medium||"").replace(/\&/g,""))+"&"+f((q.campaign||"").replace(/\&/g,""))+"&"+e+"&"+f((q.content||"").replace(/\&/g,""))+"&"+f((T.referrer||"").replace(/\&/g,""))+"&"+f((T.username||"").replace(/\&/g,""));l(s.e.sessionInfo,e,"day",s.w),M[s.e.sessionTimeout]||p()}function p(){l(s.e.sessionTimeout,T.visitorId,"session")}function h(){if(!M[s.e.sessionInfo])return T.visitorType="new",i;var e=M[s.e.sessionInfo].split("&");return"undefined"==e[0]?(T.visitorType="new",i):(T.visitorId=e[0],T.visitorType="returning",T.visitStartTime=parseInt(e[1],10),T.visitId=f(T.visitorId+(T.visitStartTime?T.visitStartTime:g()).toString()),T.lastActivityTime=e[2],T.referrer=e[8],T.username=e[9],q.source=e[3],q.medium=e[4],q.campaign=e[5],q.keyword=e[6],q.content=e[7],M[s.e.userDefined]?(e=M[s.e.userDefined].split("&"),e[0]==T.visitId&&(T.userDefined=e[1])):T.userDefined=t,n)}function v(){if(!P[s.i])return i;var e,r,t,o;return e=P[s.i],r=e.indexOf("."),r>0?(t=e.substring(0,r),o=e.indexOf(".",r+1),o>0?(r=e.substring(r+1,o),e=e.substr(o+1),e=e.split("&"),5!=e.length?i:(T.visitorId=t,T.visitStartTime=r,T.visitId=f(T.visitorId+(parseInt(T.visitStartTime,10)?parseInt(T.visitStartTime,10):g()).toString()),q.source=unescape(e[0]),q.medium=unescape(e[1]),q.campaign=unescape(e[2]),q.keyword=unescape(e[3]),q.content=unescape(e[4]),n)):i):i}function b(){v()||(h()?parseInt(T.lastActivityTime,10)+60*s.o<g()?y():M[s.e.sessionTimeout]||y():y()),T.lastActivityTime=g(),m()}function y(){if(!T.visitorId){var e,r=0;for(e=0;e<$.hostname.length;e++)r+=$.hostname.charCodeAt(e);T.visitorId=f((r+Math.floor(1e8*Math.random())).toString()),p()}T.visitStartTime=g(),T.lastActivityTime=T.visitStartTime,T.visitId=f(T.visitorId+(T.visitStartTime?T.visitStartTime:g()).toString()),T.pageviewCount=0,delete T.username,1===s.u&&q.source||(r=x(),q=r.campaign,T.referrer=r.referrer)}function w(e){if(!e)return{hostname:"",queryParams:[],stem:""};var r,n,t,o="",a=[];return r=e.indexOf("://"),-1===r?{r:i}:(r+=3,n=e.indexOf("/",r),-1===n?(n=e.indexOf("?",r),-1===n?t=e.substring(r):(t=e.substring(r,n),a=e.substring(n+1).split("&"))):(t=e.substring(r,n),r=n+1,n=e.indexOf("?",r),n>-1?(o=e.substring(r,n),a=e.substr(n+1).split("&")):o=e.substr(r)),(r=t.indexOf(":"))>-1&&(t=t.substring(0,r)),{hostname:t,queryParams:a,stem:"/"+o})}function k(e){var r,o,a,u,c,f,l="",g=i;if(!e)return{r:i};var m=w(e);if(a=m.hostname,u=m.queryParams,l=a,a=a.split("."),0===a.length)return{r:i};for(e=0;e<a.length-1;e++)o=a[e],s.f[o]&&(l=e+1<a.length?o+"."+a[e+1]:o,g=n,c=j[o.toLowerCase()]?o.toLowerCase():i,f=i,d(u,function(e){return e=u[e].split("="),c&&e[0]===j[c].B&&(f=e[1].toLowerCase(),r)?i:e[0]===s.f[o]&&(l=o,r=e[1],!c||f)?i:n}),c&&!f&&(f=j[c]["default"]),!r||c&&"utf8"!=f&&"utf-8"!=f||(r=decodeURIComponent(r),f=c=i));return g&&r!=t?(g={r:g,kw:r,hn:l},f&&(g.h=f),g):g&&a.join(".").match(/search\.yahoo\.com$/i)?{r:g,hn:"yahoo",kw:"(not provided)"}:{r:g,hn:m.hostname}}function x(){var n,o,a,u={campaign:{},referrer:""},c=r.referrer.replace(/\+/g,"%20"),f=w(r.referrer.replace(/\+/g,"%20")),d={};for(n in s.g)if(s.g.hasOwnProperty(n)!=i){d[n]=t;for(o in s.g[n])if(s.g[n].hasOwnProperty(o)!=i&&(a=s.g[n][o],P[a])){d[n]=P[a];break}}if(d.source&&d.medium&&d.campaign)u.campaign={source:d.source,medium:d.medium,campaign:d.campaign,keyword:"",content:d.content||""},d.keyword?u.campaign.keyword=d.keyword:(c=k(c),c.r&&"string"==typeof c.kw&&(u.campaign.keyword=c.kw)),u.referrer=f.hostname&&f.hostname==e.location.hostname?"":f.stem;else{if(0===s.sourceOverwrite&&q.source&&q.medium)return{campaign:q,referrer:T.referrer};if(u.referrer=f.hostname&&f.hostname==e.location.hostname?"":f.stem,c=k(c),c.hn&&(c.hn==e.location.hostname||s.d&&"auto"!=s.d&&c.hn.match(RegExp(s.d+"$"))))return q.source||(q.source="direct"),q.medium||(q.medium="(none)"),q.campaign||(q.campaign=""),q.keyword||(q.keyword=""),q.content||(q.content=""),T.referrer||(T.referrer=""),{campaign:q,referrer:T.referrer};c.r&&"google"===c.hn&&"string"==typeof P.gclid?u.campaign={source:"google",medium:"cpc",campaign:"adwords",keyword:c.kw,content:""}:c.r?"string"==typeof c.kw?(u.campaign={source:c.hn,medium:"organic",campaign:"(organic)",keyword:c.kw||"(not provided)",content:""},c.h&&(u.campaign.h=c.h)):u.campaign={source:c.hn,medium:"referral",campaign:"(referral)",keyword:"",content:""}:u.campaign=c.hn?{source:c.hn,medium:"referral",campaign:"(referral)",keyword:"",content:""}:{source:"direct",medium:"(none)",campaign:"",keyword:"",content:""}}return u.campaign.h||(u.campaign.keyword=u.campaign.keyword.toLowerCase()),u}function A(r){var n,i=[];return n="auto"===s.l?$.protocol+"//":s.l?"https://":"http://",n+="auto"==s.n?e.location.host:s.n,n+=s.p,r.vi=T.visitorId,r.vs=T.visitId,r._=Math.floor(1e6*Math.random()),r.v=o,d(s.k,function(e){e=s.k[e],M[e]&&i.push(f(e+"="+M[e]))}),r.ck=i.join(";"),i=t,n+="?"+S(r),n.replace(/%20/g,"+"),n}function S(e){var r=[];return d(e,function(n){e[n]&&("ie"==n||"kw"==n&&e.h?r.push(n+"="+e[n]):r.push(f(n)+"="+f(e[n])))}),r.join("&")}function C(){if(!a||!a.userAgent)return{name:t,version:t};var e,r=a.userAgent,n=a.platform;return(e=r.match(/Windows\sNT\s(\d+\.\d+)/i))&&e.length>0?(r=parseFloat(e[1]),5===r?{name:"Windows",version:2e3}:5.1===r?{name:"Windows",version:"XP"}:5.2===r?{name:"Windows",version:"XP Professional"}:6===r?{name:"Windows",version:"Vista"}:6.1===r?{name:"Windows",version:7}:6.2===r?{name:"Windows",version:8}:6.3===r?{name:"Windows",version:8.1}:10===r?{name:"Windows",version:10}:{name:"Windows",version:r||"-"}):(e=r.match(/Windows\sPhone\s(\d+\.\d+)/i))&&e.length>0?{name:"Windows Phone",version:parseFloat(e[1])}:(e=r.match(/(iPod|iPad|iPhone).*?OS\s([0-9\_]+)/i))&&e.length>0?{name:e[1],version:e[2].replace(/_/g,".")}:r.indexOf("PSP (PlayStation Portable)")>-1?{name:"PSP"}:r.indexOf("PLAYSTATION 3")>-1?{name:"Playstation 3"}:r.toLowerCase().indexOf("xbox")>-1?{name:"XBox"}:r.toLowerCase().indexOf("googletv")>-1?{name:"Google TV"}:(e=r.match(/Android\s(\d+\.\d+)/i))&&e.length>0?(r=parseFloat(e[1]),{name:"Android",version:r}):(e=r.match(/BlackBerry[0-9]{4}[a-zA-Z]?\/([.0-9]+)/i))&&e.length>0?{name:"BlackBerry",version:e[1]}:(e=r.match(/(BlackBerry|BB10).*Version\/([.0-9]+)/i))&&e.length>0?{name:"BlackBerry",version:e[2]}:(e=r.match(/CrOS\s\S+\s([0-9.]+)/i))&&e.length>0?{name:"Chrome OS",version:e[1]}:(e=n.match(/Linux\s(.+)/i))&&e.length>0?{name:"Linux",version:e[1]}:(e=r.match(/Mac OS\s?X ((\d\.?)+)/i))&&e.length>0?{name:"Mac OS X",version:e[1]}:{name:n}}function O(e){function r(e,r){var n,t,i,o,a;return i=2147483648&e,o=2147483648&r,n=1073741824&e,t=1073741824&r,a=(1073741823&e)+(1073741823&r),n&t?2147483648^a^i^o:n|t?1073741824&a?3221225472^a^i^o:1073741824^a^i^o:a^i^o}function n(e,n,t,i,o,a,s){return e=r(e,r(r(n&t|~n&i,o),s)),r(e<<a|e>>>32-a,n)}function t(e,n,t,i,o,a,s){return e=r(e,r(r(n&i|t&~i,o),s)),r(e<<a|e>>>32-a,n)}function i(e,n,t,i,o,a,s){return e=r(e,r(r(n^t^i,o),s)),r(e<<a|e>>>32-a,n)}function o(e,n,t,i,o,a,s){return e=r(e,r(r(t^(n|~i),o),s)),r(e<<a|e>>>32-a,n)}function a(e){var r,n="",t="";for(r=0;3>=r;r++)t=e>>>8*r&255,t="0"+t.toString(16),n+=t.substr(t.length-2,2);return n}var s,u,c,f,d,l,g,m,p=[],e=function(e){for(var e=e.replace(/\r\n/g,"\n"),r="",n=0;n<e.length;n++){var t=e.charCodeAt(n);128>t?r+=String.fromCharCode(t):(t>127&&2048>t?r+=String.fromCharCode(t>>6|192):(r+=String.fromCharCode(t>>12|224),r+=String.fromCharCode(t>>6&63|128)),r+=String.fromCharCode(63&t|128))}return r}(e),p=function(e){var r,n=e.length;r=n+8;for(var t=16*((r-r%64)/64+1),i=Array(t-1),o=0,a=0;n>a;)r=(a-a%4)/4,o=a%4*8,i[r]=i[r]|e.charCodeAt(a)<<o,a++;return r=(a-a%4)/4,i[r]=i[r]|128<<a%4*8,i[t-2]=n<<3,i[t-1]=n>>>29,i}(e);for(d=1732584193,l=4023233417,g=2562383102,m=271733878,e=0;e<p.length;e+=16)s=d,u=l,c=g,f=m,d=n(d,l,g,m,p[e+0],7,3614090360),m=n(m,d,l,g,p[e+1],12,3905402710),g=n(g,m,d,l,p[e+2],17,606105819),l=n(l,g,m,d,p[e+3],22,3250441966),d=n(d,l,g,m,p[e+4],7,4118548399),m=n(m,d,l,g,p[e+5],12,1200080426),g=n(g,m,d,l,p[e+6],17,2821735955),l=n(l,g,m,d,p[e+7],22,4249261313),d=n(d,l,g,m,p[e+8],7,1770035416),m=n(m,d,l,g,p[e+9],12,2336552879),g=n(g,m,d,l,p[e+10],17,4294925233),l=n(l,g,m,d,p[e+11],22,2304563134),d=n(d,l,g,m,p[e+12],7,1804603682),m=n(m,d,l,g,p[e+13],12,4254626195),g=n(g,m,d,l,p[e+14],17,2792965006),l=n(l,g,m,d,p[e+15],22,1236535329),d=t(d,l,g,m,p[e+1],5,4129170786),m=t(m,d,l,g,p[e+6],9,3225465664),g=t(g,m,d,l,p[e+11],14,643717713),l=t(l,g,m,d,p[e+0],20,3921069994),d=t(d,l,g,m,p[e+5],5,3593408605),m=t(m,d,l,g,p[e+10],9,38016083),g=t(g,m,d,l,p[e+15],14,3634488961),l=t(l,g,m,d,p[e+4],20,3889429448),d=t(d,l,g,m,p[e+9],5,568446438),m=t(m,d,l,g,p[e+14],9,3275163606),g=t(g,m,d,l,p[e+3],14,4107603335),l=t(l,g,m,d,p[e+8],20,1163531501),d=t(d,l,g,m,p[e+13],5,2850285829),m=t(m,d,l,g,p[e+2],9,4243563512),g=t(g,m,d,l,p[e+7],14,1735328473),l=t(l,g,m,d,p[e+12],20,2368359562),d=i(d,l,g,m,p[e+5],4,4294588738),m=i(m,d,l,g,p[e+8],11,2272392833),g=i(g,m,d,l,p[e+11],16,1839030562),l=i(l,g,m,d,p[e+14],23,4259657740),d=i(d,l,g,m,p[e+1],4,2763975236),m=i(m,d,l,g,p[e+4],11,1272893353),g=i(g,m,d,l,p[e+7],16,4139469664),l=i(l,g,m,d,p[e+10],23,3200236656),d=i(d,l,g,m,p[e+13],4,681279174),m=i(m,d,l,g,p[e+0],11,3936430074),g=i(g,m,d,l,p[e+3],16,3572445317),l=i(l,g,m,d,p[e+6],23,76029189),d=i(d,l,g,m,p[e+9],4,3654602809),m=i(m,d,l,g,p[e+12],11,3873151461),g=i(g,m,d,l,p[e+15],16,530742520),l=i(l,g,m,d,p[e+2],23,3299628645),d=o(d,l,g,m,p[e+0],6,4096336452),m=o(m,d,l,g,p[e+7],10,1126891415),g=o(g,m,d,l,p[e+14],15,2878612391),l=o(l,g,m,d,p[e+5],21,4237533241),d=o(d,l,g,m,p[e+12],6,1700485571),m=o(m,d,l,g,p[e+3],10,2399980690),g=o(g,m,d,l,p[e+10],15,4293915773),l=o(l,g,m,d,p[e+1],21,2240044497),d=o(d,l,g,m,p[e+8],6,1873313359),m=o(m,d,l,g,p[e+15],10,4264355552),g=o(g,m,d,l,p[e+6],15,2734768916),l=o(l,g,m,d,p[e+13],21,1309151649),d=o(d,l,g,m,p[e+4],6,4149444226),m=o(m,d,l,g,p[e+11],10,3174756917),g=o(g,m,d,l,p[e+2],15,718787259),l=o(l,g,m,d,p[e+9],21,3951481745),d=r(d,s),l=r(l,u),g=r(g,c),m=r(m,f);return(a(d)+a(l)+a(g)+a(m)).toLowerCase()}String.prototype.trim=function(){return this.replace(/^[\s\xA0]+/,"").replace(/[\s\xA0]+$/,"")};var I=n,T={},q={},M={},P={agfoff:0,agf_off:0,gclid:t},$=r.location,B=1,j={baidu:{"default":"gb2312",parameter:"ie"},google:{"default":"utf-8",parameter:"ie"}};e[u]={enable:function(){return I=n},disable:function(){return I=i,n},setUsername:function(e){return"undefined"==typeof e?i:(T.username=e,m(),n)},setTrackingFile:function(e){return e?(s.p=e,n):i},setTrackingHost:function(e){return e?(s.n=e,n):i},setCookiePath:function(e){return e?(s.j=e,n):i},setCookieDomain:function(e){if(!e)return i;s.d=e;var t,o,a=RegExp(O("auto"!=s.d?s.d:r.domain)+"\\.");for(t=r.cookie.split(";"),e=0;e<t.length;e++)if(o=t[e].split("="),2==o.length&&o[1].match(a)){o[1]=o[1].replace(a,"");var u=M,c=o[0].trim();o=o[1].trim(),u[c]=decodeURIComponent(o)}return b(),n},setQueryDelimiter:function(e){return!e||"?"!=e&&"#"!=e?i:(s.m=e,n)},putCookiesInQuery:function(e){return"object"==typeof e&&e.length?(s.k=e,n):i},setHttps:function(e){return"boolean"!=typeof e&&"auto"!=e?i:(s.l=e,n)},addOrganicReferrer:function(e,r){return e&&r?(s.f[e]=r,n):i},removeOrganicReferrer:function(e){return e&&s.f[e]?(delete s.f[e],n):i},addQueryExclude:function(e){return e?(s.s.push(e),n):i},pageview:function(i){"object"!=typeof i&&(i={}),parseInt(T.lastActivityTime,10)+60*s.o<g()&&b();var o,u,c;o=i.page||$.pathname,c=o.indexOf(s.m),c>0&&(o=o.substr(0,c)),(u=s.m)||(u="?"),c="?"==u?"#":"?";var f=i.page||$.href;if(u=f.lastIndexOf(u),u>0?(f=f.substr(u+1),f=f.split(c),c=f[0]):c="",o={t:"pv",pv:o,tt:i.title||r.title,qr:c},"username"in T&&"undefined"!=typeof T.username&&(o.un=T.username),o.vt=T.visitorType,o.udv=T.userDefined,o.rp=T.referrer,o.sc=q.source,o.md=q.medium,o.cp=q.campaign,o.kw=q.keyword,o.cn=q.content,q.ie&&(o.ie=q.ie),c=o,a&&(c.je=a.javaEnabled()?1:0),e&&e.screen&&(c.dp=e.screen.colorDepth,c.sh=e.screen.height,c.sw=e.screen.width),f=c=t,a&&a.userAgent)for(var d=[{source:a.userAgent,a:/BlackBerry[0-9]+.*MIDP/,c:"MIDP",b:"BlackBerry"},{source:a.userAgent,a:/BlackBerry|BB10/,c:"AppleWebKit",b:"BlackBerry"},{source:a.userAgent,a:/Version\/[.0-9]+ Mobile(\/[.A-Za-z0-9]+)? Safari/,c:"Version",b:"Mobile Safari"},{source:a.userAgent,a:/IEMobile\/[.0-9]+/,c:"IEMobile",b:"Internet Explorer Mobile"},{source:a.userAgent,a:/Mobile.+Edge\/[.0-9]+/,c:"Edge",b:"Microsoft Edge Mobile"},{source:a.userAgent,a:/Chrome\/[.0-9]+ Mobile Safari\//,c:"Chrome",b:"Chrome Mobile"},{source:a.userAgent,a:/CriOS\/[.0-9]+ Mobile/,c:"CriOS",b:"Chrome Mobile"},{source:a.userAgent,a:/Opera Mobi\//,c:"Version",b:"Opera Mobile"},{source:a.userAgent,a:/Opera Mini\//,c:"Version",b:"Opera Mini"},{source:a.userAgent,a:/Mobile; rv:[.0-9]+\) Gecko\/[.0-9]+ Firefox\/[.0-9]+/,c:"Firefox",b:"Mobile Firefox"},{source:a.userAgent,a:/Edge\/[.0-9]+/,c:"Edge",b:"Microsoft Edge"},{source:a.userAgent,a:/Chrome\/[.0-9]+ Safari\//,c:"Chrome",b:"Chrome"},{source:a.userAgent,a:/rekonq\/[.0-9]+ Safari\//,c:"rekonq",b:"Rekonq"},{source:a.userAgent,a:/OmniWeb/,c:"OmniWeb/",b:"OmniWeb"},{source:a.userAgent,a:/Version\/[.0-9]+ Safari\//,c:"Version",b:"Safari"},{source:a.userAgent,a:/Opera\/[.0-9]+/,c:"Version",b:"Opera"},{source:a.userAgent,a:/iCab\/[.0-9]+/,c:"iCab",b:"iCab"},{source:a.userAgent,a:/Konqueror\/[.0-9]+/,c:"Konqueror",b:"Konqueror"},{source:a.userAgent,a:/Firefox\/[.0-9]+/,c:"Firefox",b:"Firefox"},{source:a.userAgent,a:/Camino\/[.0-9]+/,c:"Camino",b:"Camino"},{source:a.userAgent,a:/Netscape\/[.0-9]+/,c:"Netscape",b:"Netscape"},{source:a.userAgent,a:/MSIE/,c:"MSIE",b:"Internet Explorer"},{source:a.userAgent,a:/Trident\/[.0-9]+/,c:"rv",b:"Internet Explorer"},{source:a.userAgent,a:/Gecko\/[.0-9]+/,c:"rv",b:"Mozilla"},{source:a.userAgent,a:/YaBrowser\/[.0-9]+/,c:"YaBrowser",b:"Yandex"}],l=0;l<d.length;l++){var p=d[l].source;if(u=d[l].c,p&&p.match(d[l].a)&&(c=d[l].b),c){d=a.userAgent.indexOf(u),-1==d?(d=a.appVersion.indexOf(u),-1!=d&&(f=parseFloat(a.appVersion.substring(d+u.length+1)))):f=parseFloat(a.userAgent.substring(d+u.length+1));break}}return u=C(),o.bn=c,o.bv=f,o.pn=u.name,u.version&&(o.pr=u.version),o.bl=a.language?a.language.toLowerCase():a.userLanguage?a.userLanguage.toLowerCase():"",o.js=B,o.hn=$.hostname||"-",c=o=A(o),I&&(f="undefined"!=typeof XDomainRequest?new XDomainRequest:new XMLHttpRequest,f.open("GET",c.replace(/%20/g,"+")),f.send()),"function"==typeof i.callback&&(c=i.callback,delete i.callback,i.hit=o,c(i)),T.pageviewCount++,T.lastActivityTime=g(),m(),n},setUserDefined:function(e){return"object"==typeof e&&"udv"in e?(void 0===e.udv&&(e.udv=""),T.userDefined=e.udv,e=T.visitId+"&"+f(T.userDefined.replace(/\&/g,"")),l(s.e.userDefined,e,"day",180),n):i},getVisitInfo:function(){return T?T:{}},getMarketingVariables:function(){return q?q:{}},saveMarketingVariables:function(e){return e.source&&(q.source=e.source),e.medium&&(q.medium=e.medium),e.campaign&&(q.campaign=e.campaign),e.keyword&&(q.keyword=e.keyword),e.content&&(q.content=e.content),q.source||(q.source=""),q.medium||(q.medium=""),q.campaign||(q.campaign=""),q.keyword||(q.keyword=""),q.content||(q.content=""),m(),n},resetVisit:function(){return y(),m(),n},setTransferQuery:function(e){return e?(s.i=e,n):i},getTransferUrl:c,transferVisitor:function(r){return r&&r.url?(e.location=c(r),i):n},setJSVersion:function(e){return e&&!isNaN(e)&&e>B?(B=parseFloat(e),n):i}},function(){var e,t,o=$.search.substring(1).split("&"),a=RegExp(O("auto"!=s.d?s.d:r.domain)+"\\."),u=[s.e.sessionInfo,s.e.sessionTimeout,s.e.userDefined];for(t=s.f.split(","),s.f={},e=0;e<t.length;e++){var c=t[e].split(":");s.f[c[0].trim()]=c[1].trim()}for(e=0;e<o.length;e++)t=o[e].split("="),P[t[0]]=decodeURIComponent(t[1]);if(P.A||P.z)return i;for(o=r.cookie.split(";"),e=0;e<o.length;e++)if(t=o[e].split("="),2==t.length&&(-1==u.indexOf(t[0].trim())||t[1].match(a))){t[1]=-1==u.indexOf(t[0].trim())?t[1]:t[1].replace(a,"");var c=M,f=t[0].trim();t=t[1].trim(),c[f]=decodeURIComponent(t)}for(e=[1.1,1.2,1.3,1.4,1.5,1.6,1.7,1.8,1.9],a=0;a<e.length;a++)u=r.getElementsByTagName("script")[0],o=r.createElement("script"),o.setAttribute("Language","Javascript"+e[a]),o.text="agf.setJSVersion("+e[a]+")",u.parentNode.insertBefore(o,u);return n}()&&b()}(window,document,navigator,{p:"/web-analytics/angelfish/agf.png",n:"auto",m:"?",k:[],l:"auto",f:"google:q,yahoo:p,msn:q,aol:q,lycos:query,ask:q,altavista:q,bing:q,netscape:query,cnn:query,looksmart:qt,about:terms,mamma:query,alltheweb:q,gigablast:q,voila:rdata,virgilio:qs,live:q,baidu:wd,alice:qs,yandex:text,najdi:q,club-internet:q,mama:query,seznam:q,search:q,wp:szukaj,onet:qt,netsprint:q,google.interia:q,szukacz:q,yam:k,pchome:q,duckduckgo:q",s:[],g:{source:["agfs"],medium:["agfm"],campaign:["agfc"],keyword:["agfk"],content:["agfr"]},u:0,e:{sessionInfo:"agfs",sessionTimeout:"agft",userDefined:"agfudv"},j:"/",d:"auto",o:30,w:180,i:"agfv"},"agf")},function(e,r,n){n(4);var t=window.agf;delete window.agf,e.exports=t}])});
	//# sourceMappingURL=uprr-angular-analytics.js.map

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./accordion/index.js": 92,
		"./addRemove/index.js": 97,
		"./alert/index.js": 102,
		"./alerts/index.js": 106,
		"./appTemplate/index.js": 114,
		"./autocomplete/index.js": 129,
		"./bindHtml/index.js": 6,
		"./button/index.js": 133,
		"./calendar/index.js": 156,
		"./checkbox/index.js": 161,
		"./clearable/index.js": 163,
		"./command/index.js": 166,
		"./common/index.js": 14,
		"./compact/index.js": 169,
		"./contentReplace/index.js": 7,
		"./focus/index.js": 15,
		"./groupbox/index.js": 16,
		"./hoverIntent/index.js": 17,
		"./hoverStop/index.js": 178,
		"./icon/index.js": 180,
		"./index.js": 18,
		"./infiniteScroll/index.js": 19,
		"./inputFieldWrapper/index.js": 20,
		"./keyboardNavigation/index.js": 3,
		"./listview/index.js": 21,
		"./loading/index.js": 22,
		"./mediaQuery/index.js": 5,
		"./migration/index.js": 192,
		"./modal/index.js": 8,
		"./navigation/index.js": 9,
		"./offline/index.js": 207,
		"./overlay/index.js": 10,
		"./placeholder/index.js": 211,
		"./position/index.js": 4,
		"./reauthenticate/index.js": 215,
		"./redirector/index.js": 219,
		"./ric2compat/index.js": 224,
		"./scroll/index.js": 227,
		"./seamlessUi/index.js": 11,
		"./select/index.js": 231,
		"./slideMenu/index.js": 24,
		"./smartAnchor/index.js": 237,
		"./smartMenu/index.js": 239,
		"./table/index.js": 245,
		"./tabs/index.js": 261,
		"./target/index.js": 12,
		"./tooltip/index.js": 271,
		"./usage/index.js": 1,
		"./utils/index.js": 2,
		"./validation/index.js": 286,
		"./wizard/index.js": 297
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 303;


/***/ }
/******/ ])
});
;
//# sourceMappingURL=ricola.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ricola3/ricola.js
// module id = 50
// module chunks = 0